(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],2:[function(require,module,exports){
"use strict";

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],3:[function(require,module,exports){
"use strict";

var arrayLikeToArray = require("./arrayLikeToArray.js");
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./arrayLikeToArray.js":1}],4:[function(require,module,exports){
"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],5:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],6:[function(require,module,exports){
"use strict";

var toPropertyKey = require("./toPropertyKey.js");
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./toPropertyKey.js":17}],7:[function(require,module,exports){
"use strict";

var toPropertyKey = require("./toPropertyKey.js");
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./toPropertyKey.js":17}],8:[function(require,module,exports){
"use strict";

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],9:[function(require,module,exports){
"use strict";

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],10:[function(require,module,exports){
"use strict";

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],11:[function(require,module,exports){
"use strict";

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],12:[function(require,module,exports){
"use strict";

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],13:[function(require,module,exports){
"use strict";

var _typeof = require("./typeof.js")["default"];
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./typeof.js":18}],14:[function(require,module,exports){
"use strict";

var arrayWithHoles = require("./arrayWithHoles.js");
var iterableToArrayLimit = require("./iterableToArrayLimit.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableRest = require("./nonIterableRest.js");
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./arrayWithHoles.js":2,"./iterableToArrayLimit.js":10,"./nonIterableRest.js":11,"./unsupportedIterableToArray.js":19}],15:[function(require,module,exports){
"use strict";

var arrayWithoutHoles = require("./arrayWithoutHoles.js");
var iterableToArray = require("./iterableToArray.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableSpread = require("./nonIterableSpread.js");
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./arrayWithoutHoles.js":3,"./iterableToArray.js":9,"./nonIterableSpread.js":12,"./unsupportedIterableToArray.js":19}],16:[function(require,module,exports){
"use strict";

var _typeof = require("./typeof.js")["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./typeof.js":18}],17:[function(require,module,exports){
"use strict";

var _typeof = require("./typeof.js")["default"];
var toPrimitive = require("./toPrimitive.js");
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./toPrimitive.js":16,"./typeof.js":18}],18:[function(require,module,exports){
"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],19:[function(require,module,exports){
"use strict";

var arrayLikeToArray = require("./arrayLikeToArray.js");
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"./arrayLikeToArray.js":1}],20:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
// TODO(Babel 8): Remove this file.

var runtime = require("../helpers/regeneratorRuntime")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : (0, _typeof2["default"])(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

},{"../helpers/regeneratorRuntime":13,"@babel/runtime/helpers/interopRequireDefault":8,"@babel/runtime/helpers/typeof":18}],21:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/*!
 * jQuery JavaScript Library v3.6.3
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2022-12-20T21:28Z
 */
(function (global, factory) {
  "use strict";

  if ((typeof module === "undefined" ? "undefined" : (0, _typeof2["default"])(module)) === "object" && (0, _typeof2["default"])(module.exports) === "object") {
    // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function (w) {
      if (!w.document) {
        throw new Error("jQuery requires a window with a document");
      }
      return factory(w);
    };
  } else {
    factory(global);
  }

  // Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : void 0, function (window, noGlobal) {
  // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
  // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
  // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
  // enough that all such attempts are guarded in a try block.
  "use strict";

  var arr = [];
  var getProto = Object.getPrototypeOf;
  var _slice = arr.slice;
  var flat = arr.flat ? function (array) {
    return arr.flat.call(array);
  } : function (array) {
    return arr.concat.apply([], array);
  };
  var push = arr.push;
  var indexOf = arr.indexOf;
  var class2type = {};
  var toString = class2type.toString;
  var hasOwn = class2type.hasOwnProperty;
  var fnToString = hasOwn.toString;
  var ObjectFunctionString = fnToString.call(Object);
  var support = {};
  var isFunction = function isFunction(obj) {
    // Support: Chrome <=57, Firefox <=52
    // In some browsers, typeof returns "function" for HTML <object> elements
    // (i.e., `typeof document.createElement( "object" ) === "function"`).
    // We don't want to classify *any* DOM node as a function.
    // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
    // Plus for old WebKit, typeof returns "function" for HTML collections
    // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
    return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
  };
  var isWindow = function isWindow(obj) {
    return obj != null && obj === obj.window;
  };
  var document = window.document;
  var preservedScriptAttributes = {
    type: true,
    src: true,
    nonce: true,
    noModule: true
  };
  function DOMEval(code, node, doc) {
    doc = doc || document;
    var i,
      val,
      script = doc.createElement("script");
    script.text = code;
    if (node) {
      for (i in preservedScriptAttributes) {
        // Support: Firefox 64+, Edge 18+
        // Some browsers don't support the "nonce" property on scripts.
        // On the other hand, just using `getAttribute` is not enough as
        // the `nonce` attribute is reset to an empty string whenever it
        // becomes browsing-context connected.
        // See https://github.com/whatwg/html/issues/2369
        // See https://html.spec.whatwg.org/#nonce-attributes
        // The `node.getAttribute` check was added for the sake of
        // `jQuery.globalEval` so that it can fake a nonce-containing node
        // via an object.
        val = node[i] || node.getAttribute && node.getAttribute(i);
        if (val) {
          script.setAttribute(i, val);
        }
      }
    }
    doc.head.appendChild(script).parentNode.removeChild(script);
  }
  function toType(obj) {
    if (obj == null) {
      return obj + "";
    }

    // Support: Android <=2.3 only (functionish RegExp)
    return (0, _typeof2["default"])(obj) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : (0, _typeof2["default"])(obj);
  }
  /* global Symbol */
  // Defining this global in .eslintrc.json would create a danger of using the global
  // unguarded in another place, it seems safer to define global only for this module

  var version = "3.6.3",
    // Define a local copy of jQuery
    jQuery = function jQuery(selector, context) {
      // The jQuery object is actually just the init constructor 'enhanced'
      // Need init if jQuery is called (just allow error to be thrown if not included)
      return new jQuery.fn.init(selector, context);
    };
  jQuery.fn = jQuery.prototype = {
    // The current version of jQuery being used
    jquery: version,
    constructor: jQuery,
    // The default length of a jQuery object is 0
    length: 0,
    toArray: function toArray() {
      return _slice.call(this);
    },
    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function get(num) {
      // Return all the elements in a clean array
      if (num == null) {
        return _slice.call(this);
      }

      // Return just the one element from the set
      return num < 0 ? this[num + this.length] : this[num];
    },
    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function pushStack(elems) {
      // Build a new jQuery matched element set
      var ret = jQuery.merge(this.constructor(), elems);

      // Add the old object onto the stack (as a reference)
      ret.prevObject = this;

      // Return the newly-formed element set
      return ret;
    },
    // Execute a callback for every element in the matched set.
    each: function each(callback) {
      return jQuery.each(this, callback);
    },
    map: function map(callback) {
      return this.pushStack(jQuery.map(this, function (elem, i) {
        return callback.call(elem, i, elem);
      }));
    },
    slice: function slice() {
      return this.pushStack(_slice.apply(this, arguments));
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    even: function even() {
      return this.pushStack(jQuery.grep(this, function (_elem, i) {
        return (i + 1) % 2;
      }));
    },
    odd: function odd() {
      return this.pushStack(jQuery.grep(this, function (_elem, i) {
        return i % 2;
      }));
    },
    eq: function eq(i) {
      var len = this.length,
        j = +i + (i < 0 ? len : 0);
      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
    },
    end: function end() {
      return this.prevObject || this.constructor();
    },
    // For internal use only.
    // Behaves like an Array's method, not like a jQuery method.
    push: push,
    sort: arr.sort,
    splice: arr.splice
  };
  jQuery.extend = jQuery.fn.extend = function () {
    var options,
      name,
      src,
      copy,
      copyIsArray,
      clone,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length,
      deep = false;

    // Handle a deep copy situation
    if (typeof target === "boolean") {
      deep = target;

      // Skip the boolean and the target
      target = arguments[i] || {};
      i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if ((0, _typeof2["default"])(target) !== "object" && !isFunction(target)) {
      target = {};
    }

    // Extend jQuery itself if only one argument is passed
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      // Only deal with non-null/undefined values
      if ((options = arguments[i]) != null) {
        // Extend the base object
        for (name in options) {
          copy = options[name];

          // Prevent Object.prototype pollution
          // Prevent never-ending loop
          if (name === "__proto__" || target === copy) {
            continue;
          }

          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
            src = target[name];

            // Ensure proper type for the source value
            if (copyIsArray && !Array.isArray(src)) {
              clone = [];
            } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
              clone = {};
            } else {
              clone = src;
            }
            copyIsArray = false;

            // Never move original objects, clone them
            target[name] = jQuery.extend(deep, clone, copy);

            // Don't bring in undefined values
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }

    // Return the modified object
    return target;
  };
  jQuery.extend({
    // Unique for each copy of jQuery on the page
    expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
    // Assume jQuery is ready without the ready module
    isReady: true,
    error: function error(msg) {
      throw new Error(msg);
    },
    noop: function noop() {},
    isPlainObject: function isPlainObject(obj) {
      var proto, Ctor;

      // Detect obvious negatives
      // Use toString instead of jQuery.type to catch host objects
      if (!obj || toString.call(obj) !== "[object Object]") {
        return false;
      }
      proto = getProto(obj);

      // Objects with no prototype (e.g., `Object.create( null )`) are plain
      if (!proto) {
        return true;
      }

      // Objects with prototype are plain iff they were constructed by a global Object function
      Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
      return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
    },
    isEmptyObject: function isEmptyObject(obj) {
      var name;
      for (name in obj) {
        return false;
      }
      return true;
    },
    // Evaluates a script in a provided context; falls back to the global one
    // if not specified.
    globalEval: function globalEval(code, options, doc) {
      DOMEval(code, {
        nonce: options && options.nonce
      }, doc);
    },
    each: function each(obj, callback) {
      var length,
        i = 0;
      if (isArrayLike(obj)) {
        length = obj.length;
        for (; i < length; i++) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      } else {
        for (i in obj) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      }
      return obj;
    },
    // results is for internal usage only
    makeArray: function makeArray(arr, results) {
      var ret = results || [];
      if (arr != null) {
        if (isArrayLike(Object(arr))) {
          jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
        } else {
          push.call(ret, arr);
        }
      }
      return ret;
    },
    inArray: function inArray(elem, arr, i) {
      return arr == null ? -1 : indexOf.call(arr, elem, i);
    },
    // Support: Android <=4.0 only, PhantomJS 1 only
    // push.apply(_, arraylike) throws on ancient WebKit
    merge: function merge(first, second) {
      var len = +second.length,
        j = 0,
        i = first.length;
      for (; j < len; j++) {
        first[i++] = second[j];
      }
      first.length = i;
      return first;
    },
    grep: function grep(elems, callback, invert) {
      var callbackInverse,
        matches = [],
        i = 0,
        length = elems.length,
        callbackExpect = !invert;

      // Go through the array, only saving the items
      // that pass the validator function
      for (; i < length; i++) {
        callbackInverse = !callback(elems[i], i);
        if (callbackInverse !== callbackExpect) {
          matches.push(elems[i]);
        }
      }
      return matches;
    },
    // arg is for internal usage only
    map: function map(elems, callback, arg) {
      var length,
        value,
        i = 0,
        ret = [];

      // Go through the array, translating each of the items to their new values
      if (isArrayLike(elems)) {
        length = elems.length;
        for (; i < length; i++) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }

        // Go through every key on the object,
      } else {
        for (i in elems) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }
      }

      // Flatten any nested arrays
      return flat(ret);
    },
    // A global GUID counter for objects
    guid: 1,
    // jQuery.support is not used in Core but other projects attach their
    // properties to it so it needs to exist.
    support: support
  });
  if (typeof Symbol === "function") {
    jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
  }

  // Populate the class2type map
  jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });
  function isArrayLike(obj) {
    // Support: real iOS 8.2 only (not reproducible in simulator)
    // `in` check used to prevent JIT error (gh-2145)
    // hasOwn isn't used here due to false negatives
    // regarding Nodelist length in IE
    var length = !!obj && "length" in obj && obj.length,
      type = toType(obj);
    if (isFunction(obj) || isWindow(obj)) {
      return false;
    }
    return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
  }
  var Sizzle =
  /*!
   * Sizzle CSS Selector Engine v2.3.9
   * https://sizzlejs.com/
   *
   * Copyright JS Foundation and other contributors
   * Released under the MIT license
   * https://js.foundation/
   *
   * Date: 2022-12-19
   */
  function (window) {
    var i,
      support,
      Expr,
      getText,
      isXML,
      tokenize,
      compile,
      select,
      outermostContext,
      sortInput,
      hasDuplicate,
      // Local document vars
      setDocument,
      document,
      docElem,
      documentIsHTML,
      rbuggyQSA,
      rbuggyMatches,
      matches,
      contains,
      // Instance-specific data
      expando = "sizzle" + 1 * new Date(),
      preferredDoc = window.document,
      dirruns = 0,
      done = 0,
      classCache = createCache(),
      tokenCache = createCache(),
      compilerCache = createCache(),
      nonnativeSelectorCache = createCache(),
      sortOrder = function sortOrder(a, b) {
        if (a === b) {
          hasDuplicate = true;
        }
        return 0;
      },
      // Instance methods
      hasOwn = {}.hasOwnProperty,
      arr = [],
      pop = arr.pop,
      pushNative = arr.push,
      push = arr.push,
      slice = arr.slice,
      // Use a stripped-down indexOf as it's faster than native
      // https://jsperf.com/thor-indexof-vs-for/5
      indexOf = function indexOf(list, elem) {
        var i = 0,
          len = list.length;
        for (; i < len; i++) {
          if (list[i] === elem) {
            return i;
          }
        }
        return -1;
      },
      booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" + "ismap|loop|multiple|open|readonly|required|scoped",
      // Regular expressions

      // http://www.w3.org/TR/css3-selectors/#whitespace
      whitespace = "[\\x20\\t\\r\\n\\f]",
      // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
      identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
      // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
      attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
      // Operator (capture 2)
      "*([*^$|!~]?=)" + whitespace +
      // "Attribute values must be CSS identifiers [capture 5]
      // or strings [capture 3 or capture 4]"
      "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
      pseudos = ":(" + identifier + ")(?:\\((" +
      // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
      // 1. quoted (capture 3; capture 4 or capture 5)
      "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
      // 2. simple (capture 6)
      "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
      // 3. anything else (capture 2)
      ".*" + ")\\)|)",
      // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
      rwhitespace = new RegExp(whitespace + "+", "g"),
      rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
      rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
      rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
      rdescend = new RegExp(whitespace + "|>"),
      rpseudo = new RegExp(pseudos),
      ridentifier = new RegExp("^" + identifier + "$"),
      matchExpr = {
        "ID": new RegExp("^#(" + identifier + ")"),
        "CLASS": new RegExp("^\\.(" + identifier + ")"),
        "TAG": new RegExp("^(" + identifier + "|[*])"),
        "ATTR": new RegExp("^" + attributes),
        "PSEUDO": new RegExp("^" + pseudos),
        "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
        "bool": new RegExp("^(?:" + booleans + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
      },
      rhtml = /HTML$/i,
      rinputs = /^(?:input|select|textarea|button)$/i,
      rheader = /^h\d$/i,
      rnative = /^[^{]+\{\s*\[native \w/,
      // Easily-parseable/retrievable ID or TAG or CLASS selectors
      rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      rsibling = /[+~]/,
      // CSS escapes
      // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
      runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
      funescape = function funescape(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 0x10000;
        return nonHex ?
        // Strip the backslash prefix from a non-hex escape sequence
        nonHex :
        // Replace a hexadecimal escape sequence with the encoded Unicode code point
        // Support: IE <=11+
        // For values outside the Basic Multilingual Plane (BMP), manually construct a
        // surrogate pair
        high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
      },
      // CSS string/identifier serialization
      // https://drafts.csswg.org/cssom/#common-serializing-idioms
      rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      fcssescape = function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
          // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
          if (ch === "\0") {
            return "\uFFFD";
          }

          // Control characters and (dependent upon position) numbers get escaped as code points
          return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }

        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
      },
      // Used for iframes
      // See setDocument()
      // Removing the function wrapper causes a "Permission Denied"
      // error in IE
      unloadHandler = function unloadHandler() {
        setDocument();
      },
      inDisabledFieldset = addCombinator(function (elem) {
        return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
      }, {
        dir: "parentNode",
        next: "legend"
      });

    // Optimize for push.apply( _, NodeList )
    try {
      push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);

      // Support: Android<4.0
      // Detect silently failing push.apply
      // eslint-disable-next-line no-unused-expressions
      arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push = {
        apply: arr.length ?
        // Leverage slice if possible
        function (target, els) {
          pushNative.apply(target, slice.call(els));
        } :
        // Support: IE<9
        // Otherwise append directly
        function (target, els) {
          var j = target.length,
            i = 0;

          // Can't trust NodeList.length
          while (target[j++] = els[i++]) {}
          target.length = j - 1;
        }
      };
    }
    function Sizzle(selector, context, results, seed) {
      var m,
        i,
        elem,
        nid,
        match,
        groups,
        newSelector,
        newContext = context && context.ownerDocument,
        // nodeType defaults to 9, since context defaults to document
        nodeType = context ? context.nodeType : 9;
      results = results || [];

      // Return early from calls with invalid selector or context
      if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
        return results;
      }

      // Try to shortcut find operations (as opposed to filters) in HTML documents
      if (!seed) {
        setDocument(context);
        context = context || document;
        if (documentIsHTML) {
          // If the selector is sufficiently simple, try using a "get*By*" DOM method
          // (excepting DocumentFragment context, where the methods don't exist)
          if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
            // ID selector
            if (m = match[1]) {
              // Document context
              if (nodeType === 9) {
                if (elem = context.getElementById(m)) {
                  // Support: IE, Opera, Webkit
                  // TODO: identify versions
                  // getElementById can match elements by name instead of ID
                  if (elem.id === m) {
                    results.push(elem);
                    return results;
                  }
                } else {
                  return results;
                }

                // Element context
              } else {
                // Support: IE, Opera, Webkit
                // TODO: identify versions
                // getElementById can match elements by name instead of ID
                if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                  results.push(elem);
                  return results;
                }
              }

              // Type selector
            } else if (match[2]) {
              push.apply(results, context.getElementsByTagName(selector));
              return results;

              // Class selector
            } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
              push.apply(results, context.getElementsByClassName(m));
              return results;
            }
          }

          // Take advantage of querySelectorAll
          if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && (
          // Support: IE 8 only
          // Exclude object elements
          nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
            newSelector = selector;
            newContext = context;

            // qSA considers elements outside a scoping root when evaluating child or
            // descendant combinators, which is not what we want.
            // In such cases, we work around the behavior by prefixing every selector in the
            // list with an ID selector referencing the scope context.
            // The technique has to be used as well when a leading combinator is used
            // as such selectors are not recognized by querySelectorAll.
            // Thanks to Andrew Dupont for this technique.
            if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {
              // Expand context for sibling selectors
              newContext = rsibling.test(selector) && testContext(context.parentNode) || context;

              // We can use :scope instead of the ID hack if the browser
              // supports it & if we're not changing the context.
              if (newContext !== context || !support.scope) {
                // Capture the context ID, setting it first if necessary
                if (nid = context.getAttribute("id")) {
                  nid = nid.replace(rcssescape, fcssescape);
                } else {
                  context.setAttribute("id", nid = expando);
                }
              }

              // Prefix every selector in the list
              groups = tokenize(selector);
              i = groups.length;
              while (i--) {
                groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
              }
              newSelector = groups.join(",");
            }
            try {
              // `qSA` may not throw for unrecognized parts using forgiving parsing:
              // https://drafts.csswg.org/selectors/#forgiving-selector
              // like the `:has()` pseudo-class:
              // https://drafts.csswg.org/selectors/#relational
              // `CSS.supports` is still expected to return `false` then:
              // https://drafts.csswg.org/css-conditional-4/#typedef-supports-selector-fn
              // https://drafts.csswg.org/css-conditional-4/#dfn-support-selector
              if (support.cssSupportsSelector &&
              // eslint-disable-next-line no-undef
              !CSS.supports("selector(:is(" + newSelector + "))")) {
                // Support: IE 11+
                // Throw to get to the same code path as an error directly in qSA.
                // Note: once we only support browser supporting
                // `CSS.supports('selector(...)')`, we can most likely drop
                // the `try-catch`. IE doesn't implement the API.
                throw new Error();
              }
              push.apply(results, newContext.querySelectorAll(newSelector));
              return results;
            } catch (qsaError) {
              nonnativeSelectorCache(selector, true);
            } finally {
              if (nid === expando) {
                context.removeAttribute("id");
              }
            }
          }
        }
      }

      // All others
      return select(selector.replace(rtrim, "$1"), context, results, seed);
    }

    /**
     * Create key-value caches of limited size
     * @returns {function(string, object)} Returns the Object data after storing it on itself with
     *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
     *	deleting the oldest entry
     */
    function createCache() {
      var keys = [];
      function cache(key, value) {
        // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
        if (keys.push(key + " ") > Expr.cacheLength) {
          // Only keep the most recent entries
          delete cache[keys.shift()];
        }
        return cache[key + " "] = value;
      }
      return cache;
    }

    /**
     * Mark a function for special use by Sizzle
     * @param {Function} fn The function to mark
     */
    function markFunction(fn) {
      fn[expando] = true;
      return fn;
    }

    /**
     * Support testing using an element
     * @param {Function} fn Passed the created element and returns a boolean result
     */
    function assert(fn) {
      var el = document.createElement("fieldset");
      try {
        return !!fn(el);
      } catch (e) {
        return false;
      } finally {
        // Remove from its parent by default
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }

        // release memory in IE
        el = null;
      }
    }

    /**
     * Adds the same handler for all of the specified attrs
     * @param {String} attrs Pipe-separated list of attributes
     * @param {Function} handler The method that will be applied
     */
    function addHandle(attrs, handler) {
      var arr = attrs.split("|"),
        i = arr.length;
      while (i--) {
        Expr.attrHandle[arr[i]] = handler;
      }
    }

    /**
     * Checks document order of two siblings
     * @param {Element} a
     * @param {Element} b
     * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
     */
    function siblingCheck(a, b) {
      var cur = b && a,
        diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;

      // Use IE sourceIndex if available on both nodes
      if (diff) {
        return diff;
      }

      // Check if b follows a
      if (cur) {
        while (cur = cur.nextSibling) {
          if (cur === b) {
            return -1;
          }
        }
      }
      return a ? 1 : -1;
    }

    /**
     * Returns a function to use in pseudos for input types
     * @param {String} type
     */
    function createInputPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && elem.type === type;
      };
    }

    /**
     * Returns a function to use in pseudos for buttons
     * @param {String} type
     */
    function createButtonPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && elem.type === type;
      };
    }

    /**
     * Returns a function to use in pseudos for :enabled/:disabled
     * @param {Boolean} disabled true for :disabled; false for :enabled
     */
    function createDisabledPseudo(disabled) {
      // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
      return function (elem) {
        // Only certain elements can match :enabled or :disabled
        // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
        // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
        if ("form" in elem) {
          // Check for inherited disabledness on relevant non-disabled elements:
          // * listed form-associated elements in a disabled fieldset
          //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
          //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
          // * option elements in a disabled optgroup
          //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
          // All such elements have a "form" property.
          if (elem.parentNode && elem.disabled === false) {
            // Option elements defer to a parent optgroup if present
            if ("label" in elem) {
              if ("label" in elem.parentNode) {
                return elem.parentNode.disabled === disabled;
              } else {
                return elem.disabled === disabled;
              }
            }

            // Support: IE 6 - 11
            // Use the isDisabled shortcut property to check for disabled fieldset ancestors
            return elem.isDisabled === disabled ||
            // Where there is no isDisabled, check manually
            /* jshint -W018 */
            elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
          }
          return elem.disabled === disabled;

          // Try to winnow out elements that can't be disabled before trusting the disabled property.
          // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
          // even exist on them, let alone have a boolean value.
        } else if ("label" in elem) {
          return elem.disabled === disabled;
        }

        // Remaining elements are neither :enabled nor :disabled
        return false;
      };
    }

    /**
     * Returns a function to use in pseudos for positionals
     * @param {Function} fn
     */
    function createPositionalPseudo(fn) {
      return markFunction(function (argument) {
        argument = +argument;
        return markFunction(function (seed, matches) {
          var j,
            matchIndexes = fn([], seed.length, argument),
            i = matchIndexes.length;

          // Match elements found at the specified indexes
          while (i--) {
            if (seed[j = matchIndexes[i]]) {
              seed[j] = !(matches[j] = seed[j]);
            }
          }
        });
      });
    }

    /**
     * Checks a node for validity as a Sizzle context
     * @param {Element|Object=} context
     * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
     */
    function testContext(context) {
      return context && typeof context.getElementsByTagName !== "undefined" && context;
    }

    // Expose support vars for convenience
    support = Sizzle.support = {};

    /**
     * Detects XML nodes
     * @param {Element|Object} elem An element or a document
     * @returns {Boolean} True iff elem is a non-HTML XML node
     */
    isXML = Sizzle.isXML = function (elem) {
      var namespace = elem && elem.namespaceURI,
        docElem = elem && (elem.ownerDocument || elem).documentElement;

      // Support: IE <=8
      // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
      // https://bugs.jquery.com/ticket/4833
      return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
    };

    /**
     * Sets document-related variables once based on the current document
     * @param {Element|Object} [doc] An element or document object to use to set the document
     * @returns {Object} Returns the current document
     */
    setDocument = Sizzle.setDocument = function (node) {
      var hasCompare,
        subWindow,
        doc = node ? node.ownerDocument || node : preferredDoc;

      // Return early if doc is invalid or already selected
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
        return document;
      }

      // Update global variables
      document = doc;
      docElem = document.documentElement;
      documentIsHTML = !isXML(document);

      // Support: IE 9 - 11+, Edge 12 - 18+
      // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
        // Support: IE 11, Edge
        if (subWindow.addEventListener) {
          subWindow.addEventListener("unload", unloadHandler, false);

          // Support: IE 9 - 10 only
        } else if (subWindow.attachEvent) {
          subWindow.attachEvent("onunload", unloadHandler);
        }
      }

      // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
      // Safari 4 - 5 only, Opera <=11.6 - 12.x only
      // IE/Edge & older browsers don't support the :scope pseudo-class.
      // Support: Safari 6.0 only
      // Safari 6.0 supports :scope but it's an alias of :root there.
      support.scope = assert(function (el) {
        docElem.appendChild(el).appendChild(document.createElement("div"));
        return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
      });

      // Support: Chrome 105+, Firefox 104+, Safari 15.4+
      // Make sure forgiving mode is not used in `CSS.supports( "selector(...)" )`.
      //
      // `:is()` uses a forgiving selector list as an argument and is widely
      // implemented, so it's a good one to test against.
      support.cssSupportsSelector = assert(function () {
        /* eslint-disable no-undef */

        return CSS.supports("selector(*)") &&
        // Support: Firefox 78-81 only
        // In old Firefox, `:is()` didn't use forgiving parsing. In that case,
        // fail this test as there's no selector to test against that.
        // `CSS.supports` uses unforgiving parsing
        document.querySelectorAll(":is(:jqfake)") &&
        // `*` is needed as Safari & newer Chrome implemented something in between
        // for `:has()` - it throws in `qSA` if it only contains an unsupported
        // argument but multiple ones, one of which is supported, are fine.
        // We want to play safe in case `:is()` gets the same treatment.
        !CSS.supports("selector(:is(*,:jqfake))");

        /* eslint-enable */
      });

      /* Attributes
      ---------------------------------------------------------------------- */

      // Support: IE<8
      // Verify that getAttribute really returns attributes and not properties
      // (excepting IE8 booleans)
      support.attributes = assert(function (el) {
        el.className = "i";
        return !el.getAttribute("className");
      });

      /* getElement(s)By*
      ---------------------------------------------------------------------- */

      // Check if getElementsByTagName("*") returns only elements
      support.getElementsByTagName = assert(function (el) {
        el.appendChild(document.createComment(""));
        return !el.getElementsByTagName("*").length;
      });

      // Support: IE<9
      support.getElementsByClassName = rnative.test(document.getElementsByClassName);

      // Support: IE<10
      // Check if getElementById returns elements by name
      // The broken getElementById methods don't pick up programmatically-set names,
      // so use a roundabout getElementsByName test
      support.getById = assert(function (el) {
        docElem.appendChild(el).id = expando;
        return !document.getElementsByName || !document.getElementsByName(expando).length;
      });

      // ID filter and find
      if (support.getById) {
        Expr.filter["ID"] = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            return elem.getAttribute("id") === attrId;
          };
        };
        Expr.find["ID"] = function (id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var elem = context.getElementById(id);
            return elem ? [elem] : [];
          }
        };
      } else {
        Expr.filter["ID"] = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
            return node && node.value === attrId;
          };
        };

        // Support: IE 6 - 7 only
        // getElementById is not reliable as a find shortcut
        Expr.find["ID"] = function (id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var node,
              i,
              elems,
              elem = context.getElementById(id);
            if (elem) {
              // Verify the id attribute
              node = elem.getAttributeNode("id");
              if (node && node.value === id) {
                return [elem];
              }

              // Fall back on getElementsByName
              elems = context.getElementsByName(id);
              i = 0;
              while (elem = elems[i++]) {
                node = elem.getAttributeNode("id");
                if (node && node.value === id) {
                  return [elem];
                }
              }
            }
            return [];
          }
        };
      }

      // Tag
      Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
        if (typeof context.getElementsByTagName !== "undefined") {
          return context.getElementsByTagName(tag);

          // DocumentFragment nodes don't have gEBTN
        } else if (support.qsa) {
          return context.querySelectorAll(tag);
        }
      } : function (tag, context) {
        var elem,
          tmp = [],
          i = 0,
          // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
          results = context.getElementsByTagName(tag);

        // Filter out possible comments
        if (tag === "*") {
          while (elem = results[i++]) {
            if (elem.nodeType === 1) {
              tmp.push(elem);
            }
          }
          return tmp;
        }
        return results;
      };

      // Class
      Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
        if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
          return context.getElementsByClassName(className);
        }
      };

      /* QSA/matchesSelector
      ---------------------------------------------------------------------- */

      // QSA and matchesSelector support

      // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
      rbuggyMatches = [];

      // qSa(:focus) reports false when true (Chrome 21)
      // We allow this because of a bug in IE8/9 that throws an error
      // whenever `document.activeElement` is accessed on an iframe
      // So, we allow :focus to pass through QSA all the time to avoid the IE error
      // See https://bugs.jquery.com/ticket/13378
      rbuggyQSA = [];
      if (support.qsa = rnative.test(document.querySelectorAll)) {
        // Build QSA regex
        // Regex strategy adopted from Diego Perini
        assert(function (el) {
          var input;

          // Select is set to empty string on purpose
          // This is to test IE's treatment of not explicitly
          // setting a boolean content attribute,
          // since its presence should be enough
          // https://bugs.jquery.com/ticket/12359
          docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";

          // Support: IE8, Opera 11-12.16
          // Nothing should be selected when empty strings follow ^= or $= or *=
          // The test attribute must be unknown in Opera but "safe" for WinRT
          // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
          if (el.querySelectorAll("[msallowcapture^='']").length) {
            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
          }

          // Support: IE8
          // Boolean attributes and "value" are not treated correctly
          if (!el.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          }

          // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
          if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          }

          // Support: IE 11+, Edge 15 - 18+
          // IE 11/Edge don't find elements on a `[name='']` query in some cases.
          // Adding a temporary attribute to the document before the selection works
          // around the issue.
          // Interestingly, IE 10 & older don't seem to have the issue.
          input = document.createElement("input");
          input.setAttribute("name", "");
          el.appendChild(input);
          if (!el.querySelectorAll("[name='']").length) {
            rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
          }

          // Webkit/Opera - :checked should return selected option elements
          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
          // IE8 throws error here and will not see later tests
          if (!el.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          }

          // Support: Safari 8+, iOS 8+
          // https://bugs.webkit.org/show_bug.cgi?id=136851
          // In-page `selector#id sibling-combinator selector` fails
          if (!el.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          }

          // Support: Firefox <=3.6 - 5 only
          // Old Firefox doesn't throw on a badly-escaped identifier.
          el.querySelectorAll("\\\f");
          rbuggyQSA.push("[\\r\\n\\f]");
        });
        assert(function (el) {
          el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";

          // Support: Windows 8 Native Apps
          // The type and name attributes are restricted during .innerHTML assignment
          var input = document.createElement("input");
          input.setAttribute("type", "hidden");
          el.appendChild(input).setAttribute("name", "D");

          // Support: IE8
          // Enforce case-sensitivity of name attribute
          if (el.querySelectorAll("[name=d]").length) {
            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
          }

          // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
          // IE8 throws error here and will not see later tests
          if (el.querySelectorAll(":enabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          }

          // Support: IE9-11+
          // IE's :disabled selector does not pick up the children of disabled fieldsets
          docElem.appendChild(el).disabled = true;
          if (el.querySelectorAll(":disabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          }

          // Support: Opera 10 - 11 only
          // Opera 10-11 does not throw on post-comma invalid pseudos
          el.querySelectorAll("*,:x");
          rbuggyQSA.push(",.*:");
        });
      }
      if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {
        assert(function (el) {
          // Check to see if it's possible to do matchesSelector
          // on a disconnected node (IE 9)
          support.disconnectedMatch = matches.call(el, "*");

          // This should fail with an exception
          // Gecko does not error, returns false instead
          matches.call(el, "[s!='']:x");
          rbuggyMatches.push("!=", pseudos);
        });
      }
      if (!support.cssSupportsSelector) {
        // Support: Chrome 105+, Safari 15.4+
        // `:has()` uses a forgiving selector list as an argument so our regular
        // `try-catch` mechanism fails to catch `:has()` with arguments not supported
        // natively like `:has(:contains("Foo"))`. Where supported & spec-compliant,
        // we now use `CSS.supports("selector(:is(SELECTOR_TO_BE_TESTED))")`, but
        // outside that we mark `:has` as buggy.
        rbuggyQSA.push(":has");
      }
      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

      /* Contains
      ---------------------------------------------------------------------- */
      hasCompare = rnative.test(docElem.compareDocumentPosition);

      // Element contains another
      // Purposefully self-exclusive
      // As in, an element does not contain itself
      contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
        // Support: IE <9 only
        // IE doesn't have `contains` on `document` so we need to check for
        // `documentElement` presence.
        // We need to fall back to `a` when `documentElement` is missing
        // as `ownerDocument` of elements within `<template/>` may have
        // a null one - a default behavior of all modern browsers.
        var adown = a.nodeType === 9 && a.documentElement || a,
          bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
      } : function (a, b) {
        if (b) {
          while (b = b.parentNode) {
            if (b === a) {
              return true;
            }
          }
        }
        return false;
      };

      /* Sorting
      ---------------------------------------------------------------------- */

      // Document order sorting
      sortOrder = hasCompare ? function (a, b) {
        // Flag for duplicate removal
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }

        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) {
          return compare;
        }

        // Calculate position if both inputs belong to the same document
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) :
        // Otherwise we know they are disconnected
        1;

        // Disconnected nodes
        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
          // Choose the first element that is related to our preferred document
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) {
            return -1;
          }

          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) {
            return 1;
          }

          // Maintain original order
          return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
        }
        return compare & 4 ? -1 : 1;
      } : function (a, b) {
        // Exit early if the nodes are identical
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }
        var cur,
          i = 0,
          aup = a.parentNode,
          bup = b.parentNode,
          ap = [a],
          bp = [b];

        // Parentless nodes are either documents or disconnected
        if (!aup || !bup) {
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          /* eslint-disable eqeqeq */
          return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */
          aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;

          // If the nodes are siblings, we can do a quick check
        } else if (aup === bup) {
          return siblingCheck(a, b);
        }

        // Otherwise we need full lists of their ancestors for comparison
        cur = a;
        while (cur = cur.parentNode) {
          ap.unshift(cur);
        }
        cur = b;
        while (cur = cur.parentNode) {
          bp.unshift(cur);
        }

        // Walk down the tree looking for a discrepancy
        while (ap[i] === bp[i]) {
          i++;
        }
        return i ?
        // Do a sibling check if the nodes have a common ancestor
        siblingCheck(ap[i], bp[i]) :
        // Otherwise nodes in our document sort first
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        /* eslint-disable eqeqeq */
        ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */
        0;
      };
      return document;
    };
    Sizzle.matches = function (expr, elements) {
      return Sizzle(expr, null, null, elements);
    };
    Sizzle.matchesSelector = function (elem, expr) {
      setDocument(elem);
      if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
        try {
          var ret = matches.call(elem, expr);

          // IE 9's matchesSelector returns false on disconnected nodes
          if (ret || support.disconnectedMatch ||
          // As well, disconnected nodes are said to be in a document
          // fragment in IE 9
          elem.document && elem.document.nodeType !== 11) {
            return ret;
          }
        } catch (e) {
          nonnativeSelectorCache(expr, true);
        }
      }
      return Sizzle(expr, document, null, [elem]).length > 0;
    };
    Sizzle.contains = function (context, elem) {
      // Set document vars if needed
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if ((context.ownerDocument || context) != document) {
        setDocument(context);
      }
      return contains(context, elem);
    };
    Sizzle.attr = function (elem, name) {
      // Set document vars if needed
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if ((elem.ownerDocument || elem) != document) {
        setDocument(elem);
      }
      var fn = Expr.attrHandle[name.toLowerCase()],
        // Don't get fooled by Object.prototype properties (jQuery #13807)
        val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
    };
    Sizzle.escape = function (sel) {
      return (sel + "").replace(rcssescape, fcssescape);
    };
    Sizzle.error = function (msg) {
      throw new Error("Syntax error, unrecognized expression: " + msg);
    };

    /**
     * Document sorting and removing duplicates
     * @param {ArrayLike} results
     */
    Sizzle.uniqueSort = function (results) {
      var elem,
        duplicates = [],
        j = 0,
        i = 0;

      // Unless we *know* we can detect duplicates, assume their presence
      hasDuplicate = !support.detectDuplicates;
      sortInput = !support.sortStable && results.slice(0);
      results.sort(sortOrder);
      if (hasDuplicate) {
        while (elem = results[i++]) {
          if (elem === results[i]) {
            j = duplicates.push(i);
          }
        }
        while (j--) {
          results.splice(duplicates[j], 1);
        }
      }

      // Clear input after sorting to release objects
      // See https://github.com/jquery/sizzle/pull/225
      sortInput = null;
      return results;
    };

    /**
     * Utility function for retrieving the text value of an array of DOM nodes
     * @param {Array|Element} elem
     */
    getText = Sizzle.getText = function (elem) {
      var node,
        ret = "",
        i = 0,
        nodeType = elem.nodeType;
      if (!nodeType) {
        // If no nodeType, this is expected to be an array
        while (node = elem[i++]) {
          // Do not traverse comment nodes
          ret += getText(node);
        }
      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
        // Use textContent for elements
        // innerText usage removed for consistency of new lines (jQuery #11153)
        if (typeof elem.textContent === "string") {
          return elem.textContent;
        } else {
          // Traverse its children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            ret += getText(elem);
          }
        }
      } else if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      }

      // Do not include comment or processing instruction nodes

      return ret;
    };
    Expr = Sizzle.selectors = {
      // Can be adjusted by the user
      cacheLength: 50,
      createPseudo: markFunction,
      match: matchExpr,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: true
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: true
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        "ATTR": function ATTR(match) {
          match[1] = match[1].replace(runescape, funescape);

          // Move the given value to match[3] whether quoted or unquoted
          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
          if (match[2] === "~=") {
            match[3] = " " + match[3] + " ";
          }
          return match.slice(0, 4);
        },
        "CHILD": function CHILD(match) {
          /* matches from matchExpr["CHILD"]
          	1 type (only|nth|...)
          	2 what (child|of-type)
          	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
          	4 xn-component of xn+y argument ([+-]?\d*n|)
          	5 sign of xn-component
          	6 x of xn-component
          	7 sign of y-component
          	8 y of y-component
          */
          match[1] = match[1].toLowerCase();
          if (match[1].slice(0, 3) === "nth") {
            // nth-* requires argument
            if (!match[3]) {
              Sizzle.error(match[0]);
            }

            // numeric x and y parameters for Expr.filter.CHILD
            // remember that false/true cast respectively to 0/1
            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
            match[5] = +(match[7] + match[8] || match[3] === "odd");

            // other types prohibit arguments
          } else if (match[3]) {
            Sizzle.error(match[0]);
          }
          return match;
        },
        "PSEUDO": function PSEUDO(match) {
          var excess,
            unquoted = !match[6] && match[2];
          if (matchExpr["CHILD"].test(match[0])) {
            return null;
          }

          // Accept quoted arguments as-is
          if (match[3]) {
            match[2] = match[4] || match[5] || "";

            // Strip excess characters from unquoted arguments
          } else if (unquoted && rpseudo.test(unquoted) && (
          // Get excess from tokenize (recursively)
          excess = tokenize(unquoted, true)) && (
          // advance to the next closing parenthesis
          excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
            // excess is a negative index
            match[0] = match[0].slice(0, excess);
            match[2] = unquoted.slice(0, excess);
          }

          // Return only captures needed by the pseudo filter method (type and argument)
          return match.slice(0, 3);
        }
      },
      filter: {
        "TAG": function TAG(nodeNameSelector) {
          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
          return nodeNameSelector === "*" ? function () {
            return true;
          } : function (elem) {
            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
          };
        },
        "CLASS": function CLASS(className) {
          var pattern = classCache[className + " "];
          return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
            return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
          });
        },
        "ATTR": function ATTR(name, operator, check) {
          return function (elem) {
            var result = Sizzle.attr(elem, name);
            if (result == null) {
              return operator === "!=";
            }
            if (!operator) {
              return true;
            }
            result += "";

            /* eslint-disable max-len */

            return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
            /* eslint-enable max-len */
          };
        },

        "CHILD": function CHILD(type, what, _argument, first, last) {
          var simple = type.slice(0, 3) !== "nth",
            forward = type.slice(-4) !== "last",
            ofType = what === "of-type";
          return first === 1 && last === 0 ?
          // Shortcut for :nth-*(n)
          function (elem) {
            return !!elem.parentNode;
          } : function (elem, _context, xml) {
            var cache,
              uniqueCache,
              outerCache,
              node,
              nodeIndex,
              start,
              dir = simple !== forward ? "nextSibling" : "previousSibling",
              parent = elem.parentNode,
              name = ofType && elem.nodeName.toLowerCase(),
              useCache = !xml && !ofType,
              diff = false;
            if (parent) {
              // :(first|last|only)-(child|of-type)
              if (simple) {
                while (dir) {
                  node = elem;
                  while (node = node[dir]) {
                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                      return false;
                    }
                  }

                  // Reverse direction for :only-* (if we haven't yet done so)
                  start = dir = type === "only" && !start && "nextSibling";
                }
                return true;
              }
              start = [forward ? parent.firstChild : parent.lastChild];

              // non-xml :nth-child(...) stores cache data on `parent`
              if (forward && useCache) {
                // Seek `elem` from a previously-cached index

                // ...in a gzip-friendly way
                node = parent;
                outerCache = node[expando] || (node[expando] = {});

                // Support: IE <9 only
                // Defend against cloned attroperties (jQuery gh-1709)
                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                cache = uniqueCache[type] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = nodeIndex && cache[2];
                node = nodeIndex && parent.childNodes[nodeIndex];
                while (node = ++nodeIndex && node && node[dir] || (
                // Fallback to seeking `elem` from the start
                diff = nodeIndex = 0) || start.pop()) {
                  // When found, cache indexes on `parent` and break
                  if (node.nodeType === 1 && ++diff && node === elem) {
                    uniqueCache[type] = [dirruns, nodeIndex, diff];
                    break;
                  }
                }
              } else {
                // Use previously-cached element index if available
                if (useCache) {
                  // ...in a gzip-friendly way
                  node = elem;
                  outerCache = node[expando] || (node[expando] = {});

                  // Support: IE <9 only
                  // Defend against cloned attroperties (jQuery gh-1709)
                  uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                  cache = uniqueCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = nodeIndex;
                }

                // xml :nth-child(...)
                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                if (diff === false) {
                  // Use the same loop as above to seek `elem` from the start
                  while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                    if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                      // Cache the index of each encountered element
                      if (useCache) {
                        outerCache = node[expando] || (node[expando] = {});

                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                        uniqueCache[type] = [dirruns, diff];
                      }
                      if (node === elem) {
                        break;
                      }
                    }
                  }
                }
              }

              // Incorporate the offset, then check against cycle size
              diff -= last;
              return diff === first || diff % first === 0 && diff / first >= 0;
            }
          };
        },
        "PSEUDO": function PSEUDO(pseudo, argument) {
          // pseudo-class names are case-insensitive
          // http://www.w3.org/TR/selectors/#pseudo-classes
          // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
          // Remember that setFilters inherits from pseudos
          var args,
            fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);

          // The user may use createPseudo to indicate that
          // arguments are needed to create the filter function
          // just as Sizzle does
          if (fn[expando]) {
            return fn(argument);
          }

          // But maintain support for old signatures
          if (fn.length > 1) {
            args = [pseudo, pseudo, "", argument];
            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
              var idx,
                matched = fn(seed, argument),
                i = matched.length;
              while (i--) {
                idx = indexOf(seed, matched[i]);
                seed[idx] = !(matches[idx] = matched[i]);
              }
            }) : function (elem) {
              return fn(elem, 0, args);
            };
          }
          return fn;
        }
      },
      pseudos: {
        // Potentially complex pseudos
        "not": markFunction(function (selector) {
          // Trim the selector passed to compile
          // to avoid treating leading and trailing
          // spaces as combinators
          var input = [],
            results = [],
            matcher = compile(selector.replace(rtrim, "$1"));
          return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
            var elem,
              unmatched = matcher(seed, null, xml, []),
              i = seed.length;

            // Match elements unmatched by `matcher`
            while (i--) {
              if (elem = unmatched[i]) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) : function (elem, _context, xml) {
            input[0] = elem;
            matcher(input, null, xml, results);

            // Don't keep the element (issue #299)
            input[0] = null;
            return !results.pop();
          };
        }),
        "has": markFunction(function (selector) {
          return function (elem) {
            return Sizzle(selector, elem).length > 0;
          };
        }),
        "contains": markFunction(function (text) {
          text = text.replace(runescape, funescape);
          return function (elem) {
            return (elem.textContent || getText(elem)).indexOf(text) > -1;
          };
        }),
        // "Whether an element is represented by a :lang() selector
        // is based solely on the element's language value
        // being equal to the identifier C,
        // or beginning with the identifier C immediately followed by "-".
        // The matching of C against the element's language value is performed case-insensitively.
        // The identifier C does not have to be a valid language name."
        // http://www.w3.org/TR/selectors/#lang-pseudo
        "lang": markFunction(function (lang) {
          // lang value must be a valid identifier
          if (!ridentifier.test(lang || "")) {
            Sizzle.error("unsupported lang: " + lang);
          }
          lang = lang.replace(runescape, funescape).toLowerCase();
          return function (elem) {
            var elemLang;
            do {
              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                elemLang = elemLang.toLowerCase();
                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
              }
            } while ((elem = elem.parentNode) && elem.nodeType === 1);
            return false;
          };
        }),
        // Miscellaneous
        "target": function target(elem) {
          var hash = window.location && window.location.hash;
          return hash && hash.slice(1) === elem.id;
        },
        "root": function root(elem) {
          return elem === docElem;
        },
        "focus": function focus(elem) {
          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
        },
        // Boolean properties
        "enabled": createDisabledPseudo(false),
        "disabled": createDisabledPseudo(true),
        "checked": function checked(elem) {
          // In CSS3, :checked should return both checked and selected elements
          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
          var nodeName = elem.nodeName.toLowerCase();
          return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
        },
        "selected": function selected(elem) {
          // Accessing this property makes selected-by-default
          // options in Safari work properly
          if (elem.parentNode) {
            // eslint-disable-next-line no-unused-expressions
            elem.parentNode.selectedIndex;
          }
          return elem.selected === true;
        },
        // Contents
        "empty": function empty(elem) {
          // http://www.w3.org/TR/selectors/#empty-pseudo
          // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
          //   but not by others (comment: 8; processing instruction: 7; etc.)
          // nodeType < 6 works because attributes (2) do not appear as children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            if (elem.nodeType < 6) {
              return false;
            }
          }
          return true;
        },
        "parent": function parent(elem) {
          return !Expr.pseudos["empty"](elem);
        },
        // Element/input types
        "header": function header(elem) {
          return rheader.test(elem.nodeName);
        },
        "input": function input(elem) {
          return rinputs.test(elem.nodeName);
        },
        "button": function button(elem) {
          var name = elem.nodeName.toLowerCase();
          return name === "input" && elem.type === "button" || name === "button";
        },
        "text": function text(elem) {
          var attr;
          return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && (
          // Support: IE <10 only
          // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
          (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
        },
        // Position-in-collection
        "first": createPositionalPseudo(function () {
          return [0];
        }),
        "last": createPositionalPseudo(function (_matchIndexes, length) {
          return [length - 1];
        }),
        "eq": createPositionalPseudo(function (_matchIndexes, length, argument) {
          return [argument < 0 ? argument + length : argument];
        }),
        "even": createPositionalPseudo(function (matchIndexes, length) {
          var i = 0;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "odd": createPositionalPseudo(function (matchIndexes, length) {
          var i = 1;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "lt": createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument > length ? length : argument;
          for (; --i >= 0;) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "gt": createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; ++i < length;) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        })
      }
    };
    Expr.pseudos["nth"] = Expr.pseudos["eq"];

    // Add button/input type pseudos
    for (i in {
      radio: true,
      checkbox: true,
      file: true,
      password: true,
      image: true
    }) {
      Expr.pseudos[i] = createInputPseudo(i);
    }
    for (i in {
      submit: true,
      reset: true
    }) {
      Expr.pseudos[i] = createButtonPseudo(i);
    }

    // Easy API for creating new setFilters
    function setFilters() {}
    setFilters.prototype = Expr.filters = Expr.pseudos;
    Expr.setFilters = new setFilters();
    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
      var matched,
        match,
        tokens,
        type,
        soFar,
        groups,
        preFilters,
        cached = tokenCache[selector + " "];
      if (cached) {
        return parseOnly ? 0 : cached.slice(0);
      }
      soFar = selector;
      groups = [];
      preFilters = Expr.preFilter;
      while (soFar) {
        // Comma and first run
        if (!matched || (match = rcomma.exec(soFar))) {
          if (match) {
            // Don't consume trailing commas as valid
            soFar = soFar.slice(match[0].length) || soFar;
          }
          groups.push(tokens = []);
        }
        matched = false;

        // Combinators
        if (match = rcombinators.exec(soFar)) {
          matched = match.shift();
          tokens.push({
            value: matched,
            // Cast descendant combinators to space
            type: match[0].replace(rtrim, " ")
          });
          soFar = soFar.slice(matched.length);
        }

        // Filters
        for (type in Expr.filter) {
          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: type,
              matches: match
            });
            soFar = soFar.slice(matched.length);
          }
        }
        if (!matched) {
          break;
        }
      }

      // Return the length of the invalid excess
      // if we're just parsing
      // Otherwise, throw an error or return tokens
      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) :
      // Cache the tokens
      tokenCache(selector, groups).slice(0);
    };
    function toSelector(tokens) {
      var i = 0,
        len = tokens.length,
        selector = "";
      for (; i < len; i++) {
        selector += tokens[i].value;
      }
      return selector;
    }
    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir,
        skip = combinator.next,
        key = skip || dir,
        checkNonElements = base && key === "parentNode",
        doneName = done++;
      return combinator.first ?
      // Check against closest ancestor/preceding element
      function (elem, context, xml) {
        while (elem = elem[dir]) {
          if (elem.nodeType === 1 || checkNonElements) {
            return matcher(elem, context, xml);
          }
        }
        return false;
      } :
      // Check against all ancestor/preceding elements
      function (elem, context, xml) {
        var oldCache,
          uniqueCache,
          outerCache,
          newCache = [dirruns, doneName];

        // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
        if (xml) {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              if (matcher(elem, context, xml)) {
                return true;
              }
            }
          }
        } else {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              outerCache = elem[expando] || (elem[expando] = {});

              // Support: IE <9 only
              // Defend against cloned attroperties (jQuery gh-1709)
              uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
              if (skip && skip === elem.nodeName.toLowerCase()) {
                elem = elem[dir] || elem;
              } else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                // Assign to newCache so results back-propagate to previous elements
                return newCache[2] = oldCache[2];
              } else {
                // Reuse newcache so results back-propagate to previous elements
                uniqueCache[key] = newCache;

                // A match means we're done; a fail means we have to keep checking
                if (newCache[2] = matcher(elem, context, xml)) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      };
    }
    function elementMatcher(matchers) {
      return matchers.length > 1 ? function (elem, context, xml) {
        var i = matchers.length;
        while (i--) {
          if (!matchers[i](elem, context, xml)) {
            return false;
          }
        }
        return true;
      } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
      var i = 0,
        len = contexts.length;
      for (; i < len; i++) {
        Sizzle(selector, contexts[i], results);
      }
      return results;
    }
    function condense(unmatched, map, filter, context, xml) {
      var elem,
        newUnmatched = [],
        i = 0,
        len = unmatched.length,
        mapped = map != null;
      for (; i < len; i++) {
        if (elem = unmatched[i]) {
          if (!filter || filter(elem, context, xml)) {
            newUnmatched.push(elem);
            if (mapped) {
              map.push(i);
            }
          }
        }
      }
      return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
      if (postFilter && !postFilter[expando]) {
        postFilter = setMatcher(postFilter);
      }
      if (postFinder && !postFinder[expando]) {
        postFinder = setMatcher(postFinder, postSelector);
      }
      return markFunction(function (seed, results, context, xml) {
        var temp,
          i,
          elem,
          preMap = [],
          postMap = [],
          preexisting = results.length,
          // Get initial elements from seed or context
          elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
          // Prefilter to get matcher input, preserving a map for seed-results synchronization
          matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
          matcherOut = matcher ?
          // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
          postFinder || (seed ? preFilter : preexisting || postFilter) ?
          // ...intermediate processing is necessary
          [] :
          // ...otherwise use results directly
          results : matcherIn;

        // Find primary matches
        if (matcher) {
          matcher(matcherIn, matcherOut, context, xml);
        }

        // Apply postFilter
        if (postFilter) {
          temp = condense(matcherOut, postMap);
          postFilter(temp, [], context, xml);

          // Un-match failing elements by moving them back to matcherIn
          i = temp.length;
          while (i--) {
            if (elem = temp[i]) {
              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
          }
        }
        if (seed) {
          if (postFinder || preFilter) {
            if (postFinder) {
              // Get the final matcherOut by condensing this intermediate into postFinder contexts
              temp = [];
              i = matcherOut.length;
              while (i--) {
                if (elem = matcherOut[i]) {
                  // Restore matcherIn since elem is not yet a final match
                  temp.push(matcherIn[i] = elem);
                }
              }
              postFinder(null, matcherOut = [], temp, xml);
            }

            // Move matched elements from seed to results to keep them synchronized
            i = matcherOut.length;
            while (i--) {
              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                seed[temp] = !(results[temp] = elem);
              }
            }
          }

          // Add elements to results, through postFinder if defined
        } else {
          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
          if (postFinder) {
            postFinder(null, results, matcherOut, xml);
          } else {
            push.apply(results, matcherOut);
          }
        }
      });
    }
    function matcherFromTokens(tokens) {
      var checkContext,
        matcher,
        j,
        len = tokens.length,
        leadingRelative = Expr.relative[tokens[0].type],
        implicitRelative = leadingRelative || Expr.relative[" "],
        i = leadingRelative ? 1 : 0,
        // The foundational matcher ensures that elements are reachable from top-level context(s)
        matchContext = addCombinator(function (elem) {
          return elem === checkContext;
        }, implicitRelative, true),
        matchAnyContext = addCombinator(function (elem) {
          return indexOf(checkContext, elem) > -1;
        }, implicitRelative, true),
        matchers = [function (elem, context, xml) {
          var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));

          // Avoid hanging onto element (issue #299)
          checkContext = null;
          return ret;
        }];
      for (; i < len; i++) {
        if (matcher = Expr.relative[tokens[i].type]) {
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        } else {
          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

          // Return special upon seeing a positional matcher
          if (matcher[expando]) {
            // Find the next relative operator (if any) for proper handling
            j = ++i;
            for (; j < len; j++) {
              if (Expr.relative[tokens[j].type]) {
                break;
              }
            }
            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
            // If the preceding token was a descendant combinator, insert an implicit any-element `*`
            tokens.slice(0, i - 1).concat({
              value: tokens[i - 2].type === " " ? "*" : ""
            })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
          }
          matchers.push(matcher);
        }
      }
      return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0,
        byElement = elementMatchers.length > 0,
        superMatcher = function superMatcher(seed, context, xml, results, outermost) {
          var elem,
            j,
            matcher,
            matchedCount = 0,
            i = "0",
            unmatched = seed && [],
            setMatched = [],
            contextBackup = outermostContext,
            // We must always have either seed elements or outermost context
            elems = seed || byElement && Expr.find["TAG"]("*", outermost),
            // Use integer dirruns iff this is the outermost matcher
            dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
            len = elems.length;
          if (outermost) {
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            outermostContext = context == document || context || outermost;
          }

          // Add elements passing elementMatchers directly to results
          // Support: IE<9, Safari
          // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
          for (; i !== len && (elem = elems[i]) != null; i++) {
            if (byElement && elem) {
              j = 0;

              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if (!context && elem.ownerDocument != document) {
                setDocument(elem);
                xml = !documentIsHTML;
              }
              while (matcher = elementMatchers[j++]) {
                if (matcher(elem, context || document, xml)) {
                  results.push(elem);
                  break;
                }
              }
              if (outermost) {
                dirruns = dirrunsUnique;
              }
            }

            // Track unmatched elements for set filters
            if (bySet) {
              // They will have gone through all possible matchers
              if (elem = !matcher && elem) {
                matchedCount--;
              }

              // Lengthen the array for every element, matched or not
              if (seed) {
                unmatched.push(elem);
              }
            }
          }

          // `i` is now the count of elements visited above, and adding it to `matchedCount`
          // makes the latter nonnegative.
          matchedCount += i;

          // Apply set filters to unmatched elements
          // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
          // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
          // no element matchers and no seed.
          // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
          // case, which will result in a "00" `matchedCount` that differs from `i` but is also
          // numerically zero.
          if (bySet && i !== matchedCount) {
            j = 0;
            while (matcher = setMatchers[j++]) {
              matcher(unmatched, setMatched, context, xml);
            }
            if (seed) {
              // Reintegrate element matches to eliminate the need for sorting
              if (matchedCount > 0) {
                while (i--) {
                  if (!(unmatched[i] || setMatched[i])) {
                    setMatched[i] = pop.call(results);
                  }
                }
              }

              // Discard index placeholder values to get only actual matches
              setMatched = condense(setMatched);
            }

            // Add matches to results
            push.apply(results, setMatched);

            // Seedless set matches succeeding multiple successful matchers stipulate sorting
            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
              Sizzle.uniqueSort(results);
            }
          }

          // Override manipulation of globals by nested matchers
          if (outermost) {
            dirruns = dirrunsUnique;
            outermostContext = contextBackup;
          }
          return unmatched;
        };
      return bySet ? markFunction(superMatcher) : superMatcher;
    }
    compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
      var i,
        setMatchers = [],
        elementMatchers = [],
        cached = compilerCache[selector + " "];
      if (!cached) {
        // Generate a function of recursive functions that can be used to check each element
        if (!match) {
          match = tokenize(selector);
        }
        i = match.length;
        while (i--) {
          cached = matcherFromTokens(match[i]);
          if (cached[expando]) {
            setMatchers.push(cached);
          } else {
            elementMatchers.push(cached);
          }
        }

        // Cache the compiled function
        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

        // Save selector and tokenization
        cached.selector = selector;
      }
      return cached;
    };

    /**
     * A low-level selection function that works with Sizzle's compiled
     *  selector functions
     * @param {String|Function} selector A selector or a pre-compiled
     *  selector function built with Sizzle.compile
     * @param {Element} context
     * @param {Array} [results]
     * @param {Array} [seed] A set of elements to match against
     */
    select = Sizzle.select = function (selector, context, results, seed) {
      var i,
        tokens,
        token,
        type,
        find,
        compiled = typeof selector === "function" && selector,
        match = !seed && tokenize(selector = compiled.selector || selector);
      results = results || [];

      // Try to minimize operations if there is only one selector in the list and no seed
      // (the latter of which guarantees us context)
      if (match.length === 1) {
        // Reduce context if the leading compound selector is an ID
        tokens = match[0] = match[0].slice(0);
        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
          context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
          if (!context) {
            return results;

            // Precompiled matchers will still verify ancestry, so step up a level
          } else if (compiled) {
            context = context.parentNode;
          }
          selector = selector.slice(tokens.shift().value.length);
        }

        // Fetch a seed set for right-to-left matching
        i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
        while (i--) {
          token = tokens[i];

          // Abort if we hit a combinator
          if (Expr.relative[type = token.type]) {
            break;
          }
          if (find = Expr.find[type]) {
            // Search, expanding context for leading sibling combinators
            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
              // If seed is empty or no tokens remain, we can return early
              tokens.splice(i, 1);
              selector = seed.length && toSelector(tokens);
              if (!selector) {
                push.apply(results, seed);
                return results;
              }
              break;
            }
          }
        }
      }

      // Compile and execute a filtering function if one is not provided
      // Provide `match` to avoid retokenization if we modified the selector above
      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
      return results;
    };

    // One-time assignments

    // Sort stability
    support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

    // Support: Chrome 14-35+
    // Always assume duplicates if they aren't passed to the comparison function
    support.detectDuplicates = !!hasDuplicate;

    // Initialize against the default document
    setDocument();

    // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
    // Detached nodes confoundingly follow *each other*
    support.sortDetached = assert(function (el) {
      // Should return 1, but returns 4 (following)
      return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
    });

    // Support: IE<8
    // Prevent attribute/property "interpolation"
    // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
    if (!assert(function (el) {
      el.innerHTML = "<a href='#'></a>";
      return el.firstChild.getAttribute("href") === "#";
    })) {
      addHandle("type|href|height|width", function (elem, name, isXML) {
        if (!isXML) {
          return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        }
      });
    }

    // Support: IE<9
    // Use defaultValue in place of getAttribute("value")
    if (!support.attributes || !assert(function (el) {
      el.innerHTML = "<input/>";
      el.firstChild.setAttribute("value", "");
      return el.firstChild.getAttribute("value") === "";
    })) {
      addHandle("value", function (elem, _name, isXML) {
        if (!isXML && elem.nodeName.toLowerCase() === "input") {
          return elem.defaultValue;
        }
      });
    }

    // Support: IE<9
    // Use getAttributeNode to fetch booleans when getAttribute lies
    if (!assert(function (el) {
      return el.getAttribute("disabled") == null;
    })) {
      addHandle(booleans, function (elem, name, isXML) {
        var val;
        if (!isXML) {
          return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        }
      });
    }
    return Sizzle;
  }(window);
  jQuery.find = Sizzle;
  jQuery.expr = Sizzle.selectors;

  // Deprecated
  jQuery.expr[":"] = jQuery.expr.pseudos;
  jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
  jQuery.text = Sizzle.getText;
  jQuery.isXMLDoc = Sizzle.isXML;
  jQuery.contains = Sizzle.contains;
  jQuery.escapeSelector = Sizzle.escape;
  var dir = function dir(elem, _dir, until) {
    var matched = [],
      truncate = until !== undefined;
    while ((elem = elem[_dir]) && elem.nodeType !== 9) {
      if (elem.nodeType === 1) {
        if (truncate && jQuery(elem).is(until)) {
          break;
        }
        matched.push(elem);
      }
    }
    return matched;
  };
  var _siblings = function siblings(n, elem) {
    var matched = [];
    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== elem) {
        matched.push(n);
      }
    }
    return matched;
  };
  var rneedsContext = jQuery.expr.match.needsContext;
  function nodeName(elem, name) {
    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
  }
  var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

  // Implement the identical functionality for filter and not
  function winnow(elements, qualifier, not) {
    if (isFunction(qualifier)) {
      return jQuery.grep(elements, function (elem, i) {
        return !!qualifier.call(elem, i, elem) !== not;
      });
    }

    // Single element
    if (qualifier.nodeType) {
      return jQuery.grep(elements, function (elem) {
        return elem === qualifier !== not;
      });
    }

    // Arraylike of elements (jQuery, arguments, Array)
    if (typeof qualifier !== "string") {
      return jQuery.grep(elements, function (elem) {
        return indexOf.call(qualifier, elem) > -1 !== not;
      });
    }

    // Filtered directly for both simple and complex selectors
    return jQuery.filter(qualifier, elements, not);
  }
  jQuery.filter = function (expr, elems, not) {
    var elem = elems[0];
    if (not) {
      expr = ":not(" + expr + ")";
    }
    if (elems.length === 1 && elem.nodeType === 1) {
      return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
    }
    return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
      return elem.nodeType === 1;
    }));
  };
  jQuery.fn.extend({
    find: function find(selector) {
      var i,
        ret,
        len = this.length,
        self = this;
      if (typeof selector !== "string") {
        return this.pushStack(jQuery(selector).filter(function () {
          for (i = 0; i < len; i++) {
            if (jQuery.contains(self[i], this)) {
              return true;
            }
          }
        }));
      }
      ret = this.pushStack([]);
      for (i = 0; i < len; i++) {
        jQuery.find(selector, self[i], ret);
      }
      return len > 1 ? jQuery.uniqueSort(ret) : ret;
    },
    filter: function filter(selector) {
      return this.pushStack(winnow(this, selector || [], false));
    },
    not: function not(selector) {
      return this.pushStack(winnow(this, selector || [], true));
    },
    is: function is(selector) {
      return !!winnow(this,
      // If this is a positional/relative selector, check membership in the returned set
      // so $("p:first").is("p:last") won't return true for a doc with two "p".
      typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
    }
  });

  // Initialize a jQuery object

  // A central reference to the root jQuery(document)
  var rootjQuery,
    // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
    init = jQuery.fn.init = function (selector, context, root) {
      var match, elem;

      // HANDLE: $(""), $(null), $(undefined), $(false)
      if (!selector) {
        return this;
      }

      // Method init() accepts an alternate rootjQuery
      // so migrate can support jQuery.sub (gh-2101)
      root = root || rootjQuery;

      // Handle HTML strings
      if (typeof selector === "string") {
        if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
          // Assume that strings that start and end with <> are HTML and skip the regex check
          match = [null, selector, null];
        } else {
          match = rquickExpr.exec(selector);
        }

        // Match html or make sure no context is specified for #id
        if (match && (match[1] || !context)) {
          // HANDLE: $(html) -> $(array)
          if (match[1]) {
            context = context instanceof jQuery ? context[0] : context;

            // Option to run scripts is true for back-compat
            // Intentionally let the error be thrown if parseHTML is not present
            jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

            // HANDLE: $(html, props)
            if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
              for (match in context) {
                // Properties of context are called as methods if possible
                if (isFunction(this[match])) {
                  this[match](context[match]);

                  // ...and otherwise set as attributes
                } else {
                  this.attr(match, context[match]);
                }
              }
            }
            return this;

            // HANDLE: $(#id)
          } else {
            elem = document.getElementById(match[2]);
            if (elem) {
              // Inject the element directly into the jQuery object
              this[0] = elem;
              this.length = 1;
            }
            return this;
          }

          // HANDLE: $(expr, $(...))
        } else if (!context || context.jquery) {
          return (context || root).find(selector);

          // HANDLE: $(expr, context)
          // (which is just equivalent to: $(context).find(expr)
        } else {
          return this.constructor(context).find(selector);
        }

        // HANDLE: $(DOMElement)
      } else if (selector.nodeType) {
        this[0] = selector;
        this.length = 1;
        return this;

        // HANDLE: $(function)
        // Shortcut for document ready
      } else if (isFunction(selector)) {
        return root.ready !== undefined ? root.ready(selector) :
        // Execute immediately if ready is not present
        selector(jQuery);
      }
      return jQuery.makeArray(selector, this);
    };

  // Give the init function the jQuery prototype for later instantiation
  init.prototype = jQuery.fn;

  // Initialize central reference
  rootjQuery = jQuery(document);
  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
    // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
      children: true,
      contents: true,
      next: true,
      prev: true
    };
  jQuery.fn.extend({
    has: function has(target) {
      var targets = jQuery(target, this),
        l = targets.length;
      return this.filter(function () {
        var i = 0;
        for (; i < l; i++) {
          if (jQuery.contains(this, targets[i])) {
            return true;
          }
        }
      });
    },
    closest: function closest(selectors, context) {
      var cur,
        i = 0,
        l = this.length,
        matched = [],
        targets = typeof selectors !== "string" && jQuery(selectors);

      // Positional selectors never match, since there's no _selection_ context
      if (!rneedsContext.test(selectors)) {
        for (; i < l; i++) {
          for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
            // Always skip document fragments
            if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :
            // Don't pass non-elements to Sizzle
            cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
              matched.push(cur);
              break;
            }
          }
        }
      }
      return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
    },
    // Determine the position of an element within the set
    index: function index(elem) {
      // No argument, return index in parent
      if (!elem) {
        return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      }

      // Index in selector
      if (typeof elem === "string") {
        return indexOf.call(jQuery(elem), this[0]);
      }

      // Locate the position of the desired element
      return indexOf.call(this,
      // If it receives a jQuery object, the first element is used
      elem.jquery ? elem[0] : elem);
    },
    add: function add(selector, context) {
      return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
    },
    addBack: function addBack(selector) {
      return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
    }
  });
  function sibling(cur, dir) {
    while ((cur = cur[dir]) && cur.nodeType !== 1) {}
    return cur;
  }
  jQuery.each({
    parent: function parent(elem) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function parents(elem) {
      return dir(elem, "parentNode");
    },
    parentsUntil: function parentsUntil(elem, _i, until) {
      return dir(elem, "parentNode", until);
    },
    next: function next(elem) {
      return sibling(elem, "nextSibling");
    },
    prev: function prev(elem) {
      return sibling(elem, "previousSibling");
    },
    nextAll: function nextAll(elem) {
      return dir(elem, "nextSibling");
    },
    prevAll: function prevAll(elem) {
      return dir(elem, "previousSibling");
    },
    nextUntil: function nextUntil(elem, _i, until) {
      return dir(elem, "nextSibling", until);
    },
    prevUntil: function prevUntil(elem, _i, until) {
      return dir(elem, "previousSibling", until);
    },
    siblings: function siblings(elem) {
      return _siblings((elem.parentNode || {}).firstChild, elem);
    },
    children: function children(elem) {
      return _siblings(elem.firstChild);
    },
    contents: function contents(elem) {
      if (elem.contentDocument != null &&
      // Support: IE 11+
      // <object> elements with no `data` attribute has an object
      // `contentDocument` with a `null` prototype.
      getProto(elem.contentDocument)) {
        return elem.contentDocument;
      }

      // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
      // Treat the template element as a regular one in browsers that
      // don't support it.
      if (nodeName(elem, "template")) {
        elem = elem.content || elem;
      }
      return jQuery.merge([], elem.childNodes);
    }
  }, function (name, fn) {
    jQuery.fn[name] = function (until, selector) {
      var matched = jQuery.map(this, fn, until);
      if (name.slice(-5) !== "Until") {
        selector = until;
      }
      if (selector && typeof selector === "string") {
        matched = jQuery.filter(selector, matched);
      }
      if (this.length > 1) {
        // Remove duplicates
        if (!guaranteedUnique[name]) {
          jQuery.uniqueSort(matched);
        }

        // Reverse order for parents* and prev-derivatives
        if (rparentsprev.test(name)) {
          matched.reverse();
        }
      }
      return this.pushStack(matched);
    };
  });
  var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

  // Convert String-formatted options into Object-formatted ones
  function createOptions(options) {
    var object = {};
    jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
      object[flag] = true;
    });
    return object;
  }

  /*
   * Create a callback list using the following parameters:
   *
   *	options: an optional list of space-separated options that will change how
   *			the callback list behaves or a more traditional option object
   *
   * By default a callback list will act like an event callback list and can be
   * "fired" multiple times.
   *
   * Possible options:
   *
   *	once:			will ensure the callback list can only be fired once (like a Deferred)
   *
   *	memory:			will keep track of previous values and will call any callback added
   *					after the list has been fired right away with the latest "memorized"
   *					values (like a Deferred)
   *
   *	unique:			will ensure a callback can only be added once (no duplicate in the list)
   *
   *	stopOnFalse:	interrupt callings when a callback returns false
   *
   */
  jQuery.Callbacks = function (options) {
    // Convert options from String-formatted to Object-formatted if needed
    // (we check in cache first)
    options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
    var
      // Flag to know if list is currently firing
      firing,
      // Last fire value for non-forgettable lists
      memory,
      // Flag to know if list was already fired
      _fired,
      // Flag to prevent firing
      _locked,
      // Actual callback list
      list = [],
      // Queue of execution data for repeatable lists
      queue = [],
      // Index of currently firing callback (modified by add/remove as needed)
      firingIndex = -1,
      // Fire callbacks
      fire = function fire() {
        // Enforce single-firing
        _locked = _locked || options.once;

        // Execute callbacks for all pending executions,
        // respecting firingIndex overrides and runtime changes
        _fired = firing = true;
        for (; queue.length; firingIndex = -1) {
          memory = queue.shift();
          while (++firingIndex < list.length) {
            // Run callback and check for early termination
            if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
              // Jump to end and forget the data so .add doesn't re-fire
              firingIndex = list.length;
              memory = false;
            }
          }
        }

        // Forget the data if we're done with it
        if (!options.memory) {
          memory = false;
        }
        firing = false;

        // Clean up if we're done firing for good
        if (_locked) {
          // Keep an empty list if we have data for future add calls
          if (memory) {
            list = [];

            // Otherwise, this object is spent
          } else {
            list = "";
          }
        }
      },
      // Actual Callbacks object
      self = {
        // Add a callback or a collection of callbacks to the list
        add: function add() {
          if (list) {
            // If we have memory from a past run, we should fire after adding
            if (memory && !firing) {
              firingIndex = list.length - 1;
              queue.push(memory);
            }
            (function add(args) {
              jQuery.each(args, function (_, arg) {
                if (isFunction(arg)) {
                  if (!options.unique || !self.has(arg)) {
                    list.push(arg);
                  }
                } else if (arg && arg.length && toType(arg) !== "string") {
                  // Inspect recursively
                  add(arg);
                }
              });
            })(arguments);
            if (memory && !firing) {
              fire();
            }
          }
          return this;
        },
        // Remove a callback from the list
        remove: function remove() {
          jQuery.each(arguments, function (_, arg) {
            var index;
            while ((index = jQuery.inArray(arg, list, index)) > -1) {
              list.splice(index, 1);

              // Handle firing indexes
              if (index <= firingIndex) {
                firingIndex--;
              }
            }
          });
          return this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function has(fn) {
          return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
        },
        // Remove all callbacks from the list
        empty: function empty() {
          if (list) {
            list = [];
          }
          return this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function disable() {
          _locked = queue = [];
          list = memory = "";
          return this;
        },
        disabled: function disabled() {
          return !list;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function lock() {
          _locked = queue = [];
          if (!memory && !firing) {
            list = memory = "";
          }
          return this;
        },
        locked: function locked() {
          return !!_locked;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function fireWith(context, args) {
          if (!_locked) {
            args = args || [];
            args = [context, args.slice ? args.slice() : args];
            queue.push(args);
            if (!firing) {
              fire();
            }
          }
          return this;
        },
        // Call all the callbacks with the given arguments
        fire: function fire() {
          self.fireWith(this, arguments);
          return this;
        },
        // To know if the callbacks have already been called at least once
        fired: function fired() {
          return !!_fired;
        }
      };
    return self;
  };
  function Identity(v) {
    return v;
  }
  function Thrower(ex) {
    throw ex;
  }
  function adoptValue(value, resolve, reject, noValue) {
    var method;
    try {
      // Check for promise aspect first to privilege synchronous behavior
      if (value && isFunction(method = value.promise)) {
        method.call(value).done(resolve).fail(reject);

        // Other thenables
      } else if (value && isFunction(method = value.then)) {
        method.call(value, resolve, reject);

        // Other non-thenables
      } else {
        // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
        // * false: [ value ].slice( 0 ) => resolve( value )
        // * true: [ value ].slice( 1 ) => resolve()
        resolve.apply(undefined, [value].slice(noValue));
      }

      // For Promises/A+, convert exceptions into rejections
      // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
      // Deferred#then to conditionally suppress rejection.
    } catch (value) {
      // Support: Android 4.0 only
      // Strict mode functions invoked without .call/.apply get global-object context
      reject.apply(undefined, [value]);
    }
  }
  jQuery.extend({
    Deferred: function Deferred(func) {
      var tuples = [
        // action, add listener, callbacks,
        // ... .then handlers, argument index, [final state]
        ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
        _state = "pending",
        _promise = {
          state: function state() {
            return _state;
          },
          always: function always() {
            deferred.done(arguments).fail(arguments);
            return this;
          },
          "catch": function _catch(fn) {
            return _promise.then(null, fn);
          },
          // Keep pipe for back-compat
          pipe: function pipe( /* fnDone, fnFail, fnProgress */
          ) {
            var fns = arguments;
            return jQuery.Deferred(function (newDefer) {
              jQuery.each(tuples, function (_i, tuple) {
                // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                // deferred.progress(function() { bind to newDefer or newDefer.notify })
                // deferred.done(function() { bind to newDefer or newDefer.resolve })
                // deferred.fail(function() { bind to newDefer or newDefer.reject })
                deferred[tuple[1]](function () {
                  var returned = fn && fn.apply(this, arguments);
                  if (returned && isFunction(returned.promise)) {
                    returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                  } else {
                    newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
                  }
                });
              });
              fns = null;
            }).promise();
          },
          then: function then(onFulfilled, onRejected, onProgress) {
            var maxDepth = 0;
            function resolve(depth, deferred, handler, special) {
              return function () {
                var that = this,
                  args = arguments,
                  mightThrow = function mightThrow() {
                    var returned, then;

                    // Support: Promises/A+ section 2.3.3.3.3
                    // https://promisesaplus.com/#point-59
                    // Ignore double-resolution attempts
                    if (depth < maxDepth) {
                      return;
                    }
                    returned = handler.apply(that, args);

                    // Support: Promises/A+ section 2.3.1
                    // https://promisesaplus.com/#point-48
                    if (returned === deferred.promise()) {
                      throw new TypeError("Thenable self-resolution");
                    }

                    // Support: Promises/A+ sections 2.3.3.1, 3.5
                    // https://promisesaplus.com/#point-54
                    // https://promisesaplus.com/#point-75
                    // Retrieve `then` only once
                    then = returned && (
                    // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    (0, _typeof2["default"])(returned) === "object" || typeof returned === "function") && returned.then;

                    // Handle a returned thenable
                    if (isFunction(then)) {
                      // Special processors (notify) just wait for resolution
                      if (special) {
                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

                        // Normal processors (resolve) also hook into progress
                      } else {
                        // ...and disregard older resolution values
                        maxDepth++;
                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                      }

                      // Handle all other returned values
                    } else {
                      // Only substitute handlers pass on context
                      // and multiple values (non-spec behavior)
                      if (handler !== Identity) {
                        that = undefined;
                        args = [returned];
                      }

                      // Process the value(s)
                      // Default process is resolve
                      (special || deferred.resolveWith)(that, args);
                    }
                  },
                  // Only normal processors (resolve) catch and reject exceptions
                  process = special ? mightThrow : function () {
                    try {
                      mightThrow();
                    } catch (e) {
                      if (jQuery.Deferred.exceptionHook) {
                        jQuery.Deferred.exceptionHook(e, process.stackTrace);
                      }

                      // Support: Promises/A+ section 2.3.3.3.4.1
                      // https://promisesaplus.com/#point-61
                      // Ignore post-resolution exceptions
                      if (depth + 1 >= maxDepth) {
                        // Only substitute handlers pass on context
                        // and multiple values (non-spec behavior)
                        if (handler !== Thrower) {
                          that = undefined;
                          args = [e];
                        }
                        deferred.rejectWith(that, args);
                      }
                    }
                  };

                // Support: Promises/A+ section 2.3.3.3.1
                // https://promisesaplus.com/#point-57
                // Re-resolve promises immediately to dodge false rejection from
                // subsequent errors
                if (depth) {
                  process();
                } else {
                  // Call an optional hook to record the stack, in case of exception
                  // since it's otherwise lost when execution goes async
                  if (jQuery.Deferred.getStackHook) {
                    process.stackTrace = jQuery.Deferred.getStackHook();
                  }
                  window.setTimeout(process);
                }
              };
            }
            return jQuery.Deferred(function (newDefer) {
              // progress_handlers.add( ... )
              tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

              // fulfilled_handlers.add( ... )
              tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

              // rejected_handlers.add( ... )
              tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function promise(obj) {
            return obj != null ? jQuery.extend(obj, _promise) : _promise;
          }
        },
        deferred = {};

      // Add list-specific methods
      jQuery.each(tuples, function (i, tuple) {
        var list = tuple[2],
          stateString = tuple[5];

        // promise.progress = list.add
        // promise.done = list.add
        // promise.fail = list.add
        _promise[tuple[1]] = list.add;

        // Handle state
        if (stateString) {
          list.add(function () {
            // state = "resolved" (i.e., fulfilled)
            // state = "rejected"
            _state = stateString;
          },
          // rejected_callbacks.disable
          // fulfilled_callbacks.disable
          tuples[3 - i][2].disable,
          // rejected_handlers.disable
          // fulfilled_handlers.disable
          tuples[3 - i][3].disable,
          // progress_callbacks.lock
          tuples[0][2].lock,
          // progress_handlers.lock
          tuples[0][3].lock);
        }

        // progress_handlers.fire
        // fulfilled_handlers.fire
        // rejected_handlers.fire
        list.add(tuple[3].fire);

        // deferred.notify = function() { deferred.notifyWith(...) }
        // deferred.resolve = function() { deferred.resolveWith(...) }
        // deferred.reject = function() { deferred.rejectWith(...) }
        deferred[tuple[0]] = function () {
          deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
          return this;
        };

        // deferred.notifyWith = list.fireWith
        // deferred.resolveWith = list.fireWith
        // deferred.rejectWith = list.fireWith
        deferred[tuple[0] + "With"] = list.fireWith;
      });

      // Make the deferred a promise
      _promise.promise(deferred);

      // Call given func if any
      if (func) {
        func.call(deferred, deferred);
      }

      // All done!
      return deferred;
    },
    // Deferred helper
    when: function when(singleValue) {
      var
        // count of uncompleted subordinates
        remaining = arguments.length,
        // count of unprocessed arguments
        i = remaining,
        // subordinate fulfillment data
        resolveContexts = Array(i),
        resolveValues = _slice.call(arguments),
        // the primary Deferred
        primary = jQuery.Deferred(),
        // subordinate callback factory
        updateFunc = function updateFunc(i) {
          return function (value) {
            resolveContexts[i] = this;
            resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
            if (! --remaining) {
              primary.resolveWith(resolveContexts, resolveValues);
            }
          };
        };

      // Single- and empty arguments are adopted like Promise.resolve
      if (remaining <= 1) {
        adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);

        // Use .then() to unwrap secondary thenables (cf. gh-3000)
        if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
          return primary.then();
        }
      }

      // Multiple arguments are aggregated like Promise.all array elements
      while (i--) {
        adoptValue(resolveValues[i], updateFunc(i), primary.reject);
      }
      return primary.promise();
    }
  });

  // These usually indicate a programmer mistake during development,
  // warn about them ASAP rather than swallowing them by default.
  var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  jQuery.Deferred.exceptionHook = function (error, stack) {
    // Support: IE 8 - 9 only
    // Console exists when dev tools are open, which can happen at any time
    if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
      window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    }
  };
  jQuery.readyException = function (error) {
    window.setTimeout(function () {
      throw error;
    });
  };

  // The deferred used on DOM ready
  var readyList = jQuery.Deferred();
  jQuery.fn.ready = function (fn) {
    readyList.then(fn)

    // Wrap jQuery.readyException in a function so that the lookup
    // happens at the time of error handling instead of callback
    // registration.
    ["catch"](function (error) {
      jQuery.readyException(error);
    });
    return this;
  };
  jQuery.extend({
    // Is the DOM ready to be used? Set to true once it occurs.
    isReady: false,
    // A counter to track how many items to wait for before
    // the ready event fires. See trac-6781
    readyWait: 1,
    // Handle when the DOM is ready
    ready: function ready(wait) {
      // Abort if there are pending holds or we're already ready
      if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
        return;
      }

      // Remember that the DOM is ready
      jQuery.isReady = true;

      // If a normal DOM Ready event fired, decrement, and wait if need be
      if (wait !== true && --jQuery.readyWait > 0) {
        return;
      }

      // If there are functions bound, to execute
      readyList.resolveWith(document, [jQuery]);
    }
  });
  jQuery.ready.then = readyList.then;

  // The ready event handler and self cleanup method
  function completed() {
    document.removeEventListener("DOMContentLoaded", completed);
    window.removeEventListener("load", completed);
    jQuery.ready();
  }

  // Catch cases where $(document).ready() is called
  // after the browser event has already occurred.
  // Support: IE <=9 - 10 only
  // Older IE sometimes signals "interactive" too soon
  if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
    // Handle it asynchronously to allow scripts the opportunity to delay ready
    window.setTimeout(jQuery.ready);
  } else {
    // Use the handy event callback
    document.addEventListener("DOMContentLoaded", completed);

    // A fallback to window.onload, that will always work
    window.addEventListener("load", completed);
  }

  // Multifunctional method to get and set values of a collection
  // The value/s can optionally be executed if it's a function
  var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
    var i = 0,
      len = elems.length,
      bulk = key == null;

    // Sets many values
    if (toType(key) === "object") {
      chainable = true;
      for (i in key) {
        access(elems, fn, i, key[i], true, emptyGet, raw);
      }

      // Sets one value
    } else if (value !== undefined) {
      chainable = true;
      if (!isFunction(value)) {
        raw = true;
      }
      if (bulk) {
        // Bulk operations run against the entire set
        if (raw) {
          fn.call(elems, value);
          fn = null;

          // ...except when executing function values
        } else {
          bulk = fn;
          fn = function fn(elem, _key, value) {
            return bulk.call(jQuery(elem), value);
          };
        }
      }
      if (fn) {
        for (; i < len; i++) {
          fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
      }
    }
    if (chainable) {
      return elems;
    }

    // Gets
    if (bulk) {
      return fn.call(elems);
    }
    return len ? fn(elems[0], key) : emptyGet;
  };

  // Matches dashed string for camelizing
  var rmsPrefix = /^-ms-/,
    rdashAlpha = /-([a-z])/g;

  // Used by camelCase as callback to replace()
  function fcamelCase(_all, letter) {
    return letter.toUpperCase();
  }

  // Convert dashed to camelCase; used by the css and data modules
  // Support: IE <=9 - 11, Edge 12 - 15
  // Microsoft forgot to hump their vendor prefix (trac-9572)
  function camelCase(string) {
    return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
  }
  var acceptData = function acceptData(owner) {
    // Accepts only:
    //  - Node
    //    - Node.ELEMENT_NODE
    //    - Node.DOCUMENT_NODE
    //  - Object
    //    - Any
    return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
  };
  function Data() {
    this.expando = jQuery.expando + Data.uid++;
  }
  Data.uid = 1;
  Data.prototype = {
    cache: function cache(owner) {
      // Check if the owner object already has a cache
      var value = owner[this.expando];

      // If not, create one
      if (!value) {
        value = {};

        // We can accept data for non-element nodes in modern browsers,
        // but we should not, see trac-8335.
        // Always return an empty object.
        if (acceptData(owner)) {
          // If it is a node unlikely to be stringify-ed or looped over
          // use plain assignment
          if (owner.nodeType) {
            owner[this.expando] = value;

            // Otherwise secure it in a non-enumerable property
            // configurable must be true to allow the property to be
            // deleted when data is removed
          } else {
            Object.defineProperty(owner, this.expando, {
              value: value,
              configurable: true
            });
          }
        }
      }
      return value;
    },
    set: function set(owner, data, value) {
      var prop,
        cache = this.cache(owner);

      // Handle: [ owner, key, value ] args
      // Always use camelCase key (gh-2257)
      if (typeof data === "string") {
        cache[camelCase(data)] = value;

        // Handle: [ owner, { properties } ] args
      } else {
        // Copy the properties one-by-one to the cache object
        for (prop in data) {
          cache[camelCase(prop)] = data[prop];
        }
      }
      return cache;
    },
    get: function get(owner, key) {
      return key === undefined ? this.cache(owner) :
      // Always use camelCase key (gh-2257)
      owner[this.expando] && owner[this.expando][camelCase(key)];
    },
    access: function access(owner, key, value) {
      // In cases where either:
      //
      //   1. No key was specified
      //   2. A string key was specified, but no value provided
      //
      // Take the "read" path and allow the get method to determine
      // which value to return, respectively either:
      //
      //   1. The entire cache object
      //   2. The data stored at the key
      //
      if (key === undefined || key && typeof key === "string" && value === undefined) {
        return this.get(owner, key);
      }

      // When the key is not a string, or both a key and value
      // are specified, set or extend (existing objects) with either:
      //
      //   1. An object of properties
      //   2. A key and value
      //
      this.set(owner, key, value);

      // Since the "set" path can have two possible entry points
      // return the expected data based on which path was taken[*]
      return value !== undefined ? value : key;
    },
    remove: function remove(owner, key) {
      var i,
        cache = owner[this.expando];
      if (cache === undefined) {
        return;
      }
      if (key !== undefined) {
        // Support array or space separated string of keys
        if (Array.isArray(key)) {
          // If key is an array of keys...
          // We always set camelCase keys, so remove that.
          key = key.map(camelCase);
        } else {
          key = camelCase(key);

          // If a key with the spaces exists, use it.
          // Otherwise, create an array by matching non-whitespace
          key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
        }
        i = key.length;
        while (i--) {
          delete cache[key[i]];
        }
      }

      // Remove the expando if there's no more data
      if (key === undefined || jQuery.isEmptyObject(cache)) {
        // Support: Chrome <=35 - 45
        // Webkit & Blink performance suffers when deleting properties
        // from DOM nodes, so set to undefined instead
        // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
        if (owner.nodeType) {
          owner[this.expando] = undefined;
        } else {
          delete owner[this.expando];
        }
      }
    },
    hasData: function hasData(owner) {
      var cache = owner[this.expando];
      return cache !== undefined && !jQuery.isEmptyObject(cache);
    }
  };
  var dataPriv = new Data();
  var dataUser = new Data();

  //	Implementation Summary
  //
  //	1. Enforce API surface and semantic compatibility with 1.9.x branch
  //	2. Improve the module's maintainability by reducing the storage
  //		paths to a single mechanism.
  //	3. Use the same single mechanism to support "private" and "user" data.
  //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
  //	5. Avoid exposing implementation details on user objects (eg. expando properties)
  //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    rmultiDash = /[A-Z]/g;
  function getData(data) {
    if (data === "true") {
      return true;
    }
    if (data === "false") {
      return false;
    }
    if (data === "null") {
      return null;
    }

    // Only convert to a number if it doesn't change the string
    if (data === +data + "") {
      return +data;
    }
    if (rbrace.test(data)) {
      return JSON.parse(data);
    }
    return data;
  }
  function dataAttr(elem, key, data) {
    var name;

    // If nothing was found internally, try to fetch any
    // data from the HTML5 data-* attribute
    if (data === undefined && elem.nodeType === 1) {
      name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
      data = elem.getAttribute(name);
      if (typeof data === "string") {
        try {
          data = getData(data);
        } catch (e) {}

        // Make sure we set the data so it isn't changed later
        dataUser.set(elem, key, data);
      } else {
        data = undefined;
      }
    }
    return data;
  }
  jQuery.extend({
    hasData: function hasData(elem) {
      return dataUser.hasData(elem) || dataPriv.hasData(elem);
    },
    data: function data(elem, name, _data) {
      return dataUser.access(elem, name, _data);
    },
    removeData: function removeData(elem, name) {
      dataUser.remove(elem, name);
    },
    // TODO: Now that all calls to _data and _removeData have been replaced
    // with direct calls to dataPriv methods, these can be deprecated.
    _data: function _data(elem, name, data) {
      return dataPriv.access(elem, name, data);
    },
    _removeData: function _removeData(elem, name) {
      dataPriv.remove(elem, name);
    }
  });
  jQuery.fn.extend({
    data: function data(key, value) {
      var i,
        name,
        data,
        elem = this[0],
        attrs = elem && elem.attributes;

      // Gets all values
      if (key === undefined) {
        if (this.length) {
          data = dataUser.get(elem);
          if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
            i = attrs.length;
            while (i--) {
              // Support: IE 11 only
              // The attrs elements can be null (trac-14894)
              if (attrs[i]) {
                name = attrs[i].name;
                if (name.indexOf("data-") === 0) {
                  name = camelCase(name.slice(5));
                  dataAttr(elem, name, data[name]);
                }
              }
            }
            dataPriv.set(elem, "hasDataAttrs", true);
          }
        }
        return data;
      }

      // Sets multiple values
      if ((0, _typeof2["default"])(key) === "object") {
        return this.each(function () {
          dataUser.set(this, key);
        });
      }
      return access(this, function (value) {
        var data;

        // The calling jQuery object (element matches) is not empty
        // (and therefore has an element appears at this[ 0 ]) and the
        // `value` parameter was not undefined. An empty jQuery object
        // will result in `undefined` for elem = this[ 0 ] which will
        // throw an exception if an attempt to read a data cache is made.
        if (elem && value === undefined) {
          // Attempt to get data from the cache
          // The key will always be camelCased in Data
          data = dataUser.get(elem, key);
          if (data !== undefined) {
            return data;
          }

          // Attempt to "discover" the data in
          // HTML5 custom data-* attrs
          data = dataAttr(elem, key);
          if (data !== undefined) {
            return data;
          }

          // We tried really hard, but the data doesn't exist.
          return;
        }

        // Set the data...
        this.each(function () {
          // We always store the camelCased key
          dataUser.set(this, key, value);
        });
      }, null, value, arguments.length > 1, null, true);
    },
    removeData: function removeData(key) {
      return this.each(function () {
        dataUser.remove(this, key);
      });
    }
  });
  jQuery.extend({
    queue: function queue(elem, type, data) {
      var queue;
      if (elem) {
        type = (type || "fx") + "queue";
        queue = dataPriv.get(elem, type);

        // Speed up dequeue by getting out quickly if this is just a lookup
        if (data) {
          if (!queue || Array.isArray(data)) {
            queue = dataPriv.access(elem, type, jQuery.makeArray(data));
          } else {
            queue.push(data);
          }
        }
        return queue || [];
      }
    },
    dequeue: function dequeue(elem, type) {
      type = type || "fx";
      var queue = jQuery.queue(elem, type),
        startLength = queue.length,
        fn = queue.shift(),
        hooks = jQuery._queueHooks(elem, type),
        next = function next() {
          jQuery.dequeue(elem, type);
        };

      // If the fx queue is dequeued, always remove the progress sentinel
      if (fn === "inprogress") {
        fn = queue.shift();
        startLength--;
      }
      if (fn) {
        // Add a progress sentinel to prevent the fx queue from being
        // automatically dequeued
        if (type === "fx") {
          queue.unshift("inprogress");
        }

        // Clear up the last queue stop function
        delete hooks.stop;
        fn.call(elem, next, hooks);
      }
      if (!startLength && hooks) {
        hooks.empty.fire();
      }
    },
    // Not public - generate a queueHooks object, or return the current one
    _queueHooks: function _queueHooks(elem, type) {
      var key = type + "queueHooks";
      return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
        empty: jQuery.Callbacks("once memory").add(function () {
          dataPriv.remove(elem, [type + "queue", key]);
        })
      });
    }
  });
  jQuery.fn.extend({
    queue: function queue(type, data) {
      var setter = 2;
      if (typeof type !== "string") {
        data = type;
        type = "fx";
        setter--;
      }
      if (arguments.length < setter) {
        return jQuery.queue(this[0], type);
      }
      return data === undefined ? this : this.each(function () {
        var queue = jQuery.queue(this, type, data);

        // Ensure a hooks for this queue
        jQuery._queueHooks(this, type);
        if (type === "fx" && queue[0] !== "inprogress") {
          jQuery.dequeue(this, type);
        }
      });
    },
    dequeue: function dequeue(type) {
      return this.each(function () {
        jQuery.dequeue(this, type);
      });
    },
    clearQueue: function clearQueue(type) {
      return this.queue(type || "fx", []);
    },
    // Get a promise resolved when queues of a certain type
    // are emptied (fx is the type by default)
    promise: function promise(type, obj) {
      var tmp,
        count = 1,
        defer = jQuery.Deferred(),
        elements = this,
        i = this.length,
        resolve = function resolve() {
          if (! --count) {
            defer.resolveWith(elements, [elements]);
          }
        };
      if (typeof type !== "string") {
        obj = type;
        type = undefined;
      }
      type = type || "fx";
      while (i--) {
        tmp = dataPriv.get(elements[i], type + "queueHooks");
        if (tmp && tmp.empty) {
          count++;
          tmp.empty.add(resolve);
        }
      }
      resolve();
      return defer.promise(obj);
    }
  });
  var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
  var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
  var cssExpand = ["Top", "Right", "Bottom", "Left"];
  var documentElement = document.documentElement;
  var isAttached = function isAttached(elem) {
      return jQuery.contains(elem.ownerDocument, elem);
    },
    composed = {
      composed: true
    };

  // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
  // Check attachment across shadow DOM boundaries when possible (gh-3504)
  // Support: iOS 10.0-10.2 only
  // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
  // leading to errors. We need to check for `getRootNode`.
  if (documentElement.getRootNode) {
    isAttached = function isAttached(elem) {
      return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
  }
  var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
    // isHiddenWithinTree might be called from jQuery#filter function;
    // in that case, element will be second argument
    elem = el || elem;

    // Inline style trumps all
    return elem.style.display === "none" || elem.style.display === "" &&
    // Otherwise, check computed style
    // Support: Firefox <=43 - 45
    // Disconnected elements can have computed display: none, so first confirm that elem is
    // in the document.
    isAttached(elem) && jQuery.css(elem, "display") === "none";
  };
  function adjustCSS(elem, prop, valueParts, tween) {
    var adjusted,
      scale,
      maxIterations = 20,
      currentValue = tween ? function () {
        return tween.cur();
      } : function () {
        return jQuery.css(elem, prop, "");
      },
      initial = currentValue(),
      unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
      // Starting value computation is required for potential unit mismatches
      initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
    if (initialInUnit && initialInUnit[3] !== unit) {
      // Support: Firefox <=54
      // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
      initial = initial / 2;

      // Trust units reported by jQuery.css
      unit = unit || initialInUnit[3];

      // Iteratively approximate from a nonzero starting point
      initialInUnit = +initial || 1;
      while (maxIterations--) {
        // Evaluate and update our best guess (doubling guesses that zero out).
        // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
        jQuery.style(elem, prop, initialInUnit + unit);
        if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
          maxIterations = 0;
        }
        initialInUnit = initialInUnit / scale;
      }
      initialInUnit = initialInUnit * 2;
      jQuery.style(elem, prop, initialInUnit + unit);

      // Make sure we update the tween properties later on
      valueParts = valueParts || [];
    }
    if (valueParts) {
      initialInUnit = +initialInUnit || +initial || 0;

      // Apply relative offset (+=/-=) if specified
      adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
      if (tween) {
        tween.unit = unit;
        tween.start = initialInUnit;
        tween.end = adjusted;
      }
    }
    return adjusted;
  }
  var defaultDisplayMap = {};
  function getDefaultDisplay(elem) {
    var temp,
      doc = elem.ownerDocument,
      nodeName = elem.nodeName,
      display = defaultDisplayMap[nodeName];
    if (display) {
      return display;
    }
    temp = doc.body.appendChild(doc.createElement(nodeName));
    display = jQuery.css(temp, "display");
    temp.parentNode.removeChild(temp);
    if (display === "none") {
      display = "block";
    }
    defaultDisplayMap[nodeName] = display;
    return display;
  }
  function showHide(elements, show) {
    var display,
      elem,
      values = [],
      index = 0,
      length = elements.length;

    // Determine new display value for elements that need to change
    for (; index < length; index++) {
      elem = elements[index];
      if (!elem.style) {
        continue;
      }
      display = elem.style.display;
      if (show) {
        // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
        // check is required in this first loop unless we have a nonempty display value (either
        // inline or about-to-be-restored)
        if (display === "none") {
          values[index] = dataPriv.get(elem, "display") || null;
          if (!values[index]) {
            elem.style.display = "";
          }
        }
        if (elem.style.display === "" && isHiddenWithinTree(elem)) {
          values[index] = getDefaultDisplay(elem);
        }
      } else {
        if (display !== "none") {
          values[index] = "none";

          // Remember what we're overwriting
          dataPriv.set(elem, "display", display);
        }
      }
    }

    // Set the display of the elements in a second loop to avoid constant reflow
    for (index = 0; index < length; index++) {
      if (values[index] != null) {
        elements[index].style.display = values[index];
      }
    }
    return elements;
  }
  jQuery.fn.extend({
    show: function show() {
      return showHide(this, true);
    },
    hide: function hide() {
      return showHide(this);
    },
    toggle: function toggle(state) {
      if (typeof state === "boolean") {
        return state ? this.show() : this.hide();
      }
      return this.each(function () {
        if (isHiddenWithinTree(this)) {
          jQuery(this).show();
        } else {
          jQuery(this).hide();
        }
      });
    }
  });
  var rcheckableType = /^(?:checkbox|radio)$/i;
  var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
  var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
  (function () {
    var fragment = document.createDocumentFragment(),
      div = fragment.appendChild(document.createElement("div")),
      input = document.createElement("input");

    // Support: Android 4.0 - 4.3 only
    // Check state lost if the name is set (trac-11217)
    // Support: Windows Web Apps (WWA)
    // `name` and `type` must use .setAttribute for WWA (trac-14901)
    input.setAttribute("type", "radio");
    input.setAttribute("checked", "checked");
    input.setAttribute("name", "t");
    div.appendChild(input);

    // Support: Android <=4.1 only
    // Older WebKit doesn't clone checked state correctly in fragments
    support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

    // Support: IE <=11 only
    // Make sure textarea (and checkbox) defaultValue is properly cloned
    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

    // Support: IE <=9 only
    // IE <=9 replaces <option> tags with their contents when inserted outside of
    // the select element.
    div.innerHTML = "<option></option>";
    support.option = !!div.lastChild;
  })();

  // We have to close these tags to support XHTML (trac-13200)
  var wrapMap = {
    // XHTML parsers do not magically insert elements in the
    // same way that tag soup parsers do. So we cannot shorten
    // this by omitting <tbody> or other required elements.
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

  // Support: IE <=9 only
  if (!support.option) {
    wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
  }
  function getAll(context, tag) {
    // Support: IE <=9 - 11 only
    // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
    var ret;
    if (typeof context.getElementsByTagName !== "undefined") {
      ret = context.getElementsByTagName(tag || "*");
    } else if (typeof context.querySelectorAll !== "undefined") {
      ret = context.querySelectorAll(tag || "*");
    } else {
      ret = [];
    }
    if (tag === undefined || tag && nodeName(context, tag)) {
      return jQuery.merge([context], ret);
    }
    return ret;
  }

  // Mark scripts as having already been evaluated
  function setGlobalEval(elems, refElements) {
    var i = 0,
      l = elems.length;
    for (; i < l; i++) {
      dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
  }
  var rhtml = /<|&#?\w+;/;
  function buildFragment(elems, context, scripts, selection, ignored) {
    var elem,
      tmp,
      tag,
      wrap,
      attached,
      j,
      fragment = context.createDocumentFragment(),
      nodes = [],
      i = 0,
      l = elems.length;
    for (; i < l; i++) {
      elem = elems[i];
      if (elem || elem === 0) {
        // Add nodes directly
        if (toType(elem) === "object") {
          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

          // Convert non-html into a text node
        } else if (!rhtml.test(elem)) {
          nodes.push(context.createTextNode(elem));

          // Convert html into DOM nodes
        } else {
          tmp = tmp || fragment.appendChild(context.createElement("div"));

          // Deserialize a standard representation
          tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
          wrap = wrapMap[tag] || wrapMap._default;
          tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

          // Descend through wrappers to the right content
          j = wrap[0];
          while (j--) {
            tmp = tmp.lastChild;
          }

          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          jQuery.merge(nodes, tmp.childNodes);

          // Remember the top-level container
          tmp = fragment.firstChild;

          // Ensure the created nodes are orphaned (trac-12392)
          tmp.textContent = "";
        }
      }
    }

    // Remove wrapper from fragment
    fragment.textContent = "";
    i = 0;
    while (elem = nodes[i++]) {
      // Skip elements already in the context collection (trac-4087)
      if (selection && jQuery.inArray(elem, selection) > -1) {
        if (ignored) {
          ignored.push(elem);
        }
        continue;
      }
      attached = isAttached(elem);

      // Append to fragment
      tmp = getAll(fragment.appendChild(elem), "script");

      // Preserve script evaluation history
      if (attached) {
        setGlobalEval(tmp);
      }

      // Capture executables
      if (scripts) {
        j = 0;
        while (elem = tmp[j++]) {
          if (rscriptType.test(elem.type || "")) {
            scripts.push(elem);
          }
        }
      }
    }
    return fragment;
  }
  var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
  function returnTrue() {
    return true;
  }
  function returnFalse() {
    return false;
  }

  // Support: IE <=9 - 11+
  // focus() and blur() are asynchronous, except when they are no-op.
  // So expect focus to be synchronous when the element is already active,
  // and blur to be synchronous when the element is not already active.
  // (focus and blur are always synchronous in other supported browsers,
  // this just defines when we can count on it).
  function expectSync(elem, type) {
    return elem === safeActiveElement() === (type === "focus");
  }

  // Support: IE <=9 only
  // Accessing document.activeElement can throw unexpectedly
  // https://bugs.jquery.com/ticket/13393
  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch (err) {}
  }
  function _on(elem, types, selector, data, fn, one) {
    var origFn, type;

    // Types can be a map of types/handlers
    if ((0, _typeof2["default"])(types) === "object") {
      // ( types-Object, selector, data )
      if (typeof selector !== "string") {
        // ( types-Object, data )
        data = data || selector;
        selector = undefined;
      }
      for (type in types) {
        _on(elem, type, selector, data, types[type], one);
      }
      return elem;
    }
    if (data == null && fn == null) {
      // ( types, fn )
      fn = selector;
      data = selector = undefined;
    } else if (fn == null) {
      if (typeof selector === "string") {
        // ( types, selector, fn )
        fn = data;
        data = undefined;
      } else {
        // ( types, data, fn )
        fn = data;
        data = selector;
        selector = undefined;
      }
    }
    if (fn === false) {
      fn = returnFalse;
    } else if (!fn) {
      return elem;
    }
    if (one === 1) {
      origFn = fn;
      fn = function fn(event) {
        // Can use an empty set, since event contains the info
        jQuery().off(event);
        return origFn.apply(this, arguments);
      };

      // Use same guid so caller can remove using origFn
      fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
    }
    return elem.each(function () {
      jQuery.event.add(this, types, fn, data, selector);
    });
  }

  /*
   * Helper functions for managing events -- not part of the public interface.
   * Props to Dean Edwards' addEvent library for many of the ideas.
   */
  jQuery.event = {
    global: {},
    add: function add(elem, types, handler, data, selector) {
      var handleObjIn,
        eventHandle,
        tmp,
        events,
        t,
        handleObj,
        special,
        handlers,
        type,
        namespaces,
        origType,
        elemData = dataPriv.get(elem);

      // Only attach events to objects that accept data
      if (!acceptData(elem)) {
        return;
      }

      // Caller can pass in an object of custom data in lieu of the handler
      if (handler.handler) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      }

      // Ensure that invalid selectors throw exceptions at attach time
      // Evaluate against documentElement in case elem is a non-element node (e.g., document)
      if (selector) {
        jQuery.find.matchesSelector(documentElement, selector);
      }

      // Make sure that the handler has a unique ID, used to find/remove it later
      if (!handler.guid) {
        handler.guid = jQuery.guid++;
      }

      // Init the element's event structure and main handler, if this is the first
      if (!(events = elemData.events)) {
        events = elemData.events = Object.create(null);
      }
      if (!(eventHandle = elemData.handle)) {
        eventHandle = elemData.handle = function (e) {
          // Discard the second event of a jQuery.event.trigger() and
          // when an event is called after a page has unloaded
          return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
        };
      }

      // Handle multiple events separated by a space
      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();

        // There *must* be a type, no attaching namespace-only handlers
        if (!type) {
          continue;
        }

        // If event changes its type, use the special event handlers for the changed type
        special = jQuery.event.special[type] || {};

        // If selector defined, determine special event api type, otherwise given type
        type = (selector ? special.delegateType : special.bindType) || type;

        // Update special based on newly reset type
        special = jQuery.event.special[type] || {};

        // handleObj is passed to all event handlers
        handleObj = jQuery.extend({
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test(selector),
          namespace: namespaces.join(".")
        }, handleObjIn);

        // Init the event handler queue if we're the first
        if (!(handlers = events[type])) {
          handlers = events[type] = [];
          handlers.delegateCount = 0;

          // Only use addEventListener if the special events handler returns false
          if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
            if (elem.addEventListener) {
              elem.addEventListener(type, eventHandle);
            }
          }
        }
        if (special.add) {
          special.add.call(elem, handleObj);
          if (!handleObj.handler.guid) {
            handleObj.handler.guid = handler.guid;
          }
        }

        // Add to the element's handler list, delegates in front
        if (selector) {
          handlers.splice(handlers.delegateCount++, 0, handleObj);
        } else {
          handlers.push(handleObj);
        }

        // Keep track of which events have ever been used, for event optimization
        jQuery.event.global[type] = true;
      }
    },
    // Detach an event or set of events from an element
    remove: function remove(elem, types, handler, selector, mappedTypes) {
      var j,
        origCount,
        tmp,
        events,
        t,
        handleObj,
        special,
        handlers,
        type,
        namespaces,
        origType,
        elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
      if (!elemData || !(events = elemData.events)) {
        return;
      }

      // Once for each type.namespace in types; type may be omitted
      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();

        // Unbind all events (on this namespace, if provided) for the element
        if (!type) {
          for (type in events) {
            jQuery.event.remove(elem, type + types[t], handler, selector, true);
          }
          continue;
        }
        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        handlers = events[type] || [];
        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

        // Remove matching events
        origCount = j = handlers.length;
        while (j--) {
          handleObj = handlers[j];
          if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
            handlers.splice(j, 1);
            if (handleObj.selector) {
              handlers.delegateCount--;
            }
            if (special.remove) {
              special.remove.call(elem, handleObj);
            }
          }
        }

        // Remove generic event handler if we removed something and no more handlers exist
        // (avoids potential for endless recursion during removal of special event handlers)
        if (origCount && !handlers.length) {
          if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
            jQuery.removeEvent(elem, type, elemData.handle);
          }
          delete events[type];
        }
      }

      // Remove data and the expando if it's no longer used
      if (jQuery.isEmptyObject(events)) {
        dataPriv.remove(elem, "handle events");
      }
    },
    dispatch: function dispatch(nativeEvent) {
      var i,
        j,
        ret,
        matched,
        handleObj,
        handlerQueue,
        args = new Array(arguments.length),
        // Make a writable jQuery.Event from the native event object
        event = jQuery.event.fix(nativeEvent),
        handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
        special = jQuery.event.special[event.type] || {};

      // Use the fix-ed jQuery.Event rather than the (read-only) native event
      args[0] = event;
      for (i = 1; i < arguments.length; i++) {
        args[i] = arguments[i];
      }
      event.delegateTarget = this;

      // Call the preDispatch hook for the mapped type, and let it bail if desired
      if (special.preDispatch && special.preDispatch.call(this, event) === false) {
        return;
      }

      // Determine handlers
      handlerQueue = jQuery.event.handlers.call(this, event, handlers);

      // Run delegates first; they may want to stop propagation beneath us
      i = 0;
      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
        event.currentTarget = matched.elem;
        j = 0;
        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
          // If the event is namespaced, then each handler is only invoked if it is
          // specially universal or its namespaces are a superset of the event's.
          if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
            event.handleObj = handleObj;
            event.data = handleObj.data;
            ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
            if (ret !== undefined) {
              if ((event.result = ret) === false) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      }

      // Call the postDispatch hook for the mapped type
      if (special.postDispatch) {
        special.postDispatch.call(this, event);
      }
      return event.result;
    },
    handlers: function handlers(event, _handlers) {
      var i,
        handleObj,
        sel,
        matchedHandlers,
        matchedSelectors,
        handlerQueue = [],
        delegateCount = _handlers.delegateCount,
        cur = event.target;

      // Find delegate handlers
      if (delegateCount &&
      // Support: IE <=9
      // Black-hole SVG <use> instance trees (trac-13180)
      cur.nodeType &&
      // Support: Firefox <=42
      // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
      // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
      // Support: IE 11 only
      // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
      !(event.type === "click" && event.button >= 1)) {
        for (; cur !== this; cur = cur.parentNode || this) {
          // Don't check non-elements (trac-13208)
          // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
          if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
            matchedHandlers = [];
            matchedSelectors = {};
            for (i = 0; i < delegateCount; i++) {
              handleObj = _handlers[i];

              // Don't conflict with Object.prototype properties (trac-13203)
              sel = handleObj.selector + " ";
              if (matchedSelectors[sel] === undefined) {
                matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
              }
              if (matchedSelectors[sel]) {
                matchedHandlers.push(handleObj);
              }
            }
            if (matchedHandlers.length) {
              handlerQueue.push({
                elem: cur,
                handlers: matchedHandlers
              });
            }
          }
        }
      }

      // Add the remaining (directly-bound) handlers
      cur = this;
      if (delegateCount < _handlers.length) {
        handlerQueue.push({
          elem: cur,
          handlers: _handlers.slice(delegateCount)
        });
      }
      return handlerQueue;
    },
    addProp: function addProp(name, hook) {
      Object.defineProperty(jQuery.Event.prototype, name, {
        enumerable: true,
        configurable: true,
        get: isFunction(hook) ? function () {
          if (this.originalEvent) {
            return hook(this.originalEvent);
          }
        } : function () {
          if (this.originalEvent) {
            return this.originalEvent[name];
          }
        },
        set: function set(value) {
          Object.defineProperty(this, name, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: value
          });
        }
      });
    },
    fix: function fix(originalEvent) {
      return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
    },
    special: {
      load: {
        // Prevent triggered image.load events from bubbling to window.load
        noBubble: true
      },
      click: {
        // Utilize native event to ensure correct state for checkable inputs
        setup: function setup(data) {
          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data;

          // Claim the first handler
          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
            // dataPriv.set( el, "click", ... )
            leverageNative(el, "click", returnTrue);
          }

          // Return false to allow normal processing in the caller
          return false;
        },
        trigger: function trigger(data) {
          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data;

          // Force setup before triggering a click
          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
            leverageNative(el, "click");
          }

          // Return non-false to allow normal event-path propagation
          return true;
        },
        // For cross-browser consistency, suppress native .click() on links
        // Also prevent it if we're currently inside a leveraged native-event stack
        _default: function _default(event) {
          var target = event.target;
          return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
        }
      },
      beforeunload: {
        postDispatch: function postDispatch(event) {
          // Support: Firefox 20+
          // Firefox doesn't alert if the returnValue field is not set.
          if (event.result !== undefined && event.originalEvent) {
            event.originalEvent.returnValue = event.result;
          }
        }
      }
    }
  };

  // Ensure the presence of an event listener that handles manually-triggered
  // synthetic events by interrupting progress until reinvoked in response to
  // *native* events that it fires directly, ensuring that state changes have
  // already occurred before other listeners are invoked.
  function leverageNative(el, type, expectSync) {
    // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
    if (!expectSync) {
      if (dataPriv.get(el, type) === undefined) {
        jQuery.event.add(el, type, returnTrue);
      }
      return;
    }

    // Register the controller as a special universal handler for all event namespaces
    dataPriv.set(el, type, false);
    jQuery.event.add(el, type, {
      namespace: false,
      handler: function handler(event) {
        var notAsync,
          result,
          saved = dataPriv.get(this, type);
        if (event.isTrigger & 1 && this[type]) {
          // Interrupt processing of the outer synthetic .trigger()ed event
          // Saved data should be false in such cases, but might be a leftover capture object
          // from an async native handler (gh-4350)
          if (!saved.length) {
            // Store arguments for use when handling the inner native event
            // There will always be at least one argument (an event object), so this array
            // will not be confused with a leftover capture object.
            saved = _slice.call(arguments);
            dataPriv.set(this, type, saved);

            // Trigger the native event and capture its result
            // Support: IE <=9 - 11+
            // focus() and blur() are asynchronous
            notAsync = expectSync(this, type);
            this[type]();
            result = dataPriv.get(this, type);
            if (saved !== result || notAsync) {
              dataPriv.set(this, type, false);
            } else {
              result = {};
            }
            if (saved !== result) {
              // Cancel the outer synthetic event
              event.stopImmediatePropagation();
              event.preventDefault();

              // Support: Chrome 86+
              // In Chrome, if an element having a focusout handler is blurred by
              // clicking outside of it, it invokes the handler synchronously. If
              // that handler calls `.remove()` on the element, the data is cleared,
              // leaving `result` undefined. We need to guard against this.
              return result && result.value;
            }

            // If this is an inner synthetic event for an event with a bubbling surrogate
            // (focus or blur), assume that the surrogate already propagated from triggering the
            // native event and prevent that from happening again here.
            // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
            // bubbling surrogate propagates *after* the non-bubbling base), but that seems
            // less bad than duplication.
          } else if ((jQuery.event.special[type] || {}).delegateType) {
            event.stopPropagation();
          }

          // If this is a native event triggered above, everything is now in order
          // Fire an inner synthetic event with the original arguments
        } else if (saved.length) {
          // ...and capture the result
          dataPriv.set(this, type, {
            value: jQuery.event.trigger(
            // Support: IE <=9 - 11+
            // Extend with the prototype to reset the above stopImmediatePropagation()
            jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
          });

          // Abort handling of the native event
          event.stopImmediatePropagation();
        }
      }
    });
  }
  jQuery.removeEvent = function (elem, type, handle) {
    // This "if" is needed for plain objects
    if (elem.removeEventListener) {
      elem.removeEventListener(type, handle);
    }
  };
  jQuery.Event = function (src, props) {
    // Allow instantiation without the 'new' keyword
    if (!(this instanceof jQuery.Event)) {
      return new jQuery.Event(src, props);
    }

    // Event object
    if (src && src.type) {
      this.originalEvent = src;
      this.type = src.type;

      // Events bubbling up the document may have been marked as prevented
      // by a handler lower down the tree; reflect the correct value.
      this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&
      // Support: Android <=2.3 only
      src.returnValue === false ? returnTrue : returnFalse;

      // Create target properties
      // Support: Safari <=6 - 7 only
      // Target should not be a text node (trac-504, trac-13143)
      this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
      this.currentTarget = src.currentTarget;
      this.relatedTarget = src.relatedTarget;

      // Event type
    } else {
      this.type = src;
    }

    // Put explicitly provided properties onto the event object
    if (props) {
      jQuery.extend(this, props);
    }

    // Create a timestamp if incoming event doesn't have one
    this.timeStamp = src && src.timeStamp || Date.now();

    // Mark it as fixed
    this[jQuery.expando] = true;
  };

  // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
  // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
  jQuery.Event.prototype = {
    constructor: jQuery.Event,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    isSimulated: false,
    preventDefault: function preventDefault() {
      var e = this.originalEvent;
      this.isDefaultPrevented = returnTrue;
      if (e && !this.isSimulated) {
        e.preventDefault();
      }
    },
    stopPropagation: function stopPropagation() {
      var e = this.originalEvent;
      this.isPropagationStopped = returnTrue;
      if (e && !this.isSimulated) {
        e.stopPropagation();
      }
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = returnTrue;
      if (e && !this.isSimulated) {
        e.stopImmediatePropagation();
      }
      this.stopPropagation();
    }
  };

  // Includes all common event props including KeyEvent and MouseEvent specific props
  jQuery.each({
    altKey: true,
    bubbles: true,
    cancelable: true,
    changedTouches: true,
    ctrlKey: true,
    detail: true,
    eventPhase: true,
    metaKey: true,
    pageX: true,
    pageY: true,
    shiftKey: true,
    view: true,
    "char": true,
    code: true,
    charCode: true,
    key: true,
    keyCode: true,
    button: true,
    buttons: true,
    clientX: true,
    clientY: true,
    offsetX: true,
    offsetY: true,
    pointerId: true,
    pointerType: true,
    screenX: true,
    screenY: true,
    targetTouches: true,
    toElement: true,
    touches: true,
    which: true
  }, jQuery.event.addProp);
  jQuery.each({
    focus: "focusin",
    blur: "focusout"
  }, function (type, delegateType) {
    jQuery.event.special[type] = {
      // Utilize native event if possible so blur/focus sequence is correct
      setup: function setup() {
        // Claim the first handler
        // dataPriv.set( this, "focus", ... )
        // dataPriv.set( this, "blur", ... )
        leverageNative(this, type, expectSync);

        // Return false to allow normal processing in the caller
        return false;
      },
      trigger: function trigger() {
        // Force setup before trigger
        leverageNative(this, type);

        // Return non-false to allow normal event-path propagation
        return true;
      },
      // Suppress native focus or blur if we're currently inside
      // a leveraged native-event stack
      _default: function _default(event) {
        return dataPriv.get(event.target, type);
      },
      delegateType: delegateType
    };
  });

  // Create mouseenter/leave events using mouseover/out and event-time checks
  // so that event delegation works in jQuery.
  // Do the same for pointerenter/pointerleave and pointerover/pointerout
  //
  // Support: Safari 7 only
  // Safari sends mouseenter too often; see:
  // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
  // for the description of the bug (it existed in older Chrome versions as well).
  jQuery.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function (orig, fix) {
    jQuery.event.special[orig] = {
      delegateType: fix,
      bindType: fix,
      handle: function handle(event) {
        var ret,
          target = this,
          related = event.relatedTarget,
          handleObj = event.handleObj;

        // For mouseenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window
        if (!related || related !== target && !jQuery.contains(target, related)) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply(this, arguments);
          event.type = fix;
        }
        return ret;
      }
    };
  });
  jQuery.fn.extend({
    on: function on(types, selector, data, fn) {
      return _on(this, types, selector, data, fn);
    },
    one: function one(types, selector, data, fn) {
      return _on(this, types, selector, data, fn, 1);
    },
    off: function off(types, selector, fn) {
      var handleObj, type;
      if (types && types.preventDefault && types.handleObj) {
        // ( event )  dispatched jQuery.Event
        handleObj = types.handleObj;
        jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
        return this;
      }
      if ((0, _typeof2["default"])(types) === "object") {
        // ( types-object [, selector] )
        for (type in types) {
          this.off(type, selector, types[type]);
        }
        return this;
      }
      if (selector === false || typeof selector === "function") {
        // ( types [, fn] )
        fn = selector;
        selector = undefined;
      }
      if (fn === false) {
        fn = returnFalse;
      }
      return this.each(function () {
        jQuery.event.remove(this, types, fn, selector);
      });
    }
  });
  var
    // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i,
    // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
    rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

  // Prefer a tbody over its parent table for containing new rows
  function manipulationTarget(elem, content) {
    if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
      return jQuery(elem).children("tbody")[0] || elem;
    }
    return elem;
  }

  // Replace/restore the type attribute of script elements for safe DOM manipulation
  function disableScript(elem) {
    elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
    return elem;
  }
  function restoreScript(elem) {
    if ((elem.type || "").slice(0, 5) === "true/") {
      elem.type = elem.type.slice(5);
    } else {
      elem.removeAttribute("type");
    }
    return elem;
  }
  function cloneCopyEvent(src, dest) {
    var i, l, type, pdataOld, udataOld, udataCur, events;
    if (dest.nodeType !== 1) {
      return;
    }

    // 1. Copy private data: events, handlers, etc.
    if (dataPriv.hasData(src)) {
      pdataOld = dataPriv.get(src);
      events = pdataOld.events;
      if (events) {
        dataPriv.remove(dest, "handle events");
        for (type in events) {
          for (i = 0, l = events[type].length; i < l; i++) {
            jQuery.event.add(dest, type, events[type][i]);
          }
        }
      }
    }

    // 2. Copy user data
    if (dataUser.hasData(src)) {
      udataOld = dataUser.access(src);
      udataCur = jQuery.extend({}, udataOld);
      dataUser.set(dest, udataCur);
    }
  }

  // Fix IE bugs, see support tests
  function fixInput(src, dest) {
    var nodeName = dest.nodeName.toLowerCase();

    // Fails to persist the checked state of a cloned checkbox or radio button.
    if (nodeName === "input" && rcheckableType.test(src.type)) {
      dest.checked = src.checked;

      // Fails to return the selected option to the default selected state when cloning options
    } else if (nodeName === "input" || nodeName === "textarea") {
      dest.defaultValue = src.defaultValue;
    }
  }
  function domManip(collection, args, callback, ignored) {
    // Flatten any nested arrays
    args = flat(args);
    var fragment,
      first,
      scripts,
      hasScripts,
      node,
      doc,
      i = 0,
      l = collection.length,
      iNoClone = l - 1,
      value = args[0],
      valueIsFunction = isFunction(value);

    // We can't cloneNode fragments that contain checked, in WebKit
    if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
      return collection.each(function (index) {
        var self = collection.eq(index);
        if (valueIsFunction) {
          args[0] = value.call(this, index, self.html());
        }
        domManip(self, args, callback, ignored);
      });
    }
    if (l) {
      fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
      first = fragment.firstChild;
      if (fragment.childNodes.length === 1) {
        fragment = first;
      }

      // Require either new content or an interest in ignored elements to invoke the callback
      if (first || ignored) {
        scripts = jQuery.map(getAll(fragment, "script"), disableScript);
        hasScripts = scripts.length;

        // Use the original fragment for the last item
        // instead of the first because it can end up
        // being emptied incorrectly in certain situations (trac-8070).
        for (; i < l; i++) {
          node = fragment;
          if (i !== iNoClone) {
            node = jQuery.clone(node, true, true);

            // Keep references to cloned scripts for later restoration
            if (hasScripts) {
              // Support: Android <=4.0 only, PhantomJS 1 only
              // push.apply(_, arraylike) throws on ancient WebKit
              jQuery.merge(scripts, getAll(node, "script"));
            }
          }
          callback.call(collection[i], node, i);
        }
        if (hasScripts) {
          doc = scripts[scripts.length - 1].ownerDocument;

          // Reenable scripts
          jQuery.map(scripts, restoreScript);

          // Evaluate executable scripts on first document insertion
          for (i = 0; i < hasScripts; i++) {
            node = scripts[i];
            if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
              if (node.src && (node.type || "").toLowerCase() !== "module") {
                // Optional AJAX dependency, but won't run scripts if not present
                if (jQuery._evalUrl && !node.noModule) {
                  jQuery._evalUrl(node.src, {
                    nonce: node.nonce || node.getAttribute("nonce")
                  }, doc);
                }
              } else {
                // Unwrap a CDATA section containing script contents. This shouldn't be
                // needed as in XML documents they're already not visible when
                // inspecting element contents and in HTML documents they have no
                // meaning but we're preserving that logic for backwards compatibility.
                // This will be removed completely in 4.0. See gh-4904.
                DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
              }
            }
          }
        }
      }
    }
    return collection;
  }
  function _remove(elem, selector, keepData) {
    var node,
      nodes = selector ? jQuery.filter(selector, elem) : elem,
      i = 0;
    for (; (node = nodes[i]) != null; i++) {
      if (!keepData && node.nodeType === 1) {
        jQuery.cleanData(getAll(node));
      }
      if (node.parentNode) {
        if (keepData && isAttached(node)) {
          setGlobalEval(getAll(node, "script"));
        }
        node.parentNode.removeChild(node);
      }
    }
    return elem;
  }
  jQuery.extend({
    htmlPrefilter: function htmlPrefilter(html) {
      return html;
    },
    clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
      var i,
        l,
        srcElements,
        destElements,
        clone = elem.cloneNode(true),
        inPage = isAttached(elem);

      // Fix IE cloning issues
      if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
        // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
        destElements = getAll(clone);
        srcElements = getAll(elem);
        for (i = 0, l = srcElements.length; i < l; i++) {
          fixInput(srcElements[i], destElements[i]);
        }
      }

      // Copy the events from the original to the clone
      if (dataAndEvents) {
        if (deepDataAndEvents) {
          srcElements = srcElements || getAll(elem);
          destElements = destElements || getAll(clone);
          for (i = 0, l = srcElements.length; i < l; i++) {
            cloneCopyEvent(srcElements[i], destElements[i]);
          }
        } else {
          cloneCopyEvent(elem, clone);
        }
      }

      // Preserve script evaluation history
      destElements = getAll(clone, "script");
      if (destElements.length > 0) {
        setGlobalEval(destElements, !inPage && getAll(elem, "script"));
      }

      // Return the cloned set
      return clone;
    },
    cleanData: function cleanData(elems) {
      var data,
        elem,
        type,
        special = jQuery.event.special,
        i = 0;
      for (; (elem = elems[i]) !== undefined; i++) {
        if (acceptData(elem)) {
          if (data = elem[dataPriv.expando]) {
            if (data.events) {
              for (type in data.events) {
                if (special[type]) {
                  jQuery.event.remove(elem, type);

                  // This is a shortcut to avoid jQuery.event.remove's overhead
                } else {
                  jQuery.removeEvent(elem, type, data.handle);
                }
              }
            }

            // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove
            elem[dataPriv.expando] = undefined;
          }
          if (elem[dataUser.expando]) {
            // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove
            elem[dataUser.expando] = undefined;
          }
        }
      }
    }
  });
  jQuery.fn.extend({
    detach: function detach(selector) {
      return _remove(this, selector, true);
    },
    remove: function remove(selector) {
      return _remove(this, selector);
    },
    text: function text(value) {
      return access(this, function (value) {
        return value === undefined ? jQuery.text(this) : this.empty().each(function () {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            this.textContent = value;
          }
        });
      }, null, value, arguments.length);
    },
    append: function append() {
      return domManip(this, arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.appendChild(elem);
        }
      });
    },
    prepend: function prepend() {
      return domManip(this, arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.insertBefore(elem, target.firstChild);
        }
      });
    },
    before: function before() {
      return domManip(this, arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this);
        }
      });
    },
    after: function after() {
      return domManip(this, arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this.nextSibling);
        }
      });
    },
    empty: function empty() {
      var elem,
        i = 0;
      for (; (elem = this[i]) != null; i++) {
        if (elem.nodeType === 1) {
          // Prevent memory leaks
          jQuery.cleanData(getAll(elem, false));

          // Remove any remaining nodes
          elem.textContent = "";
        }
      }
      return this;
    },
    clone: function clone(dataAndEvents, deepDataAndEvents) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
      return this.map(function () {
        return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
      });
    },
    html: function html(value) {
      return access(this, function (value) {
        var elem = this[0] || {},
          i = 0,
          l = this.length;
        if (value === undefined && elem.nodeType === 1) {
          return elem.innerHTML;
        }

        // See if we can take a shortcut and just use innerHTML
        if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
          value = jQuery.htmlPrefilter(value);
          try {
            for (; i < l; i++) {
              elem = this[i] || {};

              // Remove element nodes and prevent memory leaks
              if (elem.nodeType === 1) {
                jQuery.cleanData(getAll(elem, false));
                elem.innerHTML = value;
              }
            }
            elem = 0;

            // If using innerHTML throws an exception, use the fallback method
          } catch (e) {}
        }
        if (elem) {
          this.empty().append(value);
        }
      }, null, value, arguments.length);
    },
    replaceWith: function replaceWith() {
      var ignored = [];

      // Make the changes, replacing each non-ignored context element with the new content
      return domManip(this, arguments, function (elem) {
        var parent = this.parentNode;
        if (jQuery.inArray(this, ignored) < 0) {
          jQuery.cleanData(getAll(this));
          if (parent) {
            parent.replaceChild(elem, this);
          }
        }

        // Force callback invocation
      }, ignored);
    }
  });
  jQuery.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function (name, original) {
    jQuery.fn[name] = function (selector) {
      var elems,
        ret = [],
        insert = jQuery(selector),
        last = insert.length - 1,
        i = 0;
      for (; i <= last; i++) {
        elems = i === last ? this : this.clone(true);
        jQuery(insert[i])[original](elems);

        // Support: Android <=4.0 only, PhantomJS 1 only
        // .get() because push.apply(_, arraylike) throws on ancient WebKit
        push.apply(ret, elems.get());
      }
      return this.pushStack(ret);
    };
  });
  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
  var rcustomProp = /^--/;
  var getStyles = function getStyles(elem) {
    // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
    // IE throws on elements created in popups
    // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
    var view = elem.ownerDocument.defaultView;
    if (!view || !view.opener) {
      view = window;
    }
    return view.getComputedStyle(elem);
  };
  var swap = function swap(elem, options, callback) {
    var ret,
      name,
      old = {};

    // Remember the old values, and insert the new ones
    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }
    ret = callback.call(elem);

    // Revert the old values
    for (name in options) {
      elem.style[name] = old[name];
    }
    return ret;
  };
  var rboxStyle = new RegExp(cssExpand.join("|"), "i");
  var whitespace = "[\\x20\\t\\r\\n\\f]";
  var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
  (function () {
    // Executing both pixelPosition & boxSizingReliable tests require only one layout
    // so they're executed at the same time to save the second computation.
    function computeStyleTests() {
      // This is a singleton, we need to execute it only once
      if (!div) {
        return;
      }
      container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
      div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
      documentElement.appendChild(container).appendChild(div);
      var divStyle = window.getComputedStyle(div);
      pixelPositionVal = divStyle.top !== "1%";

      // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
      reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

      // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
      // Some styles come back with percentage values, even though they shouldn't
      div.style.right = "60%";
      pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

      // Support: IE 9 - 11 only
      // Detect misreporting of content dimensions for box-sizing:border-box elements
      boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

      // Support: IE 9 only
      // Detect overflow:scroll screwiness (gh-3699)
      // Support: Chrome <=64
      // Don't get tricked when zoom affects offsetWidth (gh-4029)
      div.style.position = "absolute";
      scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
      documentElement.removeChild(container);

      // Nullify the div so it wouldn't be stored in the memory and
      // it will also be a sign that checks already performed
      div = null;
    }
    function roundPixelMeasures(measure) {
      return Math.round(parseFloat(measure));
    }
    var pixelPositionVal,
      boxSizingReliableVal,
      scrollboxSizeVal,
      pixelBoxStylesVal,
      reliableTrDimensionsVal,
      reliableMarginLeftVal,
      container = document.createElement("div"),
      div = document.createElement("div");

    // Finish early in limited (non-browser) environments
    if (!div.style) {
      return;
    }

    // Support: IE <=9 - 11 only
    // Style of cloned element affects source element cloned (trac-8908)
    div.style.backgroundClip = "content-box";
    div.cloneNode(true).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box";
    jQuery.extend(support, {
      boxSizingReliable: function boxSizingReliable() {
        computeStyleTests();
        return boxSizingReliableVal;
      },
      pixelBoxStyles: function pixelBoxStyles() {
        computeStyleTests();
        return pixelBoxStylesVal;
      },
      pixelPosition: function pixelPosition() {
        computeStyleTests();
        return pixelPositionVal;
      },
      reliableMarginLeft: function reliableMarginLeft() {
        computeStyleTests();
        return reliableMarginLeftVal;
      },
      scrollboxSize: function scrollboxSize() {
        computeStyleTests();
        return scrollboxSizeVal;
      },
      // Support: IE 9 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Behavior in IE 9 is more subtle than in newer versions & it passes
      // some versions of this test; make sure not to make it pass there!
      //
      // Support: Firefox 70+
      // Only Firefox includes border widths
      // in computed dimensions. (gh-4529)
      reliableTrDimensions: function reliableTrDimensions() {
        var table, tr, trChild, trStyle;
        if (reliableTrDimensionsVal == null) {
          table = document.createElement("table");
          tr = document.createElement("tr");
          trChild = document.createElement("div");
          table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
          tr.style.cssText = "border:1px solid";

          // Support: Chrome 86+
          // Height set through cssText does not get applied.
          // Computed height then comes back as 0.
          tr.style.height = "1px";
          trChild.style.height = "9px";

          // Support: Android 8 Chrome 86+
          // In our bodyBackground.html iframe,
          // display for all div elements is set to "inline",
          // which causes a problem only in Android 8 Chrome 86.
          // Ensuring the div is display: block
          // gets around this issue.
          trChild.style.display = "block";
          documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
          trStyle = window.getComputedStyle(tr);
          reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
          documentElement.removeChild(table);
        }
        return reliableTrDimensionsVal;
      }
    });
  })();
  function curCSS(elem, name, computed) {
    var width,
      minWidth,
      maxWidth,
      ret,
      isCustomProp = rcustomProp.test(name),
      // Support: Firefox 51+
      // Retrieving style before computed somehow
      // fixes an issue with getting wrong values
      // on detached elements
      style = elem.style;
    computed = computed || getStyles(elem);

    // getPropertyValue is needed for:
    //   .css('filter') (IE 9 only, trac-12537)
    //   .css('--customProperty) (gh-3144)
    if (computed) {
      // Support: IE <=9 - 11+
      // IE only supports `"float"` in `getPropertyValue`; in computed styles
      // it's only available as `"cssFloat"`. We no longer modify properties
      // sent to `.css()` apart from camelCasing, so we need to check both.
      // Normally, this would create difference in behavior: if
      // `getPropertyValue` returns an empty string, the value returned
      // by `.css()` would be `undefined`. This is usually the case for
      // disconnected elements. However, in IE even disconnected elements
      // with no styles return `"none"` for `getPropertyValue( "float" )`
      ret = computed.getPropertyValue(name) || computed[name];
      if (isCustomProp && ret) {
        // Support: Firefox 105+, Chrome <=105+
        // Spec requires trimming whitespace for custom properties (gh-4926).
        // Firefox only trims leading whitespace. Chrome just collapses
        // both leading & trailing whitespace to a single space.
        //
        // Fall back to `undefined` if empty string returned.
        // This collapses a missing definition with property defined
        // and set to an empty string but there's no standard API
        // allowing us to differentiate them without a performance penalty
        // and returning `undefined` aligns with older jQuery.
        //
        // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
        // as whitespace while CSS does not, but this is not a problem
        // because CSS preprocessing replaces them with U+000A LINE FEED
        // (which *is* CSS whitespace)
        // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
        ret = ret.replace(rtrimCSS, "$1") || undefined;
      }
      if (ret === "" && !isAttached(elem)) {
        ret = jQuery.style(elem, name);
      }

      // A tribute to the "awesome hack by Dean Edwards"
      // Android Browser returns percentage for some values,
      // but width seems to be reliably pixels.
      // This is against the CSSOM draft spec:
      // https://drafts.csswg.org/cssom/#resolved-values
      if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
        // Remember the original values
        width = style.width;
        minWidth = style.minWidth;
        maxWidth = style.maxWidth;

        // Put in the new values to get a computed value out
        style.minWidth = style.maxWidth = style.width = ret;
        ret = computed.width;

        // Revert the changed values
        style.width = width;
        style.minWidth = minWidth;
        style.maxWidth = maxWidth;
      }
    }
    return ret !== undefined ?
    // Support: IE <=9 - 11 only
    // IE returns zIndex value as an integer.
    ret + "" : ret;
  }
  function addGetHookIf(conditionFn, hookFn) {
    // Define the hook, we'll check on the first run if it's really needed.
    return {
      get: function get() {
        if (conditionFn()) {
          // Hook not needed (or it's not possible to use it due
          // to missing dependency), remove it.
          delete this.get;
          return;
        }

        // Hook needed; redefine it so that the support test is not executed again.
        return (this.get = hookFn).apply(this, arguments);
      }
    };
  }
  var cssPrefixes = ["Webkit", "Moz", "ms"],
    emptyStyle = document.createElement("div").style,
    vendorProps = {};

  // Return a vendor-prefixed property or undefined
  function vendorPropName(name) {
    // Check for vendor prefixed names
    var capName = name[0].toUpperCase() + name.slice(1),
      i = cssPrefixes.length;
    while (i--) {
      name = cssPrefixes[i] + capName;
      if (name in emptyStyle) {
        return name;
      }
    }
  }

  // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
  function finalPropName(name) {
    var _final = jQuery.cssProps[name] || vendorProps[name];
    if (_final) {
      return _final;
    }
    if (name in emptyStyle) {
      return name;
    }
    return vendorProps[name] = vendorPropName(name) || name;
  }
  var
    // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/,
    cssShow = {
      position: "absolute",
      visibility: "hidden",
      display: "block"
    },
    cssNormalTransform = {
      letterSpacing: "0",
      fontWeight: "400"
    };
  function setPositiveNumber(_elem, value, subtract) {
    // Any relative (+/-) values have already been
    // normalized at this point
    var matches = rcssNum.exec(value);
    return matches ?
    // Guard against undefined "subtract", e.g., when used as in cssHooks
    Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
  }
  function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
    var i = dimension === "width" ? 1 : 0,
      extra = 0,
      delta = 0;

    // Adjustment may not be necessary
    if (box === (isBorderBox ? "border" : "content")) {
      return 0;
    }
    for (; i < 4; i += 2) {
      // Both box models exclude margin
      if (box === "margin") {
        delta += jQuery.css(elem, box + cssExpand[i], true, styles);
      }

      // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
      if (!isBorderBox) {
        // Add padding
        delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

        // For "border" or "margin", add border
        if (box !== "padding") {
          delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

          // But still keep track of it otherwise
        } else {
          extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }

        // If we get here with a border-box (content + padding + border), we're seeking "content" or
        // "padding" or "margin"
      } else {
        // For "content", subtract padding
        if (box === "content") {
          delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        }

        // For "content" or "padding", subtract border
        if (box !== "margin") {
          delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      }
    }

    // Account for positive content-box scroll gutter when requested by providing computedVal
    if (!isBorderBox && computedVal >= 0) {
      // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
      // Assuming integer scroll gutter, subtract the rest and round down
      delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

      // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
      // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0;
    }
    return delta;
  }
  function getWidthOrHeight(elem, dimension, extra) {
    // Start with computed style
    var styles = getStyles(elem),
      // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
      // Fake content-box until we know it's needed to know the true value.
      boxSizingNeeded = !support.boxSizingReliable() || extra,
      isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
      valueIsBorderBox = isBorderBox,
      val = curCSS(elem, dimension, styles),
      offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

    // Support: Firefox <=54
    // Return a confounding non-pixel value or feign ignorance, as appropriate.
    if (rnumnonpx.test(val)) {
      if (!extra) {
        return val;
      }
      val = "auto";
    }

    // Support: IE 9 - 11 only
    // Use offsetWidth/offsetHeight for when box sizing is unreliable.
    // In those cases, the computed value can be trusted to be border-box.
    if ((!support.boxSizingReliable() && isBorderBox ||
    // Support: IE 10 - 11+, Edge 15 - 18+
    // IE/Edge misreport `getComputedStyle` of table rows with width/height
    // set in CSS while `offset*` properties report correct values.
    // Interestingly, in some cases IE 9 doesn't suffer from this issue.
    !support.reliableTrDimensions() && nodeName(elem, "tr") ||
    // Fall back to offsetWidth/offsetHeight when value is "auto"
    // This happens for inline elements with no explicit setting (gh-3571)
    val === "auto" ||
    // Support: Android <=4.1 - 4.3 only
    // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
    !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&
    // Make sure the element is visible & connected
    elem.getClientRects().length) {
      isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

      // Where available, offsetWidth/offsetHeight approximate border box dimensions.
      // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
      // retrieved value as a content box dimension.
      valueIsBorderBox = offsetProp in elem;
      if (valueIsBorderBox) {
        val = elem[offsetProp];
      }
    }

    // Normalize "" and auto
    val = parseFloat(val) || 0;

    // Adjust for the element's box model
    return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,
    // Provide the current computed size to request scroll gutter calculation (gh-3589)
    val) + "px";
  }
  jQuery.extend({
    // Add in style property hooks for overriding the default
    // behavior of getting and setting a style property
    cssHooks: {
      opacity: {
        get: function get(elem, computed) {
          if (computed) {
            // We should always get a number back from opacity
            var ret = curCSS(elem, "opacity");
            return ret === "" ? "1" : ret;
          }
        }
      }
    },
    // Don't automatically add "px" to these possibly-unitless properties
    cssNumber: {
      "animationIterationCount": true,
      "columnCount": true,
      "fillOpacity": true,
      "flexGrow": true,
      "flexShrink": true,
      "fontWeight": true,
      "gridArea": true,
      "gridColumn": true,
      "gridColumnEnd": true,
      "gridColumnStart": true,
      "gridRow": true,
      "gridRowEnd": true,
      "gridRowStart": true,
      "lineHeight": true,
      "opacity": true,
      "order": true,
      "orphans": true,
      "widows": true,
      "zIndex": true,
      "zoom": true
    },
    // Add in properties whose names you wish to fix before
    // setting or getting the value
    cssProps: {},
    // Get and set the style property on a DOM Node
    style: function style(elem, name, value, extra) {
      // Don't set styles on text and comment nodes
      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
        return;
      }

      // Make sure that we're working with the right name
      var ret,
        type,
        hooks,
        origName = camelCase(name),
        isCustomProp = rcustomProp.test(name),
        style = elem.style;

      // Make sure that we're working with the right name. We don't
      // want to query the value if it is a CSS custom property
      // since they are user-defined.
      if (!isCustomProp) {
        name = finalPropName(origName);
      }

      // Gets hook for the prefixed version, then unprefixed version
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

      // Check if we're setting a value
      if (value !== undefined) {
        type = (0, _typeof2["default"])(value);

        // Convert "+=" or "-=" to relative numbers (trac-7345)
        if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
          value = adjustCSS(elem, name, ret);

          // Fixes bug trac-9237
          type = "number";
        }

        // Make sure that null and NaN values aren't set (trac-7116)
        if (value == null || value !== value) {
          return;
        }

        // If a number was passed in, add the unit (except for certain CSS properties)
        // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
        // "px" to a few hardcoded values.
        if (type === "number" && !isCustomProp) {
          value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
        }

        // background-* props affect original clone's values
        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
          style[name] = "inherit";
        }

        // If a hook was provided, use that value, otherwise just set the specified value
        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
          if (isCustomProp) {
            style.setProperty(name, value);
          } else {
            style[name] = value;
          }
        }
      } else {
        // If a hook was provided get the non-computed value from there
        if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
          return ret;
        }

        // Otherwise just get the value from the style object
        return style[name];
      }
    },
    css: function css(elem, name, extra, styles) {
      var val,
        num,
        hooks,
        origName = camelCase(name),
        isCustomProp = rcustomProp.test(name);

      // Make sure that we're working with the right name. We don't
      // want to modify the value if it is a CSS custom property
      // since they are user-defined.
      if (!isCustomProp) {
        name = finalPropName(origName);
      }

      // Try prefixed name followed by the unprefixed name
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

      // If a hook was provided get the computed value from there
      if (hooks && "get" in hooks) {
        val = hooks.get(elem, true, extra);
      }

      // Otherwise, if a way to get the computed value exists, use that
      if (val === undefined) {
        val = curCSS(elem, name, styles);
      }

      // Convert "normal" to computed value
      if (val === "normal" && name in cssNormalTransform) {
        val = cssNormalTransform[name];
      }

      // Make numeric if forced or a qualifier was provided and val looks numeric
      if (extra === "" || extra) {
        num = parseFloat(val);
        return extra === true || isFinite(num) ? num || 0 : val;
      }
      return val;
    }
  });
  jQuery.each(["height", "width"], function (_i, dimension) {
    jQuery.cssHooks[dimension] = {
      get: function get(elem, computed, extra) {
        if (computed) {
          // Certain elements can have dimension info if we invisibly show them
          // but it must have a current display style that would benefit
          return rdisplayswap.test(jQuery.css(elem, "display")) && (
          // Support: Safari 8+
          // Table columns in Safari have non-zero offsetWidth & zero
          // getBoundingClientRect().width unless display is changed.
          // Support: IE <=11 only
          // Running getBoundingClientRect on a disconnected node
          // in IE throws an error.
          !elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
            return getWidthOrHeight(elem, dimension, extra);
          }) : getWidthOrHeight(elem, dimension, extra);
        }
      },
      set: function set(elem, value, extra) {
        var matches,
          styles = getStyles(elem),
          // Only read styles.position if the test has a chance to fail
          // to avoid forcing a reflow.
          scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",
          // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
          boxSizingNeeded = scrollboxSizeBuggy || extra,
          isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
          subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

        // Account for unreliable border-box dimensions by comparing offset* to computed and
        // faking a content-box to get border and padding (gh-3699)
        if (isBorderBox && scrollboxSizeBuggy) {
          subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
        }

        // Convert to pixels if value adjustment is needed
        if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
          elem.style[dimension] = value;
          value = jQuery.css(elem, dimension);
        }
        return setPositiveNumber(elem, value, subtract);
      }
    };
  });
  jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
    if (computed) {
      return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
        marginLeft: 0
      }, function () {
        return elem.getBoundingClientRect().left;
      })) + "px";
    }
  });

  // These hooks are used by animate to expand properties
  jQuery.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function (prefix, suffix) {
    jQuery.cssHooks[prefix + suffix] = {
      expand: function expand(value) {
        var i = 0,
          expanded = {},
          // Assumes a single number if not a string
          parts = typeof value === "string" ? value.split(" ") : [value];
        for (; i < 4; i++) {
          expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
        }
        return expanded;
      }
    };
    if (prefix !== "margin") {
      jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    }
  });
  jQuery.fn.extend({
    css: function css(name, value) {
      return access(this, function (elem, name, value) {
        var styles,
          len,
          map = {},
          i = 0;
        if (Array.isArray(name)) {
          styles = getStyles(elem);
          len = name.length;
          for (; i < len; i++) {
            map[name[i]] = jQuery.css(elem, name[i], false, styles);
          }
          return map;
        }
        return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
      }, name, value, arguments.length > 1);
    }
  });
  function Tween(elem, options, prop, end, easing) {
    return new Tween.prototype.init(elem, options, prop, end, easing);
  }
  jQuery.Tween = Tween;
  Tween.prototype = {
    constructor: Tween,
    init: function init(elem, options, prop, end, easing, unit) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || jQuery.easing._default;
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
    },
    cur: function cur() {
      var hooks = Tween.propHooks[this.prop];
      return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
    },
    run: function run(percent) {
      var eased,
        hooks = Tween.propHooks[this.prop];
      if (this.options.duration) {
        this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
      } else {
        this.pos = eased = percent;
      }
      this.now = (this.end - this.start) * eased + this.start;
      if (this.options.step) {
        this.options.step.call(this.elem, this.now, this);
      }
      if (hooks && hooks.set) {
        hooks.set(this);
      } else {
        Tween.propHooks._default.set(this);
      }
      return this;
    }
  };
  Tween.prototype.init.prototype = Tween.prototype;
  Tween.propHooks = {
    _default: {
      get: function get(tween) {
        var result;

        // Use a property on the element directly when it is not a DOM element,
        // or when there is no matching style property that exists.
        if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
          return tween.elem[tween.prop];
        }

        // Passing an empty string as a 3rd parameter to .css will automatically
        // attempt a parseFloat and fallback to a string if the parse fails.
        // Simple values such as "10px" are parsed to Float;
        // complex values such as "rotate(1rad)" are returned as-is.
        result = jQuery.css(tween.elem, tween.prop, "");

        // Empty strings, null, undefined and "auto" are converted to 0.
        return !result || result === "auto" ? 0 : result;
      },
      set: function set(tween) {
        // Use step hook for back compat.
        // Use cssHook if its there.
        // Use .style if available and use plain properties where available.
        if (jQuery.fx.step[tween.prop]) {
          jQuery.fx.step[tween.prop](tween);
        } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
          jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
        } else {
          tween.elem[tween.prop] = tween.now;
        }
      }
    }
  };

  // Support: IE <=9 only
  // Panic based approach to setting things on disconnected nodes
  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
    set: function set(tween) {
      if (tween.elem.nodeType && tween.elem.parentNode) {
        tween.elem[tween.prop] = tween.now;
      }
    }
  };
  jQuery.easing = {
    linear: function linear(p) {
      return p;
    },
    swing: function swing(p) {
      return 0.5 - Math.cos(p * Math.PI) / 2;
    },
    _default: "swing"
  };
  jQuery.fx = Tween.prototype.init;

  // Back compat <1.8 extension point
  jQuery.fx.step = {};
  var fxNow,
    inProgress,
    rfxtypes = /^(?:toggle|show|hide)$/,
    rrun = /queueHooks$/;
  function schedule() {
    if (inProgress) {
      if (document.hidden === false && window.requestAnimationFrame) {
        window.requestAnimationFrame(schedule);
      } else {
        window.setTimeout(schedule, jQuery.fx.interval);
      }
      jQuery.fx.tick();
    }
  }

  // Animations created synchronously will run synchronously
  function createFxNow() {
    window.setTimeout(function () {
      fxNow = undefined;
    });
    return fxNow = Date.now();
  }

  // Generate parameters to create a standard animation
  function genFx(type, includeWidth) {
    var which,
      i = 0,
      attrs = {
        height: type
      };

    // If we include width, step value is 1 to do all cssExpand values,
    // otherwise step value is 2 to skip over Left and Right
    includeWidth = includeWidth ? 1 : 0;
    for (; i < 4; i += 2 - includeWidth) {
      which = cssExpand[i];
      attrs["margin" + which] = attrs["padding" + which] = type;
    }
    if (includeWidth) {
      attrs.opacity = attrs.width = type;
    }
    return attrs;
  }
  function createTween(value, prop, animation) {
    var tween,
      collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
      index = 0,
      length = collection.length;
    for (; index < length; index++) {
      if (tween = collection[index].call(animation, prop, value)) {
        // We're done with this property
        return tween;
      }
    }
  }
  function defaultPrefilter(elem, props, opts) {
    var prop,
      value,
      toggle,
      hooks,
      oldfire,
      propTween,
      restoreDisplay,
      display,
      isBox = "width" in props || "height" in props,
      anim = this,
      orig = {},
      style = elem.style,
      hidden = elem.nodeType && isHiddenWithinTree(elem),
      dataShow = dataPriv.get(elem, "fxshow");

    // Queue-skipping animations hijack the fx hooks
    if (!opts.queue) {
      hooks = jQuery._queueHooks(elem, "fx");
      if (hooks.unqueued == null) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;
        hooks.empty.fire = function () {
          if (!hooks.unqueued) {
            oldfire();
          }
        };
      }
      hooks.unqueued++;
      anim.always(function () {
        // Ensure the complete handler is called before this completes
        anim.always(function () {
          hooks.unqueued--;
          if (!jQuery.queue(elem, "fx").length) {
            hooks.empty.fire();
          }
        });
      });
    }

    // Detect show/hide animations
    for (prop in props) {
      value = props[prop];
      if (rfxtypes.test(value)) {
        delete props[prop];
        toggle = toggle || value === "toggle";
        if (value === (hidden ? "hide" : "show")) {
          // Pretend to be hidden if this is a "show" and
          // there is still data from a stopped show/hide
          if (value === "show" && dataShow && dataShow[prop] !== undefined) {
            hidden = true;

            // Ignore all other no-op show/hide data
          } else {
            continue;
          }
        }
        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
      }
    }

    // Bail out if this is a no-op like .hide().hide()
    propTween = !jQuery.isEmptyObject(props);
    if (!propTween && jQuery.isEmptyObject(orig)) {
      return;
    }

    // Restrict "overflow" and "display" styles during box animations
    if (isBox && elem.nodeType === 1) {
      // Support: IE <=9 - 11, Edge 12 - 15
      // Record all 3 overflow attributes because IE does not infer the shorthand
      // from identically-valued overflowX and overflowY and Edge just mirrors
      // the overflowX value there.
      opts.overflow = [style.overflow, style.overflowX, style.overflowY];

      // Identify a display type, preferring old show/hide data over the CSS cascade
      restoreDisplay = dataShow && dataShow.display;
      if (restoreDisplay == null) {
        restoreDisplay = dataPriv.get(elem, "display");
      }
      display = jQuery.css(elem, "display");
      if (display === "none") {
        if (restoreDisplay) {
          display = restoreDisplay;
        } else {
          // Get nonempty value(s) by temporarily forcing visibility
          showHide([elem], true);
          restoreDisplay = elem.style.display || restoreDisplay;
          display = jQuery.css(elem, "display");
          showHide([elem]);
        }
      }

      // Animate inline elements as inline-block
      if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
        if (jQuery.css(elem, "float") === "none") {
          // Restore the original display value at the end of pure show/hide animations
          if (!propTween) {
            anim.done(function () {
              style.display = restoreDisplay;
            });
            if (restoreDisplay == null) {
              display = style.display;
              restoreDisplay = display === "none" ? "" : display;
            }
          }
          style.display = "inline-block";
        }
      }
    }
    if (opts.overflow) {
      style.overflow = "hidden";
      anim.always(function () {
        style.overflow = opts.overflow[0];
        style.overflowX = opts.overflow[1];
        style.overflowY = opts.overflow[2];
      });
    }

    // Implement show/hide animations
    propTween = false;
    for (prop in orig) {
      // General show/hide setup for this element animation
      if (!propTween) {
        if (dataShow) {
          if ("hidden" in dataShow) {
            hidden = dataShow.hidden;
          }
        } else {
          dataShow = dataPriv.access(elem, "fxshow", {
            display: restoreDisplay
          });
        }

        // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
        if (toggle) {
          dataShow.hidden = !hidden;
        }

        // Show elements before animating them
        if (hidden) {
          showHide([elem], true);
        }

        /* eslint-disable no-loop-func */

        anim.done(function () {
          /* eslint-enable no-loop-func */

          // The final step of a "hide" animation is actually hiding the element
          if (!hidden) {
            showHide([elem]);
          }
          dataPriv.remove(elem, "fxshow");
          for (prop in orig) {
            jQuery.style(elem, prop, orig[prop]);
          }
        });
      }

      // Per-property setup
      propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
      if (!(prop in dataShow)) {
        dataShow[prop] = propTween.start;
        if (hidden) {
          propTween.end = propTween.start;
          propTween.start = 0;
        }
      }
    }
  }
  function propFilter(props, specialEasing) {
    var index, name, easing, value, hooks;

    // camelCase, specialEasing and expand cssHook pass
    for (index in props) {
      name = camelCase(index);
      easing = specialEasing[name];
      value = props[index];
      if (Array.isArray(value)) {
        easing = value[1];
        value = props[index] = value[0];
      }
      if (index !== name) {
        props[name] = value;
        delete props[index];
      }
      hooks = jQuery.cssHooks[name];
      if (hooks && "expand" in hooks) {
        value = hooks.expand(value);
        delete props[name];

        // Not quite $.extend, this won't overwrite existing keys.
        // Reusing 'index' because we have the correct "name"
        for (index in value) {
          if (!(index in props)) {
            props[index] = value[index];
            specialEasing[index] = easing;
          }
        }
      } else {
        specialEasing[name] = easing;
      }
    }
  }
  function Animation(elem, properties, options) {
    var result,
      stopped,
      index = 0,
      length = Animation.prefilters.length,
      deferred = jQuery.Deferred().always(function () {
        // Don't match elem in the :animated selector
        delete tick.elem;
      }),
      tick = function tick() {
        if (stopped) {
          return false;
        }
        var currentTime = fxNow || createFxNow(),
          remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
          // Support: Android 2.3 only
          // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
          temp = remaining / animation.duration || 0,
          percent = 1 - temp,
          index = 0,
          length = animation.tweens.length;
        for (; index < length; index++) {
          animation.tweens[index].run(percent);
        }
        deferred.notifyWith(elem, [animation, percent, remaining]);

        // If there's more to do, yield
        if (percent < 1 && length) {
          return remaining;
        }

        // If this was an empty animation, synthesize a final progress notification
        if (!length) {
          deferred.notifyWith(elem, [animation, 1, 0]);
        }

        // Resolve the animation and report its conclusion
        deferred.resolveWith(elem, [animation]);
        return false;
      },
      animation = deferred.promise({
        elem: elem,
        props: jQuery.extend({}, properties),
        opts: jQuery.extend(true, {
          specialEasing: {},
          easing: jQuery.easing._default
        }, options),
        originalProperties: properties,
        originalOptions: options,
        startTime: fxNow || createFxNow(),
        duration: options.duration,
        tweens: [],
        createTween: function createTween(prop, end) {
          var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
          animation.tweens.push(tween);
          return tween;
        },
        stop: function stop(gotoEnd) {
          var index = 0,
            // If we are going to the end, we want to run all the tweens
            // otherwise we skip this part
            length = gotoEnd ? animation.tweens.length : 0;
          if (stopped) {
            return this;
          }
          stopped = true;
          for (; index < length; index++) {
            animation.tweens[index].run(1);
          }

          // Resolve when we played the last frame; otherwise, reject
          if (gotoEnd) {
            deferred.notifyWith(elem, [animation, 1, 0]);
            deferred.resolveWith(elem, [animation, gotoEnd]);
          } else {
            deferred.rejectWith(elem, [animation, gotoEnd]);
          }
          return this;
        }
      }),
      props = animation.props;
    propFilter(props, animation.opts.specialEasing);
    for (; index < length; index++) {
      result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
      if (result) {
        if (isFunction(result.stop)) {
          jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
        }
        return result;
      }
    }
    jQuery.map(props, createTween, animation);
    if (isFunction(animation.opts.start)) {
      animation.opts.start.call(elem, animation);
    }

    // Attach callbacks from options
    animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
    jQuery.fx.timer(jQuery.extend(tick, {
      elem: elem,
      anim: animation,
      queue: animation.opts.queue
    }));
    return animation;
  }
  jQuery.Animation = jQuery.extend(Animation, {
    tweeners: {
      "*": [function (prop, value) {
        var tween = this.createTween(prop, value);
        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
        return tween;
      }]
    },
    tweener: function tweener(props, callback) {
      if (isFunction(props)) {
        callback = props;
        props = ["*"];
      } else {
        props = props.match(rnothtmlwhite);
      }
      var prop,
        index = 0,
        length = props.length;
      for (; index < length; index++) {
        prop = props[index];
        Animation.tweeners[prop] = Animation.tweeners[prop] || [];
        Animation.tweeners[prop].unshift(callback);
      }
    },
    prefilters: [defaultPrefilter],
    prefilter: function prefilter(callback, prepend) {
      if (prepend) {
        Animation.prefilters.unshift(callback);
      } else {
        Animation.prefilters.push(callback);
      }
    }
  });
  jQuery.speed = function (speed, easing, fn) {
    var opt = speed && (0, _typeof2["default"])(speed) === "object" ? jQuery.extend({}, speed) : {
      complete: fn || !fn && easing || isFunction(speed) && speed,
      duration: speed,
      easing: fn && easing || easing && !isFunction(easing) && easing
    };

    // Go to the end state if fx are off
    if (jQuery.fx.off) {
      opt.duration = 0;
    } else {
      if (typeof opt.duration !== "number") {
        if (opt.duration in jQuery.fx.speeds) {
          opt.duration = jQuery.fx.speeds[opt.duration];
        } else {
          opt.duration = jQuery.fx.speeds._default;
        }
      }
    }

    // Normalize opt.queue - true/undefined/null -> "fx"
    if (opt.queue == null || opt.queue === true) {
      opt.queue = "fx";
    }

    // Queueing
    opt.old = opt.complete;
    opt.complete = function () {
      if (isFunction(opt.old)) {
        opt.old.call(this);
      }
      if (opt.queue) {
        jQuery.dequeue(this, opt.queue);
      }
    };
    return opt;
  };
  jQuery.fn.extend({
    fadeTo: function fadeTo(speed, to, easing, callback) {
      // Show any hidden elements after setting opacity to 0
      return this.filter(isHiddenWithinTree).css("opacity", 0).show()

      // Animate to the value specified
      .end().animate({
        opacity: to
      }, speed, easing, callback);
    },
    animate: function animate(prop, speed, easing, callback) {
      var empty = jQuery.isEmptyObject(prop),
        optall = jQuery.speed(speed, easing, callback),
        doAnimation = function doAnimation() {
          // Operate on a copy of prop so per-property easing won't be lost
          var anim = Animation(this, jQuery.extend({}, prop), optall);

          // Empty animations, or finishing resolves immediately
          if (empty || dataPriv.get(this, "finish")) {
            anim.stop(true);
          }
        };
      doAnimation.finish = doAnimation;
      return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
    },
    stop: function stop(type, clearQueue, gotoEnd) {
      var stopQueue = function stopQueue(hooks) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop(gotoEnd);
      };
      if (typeof type !== "string") {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }
      if (clearQueue) {
        this.queue(type || "fx", []);
      }
      return this.each(function () {
        var dequeue = true,
          index = type != null && type + "queueHooks",
          timers = jQuery.timers,
          data = dataPriv.get(this);
        if (index) {
          if (data[index] && data[index].stop) {
            stopQueue(data[index]);
          }
        } else {
          for (index in data) {
            if (data[index] && data[index].stop && rrun.test(index)) {
              stopQueue(data[index]);
            }
          }
        }
        for (index = timers.length; index--;) {
          if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
            timers[index].anim.stop(gotoEnd);
            dequeue = false;
            timers.splice(index, 1);
          }
        }

        // Start the next in the queue if the last step wasn't forced.
        // Timers currently will call their complete callbacks, which
        // will dequeue but only if they were gotoEnd.
        if (dequeue || !gotoEnd) {
          jQuery.dequeue(this, type);
        }
      });
    },
    finish: function finish(type) {
      if (type !== false) {
        type = type || "fx";
      }
      return this.each(function () {
        var index,
          data = dataPriv.get(this),
          queue = data[type + "queue"],
          hooks = data[type + "queueHooks"],
          timers = jQuery.timers,
          length = queue ? queue.length : 0;

        // Enable finishing flag on private data
        data.finish = true;

        // Empty the queue first
        jQuery.queue(this, type, []);
        if (hooks && hooks.stop) {
          hooks.stop.call(this, true);
        }

        // Look for any active animations, and finish them
        for (index = timers.length; index--;) {
          if (timers[index].elem === this && timers[index].queue === type) {
            timers[index].anim.stop(true);
            timers.splice(index, 1);
          }
        }

        // Look for any animations in the old queue and finish them
        for (index = 0; index < length; index++) {
          if (queue[index] && queue[index].finish) {
            queue[index].finish.call(this);
          }
        }

        // Turn off finishing flag
        delete data.finish;
      });
    }
  });
  jQuery.each(["toggle", "show", "hide"], function (_i, name) {
    var cssFn = jQuery.fn[name];
    jQuery.fn[name] = function (speed, easing, callback) {
      return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
    };
  });

  // Generate shortcuts for custom animations
  jQuery.each({
    slideDown: genFx("show"),
    slideUp: genFx("hide"),
    slideToggle: genFx("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function (name, props) {
    jQuery.fn[name] = function (speed, easing, callback) {
      return this.animate(props, speed, easing, callback);
    };
  });
  jQuery.timers = [];
  jQuery.fx.tick = function () {
    var timer,
      i = 0,
      timers = jQuery.timers;
    fxNow = Date.now();
    for (; i < timers.length; i++) {
      timer = timers[i];

      // Run the timer and safely remove it when done (allowing for external removal)
      if (!timer() && timers[i] === timer) {
        timers.splice(i--, 1);
      }
    }
    if (!timers.length) {
      jQuery.fx.stop();
    }
    fxNow = undefined;
  };
  jQuery.fx.timer = function (timer) {
    jQuery.timers.push(timer);
    jQuery.fx.start();
  };
  jQuery.fx.interval = 13;
  jQuery.fx.start = function () {
    if (inProgress) {
      return;
    }
    inProgress = true;
    schedule();
  };
  jQuery.fx.stop = function () {
    inProgress = null;
  };
  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,
    // Default speed
    _default: 400
  };

  // Based off of the plugin by Clint Helfers, with permission.
  jQuery.fn.delay = function (time, type) {
    time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
    type = type || "fx";
    return this.queue(type, function (next, hooks) {
      var timeout = window.setTimeout(next, time);
      hooks.stop = function () {
        window.clearTimeout(timeout);
      };
    });
  };
  (function () {
    var input = document.createElement("input"),
      select = document.createElement("select"),
      opt = select.appendChild(document.createElement("option"));
    input.type = "checkbox";

    // Support: Android <=4.3 only
    // Default value for a checkbox should be "on"
    support.checkOn = input.value !== "";

    // Support: IE <=11 only
    // Must access selectedIndex to make default options select
    support.optSelected = opt.selected;

    // Support: IE <=11 only
    // An input loses its value after becoming a radio
    input = document.createElement("input");
    input.value = "t";
    input.type = "radio";
    support.radioValue = input.value === "t";
  })();
  var boolHook,
    attrHandle = jQuery.expr.attrHandle;
  jQuery.fn.extend({
    attr: function attr(name, value) {
      return access(this, jQuery.attr, name, value, arguments.length > 1);
    },
    removeAttr: function removeAttr(name) {
      return this.each(function () {
        jQuery.removeAttr(this, name);
      });
    }
  });
  jQuery.extend({
    attr: function attr(elem, name, value) {
      var ret,
        hooks,
        nType = elem.nodeType;

      // Don't get/set attributes on text, comment and attribute nodes
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }

      // Fallback to prop when attributes are not supported
      if (typeof elem.getAttribute === "undefined") {
        return jQuery.prop(elem, name, value);
      }

      // Attribute hooks are determined by the lowercase version
      // Grab necessary hook if one is defined
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
      }
      if (value !== undefined) {
        if (value === null) {
          jQuery.removeAttr(elem, name);
          return;
        }
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        elem.setAttribute(name, value + "");
        return value;
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      ret = jQuery.find.attr(elem, name);

      // Non-existent attributes return null, we normalize to undefined
      return ret == null ? undefined : ret;
    },
    attrHooks: {
      type: {
        set: function set(elem, value) {
          if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
            var val = elem.value;
            elem.setAttribute("type", value);
            if (val) {
              elem.value = val;
            }
            return value;
          }
        }
      }
    },
    removeAttr: function removeAttr(elem, value) {
      var name,
        i = 0,
        // Attribute names can contain non-HTML whitespace characters
        // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
        attrNames = value && value.match(rnothtmlwhite);
      if (attrNames && elem.nodeType === 1) {
        while (name = attrNames[i++]) {
          elem.removeAttribute(name);
        }
      }
    }
  });

  // Hooks for boolean attributes
  boolHook = {
    set: function set(elem, value, name) {
      if (value === false) {
        // Remove boolean attributes when set to false
        jQuery.removeAttr(elem, name);
      } else {
        elem.setAttribute(name, name);
      }
      return name;
    }
  };
  jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
    var getter = attrHandle[name] || jQuery.find.attr;
    attrHandle[name] = function (elem, name, isXML) {
      var ret,
        handle,
        lowercaseName = name.toLowerCase();
      if (!isXML) {
        // Avoid an infinite loop by temporarily removing this function from the getter
        handle = attrHandle[lowercaseName];
        attrHandle[lowercaseName] = ret;
        ret = getter(elem, name, isXML) != null ? lowercaseName : null;
        attrHandle[lowercaseName] = handle;
      }
      return ret;
    };
  });
  var rfocusable = /^(?:input|select|textarea|button)$/i,
    rclickable = /^(?:a|area)$/i;
  jQuery.fn.extend({
    prop: function prop(name, value) {
      return access(this, jQuery.prop, name, value, arguments.length > 1);
    },
    removeProp: function removeProp(name) {
      return this.each(function () {
        delete this[jQuery.propFix[name] || name];
      });
    }
  });
  jQuery.extend({
    prop: function prop(elem, name, value) {
      var ret,
        hooks,
        nType = elem.nodeType;

      // Don't get/set properties on text, comment and attribute nodes
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        // Fix name and attach hooks
        name = jQuery.propFix[name] || name;
        hooks = jQuery.propHooks[name];
      }
      if (value !== undefined) {
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        return elem[name] = value;
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      return elem[name];
    },
    propHooks: {
      tabIndex: {
        get: function get(elem) {
          // Support: IE <=9 - 11 only
          // elem.tabIndex doesn't always return the
          // correct value when it hasn't been explicitly set
          // Use proper attribute retrieval (trac-12072)
          var tabindex = jQuery.find.attr(elem, "tabindex");
          if (tabindex) {
            return parseInt(tabindex, 10);
          }
          if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
            return 0;
          }
          return -1;
        }
      }
    },
    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  });

  // Support: IE <=11 only
  // Accessing the selectedIndex property
  // forces the browser to respect setting selected
  // on the option
  // The getter ensures a default option is selected
  // when in an optgroup
  // eslint rule "no-unused-expressions" is disabled for this code
  // since it considers such accessions noop
  if (!support.optSelected) {
    jQuery.propHooks.selected = {
      get: function get(elem) {
        /* eslint no-unused-expressions: "off" */

        var parent = elem.parentNode;
        if (parent && parent.parentNode) {
          parent.parentNode.selectedIndex;
        }
        return null;
      },
      set: function set(elem) {
        /* eslint no-unused-expressions: "off" */

        var parent = elem.parentNode;
        if (parent) {
          parent.selectedIndex;
          if (parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
        }
      }
    };
  }
  jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    jQuery.propFix[this.toLowerCase()] = this;
  });

  // Strip and collapse whitespace according to HTML spec
  // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
  function stripAndCollapse(value) {
    var tokens = value.match(rnothtmlwhite) || [];
    return tokens.join(" ");
  }
  function getClass(elem) {
    return elem.getAttribute && elem.getAttribute("class") || "";
  }
  function classesToArray(value) {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === "string") {
      return value.match(rnothtmlwhite) || [];
    }
    return [];
  }
  jQuery.fn.extend({
    addClass: function addClass(value) {
      var classNames, cur, curValue, className, i, finalValue;
      if (isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).addClass(value.call(this, j, getClass(this)));
        });
      }
      classNames = classesToArray(value);
      if (classNames.length) {
        return this.each(function () {
          curValue = getClass(this);
          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
          if (cur) {
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i];
              if (cur.indexOf(" " + className + " ") < 0) {
                cur += className + " ";
              }
            }

            // Only assign if different to avoid unneeded rendering.
            finalValue = stripAndCollapse(cur);
            if (curValue !== finalValue) {
              this.setAttribute("class", finalValue);
            }
          }
        });
      }
      return this;
    },
    removeClass: function removeClass(value) {
      var classNames, cur, curValue, className, i, finalValue;
      if (isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).removeClass(value.call(this, j, getClass(this)));
        });
      }
      if (!arguments.length) {
        return this.attr("class", "");
      }
      classNames = classesToArray(value);
      if (classNames.length) {
        return this.each(function () {
          curValue = getClass(this);

          // This expression is here for better compressibility (see addClass)
          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
          if (cur) {
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i];

              // Remove *all* instances
              while (cur.indexOf(" " + className + " ") > -1) {
                cur = cur.replace(" " + className + " ", " ");
              }
            }

            // Only assign if different to avoid unneeded rendering.
            finalValue = stripAndCollapse(cur);
            if (curValue !== finalValue) {
              this.setAttribute("class", finalValue);
            }
          }
        });
      }
      return this;
    },
    toggleClass: function toggleClass(value, stateVal) {
      var classNames,
        className,
        i,
        self,
        type = (0, _typeof2["default"])(value),
        isValidValue = type === "string" || Array.isArray(value);
      if (isFunction(value)) {
        return this.each(function (i) {
          jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
        });
      }
      if (typeof stateVal === "boolean" && isValidValue) {
        return stateVal ? this.addClass(value) : this.removeClass(value);
      }
      classNames = classesToArray(value);
      return this.each(function () {
        if (isValidValue) {
          // Toggle individual class names
          self = jQuery(this);
          for (i = 0; i < classNames.length; i++) {
            className = classNames[i];

            // Check each className given, space separated list
            if (self.hasClass(className)) {
              self.removeClass(className);
            } else {
              self.addClass(className);
            }
          }

          // Toggle whole class name
        } else if (value === undefined || type === "boolean") {
          className = getClass(this);
          if (className) {
            // Store className if set
            dataPriv.set(this, "__className__", className);
          }

          // If the element has a class name or if we're passed `false`,
          // then remove the whole classname (if there was one, the above saved it).
          // Otherwise bring back whatever was previously saved (if anything),
          // falling back to the empty string if nothing was stored.
          if (this.setAttribute) {
            this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
          }
        }
      });
    },
    hasClass: function hasClass(selector) {
      var className,
        elem,
        i = 0;
      className = " " + selector + " ";
      while (elem = this[i++]) {
        if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
          return true;
        }
      }
      return false;
    }
  });
  var rreturn = /\r/g;
  jQuery.fn.extend({
    val: function val(value) {
      var hooks,
        ret,
        valueIsFunction,
        elem = this[0];
      if (!arguments.length) {
        if (elem) {
          hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
          if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
            return ret;
          }
          ret = elem.value;

          // Handle most common string cases
          if (typeof ret === "string") {
            return ret.replace(rreturn, "");
          }

          // Handle cases where value is null/undef or number
          return ret == null ? "" : ret;
        }
        return;
      }
      valueIsFunction = isFunction(value);
      return this.each(function (i) {
        var val;
        if (this.nodeType !== 1) {
          return;
        }
        if (valueIsFunction) {
          val = value.call(this, i, jQuery(this).val());
        } else {
          val = value;
        }

        // Treat null/undefined as ""; convert numbers to string
        if (val == null) {
          val = "";
        } else if (typeof val === "number") {
          val += "";
        } else if (Array.isArray(val)) {
          val = jQuery.map(val, function (value) {
            return value == null ? "" : value + "";
          });
        }
        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

        // If set returns undefined, fall back to normal setting
        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
          this.value = val;
        }
      });
    }
  });
  jQuery.extend({
    valHooks: {
      option: {
        get: function get(elem) {
          var val = jQuery.find.attr(elem, "value");
          return val != null ? val :
          // Support: IE <=10 - 11 only
          // option.text throws exceptions (trac-14686, trac-14858)
          // Strip and collapse whitespace
          // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
          stripAndCollapse(jQuery.text(elem));
        }
      },
      select: {
        get: function get(elem) {
          var value,
            option,
            i,
            options = elem.options,
            index = elem.selectedIndex,
            one = elem.type === "select-one",
            values = one ? null : [],
            max = one ? index + 1 : options.length;
          if (index < 0) {
            i = max;
          } else {
            i = one ? index : 0;
          }

          // Loop through all the selected options
          for (; i < max; i++) {
            option = options[i];

            // Support: IE <=9 only
            // IE8-9 doesn't update selected after form reset (trac-2551)
            if ((option.selected || i === index) &&
            // Don't return options that are disabled or in a disabled optgroup
            !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
              // Get the specific value for the option
              value = jQuery(option).val();

              // We don't need an array for one selects
              if (one) {
                return value;
              }

              // Multi-Selects return an array
              values.push(value);
            }
          }
          return values;
        },
        set: function set(elem, value) {
          var optionSet,
            option,
            options = elem.options,
            values = jQuery.makeArray(value),
            i = options.length;
          while (i--) {
            option = options[i];

            /* eslint-disable no-cond-assign */

            if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
              optionSet = true;
            }

            /* eslint-enable no-cond-assign */
          }

          // Force browsers to behave consistently when non-matching value is set
          if (!optionSet) {
            elem.selectedIndex = -1;
          }
          return values;
        }
      }
    }
  });

  // Radios and checkboxes getter/setter
  jQuery.each(["radio", "checkbox"], function () {
    jQuery.valHooks[this] = {
      set: function set(elem, value) {
        if (Array.isArray(value)) {
          return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
        }
      }
    };
    if (!support.checkOn) {
      jQuery.valHooks[this].get = function (elem) {
        return elem.getAttribute("value") === null ? "on" : elem.value;
      };
    }
  });

  // Return jQuery for attributes-only inclusion

  support.focusin = "onfocusin" in window;
  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
    stopPropagationCallback = function stopPropagationCallback(e) {
      e.stopPropagation();
    };
  jQuery.extend(jQuery.event, {
    trigger: function trigger(event, data, elem, onlyHandlers) {
      var i,
        cur,
        tmp,
        bubbleType,
        ontype,
        handle,
        special,
        lastElement,
        eventPath = [elem || document],
        type = hasOwn.call(event, "type") ? event.type : event,
        namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
      cur = lastElement = tmp = elem = elem || document;

      // Don't do events on text and comment nodes
      if (elem.nodeType === 3 || elem.nodeType === 8) {
        return;
      }

      // focus/blur morphs to focusin/out; ensure we're not firing them right now
      if (rfocusMorph.test(type + jQuery.event.triggered)) {
        return;
      }
      if (type.indexOf(".") > -1) {
        // Namespaced trigger; create a regexp to match event type in handle()
        namespaces = type.split(".");
        type = namespaces.shift();
        namespaces.sort();
      }
      ontype = type.indexOf(":") < 0 && "on" + type;

      // Caller can pass in a jQuery.Event object, Object, or just an event type string
      event = event[jQuery.expando] ? event : new jQuery.Event(type, (0, _typeof2["default"])(event) === "object" && event);

      // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join(".");
      event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

      // Clean up the event in case it is being reused
      event.result = undefined;
      if (!event.target) {
        event.target = elem;
      }

      // Clone any incoming data and prepend the event, creating the handler arg list
      data = data == null ? [event] : jQuery.makeArray(data, [event]);

      // Allow special events to draw outside the lines
      special = jQuery.event.special[type] || {};
      if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
        return;
      }

      // Determine event propagation path in advance, per W3C events spec (trac-9951)
      // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
      if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
        bubbleType = special.delegateType || type;
        if (!rfocusMorph.test(bubbleType + type)) {
          cur = cur.parentNode;
        }
        for (; cur; cur = cur.parentNode) {
          eventPath.push(cur);
          tmp = cur;
        }

        // Only add window if we got to document (e.g., not plain obj or detached DOM)
        if (tmp === (elem.ownerDocument || document)) {
          eventPath.push(tmp.defaultView || tmp.parentWindow || window);
        }
      }

      // Fire handlers on the event path
      i = 0;
      while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
        lastElement = cur;
        event.type = i > 1 ? bubbleType : special.bindType || type;

        // jQuery handler
        handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
        if (handle) {
          handle.apply(cur, data);
        }

        // Native handler
        handle = ontype && cur[ontype];
        if (handle && handle.apply && acceptData(cur)) {
          event.result = handle.apply(cur, data);
          if (event.result === false) {
            event.preventDefault();
          }
        }
      }
      event.type = type;

      // If nobody prevented the default action, do it now
      if (!onlyHandlers && !event.isDefaultPrevented()) {
        if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
          // Call a native DOM method on the target with the same name as the event.
          // Don't do default actions on window, that's where global variables be (trac-6170)
          if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
            // Don't re-trigger an onFOO event when we call its FOO() method
            tmp = elem[ontype];
            if (tmp) {
              elem[ontype] = null;
            }

            // Prevent re-triggering of the same event, since we already bubbled it above
            jQuery.event.triggered = type;
            if (event.isPropagationStopped()) {
              lastElement.addEventListener(type, stopPropagationCallback);
            }
            elem[type]();
            if (event.isPropagationStopped()) {
              lastElement.removeEventListener(type, stopPropagationCallback);
            }
            jQuery.event.triggered = undefined;
            if (tmp) {
              elem[ontype] = tmp;
            }
          }
        }
      }
      return event.result;
    },
    // Piggyback on a donor event to simulate a different one
    // Used only for `focus(in | out)` events
    simulate: function simulate(type, elem, event) {
      var e = jQuery.extend(new jQuery.Event(), event, {
        type: type,
        isSimulated: true
      });
      jQuery.event.trigger(e, null, elem);
    }
  });
  jQuery.fn.extend({
    trigger: function trigger(type, data) {
      return this.each(function () {
        jQuery.event.trigger(type, data, this);
      });
    },
    triggerHandler: function triggerHandler(type, data) {
      var elem = this[0];
      if (elem) {
        return jQuery.event.trigger(type, data, elem, true);
      }
    }
  });

  // Support: Firefox <=44
  // Firefox doesn't have focus(in | out) events
  // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
  //
  // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
  // focus(in | out) events fire after focus & blur events,
  // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
  // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
  if (!support.focusin) {
    jQuery.each({
      focus: "focusin",
      blur: "focusout"
    }, function (orig, fix) {
      // Attach a single capturing handler on the document while someone wants focusin/focusout
      var handler = function handler(event) {
        jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
      };
      jQuery.event.special[fix] = {
        setup: function setup() {
          // Handle: regular nodes (via `this.ownerDocument`), window
          // (via `this.document`) & document (via `this`).
          var doc = this.ownerDocument || this.document || this,
            attaches = dataPriv.access(doc, fix);
          if (!attaches) {
            doc.addEventListener(orig, handler, true);
          }
          dataPriv.access(doc, fix, (attaches || 0) + 1);
        },
        teardown: function teardown() {
          var doc = this.ownerDocument || this.document || this,
            attaches = dataPriv.access(doc, fix) - 1;
          if (!attaches) {
            doc.removeEventListener(orig, handler, true);
            dataPriv.remove(doc, fix);
          } else {
            dataPriv.access(doc, fix, attaches);
          }
        }
      };
    });
  }
  var location = window.location;
  var nonce = {
    guid: Date.now()
  };
  var rquery = /\?/;

  // Cross-browser xml parsing
  jQuery.parseXML = function (data) {
    var xml, parserErrorElem;
    if (!data || typeof data !== "string") {
      return null;
    }

    // Support: IE 9 - 11 only
    // IE throws on parseFromString with invalid input.
    try {
      xml = new window.DOMParser().parseFromString(data, "text/xml");
    } catch (e) {}
    parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
    if (!xml || parserErrorElem) {
      jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function (el) {
        return el.textContent;
      }).join("\n") : data));
    }
    return xml;
  };
  var rbracket = /\[\]$/,
    rCRLF = /\r?\n/g,
    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
    rsubmittable = /^(?:input|select|textarea|keygen)/i;
  function buildParams(prefix, obj, traditional, add) {
    var name;
    if (Array.isArray(obj)) {
      // Serialize array item.
      jQuery.each(obj, function (i, v) {
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v);
        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          buildParams(prefix + "[" + ((0, _typeof2["default"])(v) === "object" && v != null ? i : "") + "]", v, traditional, add);
        }
      });
    } else if (!traditional && toType(obj) === "object") {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj);
    }
  }

  // Serialize an array of form elements or a set of
  // key/values into a query string
  jQuery.param = function (a, traditional) {
    var prefix,
      s = [],
      add = function add(key, valueOrFunction) {
        // If value is a function, invoke it and use its return value
        var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
        s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
      };
    if (a == null) {
      return "";
    }

    // If an array was passed in, assume that it is an array of form elements.
    if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
      // Serialize the form elements
      jQuery.each(a, function () {
        add(this.name, this.value);
      });
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    }

    // Return the resulting serialization
    return s.join("&");
  };
  jQuery.fn.extend({
    serialize: function serialize() {
      return jQuery.param(this.serializeArray());
    },
    serializeArray: function serializeArray() {
      return this.map(function () {
        // Can add propHook for "elements" to filter or add form elements
        var elements = jQuery.prop(this, "elements");
        return elements ? jQuery.makeArray(elements) : this;
      }).filter(function () {
        var type = this.type;

        // Use .is( ":disabled" ) so that fieldset[disabled] works
        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
      }).map(function (_i, elem) {
        var val = jQuery(this).val();
        if (val == null) {
          return null;
        }
        if (Array.isArray(val)) {
          return jQuery.map(val, function (val) {
            return {
              name: elem.name,
              value: val.replace(rCRLF, "\r\n")
            };
          });
        }
        return {
          name: elem.name,
          value: val.replace(rCRLF, "\r\n")
        };
      }).get();
    }
  });
  var r20 = /%20/g,
    rhash = /#.*$/,
    rantiCache = /([?&])_=[^&]*/,
    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
    // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    rnoContent = /^(?:GET|HEAD)$/,
    rprotocol = /^\/\//,
    /* Prefilters
     * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
     * 2) These are called:
     *    - BEFORE asking for a transport
     *    - AFTER param serialization (s.data is a string if s.processData is true)
     * 3) key is the dataType
     * 4) the catchall symbol "*" can be used
     * 5) execution will start with transport dataType and THEN continue down to "*" if needed
     */
    prefilters = {},
    /* Transports bindings
     * 1) key is the dataType
     * 2) the catchall symbol "*" can be used
     * 3) selection will start with transport dataType and THEN go to "*" if needed
     */
    transports = {},
    // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"),
    // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
  originAnchor.href = location.href;

  // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
  function addToPrefiltersOrTransports(structure) {
    // dataTypeExpression is optional and defaults to "*"
    return function (dataTypeExpression, func) {
      if (typeof dataTypeExpression !== "string") {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }
      var dataType,
        i = 0,
        dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
      if (isFunction(func)) {
        // For each dataType in the dataTypeExpression
        while (dataType = dataTypes[i++]) {
          // Prepend if requested
          if (dataType[0] === "+") {
            dataType = dataType.slice(1) || "*";
            (structure[dataType] = structure[dataType] || []).unshift(func);

            // Otherwise append
          } else {
            (structure[dataType] = structure[dataType] || []).push(func);
          }
        }
      }
    };
  }

  // Base inspection function for prefilters and transports
  function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
    var inspected = {},
      seekingTransport = structure === transports;
    function inspect(dataType) {
      var selected;
      inspected[dataType] = true;
      jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
          options.dataTypes.unshift(dataTypeOrTransport);
          inspect(dataTypeOrTransport);
          return false;
        } else if (seekingTransport) {
          return !(selected = dataTypeOrTransport);
        }
      });
      return selected;
    }
    return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
  }

  // A special extend for ajax options
  // that takes "flat" options (not to be deep extended)
  // Fixes trac-9887
  function ajaxExtend(target, src) {
    var key,
      deep,
      flatOptions = jQuery.ajaxSettings.flatOptions || {};
    for (key in src) {
      if (src[key] !== undefined) {
        (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
      }
    }
    if (deep) {
      jQuery.extend(true, target, deep);
    }
    return target;
  }

  /* Handles responses to an ajax request:
   * - finds the right dataType (mediates between content-type and expected dataType)
   * - returns the corresponding response
   */
  function ajaxHandleResponses(s, jqXHR, responses) {
    var ct,
      type,
      finalDataType,
      firstDataType,
      contents = s.contents,
      dataTypes = s.dataTypes;

    // Remove auto dataType and get content-type in the process
    while (dataTypes[0] === "*") {
      dataTypes.shift();
      if (ct === undefined) {
        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
      }
    }

    // Check if we're dealing with a known content-type
    if (ct) {
      for (type in contents) {
        if (contents[type] && contents[type].test(ct)) {
          dataTypes.unshift(type);
          break;
        }
      }
    }

    // Check to see if we have a response for the expected dataType
    if (dataTypes[0] in responses) {
      finalDataType = dataTypes[0];
    } else {
      // Try convertible dataTypes
      for (type in responses) {
        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
          finalDataType = type;
          break;
        }
        if (!firstDataType) {
          firstDataType = type;
        }
      }

      // Or just use first one
      finalDataType = finalDataType || firstDataType;
    }

    // If we found a dataType
    // We add the dataType to the list if needed
    // and return the corresponding response
    if (finalDataType) {
      if (finalDataType !== dataTypes[0]) {
        dataTypes.unshift(finalDataType);
      }
      return responses[finalDataType];
    }
  }

  /* Chain conversions given the request and the original response
   * Also sets the responseXXX fields on the jqXHR instance
   */
  function ajaxConvert(s, response, jqXHR, isSuccess) {
    var conv2,
      current,
      conv,
      tmp,
      prev,
      converters = {},
      // Work with a copy of dataTypes in case we need to modify it for conversion
      dataTypes = s.dataTypes.slice();

    // Create converters map with lowercased keys
    if (dataTypes[1]) {
      for (conv in s.converters) {
        converters[conv.toLowerCase()] = s.converters[conv];
      }
    }
    current = dataTypes.shift();

    // Convert to each sequential dataType
    while (current) {
      if (s.responseFields[current]) {
        jqXHR[s.responseFields[current]] = response;
      }

      // Apply the dataFilter if provided
      if (!prev && isSuccess && s.dataFilter) {
        response = s.dataFilter(response, s.dataType);
      }
      prev = current;
      current = dataTypes.shift();
      if (current) {
        // There's only work to do if current dataType is non-auto
        if (current === "*") {
          current = prev;

          // Convert response if prev dataType is non-auto and differs from current
        } else if (prev !== "*" && prev !== current) {
          // Seek a direct converter
          conv = converters[prev + " " + current] || converters["* " + current];

          // If none found, seek a pair
          if (!conv) {
            for (conv2 in converters) {
              // If conv2 outputs current
              tmp = conv2.split(" ");
              if (tmp[1] === current) {
                // If prev can be converted to accepted input
                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                if (conv) {
                  // Condense equivalence converters
                  if (conv === true) {
                    conv = converters[conv2];

                    // Otherwise, insert the intermediate dataType
                  } else if (converters[conv2] !== true) {
                    current = tmp[0];
                    dataTypes.unshift(tmp[1]);
                  }
                  break;
                }
              }
            }
          }

          // Apply converter (if not an equivalence)
          if (conv !== true) {
            // Unless errors are allowed to bubble, catch and return them
            if (conv && s["throws"]) {
              response = conv(response);
            } else {
              try {
                response = conv(response);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: conv ? e : "No conversion from " + prev + " to " + current
                };
              }
            }
          }
        }
      }
    }
    return {
      state: "success",
      data: response
    };
  }
  jQuery.extend({
    // Counter for holding the number of active queries
    active: 0,
    // Last-Modified header cache for next request
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: location.href,
      type: "GET",
      isLocal: rlocalProtocol.test(location.protocol),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      /*
      timeout: 0,
      data: null,
      dataType: null,
      username: null,
      password: null,
      cache: null,
      throws: false,
      traditional: false,
      headers: {},
      */

      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      // Data converters
      // Keys separate source (or catchall "*") and destination types with a single space
      converters: {
        // Convert anything to text
        "* text": String,
        // Text to html (true = no transformation)
        "text html": true,
        // Evaluate text as a json expression
        "text json": JSON.parse,
        // Parse text as xml
        "text xml": jQuery.parseXML
      },
      // For options that shouldn't be deep extended:
      // you can add your own custom options here if
      // and when you create one that shouldn't be
      // deep extended (see ajaxExtend)
      flatOptions: {
        url: true,
        context: true
      }
    },
    // Creates a full fledged settings object into target
    // with both ajaxSettings and settings fields.
    // If target is omitted, writes into ajaxSettings.
    ajaxSetup: function ajaxSetup(target, settings) {
      return settings ?
      // Building a settings object
      ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :
      // Extending ajaxSettings
      ajaxExtend(jQuery.ajaxSettings, target);
    },
    ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
    ajaxTransport: addToPrefiltersOrTransports(transports),
    // Main method
    ajax: function ajax(url, options) {
      // If url is an object, simulate pre-1.5 signature
      if ((0, _typeof2["default"])(url) === "object") {
        options = url;
        url = undefined;
      }

      // Force options to be an object
      options = options || {};
      var transport,
        // URL without anti-cache param
        cacheURL,
        // Response headers
        responseHeadersString,
        responseHeaders,
        // timeout handle
        timeoutTimer,
        // Url cleanup var
        urlAnchor,
        // Request state (becomes false upon send and true upon completion)
        completed,
        // To know if global events are to be dispatched
        fireGlobals,
        // Loop variable
        i,
        // uncached part of the url
        uncached,
        // Create the final options object
        s = jQuery.ajaxSetup({}, options),
        // Callbacks context
        callbackContext = s.context || s,
        // Context for global events is callbackContext if it is a DOM node or jQuery collection
        globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
        // Deferreds
        deferred = jQuery.Deferred(),
        completeDeferred = jQuery.Callbacks("once memory"),
        // Status-dependent callbacks
        _statusCode = s.statusCode || {},
        // Headers (they are sent all at once)
        requestHeaders = {},
        requestHeadersNames = {},
        // Default abort message
        strAbort = "canceled",
        // Fake xhr
        jqXHR = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function getResponseHeader(key) {
            var match;
            if (completed) {
              if (!responseHeaders) {
                responseHeaders = {};
                while (match = rheaders.exec(responseHeadersString)) {
                  responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                }
              }
              match = responseHeaders[key.toLowerCase() + " "];
            }
            return match == null ? null : match.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function getAllResponseHeaders() {
            return completed ? responseHeadersString : null;
          },
          // Caches the header
          setRequestHeader: function setRequestHeader(name, value) {
            if (completed == null) {
              name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
              requestHeaders[name] = value;
            }
            return this;
          },
          // Overrides response content-type header
          overrideMimeType: function overrideMimeType(type) {
            if (completed == null) {
              s.mimeType = type;
            }
            return this;
          },
          // Status-dependent callbacks
          statusCode: function statusCode(map) {
            var code;
            if (map) {
              if (completed) {
                // Execute the appropriate callbacks
                jqXHR.always(map[jqXHR.status]);
              } else {
                // Lazy-add the new callbacks in a way that preserves old ones
                for (code in map) {
                  _statusCode[code] = [_statusCode[code], map[code]];
                }
              }
            }
            return this;
          },
          // Cancel the request
          abort: function abort(statusText) {
            var finalText = statusText || strAbort;
            if (transport) {
              transport.abort(finalText);
            }
            done(0, finalText);
            return this;
          }
        };

      // Attach deferreds
      deferred.promise(jqXHR);

      // Add protocol if not provided (prefilters might expect it)
      // Handle falsy url in the settings object (trac-10093: consistency with old signature)
      // We also use the url parameter if available
      s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

      // Alias method option to type as per ticket trac-12004
      s.type = options.method || options.type || s.method || s.type;

      // Extract dataTypes list
      s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

      // A cross-domain request is in order when the origin doesn't match the current origin.
      if (s.crossDomain == null) {
        urlAnchor = document.createElement("a");

        // Support: IE <=8 - 11, Edge 12 - 15
        // IE throws exception on accessing the href property if url is malformed,
        // e.g. http://example.com:80x/
        try {
          urlAnchor.href = s.url;

          // Support: IE <=8 - 11 only
          // Anchor's host property isn't correctly set when s.url is relative
          urlAnchor.href = urlAnchor.href;
          s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
        } catch (e) {
          // If there is an error parsing the URL, assume it is crossDomain,
          // it can be rejected by the transport if it is invalid
          s.crossDomain = true;
        }
      }

      // Convert data if not already a string
      if (s.data && s.processData && typeof s.data !== "string") {
        s.data = jQuery.param(s.data, s.traditional);
      }

      // Apply prefilters
      inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

      // If request was aborted inside a prefilter, stop there
      if (completed) {
        return jqXHR;
      }

      // We can fire global events as of now if asked to
      // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
      fireGlobals = jQuery.event && s.global;

      // Watch for a new set of requests
      if (fireGlobals && jQuery.active++ === 0) {
        jQuery.event.trigger("ajaxStart");
      }

      // Uppercase the type
      s.type = s.type.toUpperCase();

      // Determine if request has content
      s.hasContent = !rnoContent.test(s.type);

      // Save the URL in case we're toying with the If-Modified-Since
      // and/or If-None-Match header later on
      // Remove hash to simplify url manipulation
      cacheURL = s.url.replace(rhash, "");

      // More options handling for requests with no content
      if (!s.hasContent) {
        // Remember the hash so we can put it back
        uncached = s.url.slice(cacheURL.length);

        // If data is available and should be processed, append data to url
        if (s.data && (s.processData || typeof s.data === "string")) {
          cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

          // trac-9682: remove data so that it's not used in an eventual retry
          delete s.data;
        }

        // Add or update anti-cache param if needed
        if (s.cache === false) {
          cacheURL = cacheURL.replace(rantiCache, "$1");
          uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
        }

        // Put hash and anti-cache on the URL that will be requested (gh-1732)
        s.url = cacheURL + uncached;

        // Change '%20' to '+' if this is encoded form body content (gh-2658)
      } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
        s.data = s.data.replace(r20, "+");
      }

      // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
      if (s.ifModified) {
        if (jQuery.lastModified[cacheURL]) {
          jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
        }
        if (jQuery.etag[cacheURL]) {
          jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
        }
      }

      // Set the correct header, if data is being sent
      if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
        jqXHR.setRequestHeader("Content-Type", s.contentType);
      }

      // Set the Accepts header for the server, depending on the dataType
      jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

      // Check for headers option
      for (i in s.headers) {
        jqXHR.setRequestHeader(i, s.headers[i]);
      }

      // Allow custom headers/mimetypes and early abort
      if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
        // Abort if not done already and return
        return jqXHR.abort();
      }

      // Aborting is no longer a cancellation
      strAbort = "abort";

      // Install callbacks on deferreds
      completeDeferred.add(s.complete);
      jqXHR.done(s.success);
      jqXHR.fail(s.error);

      // Get transport
      transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

      // If no transport, we auto-abort
      if (!transport) {
        done(-1, "No Transport");
      } else {
        jqXHR.readyState = 1;

        // Send global event
        if (fireGlobals) {
          globalEventContext.trigger("ajaxSend", [jqXHR, s]);
        }

        // If request was aborted inside ajaxSend, stop there
        if (completed) {
          return jqXHR;
        }

        // Timeout
        if (s.async && s.timeout > 0) {
          timeoutTimer = window.setTimeout(function () {
            jqXHR.abort("timeout");
          }, s.timeout);
        }
        try {
          completed = false;
          transport.send(requestHeaders, done);
        } catch (e) {
          // Rethrow post-completion exceptions
          if (completed) {
            throw e;
          }

          // Propagate others as results
          done(-1, e);
        }
      }

      // Callback for when everything is done
      function done(status, nativeStatusText, responses, headers) {
        var isSuccess,
          success,
          error,
          response,
          modified,
          statusText = nativeStatusText;

        // Ignore repeat invocations
        if (completed) {
          return;
        }
        completed = true;

        // Clear timeout if it exists
        if (timeoutTimer) {
          window.clearTimeout(timeoutTimer);
        }

        // Dereference transport for early garbage collection
        // (no matter how long the jqXHR object will be used)
        transport = undefined;

        // Cache response headers
        responseHeadersString = headers || "";

        // Set readyState
        jqXHR.readyState = status > 0 ? 4 : 0;

        // Determine if successful
        isSuccess = status >= 200 && status < 300 || status === 304;

        // Get response data
        if (responses) {
          response = ajaxHandleResponses(s, jqXHR, responses);
        }

        // Use a noop converter for missing script but not if jsonp
        if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
          s.converters["text script"] = function () {};
        }

        // Convert no matter what (that way responseXXX fields are always set)
        response = ajaxConvert(s, response, jqXHR, isSuccess);

        // If successful, handle type chaining
        if (isSuccess) {
          // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
          if (s.ifModified) {
            modified = jqXHR.getResponseHeader("Last-Modified");
            if (modified) {
              jQuery.lastModified[cacheURL] = modified;
            }
            modified = jqXHR.getResponseHeader("etag");
            if (modified) {
              jQuery.etag[cacheURL] = modified;
            }
          }

          // if no content
          if (status === 204 || s.type === "HEAD") {
            statusText = "nocontent";

            // if not modified
          } else if (status === 304) {
            statusText = "notmodified";

            // If we have data, let's convert it
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {
          // Extract error from statusText and normalize for non-aborts
          error = statusText;
          if (status || !statusText) {
            statusText = "error";
            if (status < 0) {
              status = 0;
            }
          }
        }

        // Set data for the fake xhr object
        jqXHR.status = status;
        jqXHR.statusText = (nativeStatusText || statusText) + "";

        // Success/Error
        if (isSuccess) {
          deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
        } else {
          deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
        }

        // Status-dependent callbacks
        jqXHR.statusCode(_statusCode);
        _statusCode = undefined;
        if (fireGlobals) {
          globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
        }

        // Complete
        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
        if (fireGlobals) {
          globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

          // Handle the global AJAX counter
          if (! --jQuery.active) {
            jQuery.event.trigger("ajaxStop");
          }
        }
      }
      return jqXHR;
    },
    getJSON: function getJSON(url, data, callback) {
      return jQuery.get(url, data, callback, "json");
    },
    getScript: function getScript(url, callback) {
      return jQuery.get(url, undefined, callback, "script");
    }
  });
  jQuery.each(["get", "post"], function (_i, method) {
    jQuery[method] = function (url, data, callback, type) {
      // Shift arguments if data argument was omitted
      if (isFunction(data)) {
        type = type || callback;
        callback = data;
        data = undefined;
      }

      // The url can be an options object (which then must have .url)
      return jQuery.ajax(jQuery.extend({
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      }, jQuery.isPlainObject(url) && url));
    };
  });
  jQuery.ajaxPrefilter(function (s) {
    var i;
    for (i in s.headers) {
      if (i.toLowerCase() === "content-type") {
        s.contentType = s.headers[i] || "";
      }
    }
  });
  jQuery._evalUrl = function (url, options, doc) {
    return jQuery.ajax({
      url: url,
      // Make this explicit, since user can override this through ajaxSetup (trac-11264)
      type: "GET",
      dataType: "script",
      cache: true,
      async: false,
      global: false,
      // Only evaluate the response if it is successful (gh-4126)
      // dataFilter is not invoked for failure responses, so using it instead
      // of the default converter is kludgy but it works.
      converters: {
        "text script": function textScript() {}
      },
      dataFilter: function dataFilter(response) {
        jQuery.globalEval(response, options, doc);
      }
    });
  };
  jQuery.fn.extend({
    wrapAll: function wrapAll(html) {
      var wrap;
      if (this[0]) {
        if (isFunction(html)) {
          html = html.call(this[0]);
        }

        // The elements to wrap the target around
        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
        if (this[0].parentNode) {
          wrap.insertBefore(this[0]);
        }
        wrap.map(function () {
          var elem = this;
          while (elem.firstElementChild) {
            elem = elem.firstElementChild;
          }
          return elem;
        }).append(this);
      }
      return this;
    },
    wrapInner: function wrapInner(html) {
      if (isFunction(html)) {
        return this.each(function (i) {
          jQuery(this).wrapInner(html.call(this, i));
        });
      }
      return this.each(function () {
        var self = jQuery(this),
          contents = self.contents();
        if (contents.length) {
          contents.wrapAll(html);
        } else {
          self.append(html);
        }
      });
    },
    wrap: function wrap(html) {
      var htmlIsFunction = isFunction(html);
      return this.each(function (i) {
        jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
      });
    },
    unwrap: function unwrap(selector) {
      this.parent(selector).not("body").each(function () {
        jQuery(this).replaceWith(this.childNodes);
      });
      return this;
    }
  });
  jQuery.expr.pseudos.hidden = function (elem) {
    return !jQuery.expr.pseudos.visible(elem);
  };
  jQuery.expr.pseudos.visible = function (elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
  };
  jQuery.ajaxSettings.xhr = function () {
    try {
      return new window.XMLHttpRequest();
    } catch (e) {}
  };
  var xhrSuccessStatus = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    },
    xhrSupported = jQuery.ajaxSettings.xhr();
  support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
  support.ajax = xhrSupported = !!xhrSupported;
  jQuery.ajaxTransport(function (options) {
    var _callback, errorCallback;

    // Cross domain only allowed if supported through XMLHttpRequest
    if (support.cors || xhrSupported && !options.crossDomain) {
      return {
        send: function send(headers, complete) {
          var i,
            xhr = options.xhr();
          xhr.open(options.type, options.url, options.async, options.username, options.password);

          // Apply custom fields if provided
          if (options.xhrFields) {
            for (i in options.xhrFields) {
              xhr[i] = options.xhrFields[i];
            }
          }

          // Override mime type if needed
          if (options.mimeType && xhr.overrideMimeType) {
            xhr.overrideMimeType(options.mimeType);
          }

          // X-Requested-With header
          // For cross-domain requests, seeing as conditions for a preflight are
          // akin to a jigsaw puzzle, we simply never set it to be sure.
          // (it can always be set on a per-request basis or even using ajaxSetup)
          // For same-domain requests, won't change header if already provided.
          if (!options.crossDomain && !headers["X-Requested-With"]) {
            headers["X-Requested-With"] = "XMLHttpRequest";
          }

          // Set headers
          for (i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }

          // Callback
          _callback = function callback(type) {
            return function () {
              if (_callback) {
                _callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                if (type === "abort") {
                  xhr.abort();
                } else if (type === "error") {
                  // Support: IE <=9 only
                  // On a manual native abort, IE9 throws
                  // errors on any property access that is not readyState
                  if (typeof xhr.status !== "number") {
                    complete(0, "error");
                  } else {
                    complete(
                    // File: protocol always yields status 0; see trac-8605, trac-14207
                    xhr.status, xhr.statusText);
                  }
                } else {
                  complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,
                  // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                    binary: xhr.response
                  } : {
                    text: xhr.responseText
                  }, xhr.getAllResponseHeaders());
                }
              }
            };
          };

          // Listen to events
          xhr.onload = _callback();
          errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

          // Support: IE 9 only
          // Use onreadystatechange to replace onabort
          // to handle uncaught aborts
          if (xhr.onabort !== undefined) {
            xhr.onabort = errorCallback;
          } else {
            xhr.onreadystatechange = function () {
              // Check readyState before timeout as it changes
              if (xhr.readyState === 4) {
                // Allow onerror to be called first,
                // but that will not handle a native abort
                // Also, save errorCallback to a variable
                // as xhr.onerror cannot be accessed
                window.setTimeout(function () {
                  if (_callback) {
                    errorCallback();
                  }
                });
              }
            };
          }

          // Create the abort callback
          _callback = _callback("abort");
          try {
            // Do send the request (this may raise an exception)
            xhr.send(options.hasContent && options.data || null);
          } catch (e) {
            // trac-14683: Only rethrow if this hasn't been notified as an error yet
            if (_callback) {
              throw e;
            }
          }
        },
        abort: function abort() {
          if (_callback) {
            _callback();
          }
        }
      };
    }
  });

  // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
  jQuery.ajaxPrefilter(function (s) {
    if (s.crossDomain) {
      s.contents.script = false;
    }
  });

  // Install script dataType
  jQuery.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /\b(?:java|ecma)script\b/
    },
    converters: {
      "text script": function textScript(text) {
        jQuery.globalEval(text);
        return text;
      }
    }
  });

  // Handle cache's special case and crossDomain
  jQuery.ajaxPrefilter("script", function (s) {
    if (s.cache === undefined) {
      s.cache = false;
    }
    if (s.crossDomain) {
      s.type = "GET";
    }
  });

  // Bind script tag hack transport
  jQuery.ajaxTransport("script", function (s) {
    // This transport only deals with cross domain or forced-by-attrs requests
    if (s.crossDomain || s.scriptAttrs) {
      var script, _callback2;
      return {
        send: function send(_, complete) {
          script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
            charset: s.scriptCharset,
            src: s.url
          }).on("load error", _callback2 = function callback(evt) {
            script.remove();
            _callback2 = null;
            if (evt) {
              complete(evt.type === "error" ? 404 : 200, evt.type);
            }
          });

          // Use native DOM manipulation to avoid our domManip AJAX trickery
          document.head.appendChild(script[0]);
        },
        abort: function abort() {
          if (_callback2) {
            _callback2();
          }
        }
      };
    }
  });
  var oldCallbacks = [],
    rjsonp = /(=)\?(?=&|$)|\?\?/;

  // Default jsonp settings
  jQuery.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function jsonpCallback() {
      var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
      this[callback] = true;
      return callback;
    }
  });

  // Detect, normalize options and install callbacks for jsonp requests
  jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
    var callbackName,
      overwritten,
      responseContainer,
      jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

    // Handle iff the expected data type is "jsonp" or we have a parameter to set
    if (jsonProp || s.dataTypes[0] === "jsonp") {
      // Get callback name, remembering preexisting value associated with it
      callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

      // Insert callback into url or form data
      if (jsonProp) {
        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
      } else if (s.jsonp !== false) {
        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
      }

      // Use data converter to retrieve json after script execution
      s.converters["script json"] = function () {
        if (!responseContainer) {
          jQuery.error(callbackName + " was not called");
        }
        return responseContainer[0];
      };

      // Force json dataType
      s.dataTypes[0] = "json";

      // Install callback
      overwritten = window[callbackName];
      window[callbackName] = function () {
        responseContainer = arguments;
      };

      // Clean-up function (fires after converters)
      jqXHR.always(function () {
        // If previous value didn't exist - remove it
        if (overwritten === undefined) {
          jQuery(window).removeProp(callbackName);

          // Otherwise restore preexisting value
        } else {
          window[callbackName] = overwritten;
        }

        // Save back as free
        if (s[callbackName]) {
          // Make sure that re-using the options doesn't screw things around
          s.jsonpCallback = originalSettings.jsonpCallback;

          // Save the callback name for future use
          oldCallbacks.push(callbackName);
        }

        // Call if it was a function and we have a response
        if (responseContainer && isFunction(overwritten)) {
          overwritten(responseContainer[0]);
        }
        responseContainer = overwritten = undefined;
      });

      // Delegate to script
      return "script";
    }
  });

  // Support: Safari 8 only
  // In Safari 8 documents created via document.implementation.createHTMLDocument
  // collapse sibling forms: the second one becomes a child of the first one.
  // Because of that, this security measure has to be disabled in Safari 8.
  // https://bugs.webkit.org/show_bug.cgi?id=137337
  support.createHTMLDocument = function () {
    var body = document.implementation.createHTMLDocument("").body;
    body.innerHTML = "<form></form><form></form>";
    return body.childNodes.length === 2;
  }();

  // Argument "data" should be string of html
  // context (optional): If specified, the fragment will be created in this context,
  // defaults to document
  // keepScripts (optional): If true, will include scripts passed in the html string
  jQuery.parseHTML = function (data, context, keepScripts) {
    if (typeof data !== "string") {
      return [];
    }
    if (typeof context === "boolean") {
      keepScripts = context;
      context = false;
    }
    var base, parsed, scripts;
    if (!context) {
      // Stop scripts or inline event handlers from being executed immediately
      // by using document.implementation
      if (support.createHTMLDocument) {
        context = document.implementation.createHTMLDocument("");

        // Set the base href for the created document
        // so any parsed elements with URLs
        // are based on the document's URL (gh-2965)
        base = context.createElement("base");
        base.href = document.location.href;
        context.head.appendChild(base);
      } else {
        context = document;
      }
    }
    parsed = rsingleTag.exec(data);
    scripts = !keepScripts && [];

    // Single tag
    if (parsed) {
      return [context.createElement(parsed[1])];
    }
    parsed = buildFragment([data], context, scripts);
    if (scripts && scripts.length) {
      jQuery(scripts).remove();
    }
    return jQuery.merge([], parsed.childNodes);
  };

  /**
   * Load a url into a page
   */
  jQuery.fn.load = function (url, params, callback) {
    var selector,
      type,
      response,
      self = this,
      off = url.indexOf(" ");
    if (off > -1) {
      selector = stripAndCollapse(url.slice(off));
      url = url.slice(0, off);
    }

    // If it's a function
    if (isFunction(params)) {
      // We assume that it's the callback
      callback = params;
      params = undefined;

      // Otherwise, build a param string
    } else if (params && (0, _typeof2["default"])(params) === "object") {
      type = "POST";
    }

    // If we have elements to modify, make the request
    if (self.length > 0) {
      jQuery.ajax({
        url: url,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: type || "GET",
        dataType: "html",
        data: params
      }).done(function (responseText) {
        // Save response for use in complete callback
        response = arguments;
        self.html(selector ?
        // If a selector was specified, locate the right elements in a dummy div
        // Exclude scripts to avoid IE 'Permission Denied' errors
        jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :
        // Otherwise use the full result
        responseText);

        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
      }).always(callback && function (jqXHR, status) {
        self.each(function () {
          callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
        });
      });
    }
    return this;
  };
  jQuery.expr.pseudos.animated = function (elem) {
    return jQuery.grep(jQuery.timers, function (fn) {
      return elem === fn.elem;
    }).length;
  };
  jQuery.offset = {
    setOffset: function setOffset(elem, options, i) {
      var curPosition,
        curLeft,
        curCSSTop,
        curTop,
        curOffset,
        curCSSLeft,
        calculatePosition,
        position = jQuery.css(elem, "position"),
        curElem = jQuery(elem),
        props = {};

      // Set position first, in-case top/left are set even on static elem
      if (position === "static") {
        elem.style.position = "relative";
      }
      curOffset = curElem.offset();
      curCSSTop = jQuery.css(elem, "top");
      curCSSLeft = jQuery.css(elem, "left");
      calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

      // Need to be able to calculate position if either
      // top or left is auto and position is either absolute or fixed
      if (calculatePosition) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }
      if (isFunction(options)) {
        // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
        options = options.call(elem, i, jQuery.extend({}, curOffset));
      }
      if (options.top != null) {
        props.top = options.top - curOffset.top + curTop;
      }
      if (options.left != null) {
        props.left = options.left - curOffset.left + curLeft;
      }
      if ("using" in options) {
        options.using.call(elem, props);
      } else {
        curElem.css(props);
      }
    }
  };
  jQuery.fn.extend({
    // offset() relates an element's border box to the document origin
    offset: function offset(options) {
      // Preserve chaining for setter
      if (arguments.length) {
        return options === undefined ? this : this.each(function (i) {
          jQuery.offset.setOffset(this, options, i);
        });
      }
      var rect,
        win,
        elem = this[0];
      if (!elem) {
        return;
      }

      // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
      // Support: IE <=11 only
      // Running getBoundingClientRect on a
      // disconnected node in IE throws an error
      if (!elem.getClientRects().length) {
        return {
          top: 0,
          left: 0
        };
      }

      // Get document-relative position by adding viewport scroll to viewport-relative gBCR
      rect = elem.getBoundingClientRect();
      win = elem.ownerDocument.defaultView;
      return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      };
    },
    // position() relates an element's margin box to its offset parent's padding box
    // This corresponds to the behavior of CSS absolute positioning
    position: function position() {
      if (!this[0]) {
        return;
      }
      var offsetParent,
        offset,
        doc,
        elem = this[0],
        parentOffset = {
          top: 0,
          left: 0
        };

      // position:fixed elements are offset from the viewport, which itself always has zero offset
      if (jQuery.css(elem, "position") === "fixed") {
        // Assume position:fixed implies availability of getBoundingClientRect
        offset = elem.getBoundingClientRect();
      } else {
        offset = this.offset();

        // Account for the *real* offset parent, which can be the document or its root element
        // when a statically positioned element is identified
        doc = elem.ownerDocument;
        offsetParent = elem.offsetParent || doc.documentElement;
        while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.parentNode;
        }
        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
          // Incorporate borders into its offset, since they are outside its content origin
          parentOffset = jQuery(offsetParent).offset();
          parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
          parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
        }
      }

      // Subtract parent offsets and element margins
      return {
        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
      };
    },
    // This method will return documentElement in the following cases:
    // 1) For the element inside the iframe without offsetParent, this method will return
    //    documentElement of the parent window
    // 2) For the hidden or detached element
    // 3) For body or html element, i.e. in case of the html node - it will return itself
    //
    // but those exceptions were never presented as a real life use-cases
    // and might be considered as more preferable results.
    //
    // This logic, however, is not guaranteed and can change at any point in the future
    offsetParent: function offsetParent() {
      return this.map(function () {
        var offsetParent = this.offsetParent;
        while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || documentElement;
      });
    }
  });

  // Create scrollLeft and scrollTop methods
  jQuery.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function (method, prop) {
    var top = "pageYOffset" === prop;
    jQuery.fn[method] = function (val) {
      return access(this, function (elem, method, val) {
        // Coalesce documents and windows
        var win;
        if (isWindow(elem)) {
          win = elem;
        } else if (elem.nodeType === 9) {
          win = elem.defaultView;
        }
        if (val === undefined) {
          return win ? win[prop] : elem[method];
        }
        if (win) {
          win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
        } else {
          elem[method] = val;
        }
      }, method, val, arguments.length);
    };
  });

  // Support: Safari <=7 - 9.1, Chrome <=37 - 49
  // Add the top/left cssHooks using jQuery.fn.position
  // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
  // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
  // getComputedStyle returns percent when specified for top/left/bottom/right;
  // rather than make the css module depend on the offset module, just check for it here
  jQuery.each(["top", "left"], function (_i, prop) {
    jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
      if (computed) {
        computed = curCSS(elem, prop);

        // If curCSS returns percentage, fallback to offset
        return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
      }
    });
  });

  // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
  jQuery.each({
    Height: "height",
    Width: "width"
  }, function (name, type) {
    jQuery.each({
      padding: "inner" + name,
      content: type,
      "": "outer" + name
    }, function (defaultExtra, funcName) {
      // Margin is only for outerHeight, outerWidth
      jQuery.fn[funcName] = function (margin, value) {
        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
          extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
        return access(this, function (elem, type, value) {
          var doc;
          if (isWindow(elem)) {
            // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
            return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
          }

          // Get document width or height
          if (elem.nodeType === 9) {
            doc = elem.documentElement;

            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
            // whichever is greatest
            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
          }
          return value === undefined ?
          // Get width or height on the element, requesting but not forcing parseFloat
          jQuery.css(elem, type, extra) :
          // Set width or height on the element
          jQuery.style(elem, type, value, extra);
        }, type, chainable ? margin : undefined, chainable);
      };
    });
  });
  jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
    jQuery.fn[type] = function (fn) {
      return this.on(type, fn);
    };
  });
  jQuery.fn.extend({
    bind: function bind(types, data, fn) {
      return this.on(types, null, data, fn);
    },
    unbind: function unbind(types, fn) {
      return this.off(types, null, fn);
    },
    delegate: function delegate(selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    },
    undelegate: function undelegate(selector, types, fn) {
      // ( namespace ) or ( selector, types [, fn] )
      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
    },
    hover: function hover(fnOver, fnOut) {
      return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
    }
  });
  jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {
    // Handle event binding
    jQuery.fn[name] = function (data, fn) {
      return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
    };
  });

  // Support: Android <=4.0 only
  // Make sure we trim BOM and NBSP
  // Require that the "whitespace run" starts from a non-whitespace
  // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
  var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

  // Bind a function to a context, optionally partially applying any
  // arguments.
  // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
  // However, it is not slated for removal any time soon
  jQuery.proxy = function (fn, context) {
    var tmp, args, proxy;
    if (typeof context === "string") {
      tmp = fn[context];
      context = fn;
      fn = tmp;
    }

    // Quick check to determine if target is callable, in the spec
    // this throws a TypeError, but we will just return undefined.
    if (!isFunction(fn)) {
      return undefined;
    }

    // Simulated bind
    args = _slice.call(arguments, 2);
    proxy = function proxy() {
      return fn.apply(context || this, args.concat(_slice.call(arguments)));
    };

    // Set the guid of unique handler to the same of original handler, so it can be removed
    proxy.guid = fn.guid = fn.guid || jQuery.guid++;
    return proxy;
  };
  jQuery.holdReady = function (hold) {
    if (hold) {
      jQuery.readyWait++;
    } else {
      jQuery.ready(true);
    }
  };
  jQuery.isArray = Array.isArray;
  jQuery.parseJSON = JSON.parse;
  jQuery.nodeName = nodeName;
  jQuery.isFunction = isFunction;
  jQuery.isWindow = isWindow;
  jQuery.camelCase = camelCase;
  jQuery.type = toType;
  jQuery.now = Date.now;
  jQuery.isNumeric = function (obj) {
    // As of jQuery 3.0, isNumeric is limited to
    // strings and numbers (primitives or objects)
    // that can be coerced to finite numbers (gh-2662)
    var type = jQuery.type(obj);
    return (type === "number" || type === "string") &&
    // parseFloat NaNs numeric-cast false positives ("")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    !isNaN(obj - parseFloat(obj));
  };
  jQuery.trim = function (text) {
    return text == null ? "" : (text + "").replace(rtrim, "$1");
  };

  // Register as a named AMD module, since jQuery can be concatenated with other
  // files that may use define, but not via a proper concatenation script that
  // understands anonymous AMD modules. A named AMD is safest and most robust
  // way to register. Lowercase jquery is used because AMD module names are
  // derived from file names, and jQuery is normally delivered in a lowercase
  // file name. Do this after creating the global so that if an AMD module wants
  // to call noConflict to hide this version of jQuery, it will work.

  // Note that for maximum portability, libraries that are not jQuery should
  // declare themselves as anonymous modules, and avoid setting a global if an
  // AMD loader is present. jQuery is a special case. For more information, see
  // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

  if (typeof define === "function" && define.amd) {
    define("jquery", [], function () {
      return jQuery;
    });
  }
  var
    // Map over jQuery in case of overwrite
    _jQuery = window.jQuery,
    // Map over the $ in case of overwrite
    _$ = window.$;
  jQuery.noConflict = function (deep) {
    if (window.$ === jQuery) {
      window.$ = _$;
    }
    if (deep && window.jQuery === jQuery) {
      window.jQuery = _jQuery;
    }
    return jQuery;
  };

  // Expose jQuery and $ identifiers, even in AMD
  // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
  // and CommonJS for browser emulators (trac-13566)
  if (typeof noGlobal === "undefined") {
    window.jQuery = window.$ = jQuery;
  }
  return jQuery;
});

},{"@babel/runtime/helpers/interopRequireDefault":8,"@babel/runtime/helpers/typeof":18}],22:[function(require,module,exports){
"use strict";

/*! roundSlider v1.6.1 | (c) 2015-2020, Soundar | MIT license | http://roundsliderui.com/licence.html */
!function (t) {
  "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? t(require("jquery")) : t(jQuery);
}(function (p) {
  "use strict";

  var o = "roundSlider";
  function r(t, e) {
    this.id = t.id, this.control = p(t), this.options = p.extend({}, this.defaults, e);
  }
  p.fn[o] = function (t) {
    return function (t, e) {
      for (var i = 0; i < this.length; i++) {
        var s = this[i],
          a = p.data(s, o);
        if (a) {
          if (p.isPlainObject(t)) "function" == typeof a.option ? a.option(t) : s.id && window[s.id] && "function" == typeof window[s.id].option && window[s.id].option(t);else if ("string" == typeof t && "function" == typeof a[t]) {
            if (("option" === t || 0 === t.indexOf("get")) && void 0 === e[2]) return a[t](e[1]);
            a[t](e[1], e[2]);
          }
        } else {
          var n = new r(s, t);
          n._saveInstanceOnElement(), n._saveInstanceOnID(), !1 !== n._raise("beforeCreate") ? (n._init(), n._raise("create")) : n._removeData();
        }
      }
      return this;
    }.call(this, t, arguments);
  }, r.prototype = {
    pluginName: o,
    version: "1.6.1",
    options: {},
    control: null,
    defaults: {
      min: 0,
      max: 100,
      step: 1,
      value: null,
      radius: 85,
      width: 18,
      handleSize: "+0",
      startAngle: 0,
      endAngle: "+360",
      animation: !0,
      showTooltip: !0,
      editableTooltip: !0,
      readOnly: !1,
      disabled: !1,
      keyboardAction: !0,
      mouseScrollAction: !1,
      lineCap: "butt",
      sliderType: "default",
      circleShape: "full",
      handleShape: "round",
      startValue: null,
      svgMode: !1,
      borderWidth: 1,
      borderColor: null,
      pathColor: null,
      rangeColor: null,
      tooltipColor: null,
      beforeCreate: null,
      create: null,
      start: null,
      beforeValueChange: null,
      drag: null,
      change: null,
      update: null,
      valueChange: null,
      stop: null,
      tooltipFormat: null
    },
    keys: {
      UP: 38,
      DOWN: 40,
      LEFT: 37,
      RIGHT: 39
    },
    _props: function _props() {
      return {
        numberType: ["min", "max", "step", "radius", "width", "borderWidth", "startAngle", "startValue"],
        booleanType: ["animation", "showTooltip", "editableTooltip", "readOnly", "disabled", "keyboardAction", "mouseScrollAction", "svgMode"],
        stringType: ["sliderType", "circleShape", "handleShape", "lineCap"]
      };
    },
    _init: function _init() {
      var t,
        e = this.options;
      e.svgMode && (t = function t() {}, this._appendSeperator = t, this._refreshSeperator = t, this._updateSeperator = t, this._appendOverlay = t, this._checkOverlay = t, this._updateWidth = t), this.control.is("input") && (this._isInputType = !0, this._hiddenField = this.control, this.control = this.$createElement("div"), this.control.insertAfter(this._hiddenField), e.value = this._hiddenField.val() || e.value), this._isBrowserSupported() && this._onInit();
    },
    _onInit: function _onInit() {
      this._initialize(), this._update(), this._render();
    },
    _initialize: function _initialize() {
      var t = this.browserName = this.getBrowserName();
      t && this.control.addClass("rs-" + t), this._isReadOnly = !1, this._checkDataType(), this._refreshCircleShape();
    },
    _render: function _render() {
      this.container = this.$createElement("div.rs-container"), this.innerContainer = this.$createElement("div.rs-inner-container"), this.container.append(this.innerContainer);
      var t = "rs-control " + (this.options.svgMode ? "rs-svg-mode" : "rs-classic-mode");
      this.control.addClass(t).empty().append(this.container), this._createLayers(), this._createOtherLayers(), this._setContainerClass(), this._setRadius(), this._setProperties(), this._setValue(), this._updateTooltipPos(), this._bindControlEvents("_bind"), this._raiseValueChange("create"), this._updatePre();
    },
    _update: function _update() {
      this._validateSliderType(), this._updateStartEnd(), this._validateStartEnd(), this._handle1 = this._handle2 = this._handleDefaults(), this._analyzeModelValue(), this._validateModelValue();
    },
    _createLayers: function _createLayers() {
      var t = this.options;
      if (t.svgMode) return this._createSVGElements(), this._setSVGAttributes(), this._setSVGStyles(), void this._moveSliderRange(!0);
      this.block = this.$createElement("div.rs-block rs-outer rs-border"), this.innerContainer.append(this.block);
      var e = t.width,
        i = this._start,
        s = this.$createElement("div.rs-path rs-transition");
      this._showRange ? (this.block1 = s.clone().addClass("rs-range-color").rsRotate(i), this.block2 = s.clone().addClass("rs-range-color").css("opacity", "0").rsRotate(i), this.block3 = s.clone().addClass("rs-path-color").rsRotate(i), this.block4 = s.addClass("rs-path-color").css({
        opacity: "1",
        "z-index": "1"
      }).rsRotate(i - 180), this.block.append(this.block1, this.block2, this.block3, this.block4).addClass("rs-split")) : this.block.append(s.addClass("rs-path-color")), this.lastBlock = this.$createElement("span.rs-block").css({
        padding: e
      }), this.innerBlock = this.$createElement("div.rs-inner rs-bg-color rs-border"), this.lastBlock.append(this.innerBlock), this.block.append(this.lastBlock);
    },
    _createOtherLayers: function _createOtherLayers() {
      this._appendHandle(), this._appendSeperator(), this._appendOverlay(), this._appendHiddenField();
    },
    _setProperties: function _setProperties() {
      var t = this.options;
      this._setHandleShape(), this._addAnimation(), this._appendTooltip(), t.showTooltip || this._removeTooltip(), t.disabled ? this.disable() : t.readOnly && this._readOnly(!0), t.mouseScrollAction && this._bindScrollEvents("_bind");
    },
    _updatePre: function _updatePre() {
      this._prechange = this._predrag = this._pre_bvc = this._preValue = this.options.value;
    },
    _backupPreValue: function _backupPreValue() {
      this._pre_handle1 = this._handle1, this._pre_handle2 = this._handle2;
    },
    _revertPreValue: function _revertPreValue() {
      this._handle1 = this._pre_handle1, this._handle2 = this._pre_handle2, this._updateModelValue();
    },
    _setValue: function _setValue() {
      var t;
      this._rangeSlider ? (this._setHandleValue(1), this._setHandleValue(2)) : (this._minRange && !this.options.svgMode && this._setHandleValue(1), t = this._minRange ? 2 : this._active || 1, this._setHandleValue(t));
    },
    _appendTooltip: function _appendTooltip() {
      var t;
      0 === this.container.children(".rs-tooltip").length && (t = this.tooltip = this.$createElement("span.rs-tooltip rs-tooltip-text"), this.container.append(t), this._setTooltipColor(t), this._tooltipEditable(), this._updateTooltip());
    },
    _removeTooltip: function _removeTooltip() {
      0 != this.container.children(".rs-tooltip").length && this.tooltip && this.tooltip.remove();
    },
    _setTooltipColor: function _setTooltipColor(t) {
      var e = this.options,
        i = e.tooltipColor,
        s = "inherit" !== i ? i : e.rangeColor;
      t && null != s && t.css("color", s);
    },
    _tooltipEditable: function _tooltipEditable() {
      var t = this.options,
        e = this.tooltip;
      e && t.showTooltip && this[t.editableTooltip ? (e.addClass("rs-edit"), "_bind") : (e.removeClass("rs-edit"), "_unbind")](e, "click", this._editTooltip);
    },
    _editTooltip: function _editTooltip(t) {
      var e,
        i,
        s = this.tooltip;
      s.hasClass("rs-edit") && !this._isReadOnly && (e = 2 * parseFloat(s.css("border-left-width")), i = this.input = this.$createElement("input.rs-input rs-tooltip-text").css({
        height: s.outerHeight() - e,
        width: s.outerWidth() - e
      }), this._setTooltipColor(i), s.html(i).removeClass("rs-edit").addClass("rs-hover"), i.focus().val(this._getTooltipValue(!0)), this._bind(i, "blur change", this._focusOut));
    },
    _focusOut: function _focusOut(t) {
      var e;
      "change" == t.type ? ("," == (e = this.input.val().replace("-", ","))[0] && (e = "-" + e.slice(1).replace("-", ",")), this.options.value = e, this._validateValue(!0) && (this.input.val(this._getTooltipValue(!0)), this._raiseEvent("change"))) : (delete this.input, this.tooltip.addClass("rs-edit").removeClass("rs-hover"), this._updateTooltip());
    },
    _setHandleShape: function _setHandleShape() {
      var t = this.options,
        e = t.handleShape,
        i = this._handles();
      i.removeClass("rs-handle-dot rs-handle-square"), "dot" == e ? i.addClass("rs-handle-dot") : "square" == e ? i.addClass("rs-handle-square") : t.handleShape = "round";
    },
    _setHandleValue: function _setHandleValue(t) {
      this._active = t;
      var e = this["_handle" + t];
      this._minRange || (this.bar = this._activeHandleBar()), this._changeSliderValue(e.value, e.angle);
    },
    _addAnimation: function _addAnimation() {
      this.options.animation && this.control.addClass("rs-animation");
    },
    _removeAnimation: function _removeAnimation() {
      this.control.removeClass("rs-animation");
    },
    _setContainerClass: function _setContainerClass() {
      var t = this.options.circleShape;
      "full" == t || "pie" == t || 0 === t.indexOf("custom") ? this.container.addClass("rs-full rs-" + t) : this.container.addClass("rs-" + t.split("-").join(" rs-"));
    },
    _setRadius: function _setRadius() {
      var t,
        e,
        i,
        s = this.options,
        a = s.radius,
        n = 2 * a,
        r = s.circleShape,
        o = 0,
        h = t = n,
        l = e = n,
        d = "full" == r || "pie" == r || 0 === r.indexOf("custom");
      if (s.svgMode && !d && (i = this._handleBars(), "none" != s.lineCap ? (o = "butt" === s.lineCap ? s.borderWidth / 2 : s.width / 2 + s.borderWidth, -1 != r.indexOf("bottom") && i.css("margin-top", o + "px"), -1 != r.indexOf("right") && i.css("margin-right", -o + "px")) : p.each(i, function (t, e) {
        e.style.removeProperty("margin-top"), e.style.removeProperty("margin-right");
      })), 0 === r.indexOf("half")) switch (r) {
        case "half-top":
        case "half-bottom":
          t = (h = a) + o;
          break;
        case "half-left":
        case "half-right":
          e = (l = a) + o;
      } else 0 === r.indexOf("quarter") && (t = e = (h = l = a) + o);
      this.container.css({
        height: h,
        width: l
      }), this.control.css({
        height: t,
        width: e
      }), 0 !== o ? this.innerContainer.css({
        height: t,
        width: e
      }) : this.innerContainer.removeAttr("style"), s.svgMode && this.svgContainer.height(n).width(n).children("svg").height(n).width(n);
    },
    _border: function _border(t) {
      var e = this.options;
      return e.svgMode ? 2 * e.borderWidth : t ? parseFloat(this._startLine.children().css("border-bottom-width")) : 2 * parseFloat(this.block.css("border-top-width"));
    },
    _appendHandle: function _appendHandle() {
      !this._rangeSlider && this._minRange || this._createHandle(1), this._showRange && this._createHandle(2);
    },
    _appendSeperator: function _appendSeperator() {
      this._startLine = this._addSeperator(this._start, "rs-start"), this._endLine = this._addSeperator(this._start + this._end, "rs-end"), this._refreshSeperator();
    },
    _addSeperator: function _addSeperator(t, e) {
      var i = this.$createElement("span.rs-seperator rs-border"),
        s = this.$createElement("span.rs-bar rs-transition " + e).append(i).rsRotate(t);
      return this.container.append(s), s;
    },
    _refreshSeperator: function _refreshSeperator() {
      var t = this._startLine.add(this._endLine),
        e = t.children().removeAttr("style"),
        i = this.options,
        s = i.width + this._border();
      "round" == i.lineCap && "full" != i.circleShape ? (t.addClass("rs-rounded"), e.css({
        width: s,
        height: s / 2 + 1
      }), this._startLine.children().css("margin-top", -1).addClass(this._minRange ? "rs-range-color" : "rs-path-color"), this._endLine.children().css("margin-top", s / -2).addClass("rs-path-color")) : (t.removeClass("rs-rounded"), e.css({
        width: s,
        "margin-top": this._border(!0) / -2
      }).removeClass("rs-range-color rs-path-color"));
    },
    _updateSeperator: function _updateSeperator() {
      this._startLine.rsRotate(this._start), this._endLine.rsRotate(this._start + this._end);
    },
    _createHandle: function _createHandle(t) {
      var e,
        i = this.$createElement("div.rs-handle rs-move");
      "round" != (e = this.options.handleShape) && i.addClass("rs-handle-" + e), i.attr({
        index: t,
        tabIndex: "0"
      });
      var s = this._dataElement()[0].id,
        a = (s = s ? s + "_" : "") + "handle";
      this._rangeSlider && (a += "_" + (1 == t ? "start" : "end")), i.attr({
        role: "slider",
        "aria-label": a
      });
      var n = this._handleDefaults(),
        r = this.$createElement("div.rs-bar rs-transition").css("z-index", "7").append(i);
      return r.addClass(this._rangeSlider && 2 == t ? "rs-second" : "rs-first"), r.rsRotate(n.angle), this.container.append(r), this._refreshHandle(), this.bar = r, 1 != (this._active = t) && 2 != t && (this["_handle" + t] = n), this._bind(i, "focus blur", this._handleFocus), i;
    },
    _refreshHandle: function _refreshHandle() {
      var t,
        e,
        i,
        s = this.options,
        a = s.handleSize,
        n = s.width,
        r = !0,
        o = this.isNumber;
      "string" == typeof a && o(a) && ("+" === a.charAt(0) || "-" === a.charAt(0) ? a = n + parseFloat(a) : !a.indexOf(",") || o((i = a.split(","))[0]) && o(i[1]) && (e = parseFloat(i[0]), t = parseFloat(i[1]), r = !1)), r && (t = e = o(a) ? parseFloat(a) : n);
      var h = (n + this._border() - e) / 2;
      this._handles().css({
        height: t,
        width: e,
        margin: -t / 2 + "px 0 0 " + h + "px"
      });
    },
    _defaultValue: function _defaultValue() {
      var t = this.options,
        e = t.startValue;
      return this.isNumber(e) ? this._limitValue(e) : t.min;
    },
    _handleDefaults: function _handleDefaults() {
      var t = this._defaultValue();
      return {
        angle: this._valueToAngle(t),
        value: t
      };
    },
    _handleBars: function _handleBars() {
      return this.container.children("div.rs-bar");
    },
    _handles: function _handles() {
      return this._handleBars().find(".rs-handle");
    },
    _activeHandleBar: function _activeHandleBar(t) {
      return this._minRange ? this.bar : (t = null != t ? t : this._active, p(this._handleBars()[t - 1]));
    },
    _handleArgs: function _handleArgs(t) {
      var e = this["_handle" + (t = null != t ? t : this._active)] || {};
      return {
        element: this._activeHandleBar(t).children(),
        index: t,
        isActive: t == this._active,
        value: e.value,
        angle: e.angle
      };
    },
    _dataElement: function _dataElement() {
      return this._isInputType ? this._hiddenField : this.control;
    },
    _raiseEvent: function _raiseEvent(t) {
      var e,
        i = this["_pre" + t],
        s = this.options.value;
      i !== s && (this["_pre" + t] = s, "change" == t && (this._predrag = s, this._updateHidden()), this._updateTooltip(), e = this._handleArgs(), this._raise(t, {
        value: s,
        preValue: i,
        handle: e
      }), s != this._preValue && (this._raise("update", {
        value: s,
        preValue: i,
        handle: e,
        action: t
      }), this._raiseValueChange(t)));
    },
    _raiseBeforeValueChange: function _raiseBeforeValueChange(t, e) {
      void 0 !== e ? this._rangeSlider && (e = this._formRangeValue(e)) : e = this.options.value;
      var i = "code" !== t;
      if (e === this._pre_bvc) return !i;
      var s = {
          value: e,
          preValue: this._pre_bvc,
          action: t,
          isUserAction: i,
          cancelable: !0
        },
        a = 0 != this._raise("beforeValueChange", s);
      return a && (this._pre_bvc = e), a;
    },
    _raiseValueChange: function _raiseValueChange(t) {
      var e = this.options.value,
        i = [];
      this._minRange || i.push(this._handleArgs(1)), this._showRange && i.push(this._handleArgs(2));
      var s = {
        value: e,
        preValue: this._preValue,
        action: t,
        isUserAction: "code" !== t && "create" !== t,
        isInvertedRange: this._isInvertedRange,
        handles: i
      };
      this._raise("valueChange", s), this._preValue = e;
    },
    _elementDown: function _elementDown(t) {
      var e, i, s, a, n, r, o, h, l;
      this._isReadOnly || (p(t.target).hasClass("rs-handle") ? this._handleDown(t) : (e = this._getXY(t), i = this._getCenterPoint(), s = this._getDistance(e, i), (a = (this.block || this.svgContainer).outerWidth() / 2) - (this.options.width + this._border()) <= s && s <= a && (0 !== (n = this.control.find(".rs-handle.rs-focus")).length && t.preventDefault(), h = (r = this._getAngleValue(e, i)).angle, l = r.value, this._rangeSlider && (1 == n.length ? (o = parseFloat(n.attr("index")), this._invertRange || (1 == o && h > this._handle2.angle ? o = 2 : 2 == o && h < this._handle1.angle && (o = 1)), this._active = o) : this._active = this._handle2.angle - h < h - this._handle1.angle ? 2 : 1, this.bar = this._activeHandleBar()), this._raiseBeforeValueChange("change", l) && (this._changeSliderValue(l, h), this._raiseEvent("change")))));
    },
    _handleDown: function _handleDown(t) {
      t.preventDefault();
      var e = p(t.target);
      e.focus(), this._removeAnimation(), this._bindMouseEvents("_bind"), this.bar = e.parent(), this._active = parseFloat(e.attr("index")), this._handles().removeClass("rs-move"), this._raise("start", {
        value: this.options.value,
        handle: this._handleArgs()
      });
    },
    _handleMove: function _handleMove(t) {
      t.preventDefault();
      var e = this._getXY(t),
        i = this._getCenterPoint(),
        s = this._getAngleValue(e, i, !0),
        a = s.angle,
        n = s.value;
      this._raiseBeforeValueChange("drag", n) && (this._changeSliderValue(n, a), this._raiseEvent("drag"));
    },
    _handleUp: function _handleUp(t) {
      this._handles().addClass("rs-move"), this._bindMouseEvents("_unbind"), this._addAnimation(), this._raiseEvent("change"), this._raise("stop", {
        value: this.options.value,
        handle: this._handleArgs()
      });
    },
    _handleFocus: function _handleFocus(t) {
      var e, i;
      this._isReadOnly || (this._handles().removeClass("rs-focus"), (e = this.options.keyboardAction) && this._bindKeyboardEvents("_unbind"), "blur" !== t.type && ((i = p(t.target)).addClass("rs-focus"), this.bar = i.parent(), this._active = parseFloat(i.attr("index")), e && this._bindKeyboardEvents("_bind"), this.control.find("div.rs-bar").css("z-index", "7"), this.bar.css("z-index", "8")));
    },
    _handleKeyDown: function _handleKeyDown(t) {
      var e,
        i,
        s,
        a = t.keyCode,
        n = this.keys;
      27 == a && this._handles().blur(), 35 <= a && a <= 40 && (37 <= a && a <= 40 && this._removeAnimation(), e = this["_handle" + this._active], t.preventDefault(), a == n.UP || a == n.RIGHT ? i = this._round(this._limitValue(e.value + this.options.step)) : a == n.DOWN || a == n.LEFT ? i = this._round(this._limitValue(e.value - this._getMinusStep(e.value))) : 36 == a ? i = this._getKeyValue("Home") : 35 == a && (i = this._getKeyValue("End")), s = this._valueToAngle(i), this._raiseBeforeValueChange("drag", i) && (this._changeSliderValue(i, s), this._raiseEvent("drag")));
    },
    _handleKeyUp: function _handleKeyUp(t) {
      this._addAnimation(), this._raiseEvent("change");
    },
    _getMinusStep: function _getMinusStep(t) {
      var e = this.options,
        i = e.min,
        s = e.max,
        a = e.step;
      if (t != s) return a;
      var n = (s - i) % a;
      return 0 == n ? a : n;
    },
    _getKeyValue: function _getKeyValue(t) {
      var e = this.options,
        i = e.min,
        s = e.max;
      return this._rangeSlider ? "Home" == t ? 1 == this._active ? i : this._handle1.value : 1 == this._active ? this._handle2.value : s : "Home" == t ? i : s;
    },
    _elementScroll: function _elementScroll(t) {
      var e, i, s, a, n;
      this._isReadOnly || (t.preventDefault(), 0 != (n = (e = t.originalEvent || t).wheelDelta ? e.wheelDelta / 60 : e.detail ? -e.detail / 2 : 0) && (this._updateActiveHandle(t), s = (i = this["_handle" + this._active]).value + (0 < n ? this.options.step : -this._getMinusStep(i.value)), s = this._limitValue(s), a = this._valueToAngle(s), this._raiseBeforeValueChange("change", s) && (this._removeAnimation(), this._changeSliderValue(s, a), this._raiseEvent("change"), this._addAnimation())));
    },
    _updateActiveHandle: function _updateActiveHandle(t) {
      var e = p(t.target);
      e.hasClass("rs-handle") && e.parent().parent()[0] == this.control[0] && (this.bar = e.parent(), this._active = parseFloat(e.attr("index"))), this.bar.find(".rs-handle").hasClass("rs-focus") || this.bar.find(".rs-handle").focus();
    },
    _bindControlEvents: function _bindControlEvents(t) {
      this[t](this.control, "mousedown touchstart", this._elementDown);
    },
    _bindScrollEvents: function _bindScrollEvents(t) {
      this[t](this.control, "mousewheel DOMMouseScroll", this._elementScroll);
    },
    _bindMouseEvents: function _bindMouseEvents(t) {
      var e = p(document);
      this[t](e, "mousemove touchmove", this._handleMove), this[t](e, "mouseup mouseleave touchend touchcancel", this._handleUp);
    },
    _bindKeyboardEvents: function _bindKeyboardEvents(t) {
      var e = p(document);
      this[t](e, "keydown", this._handleKeyDown), this[t](e, "keyup", this._handleKeyUp);
    },
    _changeSliderValue: function _changeSliderValue(t, e) {
      var i = this._oriAngle(e),
        s = this._limitAngle(e),
        a = this._active,
        n = this.options;
      if (this._showRange) {
        var r = 1 == a && i <= this._oriAngle(this._handle2.angle) || 2 == a && i >= this._oriAngle(this._handle1.angle),
          o = this._invertRange;
        if (this._minRange || r || o) {
          if (this["_handle" + a] = {
            angle: e,
            value: t
          }, n.value = this._rangeSlider ? this._handle1.value + "," + this._handle2.value : t, this.bar.rsRotate(s), this._updateARIA(t), n.svgMode) return void this._moveSliderRange();
          var h = this._oriAngle(this._handle2.angle) - this._oriAngle(this._handle1.angle),
            l = "1",
            d = "0";
          h <= 180 && !(h < 0 && -180 < h) && (l = "0", d = "1"), this.block2.css("opacity", l), this.block3.css("opacity", d), (1 == a ? this.block4 : this.block2).rsRotate(s - 180), (1 == a ? this.block1 : this.block3).rsRotate(s);
        }
      } else this["_handle" + a] = {
        angle: e,
        value: t
      }, n.value = t, this.bar.rsRotate(s), this._updateARIA(t);
    },
    _createSVGElements: function _createSVGElements() {
      var t = this.$createSVG("svg"),
        e = "path.rs-transition ",
        i = {
          fill: "transparent"
        };
      this.$path = this.$createSVG(e + "rs-path", i), this.$range = this._showRange ? this.$createSVG(e + "rs-range", i) : null, this.$border = this.$createSVG(e + "rs-border", i), this.$append(t, [this.$path, this.$range, this.$border]), this.svgContainer = this.$createElement("div.rs-svg-container").append(t).appendTo(this.innerContainer);
    },
    _setSVGAttributes: function _setSVGAttributes() {
      var t = this.options,
        e = t.radius,
        i = t.borderWidth,
        s = t.width,
        a = t.lineCap,
        n = e - i / 2,
        r = n - s - i,
        o = this._start,
        h = this._end,
        l = o + h,
        d = this.$drawPath(e, n, o, l, r, a);
      this.$setAttribute(this.$border, {
        d: d
      }), p(this.$border).css("stroke-width", i);
      var u = e - i - s / 2;
      this.svgPathLength = this.$getArcLength(u, h);
      var _ = {
        d: this.$drawPath(e, u, o, l),
        "stroke-width": s,
        "stroke-linecap": a
      };
      this.$setAttribute(this.$path, _), this._showRange && (this.$setAttribute(this.$range, _), "round" == a || "square" == a ? this.$range.setAttribute("stroke-dashoffset", "0.01") : this.$range.removeAttribute("stroke-dashoffset"));
    },
    _setSVGStyles: function _setSVGStyles() {
      var t = this.options,
        e = t.borderColor,
        i = t.pathColor,
        s = t.rangeColor;
      e && ("inherit" == e && (e = s), p(this.$border).css("stroke", e)), i && (this.svgContainer["inherit" == i ? "addClass" : "removeClass"]("rs-path-inherited"), "inherit" == i && (i = s), p(this.$path).css("stroke", i)), this._showRange && s && p(this.$range).css("stroke", s);
    },
    _moveSliderRange: function _moveSliderRange(t) {
      var e, i, s, a, n, r, o, h, l;
      this._showRange && (e = this._start, i = this._end, r = this._handle1.angle, o = this._handle2.angle, t && (r = o = this._handleDefaults().angle), s = [], a = (r -= e) <= (o -= e), this._isInvertedRange = !a, a ? s.push(0) : (this._minRange && s.push(0), n = r, r = o, o = n), h = r / i * this.svgPathLength, s.push(h), l = (o - r) / i * this.svgPathLength, s.push(l, this.svgPathLength), this.$range.style.strokeDasharray = s.join(" "));
    },
    _isPropsRelatedToSVG: function _isPropsRelatedToSVG(t) {
      return this._hasProperty(t, ["radius", "borderWidth", "width", "lineCap", "startAngle", "endAngle"]);
    },
    _isPropsRelatedToSVGStyles: function _isPropsRelatedToSVGStyles(t) {
      return this._hasProperty(t, ["borderColor", "pathColor", "rangeColor"]);
    },
    _hasProperty: function _hasProperty(t, e) {
      return "string" == typeof t ? -1 !== e.indexOf(t) : Object.keys(t).some(function (t) {
        return -1 !== e.indexOf(t);
      });
    },
    _updateARIA: function _updateARIA(t) {
      var e,
        i = this.options,
        s = i.min,
        a = i.max;
      this.bar.children().attr({
        "aria-valuenow": t
      }), this._rangeSlider ? ((e = this._handles()).eq(0).attr({
        "aria-valuemin": s
      }), e.eq(1).attr({
        "aria-valuemax": a
      }), 1 == this._active ? e.eq(1).attr({
        "aria-valuemin": t
      }) : e.eq(0).attr({
        "aria-valuemax": t
      })) : this.bar.children().attr({
        "aria-valuemin": s,
        "aria-valuemax": a
      });
    },
    _getDistance: function _getDistance(t, e) {
      return Math.sqrt((t.x - e.x) * (t.x - e.x) + (t.y - e.y) * (t.y - e.y));
    },
    _getXY: function _getXY(t) {
      return -1 == t.type.indexOf("mouse") && (t = (t.originalEvent || t).changedTouches[0]), {
        x: t.pageX,
        y: t.pageY
      };
    },
    _getCenterPoint: function _getCenterPoint() {
      var t = this.block || this.svgContainer,
        e = t.offset();
      return {
        x: e.left + t.outerWidth() / 2,
        y: e.top + t.outerHeight() / 2
      };
    },
    _getAngleValue: function _getAngleValue(t, e, i) {
      var s = -Math.atan2(t.y - e.y, e.x - t.x) / (Math.PI / 180);
      return s < this._start && (s += 360), s = this._checkAngle(s, i), this._processStepByAngle(s);
    },
    _checkAngle: function _checkAngle(t, e) {
      var i = this._oriAngle(t),
        s = this["_handle" + this._active].angle,
        a = this._oriAngle(s);
      if (i > this._end) {
        if (!e) return s;
        t = this._start + (a <= this._end - a ? 0 : this._end);
      } else if (e) {
        var n = this._handleDragDistance;
        if (this.isNumber(n) && Math.abs(i - a) > n) return s;
      }
      return t;
    },
    _processStepByAngle: function _processStepByAngle(t) {
      var e = this._angleToValue(t);
      return this._processStepByValue(e);
    },
    _processStepByValue: function _processStepByValue(t) {
      var e = this.options,
        i = e.min,
        s = e.max,
        a = e.step,
        n = s < i,
        r = t - (t - i) % (a = n ? -a : a),
        o = this._limitValue(r + a),
        h = this._limitValue(r - a),
        l = n ? t <= r ? r - t < t - o ? r : o : h - t < t - r ? r : h : r <= t ? t - r < o - t ? r : o : t - h < r - t ? r : h;
      return {
        value: l = this._round(l),
        angle: this._valueToAngle(l)
      };
    },
    _round: function _round(t) {
      var e = this.options.step.toString().split(".");
      return e[1] ? parseFloat(t.toFixed(e[1].length)) : Math.round(t);
    },
    _oriAngle: function _oriAngle(t) {
      var e = t - this._start;
      return e < 0 && (e += 360), e;
    },
    _limitAngle: function _limitAngle(t) {
      return t > 360 + this._start && (t -= 360), t < this._start && (t += 360), t;
    },
    _limitValue: function _limitValue(t) {
      var e = this.options,
        i = e.min,
        s = e.max,
        a = s < i;
      return (!a && t < i || a && i < t) && (t = i), (!a && s < t || a && t < s) && (t = s), t;
    },
    _angleToValue: function _angleToValue(t) {
      var e = this.options,
        i = e.min,
        s = e.max;
      return this._oriAngle(t) / this._end * (s - i) + i;
    },
    _valueToAngle: function _valueToAngle(t) {
      var e = this.options,
        i = e.min;
      return (t - i) / (e.max - i) * this._end + this._start;
    },
    _appendHiddenField: function _appendHiddenField() {
      var t = this._hiddenField = this._hiddenField || this.$createElement("input");
      t.attr({
        type: "hidden",
        name: this._dataElement()[0].id || ""
      }), this.control.append(t), this._updateHidden();
    },
    _updateHidden: function _updateHidden() {
      var t = this.options.value;
      this._hiddenField.val(t);
    },
    _updateTooltip: function _updateTooltip() {
      var t = this.options,
        e = this.tooltip;
      e && (e.hasClass("rs-hover") || e.html(this._getTooltipValue()), this._updateTooltipPos()), !t.showTooltip && t.mouseScrollAction && this.control.height();
    },
    _updateTooltipPos: function _updateTooltipPos() {
      var t,
        e,
        i,
        s = this.options,
        a = s.circleShape,
        n = {};
      s.showTooltip && 0 !== a.indexOf("quarter") && ((t = this.tooltip).is(":visible") ? (t.removeClass("rs-center").addClass("rs-reset"), e = -t.outerHeight() / 2, i = -t.outerWidth() / 2, t.removeClass("rs-reset"), "full" == a || "pie" == a || 0 === a.indexOf("custom") ? n = {
        "margin-top": e,
        "margin-left": i
      } : "half-top" == a || "half-bottom" == a ? n = {
        "margin-left": i
      } : "half-left" != a && "half-right" != a || (n = {
        "margin-top": e
      })) : t.addClass("rs-center"), t.css(n));
    },
    _getTooltipValue: function _getTooltipValue(t) {
      var e = this.options.value;
      if (this._rangeSlider) {
        var i = e.split(",");
        return t ? i[0] + " - " + i[1] : this._tooltipValue(i[0], 1) + " - " + this._tooltipValue(i[1], 2);
      }
      return t ? e : this._tooltipValue(e);
    },
    _tooltipValue: function _tooltipValue(t, e) {
      var i = this._raise("tooltipFormat", {
        value: t,
        handle: this._handleArgs(e)
      });
      return null != i && "boolean" != typeof i ? i : t;
    },
    _validateStartAngle: function _validateStartAngle() {
      var t = this.options,
        e = t.startAngle;
      return (e = (this.isNumber(e) ? parseFloat(e) : 0) % 360) < 0 && (e += 360), t.startAngle = e;
    },
    _validateEndAngle: function _validateEndAngle() {
      var t = this.options,
        e = t.startAngle,
        i = t.endAngle,
        i = this.isNumber(i) ? ("string" != typeof i || "+" !== i.charAt(0) && "-" !== i.charAt(0) || (i = e + parseFloat(i)), parseFloat(i)) : 360;
      return (i %= 360) <= e && (i += 360), i;
    },
    _refreshCircleShape: function _refreshCircleShape() {
      var t = this.options,
        e = t.circleShape;
      -1 == ["half-top", "half-bottom", "half-left", "half-right", "quarter-top-left", "quarter-top-right", "quarter-bottom-right", "quarter-bottom-left", "pie", "custom-half", "custom-quarter"].indexOf(e) && (e = "half" == e ? "half-top" : "quarter" == e ? "quarter-top-left" : "full"), t.circleShape = e;
    },
    _appendOverlay: function _appendOverlay() {
      var t = this.options.circleShape;
      "pie" == t ? this._checkOverlay(".rs-overlay", 270) : "custom-half" != t && "custom-quarter" != t || (this._checkOverlay(".rs-overlay1", 180), "custom-quarter" == t && this._checkOverlay(".rs-overlay2", this._end));
    },
    _checkOverlay: function _checkOverlay(t, e) {
      var i = this.container.children(t);
      0 == i.length && (i = this.$createElement("div" + t + " rs-transition rs-bg-color"), this.container.append(i)), i.rsRotate(this._start + e);
    },
    _checkDataType: function _checkDataType() {
      var t,
        e,
        i,
        s = this.options,
        a = this._props();
      for (t in a.numberType) i = s[e = a.numberType[t]], this.isNumber(i) ? s[e] = parseFloat(i) : s[e] = this.defaults[e];
      for (t in a.booleanType) i = s[e = a.booleanType[t]], s[e] = "false" != i && !!i;
      for (t in a.stringType) i = s[e = a.stringType[t]], s[e] = ("" + i).toLowerCase();
    },
    _validateSliderType: function _validateSliderType() {
      var t = this.options,
        e = t.sliderType.toLowerCase();
      this._rangeSlider = this._showRange = this._minRange = !1, "range" == e ? this._rangeSlider = this._showRange = !0 : e = -1 != e.indexOf("min") ? (this._showRange = this._minRange = !0, "min-range") : "default", t.sliderType = e;
    },
    _updateStartEnd: function _updateStartEnd() {
      var t = this.options,
        e = t.circleShape,
        i = t.startAngle,
        s = t.endAngle;
      "full" != e && (-1 != e.indexOf("quarter") ? s = "+90" : -1 != e.indexOf("half") ? s = "+180" : "pie" == e && (s = "+270"), t.endAngle = s, "quarter-top-left" == e || "half-top" == e ? i = 0 : "quarter-top-right" == e || "half-right" == e ? i = 90 : "quarter-bottom-right" == e || "half-bottom" == e ? i = 180 : "quarter-bottom-left" != e && "half-left" != e || (i = 270), t.startAngle = i);
    },
    _validateStartEnd: function _validateStartEnd() {
      this._start = this._validateStartAngle(), this._end = this._validateEndAngle();
      var t = this._start < this._end ? 0 : 360;
      this._end += t - this._start;
    },
    _validateValue: function _validateValue(t) {
      return this._backupPreValue(), this._analyzeModelValue(), this._validateModelValue(), this._raiseBeforeValueChange(t ? "change" : "code") ? (this._setValue(), this._backupPreValue(), !0) : (this._revertPreValue(), !1);
    },
    _analyzeModelValue: function _analyzeModelValue() {
      var t = this.options,
        e = t.value;
      e instanceof Array && (e = e.toString());
      var i,
        s,
        a = "string" == typeof e ? e.split(",") : [e];
      1 == a.length && this.isNumber(a[0]) ? a = [t.min, a[0]] : 2 <= a.length && !this.isNumber(a[1]) && (a[1] = t.max), s = this._rangeSlider ? [this._parseModelValue(a[0]), this._parseModelValue(a[1])].toString() : (i = a.pop(), this._parseModelValue(i)), t.value = s;
    },
    _parseModelValue: function _parseModelValue(t) {
      return this.isNumber(t) ? parseFloat(t) : this._defaultValue();
    },
    _validateModelValue: function _validateModelValue() {
      var t,
        e,
        i,
        s,
        a = this.options,
        n = a.value;
      this._rangeSlider ? (t = n.split(","), i = parseFloat(t[0]), s = parseFloat(t[1]), i = this._limitValue(i), s = this._limitValue(s), this._invertRange || (e = a.min, a.max < e ? i < s && (i = s) : s < i && (s = i)), this._handle1 = this._processStepByValue(i), this._handle2 = this._processStepByValue(s)) : this["_handle" + (this._minRange ? 2 : this._active || 1)] = this._processStepByValue(this._limitValue(n)), this._updateModelValue();
    },
    _updateModelValue: function _updateModelValue() {
      var t;
      t = this._rangeSlider ? this._handle1.value + "," + this._handle2.value : this["_handle" + (this._minRange ? 2 : this._active || 1)].value, this.options.value = t;
    },
    _formRangeValue: function _formRangeValue(t, e) {
      e = e || this._active;
      var i = this._handle1.value,
        s = this._handle2.value;
      return 1 == e ? t + "," + s : i + "," + t;
    },
    $createElement: function $createElement(t) {
      var e = t.split(".");
      return p(document.createElement(e[0])).addClass(e[1] || "");
    },
    $createSVG: function $createSVG(t, e) {
      var i = t.split("."),
        s = document.createElementNS("http://www.w3.org/2000/svg", i[0]);
      return i[1] && s.setAttribute("class", i[1]), e && this.$setAttribute(s, e), s;
    },
    $setAttribute: function $setAttribute(t, e) {
      for (var i in e) {
        var s,
          a = e[i];
        "class" !== i || (s = t.getAttribute("class")) && (a += " " + s), t.setAttribute(i, a);
      }
      return t;
    },
    $append: function $append(e, t) {
      return t.forEach(function (t) {
        t && e.appendChild(t);
      }), e;
    },
    isNumber: function isNumber(t) {
      return "number" == typeof (t = parseFloat(t)) && !isNaN(t);
    },
    getBrowserName: function getBrowserName() {
      var t = "",
        e = window.navigator.userAgent;
      return window.opr && opr.addons || window.opera || 0 <= e.indexOf(" OPR/") ? t = "opera" : "undefined" != typeof InstallTrigger ? t = "firefox" : 0 < e.indexOf("MSIE ") || 0 < e.indexOf("Trident/") ? t = "ie" : window.StyleMedia ? t = "edge" : -1 != e.indexOf("Safari") && -1 == e.indexOf("Chrome") ? t = "safari" : (window.chrome && window.chrome.webstore || -1 != e.indexOf("Chrome")) && (t = "chrome"), t;
    },
    _isBrowserSupported: function _isBrowserSupported() {
      for (var t = ["borderRadius", "WebkitBorderRadius", "MozBorderRadius", "OBorderRadius", "msBorderRadius", "KhtmlBorderRadius"], e = 0; e < t.length; e++) if (void 0 !== document.body.style[t[e]]) return !0;
      console.error(o + " : Browser not supported");
    },
    _raise: function _raise(t, e) {
      var i = this.options,
        s = i[t],
        a = !0;
      return (e = e || {
        value: i.value
      }).id = this.id, e.control = this.control, e.options = i, s && (e.type = t, "string" == typeof s && (s = window[s]), p.isFunction(s) && (a = !1 !== (a = s.call(this, e)) && a)), this.control.trigger(p.Event(t, e)), a;
    },
    _bind: function _bind(t, e, i) {
      p(t).bind(e, p.proxy(i, this));
    },
    _unbind: function _unbind(t, e, i) {
      p(t).unbind(e, p.proxy(i, this));
    },
    _getInstance: function _getInstance() {
      return p.data(this._dataElement()[0], o);
    },
    _saveInstanceOnElement: function _saveInstanceOnElement() {
      p.data(this.control[0], o, this);
    },
    _saveInstanceOnID: function _saveInstanceOnID() {
      var t = this.id;
      t && void 0 !== window[t] && (window[t] = this);
    },
    _removeData: function _removeData() {
      var t = this._dataElement()[0];
      p.removeData && p.removeData(t, o), t.id && "function" == typeof window[t.id]._init && delete window[t.id];
    },
    _destroyControl: function _destroyControl() {
      this._isInputType && this._dataElement().insertAfter(this.control).attr("type", "text"), this.control.empty().removeClass("rs-control").height("").width(""), this._removeAnimation(), this._bindControlEvents("_unbind"), this._bindScrollEvents("_unbind");
    },
    _updateWidth: function _updateWidth() {
      this.lastBlock.css("padding", this.options.width);
    },
    _readOnly: function _readOnly(t) {
      this._isReadOnly = t, this.container.removeClass("rs-readonly"), t && this.container.addClass("rs-readonly");
    },
    _get: function _get(t) {
      return this.options[t];
    },
    _set: function _set(t, e, i) {
      var s = this._props();
      if (-1 != p.inArray(t, s.numberType)) {
        if (!this.isNumber(e)) return;
        e = parseFloat(e);
      } else -1 != p.inArray(t, s.booleanType) ? e = "false" != e && !!e : -1 != p.inArray(t, s.stringType) && (e = e.toLowerCase());
      var a = this.options;
      if (this._preValue = a.value, i || a[t] !== e) {
        switch (a[t] = e, t) {
          case "startAngle":
          case "endAngle":
            this._validateStartEnd(), this._updateSeperator(), this._appendOverlay();
          case "startValue":
            this._minRange && (this._handle1 = this._handleDefaults());
          case "min":
          case "max":
          case "step":
          case "value":
            this._validateValue() && (this._updateHidden(), this._updateTooltip(), a.value !== this._preValue && (this._raiseValueChange("code"), this._updatePre()));
            break;
          case "radius":
            this._setRadius(), this._updateTooltipPos();
            break;
          case "width":
            this._removeAnimation(), this._updateWidth(), this._setRadius(), this._refreshHandle(), this._updateTooltipPos(), this._addAnimation(), this._refreshSeperator();
            break;
          case "borderWidth":
            this._setRadius(), this._refreshHandle();
            break;
          case "handleSize":
            this._refreshHandle();
            break;
          case "handleShape":
            this._setHandleShape();
            break;
          case "animation":
            a.animation ? this._addAnimation() : this._removeAnimation();
            break;
          case "showTooltip":
            a.showTooltip ? this._appendTooltip() : this._removeTooltip();
            break;
          case "editableTooltip":
            this._tooltipEditable(), this._updateTooltipPos();
            break;
          case "rangeColor":
          case "tooltipColor":
            this._setTooltipColor(this.tooltip), this._setTooltipColor(this.input);
            break;
          case "disabled":
            a.disabled ? this.disable() : this.enable();
            break;
          case "readOnly":
            a.readOnly ? this._readOnly(!0) : a.disabled || this._readOnly(!1);
            break;
          case "mouseScrollAction":
            this._bindScrollEvents(a.mouseScrollAction ? "_bind" : "_unbind");
            break;
          case "lineCap":
            this._setRadius(), this._refreshSeperator();
            break;
          case "circleShape":
            this._refreshCircleShape(), "full" == a.circleShape && (a.startAngle = 0, a.endAngle = "+360");
          case "sliderType":
            this._destroyControl(), this._onInit();
            break;
          case "svgMode":
            var n = this.control,
              r = a;
            this.destroy(), n[o](r);
        }
        return this;
      }
    },
    option: function option(t, e) {
      if (t && this._getInstance()) {
        var i = this.options;
        if (p.isPlainObject(t)) {
          var s,
            a = "value",
            n = void 0 !== t.min,
            r = void 0 !== t.max;
          for (var o in (n || r) && (n && (i.min = t.min, delete t.min), r && (i.max = t.max, delete t.max), s = i.value, void 0 !== t[a] && (s = t[a], delete t[a]), this._set(a, s, !0)), t) this._set(o, t[o]);
        } else if ("string" == typeof t) {
          if (void 0 === e) return this._get(t);
          this._set(t, e);
        }
        return i.svgMode && (this._isPropsRelatedToSVG(t) && (this._setSVGAttributes(), this._moveSliderRange()), this._isPropsRelatedToSVGStyles(t) && this._setSVGStyles()), this;
      }
    },
    getValue: function getValue(t) {
      if (this._rangeSlider && this.isNumber(t)) {
        var e = parseFloat(t);
        if (1 == e || 2 == e) return this["_handle" + e].value;
      }
      return this._get("value");
    },
    setValue: function setValue(t, e) {
      var i, s;
      this.isNumber(t) && (this.isNumber(e) && (this._rangeSlider ? (i = parseFloat(e), s = parseFloat(t), t = this._formRangeValue(s, i)) : this._minRange || (this._active = e)), this._set("value", t));
    },
    refreshTooltip: function refreshTooltip() {
      this._updateTooltipPos();
    },
    disable: function disable() {
      this.options.disabled = !0, this.container.addClass("rs-disabled"), this._readOnly(!0);
    },
    enable: function enable() {
      var t = this.options;
      t.disabled = !1, this.container.removeClass("rs-disabled"), t.readOnly || this._readOnly(!1);
    },
    destroy: function destroy() {
      this._getInstance() && (this._destroyControl(), this._removeData(), this._isInputType && this.control.remove());
    }
  }, p.fn.rsRotate = function (t) {
    var e = this,
      i = "rotate(" + t + "deg)";
    return e.css("-webkit-transform", i), e.css("-moz-transform", i), e.css("-ms-transform", i), e.css("-o-transform", i), e.css("transform", i), e;
  }, r.prototype.$polarToCartesian = function (t, e, i) {
    var s = (i - 180) * Math.PI / 180;
    return [t + e * Math.cos(s), t + e * Math.sin(s)].join(" ");
  }, r.prototype.$drawArc = function (t, e, i, s, a) {
    var n,
      r,
      o,
      h = s - i == 360,
      l = Math.abs(i - s) <= 180 ? "0" : "1",
      d = a ? 1 : 0,
      u = a ? s : i,
      _ = [];
    return h ? (n = (i + s) / 2, r = this.$polarToCartesian(t, e, n), o = this.$polarToCartesian(t, e, u), _.push("A", 1, 1, 0, 0, d, r, "A", 1, 1, 0, 0, d, o)) : (o = this.$polarToCartesian(t, e, u), _.push("A", e, e, 0, l, d, o)), _.join(" ");
  }, r.prototype.$drawPath = function (t, e, i, s, a, n) {
    var r,
      o,
      h = this.$polarToCartesian(t, e, i),
      l = ["M " + h, this.$drawArc(t, e, i, s, !0)];
    return a && (r = this.$polarToCartesian(t, a, s), o = this.$drawArc(t, a, i, s, !1), "none" == n ? l.push("M " + r, o) : "round" == n ? l.push("A 1, 1, 0, 0, 1, " + r, o, "A 1, 1, 0, 0, 1, " + h) : "butt" != n && "square" != n || l.push("L " + r, o, "L " + h, "Z")), l.join(" ");
  }, r.prototype.$getArcLength = function (t, e) {
    return void 0 === e && (e = 360), 2 * Math.PI * t * (e / 360);
  }, p.fn[o].prototype = r.prototype;
});

},{"jquery":21}],23:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/*! UIkit 3.19.4 | https://www.getuikit.com | (c) 2014 - 2024 YOOtheme | MIT License */

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : (0, _typeof2["default"])(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define('uikit', factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.UIkit = factory());
})(void 0, function () {
  'use strict';

  var _events;
  var _Object$prototype = Object.prototype,
    hasOwnProperty = _Object$prototype.hasOwnProperty,
    toString = _Object$prototype.toString;
  function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
  }
  var hyphenateRe = /\B([A-Z])/g;
  var hyphenate = memoize(function (str) {
    return str.replace(hyphenateRe, "-$1").toLowerCase();
  });
  var camelizeRe = /-(\w)/g;
  var camelize = memoize(function (str) {
    return (str.charAt(0).toLowerCase() + str.slice(1)).replace(camelizeRe, function (_, c) {
      return c.toUpperCase();
    });
  });
  var ucfirst = memoize(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  });
  function startsWith(str, search) {
    var _a;
    return (_a = str == null ? void 0 : str.startsWith) == null ? void 0 : _a.call(str, search);
  }
  function endsWith(str, search) {
    var _a;
    return (_a = str == null ? void 0 : str.endsWith) == null ? void 0 : _a.call(str, search);
  }
  function includes(obj, search) {
    var _a;
    return (_a = obj == null ? void 0 : obj.includes) == null ? void 0 : _a.call(obj, search);
  }
  function findIndex(array, predicate) {
    var _a;
    return (_a = array == null ? void 0 : array.findIndex) == null ? void 0 : _a.call(array, predicate);
  }
  var isArray = Array.isArray,
    toArray = Array.from;
  var assign = Object.assign;
  function isFunction(obj) {
    return typeof obj === "function";
  }
  function isObject(obj) {
    return obj !== null && (0, _typeof2["default"])(obj) === "object";
  }
  function isPlainObject(obj) {
    return toString.call(obj) === "[object Object]";
  }
  function isWindow(obj) {
    return isObject(obj) && obj === obj.window;
  }
  function isDocument(obj) {
    return nodeType(obj) === 9;
  }
  function isNode(obj) {
    return nodeType(obj) >= 1;
  }
  function isElement(obj) {
    return nodeType(obj) === 1;
  }
  function nodeType(obj) {
    return !isWindow(obj) && isObject(obj) && obj.nodeType;
  }
  function isBoolean(value) {
    return typeof value === "boolean";
  }
  function isString(value) {
    return typeof value === "string";
  }
  function isNumber(value) {
    return typeof value === "number";
  }
  function isNumeric(value) {
    return isNumber(value) || isString(value) && !isNaN(value - parseFloat(value));
  }
  function isEmpty(obj) {
    return !(isArray(obj) ? obj.length : isObject(obj) ? Object.keys(obj).length : false);
  }
  function isUndefined(value) {
    return value === void 0;
  }
  function toBoolean(value) {
    return isBoolean(value) ? value : value === "true" || value === "1" || value === "" ? true : value === "false" || value === "0" ? false : value;
  }
  function toNumber(value) {
    var number = Number(value);
    return isNaN(number) ? false : number;
  }
  function toFloat(value) {
    return parseFloat(value) || 0;
  }
  function toNode(element) {
    return toNodes(element)[0];
  }
  function toNodes(element) {
    return isNode(element) ? [element] : Array.from(element || []).filter(isNode);
  }
  function toWindow(element) {
    if (isWindow(element)) {
      return element;
    }
    element = toNode(element);
    var document = isDocument(element) ? element : element == null ? void 0 : element.ownerDocument;
    return (document == null ? void 0 : document.defaultView) || window;
  }
  function isEqual(value, other) {
    return value === other || isObject(value) && isObject(other) && Object.keys(value).length === Object.keys(other).length && each(value, function (val, key) {
      return val === other[key];
    });
  }
  function swap(value, a, b) {
    return value.replace(new RegExp("".concat(a, "|").concat(b), "g"), function (match) {
      return match === a ? b : a;
    });
  }
  function last(array) {
    return array[array.length - 1];
  }
  function each(obj, cb) {
    for (var key in obj) {
      if (false === cb(obj[key], key)) {
        return false;
      }
    }
    return true;
  }
  function sortBy(array, prop) {
    return array.slice().sort(function (_ref, _ref2) {
      var _ref$prop = _ref[prop],
        propA = _ref$prop === void 0 ? 0 : _ref$prop;
      var _ref2$prop = _ref2[prop],
        propB = _ref2$prop === void 0 ? 0 : _ref2$prop;
      return propA > propB ? 1 : propB > propA ? -1 : 0;
    });
  }
  function sumBy(array, iteratee) {
    return array.reduce(function (sum, item) {
      return sum + toFloat(isFunction(iteratee) ? iteratee(item) : item[iteratee]);
    }, 0);
  }
  function uniqueBy(array, prop) {
    var seen = /* @__PURE__ */new Set();
    return array.filter(function (_ref3) {
      var check = _ref3[prop];
      return seen.has(check) ? false : seen.add(check);
    });
  }
  function pick(obj, props) {
    return props.reduce(function (res, prop) {
      return _objectSpread(_objectSpread({}, res), {}, (0, _defineProperty2["default"])({}, prop, obj[prop]));
    }, {});
  }
  function clamp(number) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(toNumber(number) || 0, min), max);
  }
  function noop() {}
  function intersectRect() {
    for (var _len = arguments.length, rects = new Array(_len), _key = 0; _key < _len; _key++) {
      rects[_key] = arguments[_key];
    }
    return [["bottom", "top"], ["right", "left"]].every(function (_ref4) {
      var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
        minProp = _ref5[0],
        maxProp = _ref5[1];
      return Math.min.apply(Math, (0, _toConsumableArray2["default"])(rects.map(function (_ref6) {
        var min = _ref6[minProp];
        return min;
      }))) - Math.max.apply(Math, (0, _toConsumableArray2["default"])(rects.map(function (_ref7) {
        var max = _ref7[maxProp];
        return max;
      }))) > 0;
    });
  }
  function pointInRect(point, rect) {
    return point.x <= rect.right && point.x >= rect.left && point.y <= rect.bottom && point.y >= rect.top;
  }
  function ratio(dimensions, prop, value) {
    var _ref8;
    var aProp = prop === "width" ? "height" : "width";
    return _ref8 = {}, (0, _defineProperty2["default"])(_ref8, aProp, dimensions[prop] ? Math.round(value * dimensions[aProp] / dimensions[prop]) : dimensions[aProp]), (0, _defineProperty2["default"])(_ref8, prop, value), _ref8;
  }
  function contain(dimensions, maxDimensions) {
    dimensions = _objectSpread({}, dimensions);
    for (var prop in dimensions) {
      dimensions = dimensions[prop] > maxDimensions[prop] ? ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
    }
    return dimensions;
  }
  function cover$1(dimensions, maxDimensions) {
    dimensions = contain(dimensions, maxDimensions);
    for (var prop in dimensions) {
      dimensions = dimensions[prop] < maxDimensions[prop] ? ratio(dimensions, prop, maxDimensions[prop]) : dimensions;
    }
    return dimensions;
  }
  var Dimensions = {
    ratio: ratio,
    contain: contain,
    cover: cover$1
  };
  function _getIndex(i, elements) {
    var current = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var finite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    elements = toNodes(elements);
    var _elements = elements,
      length = _elements.length;
    if (!length) {
      return -1;
    }
    i = isNumeric(i) ? toNumber(i) : i === "next" ? current + 1 : i === "previous" ? current - 1 : i === "last" ? length - 1 : elements.indexOf(toNode(i));
    if (finite) {
      return clamp(i, 0, length - 1);
    }
    i %= length;
    return i < 0 ? i + length : i;
  }
  function memoize(fn) {
    var cache = /* @__PURE__ */Object.create(null);
    return function (key) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      return cache[key] || (cache[key] = fn.apply(void 0, [key].concat(args)));
    };
  }
  function attr(element, name, value) {
    var _a;
    if (isObject(name)) {
      for (var key in name) {
        attr(element, key, name[key]);
      }
      return;
    }
    if (isUndefined(value)) {
      return (_a = toNode(element)) == null ? void 0 : _a.getAttribute(name);
    } else {
      var _iterator = _createForOfIteratorHelper(toNodes(element)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;
          if (isFunction(value)) {
            value = value.call(el, attr(el, name));
          }
          if (value === null) {
            removeAttr(el, name);
          } else {
            el.setAttribute(name, value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  function hasAttr(element, name) {
    return toNodes(element).some(function (element2) {
      return element2.hasAttribute(name);
    });
  }
  function removeAttr(element, name) {
    toNodes(element).forEach(function (element2) {
      return element2.removeAttribute(name);
    });
  }
  function data(element, attribute) {
    for (var _i = 0, _arr = [attribute, "data-".concat(attribute)]; _i < _arr.length; _i++) {
      var name = _arr[_i];
      if (hasAttr(element, name)) {
        return attr(element, name);
      }
    }
  }
  function addClass(element) {
    for (var _len3 = arguments.length, classes = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      classes[_key3 - 1] = arguments[_key3];
    }
    var _iterator2 = _createForOfIteratorHelper(toNodes(element)),
      _step2;
    try {
      var _loop = function _loop() {
        var node = _step2.value;
        var add = toClasses(classes).filter(function (cls) {
          return !hasClass(node, cls);
        });
        if (add.length) {
          var _node$classList;
          (_node$classList = node.classList).add.apply(_node$classList, (0, _toConsumableArray2["default"])(add));
        }
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  function removeClass(element) {
    for (var _len4 = arguments.length, classes = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      classes[_key4 - 1] = arguments[_key4];
    }
    var _iterator3 = _createForOfIteratorHelper(toNodes(element)),
      _step3;
    try {
      var _loop2 = function _loop2() {
        var node = _step3.value;
        var remove = toClasses(classes).filter(function (cls) {
          return hasClass(node, cls);
        });
        if (remove.length) {
          var _node$classList2;
          (_node$classList2 = node.classList).remove.apply(_node$classList2, (0, _toConsumableArray2["default"])(remove));
        }
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  function removeClasses(element, clsRegex) {
    clsRegex = new RegExp(clsRegex);
    var _iterator4 = _createForOfIteratorHelper(toNodes(element)),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _node$classList3;
        var node = _step4.value;
        (_node$classList3 = node.classList).remove.apply(_node$classList3, (0, _toConsumableArray2["default"])(toArray(node.classList).filter(function (cls) {
          return cls.match(clsRegex);
        })));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  function replaceClass(element, oldClass, newClass) {
    newClass = toClasses(newClass);
    oldClass = toClasses(oldClass).filter(function (cls) {
      return !includes(newClass, cls);
    });
    removeClass(element, oldClass);
    addClass(element, newClass);
  }
  function hasClass(element, cls) {
    var _toClasses = toClasses(cls);
    var _toClasses2 = (0, _slicedToArray2["default"])(_toClasses, 1);
    cls = _toClasses2[0];
    return toNodes(element).some(function (node) {
      return node.classList.contains(cls);
    });
  }
  function toggleClass(element, cls, force) {
    var classes = toClasses(cls);
    if (!isUndefined(force)) {
      force = !!force;
    }
    var _iterator5 = _createForOfIteratorHelper(toNodes(element)),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var node = _step5.value;
        var _iterator6 = _createForOfIteratorHelper(classes),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var cls2 = _step6.value;
            node.classList.toggle(cls2, force);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  function toClasses(str) {
    return str ? isArray(str) ? str.map(toClasses).flat() : String(str).split(/[ ,]/).filter(Boolean) : [];
  }
  var voidElements = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
  };
  function isVoidElement(element) {
    return toNodes(element).some(function (element2) {
      return voidElements[element2.tagName.toLowerCase()];
    });
  }
  function isVisible(element) {
    return toNodes(element).some(function (element2) {
      return element2.offsetWidth || element2.offsetHeight || element2.getClientRects().length;
    });
  }
  var selInput = "input,select,textarea,button";
  function isInput(element) {
    return toNodes(element).some(function (element2) {
      return matches(element2, selInput);
    });
  }
  var selFocusable = "".concat(selInput, ",a[href],[tabindex]");
  function isFocusable(element) {
    return matches(element, selFocusable);
  }
  function parent(element) {
    var _a;
    return (_a = toNode(element)) == null ? void 0 : _a.parentElement;
  }
  function filter$1(element, selector) {
    return toNodes(element).filter(function (element2) {
      return matches(element2, selector);
    });
  }
  function matches(element, selector) {
    return toNodes(element).some(function (element2) {
      return element2.matches(selector);
    });
  }
  function closest(element, selector) {
    var _a;
    return (_a = toNode(element)) == null ? void 0 : _a.closest(startsWith(selector, ">") ? selector.slice(1) : selector);
  }
  function within(element, selector) {
    return isString(selector) ? !!closest(element, selector) : toNode(selector).contains(toNode(element));
  }
  function parents(element, selector) {
    var elements = [];
    while (element = parent(element)) {
      if (!selector || matches(element, selector)) {
        elements.push(element);
      }
    }
    return elements;
  }
  function _children(element, selector) {
    element = toNode(element);
    var children2 = element ? toArray(element.children) : [];
    return selector ? filter$1(children2, selector) : children2;
  }
  function index(element, ref) {
    return ref ? toNodes(element).indexOf(toNode(ref)) : _children(parent(element)).indexOf(element);
  }
  function isSameSiteAnchor(el) {
    el = toNode(el);
    return el && ["origin", "pathname", "search"].every(function (part) {
      return el[part] === location[part];
    });
  }
  function getTargetedElement(el) {
    if (isSameSiteAnchor(el)) {
      el = toNode(el);
      var _id = decodeURIComponent(el.hash).substring(1);
      return document.getElementById(_id) || document.getElementsByName(_id)[0];
    }
  }
  function query(selector, context) {
    return find(selector, getContext(selector, context));
  }
  function queryAll(selector, context) {
    return findAll(selector, getContext(selector, context));
  }
  function find(selector, context) {
    return toNode(_query(selector, toNode(context), "querySelector"));
  }
  function findAll(selector, context) {
    return toNodes(_query(selector, toNode(context), "querySelectorAll"));
  }
  var contextSelectorRe = /(^|[^\\],)\s*[!>+~-]/;
  var isContextSelector = memoize(function (selector) {
    return selector.match(contextSelectorRe);
  });
  function getContext(selector) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    return isString(selector) && isContextSelector(selector) || isDocument(context) ? context : context.ownerDocument;
  }
  var contextSanitizeRe = /([!>+~-])(?=\s+[!>+~-]|\s*$)/g;
  var sanatize = memoize(function (selector) {
    return selector.replace(contextSanitizeRe, "$1 *");
  });
  function _query(selector) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    var queryFn = arguments.length > 2 ? arguments[2] : undefined;
    if (!selector || !isString(selector)) {
      return selector;
    }
    selector = sanatize(selector);
    if (isContextSelector(selector)) {
      var split = splitSelector(selector);
      selector = "";
      var _iterator7 = _createForOfIteratorHelper(split),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var sel = _step7.value;
          var ctx = context;
          if (sel[0] === "!") {
            var selectors = sel.substr(1).trim().split(" ");
            ctx = parent(context).closest(selectors[0]);
            sel = selectors.slice(1).join(" ").trim();
            if (!sel.length && split.length === 1) {
              return ctx;
            }
          }
          if (sel[0] === "-") {
            var _selectors = sel.substr(1).trim().split(" ");
            var prev = (ctx || context).previousElementSibling;
            ctx = matches(prev, sel.substr(1)) ? prev : null;
            sel = _selectors.slice(1).join(" ");
          }
          if (ctx) {
            selector += "".concat(selector ? "," : "").concat(domPath(ctx), " ").concat(sel);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      if (!isDocument(context)) {
        context = context.ownerDocument;
      }
    }
    try {
      return context[queryFn](selector);
    } catch (e) {
      return null;
    }
  }
  var selectorRe = /.*?[^\\](?![^(]*\))(?:,|$)/g;
  var splitSelector = memoize(function (selector) {
    return selector.match(selectorRe).map(function (selector2) {
      return selector2.replace(/,$/, "").trim();
    });
  });
  function domPath(element) {
    var names = [];
    while (element.parentNode) {
      var _id2 = attr(element, "id");
      if (_id2) {
        names.unshift("#".concat(escape(_id2)));
        break;
      } else {
        var _element = element,
          tagName = _element.tagName;
        if (tagName !== "HTML") {
          tagName += ":nth-child(".concat(index(element) + 1, ")");
        }
        names.unshift(tagName);
        element = element.parentNode;
      }
    }
    return names.join(" > ");
  }
  function escape(css) {
    return isString(css) ? CSS.escape(css) : "";
  }
  function on() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    var _getArgs = getArgs(args),
      _getArgs2 = (0, _slicedToArray2["default"])(_getArgs, 5),
      targets = _getArgs2[0],
      types = _getArgs2[1],
      selector = _getArgs2[2],
      listener = _getArgs2[3],
      _getArgs2$ = _getArgs2[4],
      useCapture = _getArgs2$ === void 0 ? false : _getArgs2$;
    if (listener.length > 1) {
      listener = detail(listener);
    }
    if (useCapture == null ? void 0 : useCapture.self) {
      listener = selfFilter(listener);
    }
    if (selector) {
      listener = delegate(selector, listener);
    }
    var _iterator8 = _createForOfIteratorHelper(types),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var type = _step8.value;
        var _iterator9 = _createForOfIteratorHelper(targets),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var target = _step9.value;
            target.addEventListener(type, listener, useCapture);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    return function () {
      return off(targets, types, listener, useCapture);
    };
  }
  function off() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    var _getArgs3 = getArgs(args),
      _getArgs4 = (0, _slicedToArray2["default"])(_getArgs3, 5),
      targets = _getArgs4[0],
      types = _getArgs4[1],
      listener = _getArgs4[3],
      _getArgs4$ = _getArgs4[4],
      useCapture = _getArgs4$ === void 0 ? false : _getArgs4$;
    var _iterator10 = _createForOfIteratorHelper(types),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var type = _step10.value;
        var _iterator11 = _createForOfIteratorHelper(targets),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var target = _step11.value;
            target.removeEventListener(type, listener, useCapture);
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }
  function once() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    var _getArgs5 = getArgs(args),
      _getArgs6 = (0, _slicedToArray2["default"])(_getArgs5, 6),
      element = _getArgs6[0],
      types = _getArgs6[1],
      selector = _getArgs6[2],
      listener = _getArgs6[3],
      _getArgs6$ = _getArgs6[4],
      useCapture = _getArgs6$ === void 0 ? false : _getArgs6$,
      condition = _getArgs6[5];
    var off2 = on(element, types, selector, function (e) {
      var result = !condition || condition(e);
      if (result) {
        off2();
        listener(e, result);
      }
    }, useCapture);
    return off2;
  }
  function trigger(targets, event, detail2) {
    return toEventTargets(targets).every(function (target) {
      return target.dispatchEvent(createEvent(event, true, true, detail2));
    });
  }
  function createEvent(e) {
    var bubbles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var cancelable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var detail2 = arguments.length > 3 ? arguments[3] : undefined;
    if (isString(e)) {
      e = new CustomEvent(e, {
        bubbles: bubbles,
        cancelable: cancelable,
        detail: detail2
      });
    }
    return e;
  }
  function getArgs(args) {
    args[0] = toEventTargets(args[0]);
    if (isString(args[1])) {
      args[1] = args[1].split(" ");
    }
    if (isFunction(args[2])) {
      args.splice(2, 0, false);
    }
    return args;
  }
  function delegate(selector, listener) {
    var _this = this;
    return function (e) {
      var current = selector[0] === ">" ? findAll(selector, e.currentTarget).reverse().find(function (element) {
        return element.contains(e.target);
      }) : e.target.closest(selector);
      if (current) {
        e.current = current;
        listener.call(_this, e);
        delete e.current;
      }
    };
  }
  function detail(listener) {
    return function (e) {
      return isArray(e.detail) ? listener.apply(void 0, [e].concat((0, _toConsumableArray2["default"])(e.detail))) : listener(e);
    };
  }
  function selfFilter(listener) {
    return function (e) {
      if (e.target === e.currentTarget || e.target === e.current) {
        return listener.call(null, e);
      }
    };
  }
  function isEventTarget(target) {
    return target && "addEventListener" in target;
  }
  function toEventTarget(target) {
    return isEventTarget(target) ? target : toNode(target);
  }
  function toEventTargets(target) {
    return isArray(target) ? target.map(toEventTarget).filter(Boolean) : isString(target) ? findAll(target) : isEventTarget(target) ? [target] : toNodes(target);
  }
  function isTouch(e) {
    return e.pointerType === "touch" || !!e.touches;
  }
  function getEventPos(e) {
    var _a, _b;
    var _ref9 = ((_a = e.touches) == null ? void 0 : _a[0]) || ((_b = e.changedTouches) == null ? void 0 : _b[0]) || e,
      x = _ref9.clientX,
      y = _ref9.clientY;
    return {
      x: x,
      y: y
    };
  }
  var cssNumber = {
    "animation-iteration-count": true,
    "column-count": true,
    "fill-opacity": true,
    "flex-grow": true,
    "flex-shrink": true,
    "font-weight": true,
    "line-height": true,
    opacity: true,
    order: true,
    orphans: true,
    "stroke-dasharray": true,
    "stroke-dashoffset": true,
    widows: true,
    "z-index": true,
    zoom: true
  };
  function css(element, property, value, priority) {
    var elements = toNodes(element);
    var _iterator12 = _createForOfIteratorHelper(elements),
      _step12;
    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var element2 = _step12.value;
        if (isString(property)) {
          property = propName(property);
          if (isUndefined(value)) {
            return getComputedStyle(element2).getPropertyValue(property);
          } else {
            element2.style.setProperty(property, isNumeric(value) && !cssNumber[property] ? "".concat(value, "px") : value || isNumber(value) ? value : "", priority);
          }
        } else if (isArray(property)) {
          var _props = {};
          var _iterator13 = _createForOfIteratorHelper(property),
            _step13;
          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var prop = _step13.value;
              _props[prop] = css(element2, prop);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
          return _props;
        } else if (isObject(property)) {
          for (var _prop in property) {
            css(element2, _prop, property[_prop], value);
          }
        }
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
    return elements[0];
  }
  var propName = memoize(function (name) {
    return vendorPropName(name);
  });
  function vendorPropName(name) {
    if (startsWith(name, "--")) {
      return name;
    }
    name = hyphenate(name);
    var style = document.documentElement.style;
    if (name in style) {
      return name;
    }
    for (var _i2 = 0, _arr2 = ["webkit", "moz"]; _i2 < _arr2.length; _i2++) {
      var prefix = _arr2[_i2];
      var prefixedName = "-".concat(prefix, "-").concat(name);
      if (prefixedName in style) {
        return prefixedName;
      }
    }
  }
  var clsTransition = "uk-transition";
  var transitionEnd = "transitionend";
  var transitionCanceled = "transitioncanceled";
  function transition$1(element, props) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;
    var timing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "linear";
    duration = Math.round(duration);
    return Promise.all(toNodes(element).map(function (element2) {
      return new Promise(function (resolve, reject) {
        for (var name in props) {
          var value = css(element2, name);
          if (value === "") {
            css(element2, name, value);
          }
        }
        var timer = setTimeout(function () {
          return trigger(element2, transitionEnd);
        }, duration);
        once(element2, [transitionEnd, transitionCanceled], function (_ref10) {
          var type = _ref10.type;
          clearTimeout(timer);
          removeClass(element2, clsTransition);
          css(element2, {
            transitionProperty: "",
            transitionDuration: "",
            transitionTimingFunction: ""
          });
          type === transitionCanceled ? reject() : resolve(element2);
        }, {
          self: true
        });
        addClass(element2, clsTransition);
        css(element2, _objectSpread({
          transitionProperty: Object.keys(props).map(propName).join(","),
          transitionDuration: "".concat(duration, "ms"),
          transitionTimingFunction: timing
        }, props));
      });
    }));
  }
  var Transition = {
    start: transition$1,
    stop: function stop(element) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              trigger(element, transitionEnd);
              _context.next = 3;
              return Promise.resolve();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    cancel: function cancel(element) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              trigger(element, transitionCanceled);
              _context2.next = 3;
              return Promise.resolve();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    inProgress: function inProgress(element) {
      return hasClass(element, clsTransition);
    }
  };
  var animationPrefix = "uk-animation-";
  var animationEnd = "animationend";
  var animationCanceled = "animationcanceled";
  function animate$2(element, animation) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var origin = arguments.length > 3 ? arguments[3] : undefined;
    var out = arguments.length > 4 ? arguments[4] : undefined;
    return Promise.all(toNodes(element).map(function (element2) {
      return new Promise(function (resolve, reject) {
        trigger(element2, animationCanceled);
        var timer = setTimeout(function () {
          return trigger(element2, animationEnd);
        }, duration);
        once(element2, [animationEnd, animationCanceled], function (_ref11) {
          var type = _ref11.type;
          clearTimeout(timer);
          type === animationCanceled ? reject() : resolve(element2);
          css(element2, "animationDuration", "");
          removeClasses(element2, "".concat(animationPrefix, "\\S*"));
        }, {
          self: true
        });
        css(element2, "animationDuration", "".concat(duration, "ms"));
        addClass(element2, animation, animationPrefix + (out ? "leave" : "enter"));
        if (startsWith(animation, animationPrefix)) {
          origin && addClass(element2, "uk-transform-origin-".concat(origin));
          out && addClass(element2, "".concat(animationPrefix, "reverse"));
        }
      });
    }));
  }
  var inProgressRe = new RegExp("".concat(animationPrefix, "(enter|leave)"));
  var Animation = {
    "in": animate$2,
    out: function out(element, animation, duration, origin) {
      return animate$2(element, animation, duration, origin, true);
    },
    inProgress: function inProgress(element) {
      return inProgressRe.test(attr(element, "class"));
    },
    cancel: function cancel(element) {
      trigger(element, animationCanceled);
    }
  };
  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
      return;
    }
    once(document, "DOMContentLoaded", fn);
  }
  function isTag(element) {
    for (var _len8 = arguments.length, tagNames = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
      tagNames[_key8 - 1] = arguments[_key8];
    }
    return tagNames.some(function (tagName) {
      var _a;
      return ((_a = element == null ? void 0 : element.tagName) == null ? void 0 : _a.toLowerCase()) === tagName.toLowerCase();
    });
  }
  function empty(element) {
    element = $(element);
    element.innerHTML = "";
    return element;
  }
  function html(parent2, html2) {
    return isUndefined(html2) ? $(parent2).innerHTML : append(empty(parent2), html2);
  }
  var prepend = applyFn("prepend");
  var append = applyFn("append");
  var before = applyFn("before");
  var after = applyFn("after");
  function applyFn(fn) {
    return function (ref, element) {
      var _a2;
      var _a;
      var nodes = toNodes(isString(element) ? fragment(element) : element);
      (_a = $(ref)) == null ? void 0 : (_a2 = _a)[fn].apply(_a2, (0, _toConsumableArray2["default"])(nodes));
      return unwrapSingle(nodes);
    };
  }
  function remove$1(element) {
    toNodes(element).forEach(function (element2) {
      return element2.remove();
    });
  }
  function wrapAll(element, structure) {
    structure = toNode(before(element, structure));
    while (structure.firstElementChild) {
      structure = structure.firstElementChild;
    }
    append(structure, element);
    return structure;
  }
  function wrapInner(element, structure) {
    return toNodes(toNodes(element).map(function (element2) {
      return element2.hasChildNodes() ? wrapAll(toArray(element2.childNodes), structure) : append(element2, structure);
    }));
  }
  function unwrap(element) {
    toNodes(element).map(parent).filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (parent2) {
      return parent2.replaceWith.apply(parent2, (0, _toConsumableArray2["default"])(parent2.childNodes));
    });
  }
  var singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
  function fragment(html2) {
    var matches = singleTagRe.exec(html2);
    if (matches) {
      return document.createElement(matches[1]);
    }
    var container = document.createElement("template");
    container.innerHTML = html2.trim();
    return unwrapSingle(container.content.childNodes);
  }
  function unwrapSingle(nodes) {
    return nodes.length > 1 ? nodes : nodes[0];
  }
  function apply(node, fn) {
    if (!isElement(node)) {
      return;
    }
    fn(node);
    node = node.firstElementChild;
    while (node) {
      var next = node.nextElementSibling;
      apply(node, fn);
      node = next;
    }
  }
  function $(selector, context) {
    return isHtml(selector) ? toNode(fragment(selector)) : find(selector, context);
  }
  function $$(selector, context) {
    return isHtml(selector) ? toNodes(fragment(selector)) : findAll(selector, context);
  }
  function isHtml(str) {
    return isString(str) && startsWith(str.trim(), "<");
  }
  var dirs$1 = {
    width: ["left", "right"],
    height: ["top", "bottom"]
  };
  function dimensions$1(element) {
    var rect = isElement(element) ? toNode(element).getBoundingClientRect() : {
      height: height(element),
      width: width(element),
      top: 0,
      left: 0
    };
    return {
      height: rect.height,
      width: rect.width,
      top: rect.top,
      left: rect.left,
      bottom: rect.top + rect.height,
      right: rect.left + rect.width
    };
  }
  function offset(element, coordinates) {
    if (coordinates) {
      css(element, {
        left: 0,
        top: 0
      });
    }
    var currentOffset = dimensions$1(element);
    if (element) {
      var _toWindow = toWindow(element),
        scrollY = _toWindow.scrollY,
        scrollX = _toWindow.scrollX;
      var offsetBy = {
        height: scrollY,
        width: scrollX
      };
      for (var dir in dirs$1) {
        var _iterator14 = _createForOfIteratorHelper(dirs$1[dir]),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var prop = _step14.value;
            currentOffset[prop] += offsetBy[dir];
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      }
    }
    if (!coordinates) {
      return currentOffset;
    }
    for (var _i3 = 0, _arr3 = ["left", "top"]; _i3 < _arr3.length; _i3++) {
      var _prop2 = _arr3[_i3];
      css(element, _prop2, coordinates[_prop2] - currentOffset[_prop2]);
    }
  }
  function position(element) {
    var _offset = offset(element),
      top = _offset.top,
      left = _offset.left;
    var _toNode = toNode(element),
      _toNode$ownerDocument = _toNode.ownerDocument,
      body = _toNode$ownerDocument.body,
      documentElement = _toNode$ownerDocument.documentElement,
      offsetParent = _toNode.offsetParent;
    var parent = offsetParent || documentElement;
    while (parent && (parent === body || parent === documentElement) && css(parent, "position") === "static") {
      parent = parent.parentNode;
    }
    if (isElement(parent)) {
      var parentOffset = offset(parent);
      top -= parentOffset.top + toFloat(css(parent, "borderTopWidth"));
      left -= parentOffset.left + toFloat(css(parent, "borderLeftWidth"));
    }
    return {
      top: top - toFloat(css(element, "marginTop")),
      left: left - toFloat(css(element, "marginLeft"))
    };
  }
  function offsetPosition(element) {
    element = toNode(element);
    var offset2 = [element.offsetTop, element.offsetLeft];
    while (element = element.offsetParent) {
      offset2[0] += element.offsetTop + toFloat(css(element, "borderTopWidth"));
      offset2[1] += element.offsetLeft + toFloat(css(element, "borderLeftWidth"));
      if (css(element, "position") === "fixed") {
        var win = toWindow(element);
        offset2[0] += win.scrollY;
        offset2[1] += win.scrollX;
        return offset2;
      }
    }
    return offset2;
  }
  var height = dimension("height");
  var width = dimension("width");
  function dimension(prop) {
    var propName = ucfirst(prop);
    return function (element, value) {
      if (isUndefined(value)) {
        if (isWindow(element)) {
          return element["inner".concat(propName)];
        }
        if (isDocument(element)) {
          var doc = element.documentElement;
          return Math.max(doc["offset".concat(propName)], doc["scroll".concat(propName)]);
        }
        element = toNode(element);
        value = css(element, prop);
        value = value === "auto" ? element["offset".concat(propName)] : toFloat(value) || 0;
        return value - boxModelAdjust(element, prop);
      } else {
        return css(element, prop, !value && value !== 0 ? "" : +value + boxModelAdjust(element, prop) + "px");
      }
    };
  }
  function boxModelAdjust(element, prop) {
    var sizing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "border-box";
    return css(element, "boxSizing") === sizing ? sumBy(dirs$1[prop].map(ucfirst), function (prop2) {
      return toFloat(css(element, "padding".concat(prop2))) + toFloat(css(element, "border".concat(prop2, "Width")));
    }) : 0;
  }
  function flipPosition(pos) {
    for (var dir in dirs$1) {
      for (var i in dirs$1[dir]) {
        if (dirs$1[dir][i] === pos) {
          return dirs$1[dir][1 - i];
        }
      }
    }
    return pos;
  }
  function toPx(value) {
    var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "width";
    var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
    var offsetDim = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!isString(value)) {
      return toFloat(value);
    }
    return sumBy(parseCalc(value), function (value2) {
      var unit = parseUnit(value2);
      return unit ? percent(unit === "vh" ? getViewportHeight() : unit === "vw" ? width(toWindow(element)) : offsetDim ? element["offset".concat(ucfirst(property))] : dimensions$1(element)[property], value2) : value2;
    });
  }
  var calcRe = /-?\d+(?:\.\d+)?(?:v[wh]|%|px)?/g;
  var parseCalc = memoize(function (calc) {
    return calc.toString().replace(/\s/g, "").match(calcRe) || [];
  });
  var unitRe$1 = /(?:v[hw]|%)$/;
  var parseUnit = memoize(function (str) {
    return (str.match(unitRe$1) || [])[0];
  });
  function percent(base, value) {
    return base * toFloat(value) / 100;
  }
  var vh;
  var vhEl;
  function getViewportHeight() {
    if (vh) {
      return vh;
    }
    if (!vhEl) {
      vhEl = $("<div>");
      css(vhEl, {
        height: "100vh",
        position: "fixed"
      });
      on(window, "resize", function () {
        return vh = null;
      });
    }
    append(document.body, vhEl);
    vh = vhEl.clientHeight;
    remove$1(vhEl);
    return vh;
  }
  var inBrowser = typeof window !== "undefined";
  var isRtl = inBrowser && document.dir === "rtl";
  var hasTouch = inBrowser && "ontouchstart" in window;
  var hasPointerEvents = inBrowser && window.PointerEvent;
  var pointerDown$1 = hasPointerEvents ? "pointerdown" : hasTouch ? "touchstart" : "mousedown";
  var pointerMove$1 = hasPointerEvents ? "pointermove" : hasTouch ? "touchmove" : "mousemove";
  var pointerUp$1 = hasPointerEvents ? "pointerup" : hasTouch ? "touchend" : "mouseup";
  var pointerEnter = hasPointerEvents ? "pointerenter" : hasTouch ? "" : "mouseenter";
  var pointerLeave = hasPointerEvents ? "pointerleave" : hasTouch ? "" : "mouseleave";
  var pointerCancel = hasPointerEvents ? "pointercancel" : "touchcancel";
  var fastdom = {
    reads: [],
    writes: [],
    read: function read(task) {
      this.reads.push(task);
      scheduleFlush();
      return task;
    },
    write: function write(task) {
      this.writes.push(task);
      scheduleFlush();
      return task;
    },
    clear: function clear(task) {
      remove(this.reads, task);
      remove(this.writes, task);
    },
    flush: flush
  };
  function flush(recursion) {
    runTasks(fastdom.reads);
    runTasks(fastdom.writes.splice(0));
    fastdom.scheduled = false;
    if (fastdom.reads.length || fastdom.writes.length) {
      scheduleFlush(recursion + 1);
    }
  }
  var RECURSION_LIMIT = 4;
  function scheduleFlush(recursion) {
    if (fastdom.scheduled) {
      return;
    }
    fastdom.scheduled = true;
    if (recursion && recursion < RECURSION_LIMIT) {
      Promise.resolve().then(function () {
        return flush(recursion);
      });
    } else {
      requestAnimationFrame(function () {
        return flush(1);
      });
    }
  }
  function runTasks(tasks) {
    var task;
    while (task = tasks.shift()) {
      try {
        task();
      } catch (e) {
        console.error(e);
      }
    }
  }
  function remove(array, item) {
    var index = array.indexOf(item);
    return ~index && array.splice(index, 1);
  }
  var MouseTracker = /*#__PURE__*/function () {
    function MouseTracker() {
      (0, _classCallCheck2["default"])(this, MouseTracker);
    }
    (0, _createClass2["default"])(MouseTracker, [{
      key: "init",
      value: function init() {
        var _this2 = this;
        this.positions = [];
        var position;
        this.unbind = on(document, "mousemove", function (e) {
          return position = getEventPos(e);
        });
        this.interval = setInterval(function () {
          if (!position) {
            return;
          }
          _this2.positions.push(position);
          if (_this2.positions.length > 5) {
            _this2.positions.shift();
          }
        }, 50);
      }
    }, {
      key: "cancel",
      value: function cancel() {
        var _a;
        (_a = this.unbind) == null ? void 0 : _a.call(this);
        clearInterval(this.interval);
      }
    }, {
      key: "movesTo",
      value: function movesTo(target) {
        if (!this.positions || this.positions.length < 2) {
          return false;
        }
        var p = dimensions$1(target);
        var left = p.left,
          right = p.right,
          top = p.top,
          bottom = p.bottom;
        var _this$positions = (0, _slicedToArray2["default"])(this.positions, 1),
          prevPosition = _this$positions[0];
        var position = last(this.positions);
        var path = [prevPosition, position];
        if (pointInRect(position, p)) {
          return false;
        }
        var diagonals = [[{
          x: left,
          y: top
        }, {
          x: right,
          y: bottom
        }], [{
          x: left,
          y: bottom
        }, {
          x: right,
          y: top
        }]];
        return diagonals.some(function (diagonal) {
          var intersection = intersect(path, diagonal);
          return intersection && pointInRect(intersection, p);
        });
      }
    }]);
    return MouseTracker;
  }();
  function intersect(_ref12, _ref13) {
    var _ref14 = (0, _slicedToArray2["default"])(_ref12, 2),
      _ref14$ = _ref14[0],
      x1 = _ref14$.x,
      y1 = _ref14$.y,
      _ref14$2 = _ref14[1],
      x2 = _ref14$2.x,
      y2 = _ref14$2.y;
    var _ref15 = (0, _slicedToArray2["default"])(_ref13, 2),
      _ref15$ = _ref15[0],
      x3 = _ref15$.x,
      y3 = _ref15$.y,
      _ref15$2 = _ref15[1],
      x4 = _ref15$2.x,
      y4 = _ref15$2.y;
    var denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    if (denominator === 0) {
      return false;
    }
    var ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
    if (ua < 0) {
      return false;
    }
    return {
      x: x1 + ua * (x2 - x1),
      y: y1 + ua * (y2 - y1)
    };
  }
  function observeIntersection(targets, cb) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _ref16 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref16$intersecting = _ref16.intersecting,
      intersecting = _ref16$intersecting === void 0 ? true : _ref16$intersecting;
    var observer = new IntersectionObserver(intersecting ? function (entries, observer2) {
      if (entries.some(function (entry) {
        return entry.isIntersecting;
      })) {
        cb(entries, observer2);
      }
    } : cb, options);
    var _iterator15 = _createForOfIteratorHelper(toNodes(targets)),
      _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var el = _step15.value;
        observer.observe(el);
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
    return observer;
  }
  var hasResizeObserver = inBrowser && window.ResizeObserver;
  function observeResize(targets, cb) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      box: "border-box"
    };
    if (hasResizeObserver) {
      return observe$1(ResizeObserver, targets, cb, options);
    }
    var off = [on(window, "load resize", cb), on(document, "loadedmetadata load", cb, true)];
    return {
      disconnect: function disconnect() {
        return off.map(function (cb2) {
          return cb2();
        });
      }
    };
  }
  function observeViewportResize(cb) {
    return {
      disconnect: on([window, window.visualViewport], "resize", cb)
    };
  }
  function observeMutation(targets, cb, options) {
    return observe$1(MutationObserver, targets, cb, options);
  }
  function observe$1(Observer, targets, cb, options) {
    var observer = new Observer(cb);
    var _iterator16 = _createForOfIteratorHelper(toNodes(targets)),
      _step16;
    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var el = _step16.value;
        observer.observe(el, options);
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }
    return observer;
  }
  function play(el) {
    if (isIFrame(el)) {
      call(el, {
        func: "playVideo",
        method: "play"
      });
    }
    if (isHTML5(el)) {
      el.play();
    }
  }
  function pause(el) {
    if (isIFrame(el)) {
      call(el, {
        func: "pauseVideo",
        method: "pause"
      });
    }
    if (isHTML5(el)) {
      el.pause();
    }
  }
  function mute(el) {
    if (isIFrame(el)) {
      call(el, {
        func: "mute",
        method: "setVolume",
        value: 0
      });
    }
    if (isHTML5(el)) {
      el.muted = true;
    }
  }
  function isVideo(el) {
    return isHTML5(el) || isIFrame(el);
  }
  function isHTML5(el) {
    return isTag(el, "video");
  }
  function isIFrame(el) {
    return isTag(el, "iframe") && (isYoutube(el) || isVimeo(el));
  }
  function isYoutube(el) {
    return !!el.src.match(/\/\/.*?youtube(-nocookie)?\.[a-z]+\/(watch\?v=[^&\s]+|embed)|youtu\.be\/.*/);
  }
  function isVimeo(el) {
    return !!el.src.match(/vimeo\.com\/video\/.*/);
  }
  function call(_x, _x2) {
    return _call.apply(this, arguments);
  }
  function _call() {
    _call = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee32(el, cmd) {
      return _regenerator["default"].wrap(function _callee32$(_context32) {
        while (1) switch (_context32.prev = _context32.next) {
          case 0:
            _context32.next = 2;
            return enableApi(el);
          case 2:
            post(el, cmd);
          case 3:
          case "end":
            return _context32.stop();
        }
      }, _callee32);
    }));
    return _call.apply(this, arguments);
  }
  function post(el, cmd) {
    el.contentWindow.postMessage(JSON.stringify(_objectSpread({
      event: "command"
    }, cmd)), "*");
  }
  var stateKey = "_ukPlayer";
  var counter = 0;
  function enableApi(el) {
    if (el[stateKey]) {
      return el[stateKey];
    }
    var youtube = isYoutube(el);
    var vimeo = isVimeo(el);
    var id = ++counter;
    var poller;
    return el[stateKey] = new Promise(function (resolve) {
      youtube && once(el, "load", function () {
        var listener = function listener() {
          return post(el, {
            event: "listening",
            id: id
          });
        };
        poller = setInterval(listener, 100);
        listener();
      });
      once(window, "message", resolve, false, function (_ref17) {
        var data = _ref17.data;
        try {
          data = JSON.parse(data);
          return youtube && (data == null ? void 0 : data.id) === id && data.event === "onReady" || vimeo && Number(data == null ? void 0 : data.player_id) === id;
        } catch (e) {}
      });
      el.src = "".concat(el.src).concat(includes(el.src, "?") ? "&" : "?").concat(youtube ? "enablejsapi=1" : "api=1&player_id=".concat(id));
    }).then(function () {
      return clearInterval(poller);
    });
  }
  function isInView(element) {
    var offsetTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (!isVisible(element)) {
      return false;
    }
    return intersectRect.apply(void 0, (0, _toConsumableArray2["default"])(overflowParents(element).map(function (parent2) {
      var _offsetViewport = offsetViewport(parent2),
        top = _offsetViewport.top,
        left = _offsetViewport.left,
        bottom = _offsetViewport.bottom,
        right = _offsetViewport.right;
      return {
        top: top - offsetTop,
        left: left - offsetLeft,
        bottom: bottom + offsetTop,
        right: right + offsetLeft
      };
    }).concat(offset(element))));
  }
  function scrollIntoView(element) {
    var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref18$offset = _ref18.offset,
      offsetBy = _ref18$offset === void 0 ? 0 : _ref18$offset;
    var parents2 = isVisible(element) ? scrollParents(element, false, ["hidden"]) : [];
    return parents2.reduce(function (fn, scrollElement, i) {
      var scrollTop = scrollElement.scrollTop,
        scrollHeight = scrollElement.scrollHeight,
        offsetHeight = scrollElement.offsetHeight;
      var viewport = offsetViewport(scrollElement);
      var maxScroll = scrollHeight - viewport.height;
      var _ref19 = parents2[i - 1] ? offsetViewport(parents2[i - 1]) : offset(element),
        elHeight = _ref19.height,
        elTop = _ref19.top;
      var top = Math.ceil(elTop - viewport.top - offsetBy + scrollTop);
      if (offsetBy > 0 && offsetHeight < elHeight + offsetBy) {
        top += offsetBy;
      } else {
        offsetBy = 0;
      }
      if (top > maxScroll) {
        offsetBy -= top - maxScroll;
        top = maxScroll;
      } else if (top < 0) {
        offsetBy -= top;
        top = 0;
      }
      return function () {
        return scrollTo(scrollElement, top - scrollTop, element, maxScroll).then(fn);
      };
    }, function () {
      return Promise.resolve();
    })();
    function scrollTo(element2, top, targetEl, maxScroll) {
      return new Promise(function (resolve) {
        var scroll = element2.scrollTop;
        var duration = getDuration(Math.abs(top));
        var start = Date.now();
        var isScrollingElement = scrollingElement(element2) === element2;
        var targetTop = offset(targetEl).top + (isScrollingElement ? 0 : scroll);
        var prev = 0;
        var frames = 15;
        (function step() {
          var percent = ease(clamp((Date.now() - start) / duration));
          var diff = 0;
          if (parents2[0] === element2 && scroll + top < maxScroll) {
            diff = offset(targetEl).top + (isScrollingElement ? 0 : element2.scrollTop) - targetTop;
            var coverEl = getCoveringElement(targetEl);
            diff -= coverEl ? offset(coverEl).height : 0;
          }
          element2.scrollTop = scroll + (top + diff) * percent;
          if (percent === 1 && (prev === diff || !frames--)) {
            resolve();
          } else {
            prev = diff;
            requestAnimationFrame(step);
          }
        })();
      });
    }
    function getDuration(dist) {
      return 40 * Math.pow(dist, 0.375);
    }
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }
  }
  function scrolledOver(element) {
    var startOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var endOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (!isVisible(element)) {
      return 0;
    }
    var scrollElement = scrollParent(element, true);
    var scrollHeight = scrollElement.scrollHeight,
      scrollTop = scrollElement.scrollTop;
    var _offsetViewport2 = offsetViewport(scrollElement),
      viewportHeight = _offsetViewport2.height;
    var maxScroll = scrollHeight - viewportHeight;
    var elementOffsetTop = offsetPosition(element)[0] - offsetPosition(scrollElement)[0];
    var start = Math.max(0, elementOffsetTop - viewportHeight + startOffset);
    var end = Math.min(maxScroll, elementOffsetTop + element.offsetHeight - endOffset);
    return start < end ? clamp((scrollTop - start) / (end - start)) : 1;
  }
  function scrollParents(element) {
    var scrollable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var scrollEl = scrollingElement(element);
    var ancestors = parents(element).reverse();
    ancestors = ancestors.slice(ancestors.indexOf(scrollEl) + 1);
    var fixedIndex = findIndex(ancestors, function (el) {
      return css(el, "position") === "fixed";
    });
    if (~fixedIndex) {
      ancestors = ancestors.slice(fixedIndex);
    }
    return [scrollEl].concat(ancestors.filter(function (parent2) {
      return css(parent2, "overflow").split(" ").some(function (prop) {
        return includes(["auto", "scroll"].concat((0, _toConsumableArray2["default"])(props)), prop);
      }) && (!scrollable || parent2.scrollHeight > offsetViewport(parent2).height);
    })).reverse();
  }
  function scrollParent() {
    return scrollParents.apply(void 0, arguments)[0];
  }
  function overflowParents(element) {
    return scrollParents(element, false, ["hidden", "clip"]);
  }
  function offsetViewport(scrollElement) {
    var window = toWindow(scrollElement);
    var viewportElement = scrollElement === scrollingElement(scrollElement) ? window : scrollElement;
    if (isWindow(viewportElement) && window.visualViewport) {
      var _window$visualViewpor = window.visualViewport,
        _height = _window$visualViewpor.height,
        _width = _window$visualViewpor.width,
        scale = _window$visualViewpor.scale,
        top = _window$visualViewpor.pageTop,
        left = _window$visualViewpor.pageLeft;
      _height = Math.round(_height * scale);
      _width = Math.round(_width * scale);
      return {
        height: _height,
        width: _width,
        top: top,
        left: left,
        bottom: top + _height,
        right: left + _width
      };
    }
    var rect = offset(viewportElement);
    if (css(viewportElement, "display") === "inline") {
      return rect;
    }
    for (var _i4 = 0, _arr4 = [["width", "x", "left", "right"], ["height", "y", "top", "bottom"]]; _i4 < _arr4.length; _i4++) {
      var _arr4$_i = (0, _slicedToArray2["default"])(_arr4[_i4], 4),
        prop = _arr4$_i[0],
        dir = _arr4$_i[1],
        start = _arr4$_i[2],
        end = _arr4$_i[3];
      if (isWindow(viewportElement)) {
        viewportElement = scrollElement.ownerDocument;
      } else {
        rect[start] += toFloat(css(viewportElement, "border-".concat(start, "-width")));
      }
      var subpixel = rect[prop] % 1;
      rect[prop] = rect[dir] = viewportElement["client".concat(ucfirst(prop))] - (subpixel ? subpixel < 0.5 ? -subpixel : 1 - subpixel : 0);
      rect[end] = rect[prop] + rect[start];
    }
    return rect;
  }
  function getCoveringElement(target) {
    var _dimensions$ = dimensions$1(target),
      left = _dimensions$.left,
      width = _dimensions$.width,
      top = _dimensions$.top;
    for (var _i5 = 0, _arr5 = [0, top]; _i5 < _arr5.length; _i5++) {
      var topPosition = _arr5[_i5];
      var coverEl = target.ownerDocument.elementsFromPoint(left + width / 2, topPosition).find(function (el) {
        return !el.contains(target) &&
        // If e.g. Offcanvas is not yet closed
        !hasClass(el, "uk-togglable-leave") && (hasPosition(el, "fixed") && zIndex(parents(target).reverse().find(function (parent2) {
          return !parent2.contains(el) && !hasPosition(parent2, "static");
        })) < zIndex(el) || hasPosition(el, "sticky") && parent(el).contains(target));
      });
      if (coverEl) {
        return coverEl;
      }
    }
  }
  function zIndex(element) {
    return toFloat(css(element, "zIndex"));
  }
  function hasPosition(element, position) {
    return css(element, "position") === position;
  }
  function scrollingElement(element) {
    return toWindow(element).document.scrollingElement;
  }
  var dirs = [["width", "x", "left", "right"], ["height", "y", "top", "bottom"]];
  function _positionAt(element, target, options) {
    options = _objectSpread({
      attach: _objectSpread({
        element: ["left", "top"],
        target: ["left", "top"]
      }, options.attach),
      offset: [0, 0],
      placement: []
    }, options);
    if (!isArray(target)) {
      target = [target, target];
    }
    offset(element, getPosition(element, target, options));
  }
  function getPosition(element, target, options) {
    var position = attachTo(element, target, options);
    var boundary = options.boundary,
      _options$viewportOffs = options.viewportOffset,
      viewportOffset = _options$viewportOffs === void 0 ? 0 : _options$viewportOffs,
      placement = options.placement;
    var offsetPosition = position;
    for (var _i6 = 0, _Object$entries = Object.entries(dirs); _i6 < _Object$entries.length; _i6++) {
      var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i6], 2),
        i = _Object$entries$_i[0],
        _Object$entries$_i$ = (0, _slicedToArray2["default"])(_Object$entries$_i[1], 4),
        prop = _Object$entries$_i$[0],
        start = _Object$entries$_i$[2],
        end = _Object$entries$_i$[3];
      var _viewport = getViewport$2(element, target[i], viewportOffset, boundary, i);
      if (isWithin(position, _viewport, i)) {
        continue;
      }
      var offsetBy = 0;
      if (placement[i] === "flip") {
        var attach = options.attach.target[i];
        if (attach === end && position[end] <= _viewport[end] || attach === start && position[start] >= _viewport[start]) {
          continue;
        }
        offsetBy = flip(element, target, options, i)[start] - position[start];
        var scrollArea = getScrollArea(element, target[i], viewportOffset, i);
        if (!isWithin(applyOffset(position, offsetBy, i), scrollArea, i)) {
          if (isWithin(position, scrollArea, i)) {
            continue;
          }
          if (options.recursion) {
            return false;
          }
          var newPos = flipAxis(element, target, options);
          if (newPos && isWithin(newPos, scrollArea, 1 - i)) {
            return newPos;
          }
          continue;
        }
      } else if (placement[i] === "shift") {
        var targetDim = offset(target[i]);
        var elOffset = options.offset;
        offsetBy = clamp(clamp(position[start], _viewport[start], _viewport[end] - position[prop]), targetDim[start] - position[prop] + elOffset[i], targetDim[end] - elOffset[i]) - position[start];
      }
      offsetPosition = applyOffset(offsetPosition, offsetBy, i);
    }
    return offsetPosition;
  }
  function attachTo(element, target, options) {
    var _attach$offset$option = _objectSpread({
        attach: _objectSpread({
          element: ["left", "top"],
          target: ["left", "top"]
        }, options.attach),
        offset: [0, 0]
      }, options),
      attach = _attach$offset$option.attach,
      offsetBy = _attach$offset$option.offset;
    var elOffset = offset(element);
    for (var _i7 = 0, _Object$entries2 = Object.entries(dirs); _i7 < _Object$entries2.length; _i7++) {
      var _Object$entries2$_i = (0, _slicedToArray2["default"])(_Object$entries2[_i7], 2),
        i = _Object$entries2$_i[0],
        _Object$entries2$_i$ = (0, _slicedToArray2["default"])(_Object$entries2$_i[1], 4),
        prop = _Object$entries2$_i$[0],
        start = _Object$entries2$_i$[2],
        end = _Object$entries2$_i$[3];
      var targetOffset = attach.target[i] === attach.element[i] ? offsetViewport(target[i]) : offset(target[i]);
      elOffset = applyOffset(elOffset, targetOffset[start] - elOffset[start] + moveBy(attach.target[i], end, targetOffset[prop]) - moveBy(attach.element[i], end, elOffset[prop]) + +offsetBy[i], i);
    }
    return elOffset;
  }
  function applyOffset(position, offset2, i) {
    var _dirs$i = (0, _slicedToArray2["default"])(dirs[i], 4),
      dir = _dirs$i[1],
      start = _dirs$i[2],
      end = _dirs$i[3];
    var newPos = _objectSpread({}, position);
    newPos[start] = position[dir] = position[start] + offset2;
    newPos[end] += offset2;
    return newPos;
  }
  function moveBy(attach, end, dim) {
    return attach === "center" ? dim / 2 : attach === end ? dim : 0;
  }
  function getViewport$2(element, target, viewportOffset, boundary, i) {
    var viewport = getIntersectionArea.apply(void 0, (0, _toConsumableArray2["default"])(commonScrollParents(element, target).map(offsetViewport)));
    if (viewportOffset) {
      viewport[dirs[i][2]] += viewportOffset;
      viewport[dirs[i][3]] -= viewportOffset;
    }
    if (boundary) {
      viewport = getIntersectionArea(viewport, offset(isArray(boundary) ? boundary[i] : boundary));
    }
    return viewport;
  }
  function getScrollArea(element, target, viewportOffset, i) {
    var _dirs$i2 = (0, _slicedToArray2["default"])(dirs[i], 4),
      prop = _dirs$i2[0],
      axis = _dirs$i2[1],
      start = _dirs$i2[2],
      end = _dirs$i2[3];
    var _commonScrollParents = commonScrollParents(element, target),
      _commonScrollParents2 = (0, _slicedToArray2["default"])(_commonScrollParents, 1),
      scrollElement = _commonScrollParents2[0];
    var viewport = offsetViewport(scrollElement);
    if (["auto", "scroll"].includes(css(scrollElement, "overflow-".concat(axis)))) {
      viewport[start] -= scrollElement["scroll".concat(ucfirst(start))];
      viewport[end] = viewport[start] + scrollElement["scroll".concat(ucfirst(prop))];
    }
    viewport[start] += viewportOffset;
    viewport[end] -= viewportOffset;
    return viewport;
  }
  function commonScrollParents(element, target) {
    return overflowParents(target).filter(function (parent) {
      return parent.contains(element);
    });
  }
  function getIntersectionArea() {
    var area = {};
    for (var _len9 = arguments.length, rects = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      rects[_key9] = arguments[_key9];
    }
    for (var _i8 = 0, _rects = rects; _i8 < _rects.length; _i8++) {
      var rect = _rects[_i8];
      var _iterator17 = _createForOfIteratorHelper(dirs),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _step17$value = (0, _slicedToArray2["default"])(_step17.value, 4),
            start = _step17$value[2],
            end = _step17$value[3];
          area[start] = Math.max(area[start] || 0, rect[start]);
          area[end] = Math.min.apply(Math, (0, _toConsumableArray2["default"])([area[end], rect[end]].filter(Boolean)));
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
    return area;
  }
  function isWithin(positionA, positionB, i) {
    var _dirs$i3 = (0, _slicedToArray2["default"])(dirs[i], 4),
      start = _dirs$i3[2],
      end = _dirs$i3[3];
    return positionA[start] >= positionB[start] && positionA[end] <= positionB[end];
  }
  function flip(element, target, _ref20, i) {
    var offset2 = _ref20.offset,
      attach = _ref20.attach;
    return attachTo(element, target, {
      attach: {
        element: flipAttach(attach.element, i),
        target: flipAttach(attach.target, i)
      },
      offset: flipOffset(offset2, i)
    });
  }
  function flipAxis(element, target, options) {
    return getPosition(element, target, _objectSpread(_objectSpread({}, options), {}, {
      attach: {
        element: options.attach.element.map(flipAttachAxis).reverse(),
        target: options.attach.target.map(flipAttachAxis).reverse()
      },
      offset: options.offset.reverse(),
      placement: options.placement.reverse(),
      recursion: true
    }));
  }
  function flipAttach(attach, i) {
    var newAttach = (0, _toConsumableArray2["default"])(attach);
    var index = dirs[i].indexOf(attach[i]);
    if (~index) {
      newAttach[i] = dirs[i][1 - index % 2 + 2];
    }
    return newAttach;
  }
  function flipAttachAxis(prop) {
    for (var i = 0; i < dirs.length; i++) {
      var _index = dirs[i].indexOf(prop);
      if (~_index) {
        return dirs[1 - i][_index % 2 + 2];
      }
    }
  }
  function flipOffset(offset2, i) {
    offset2 = (0, _toConsumableArray2["default"])(offset2);
    offset2[i] *= -1;
    return offset2;
  }
  var util = /*#__PURE__*/Object.freeze({
    __proto__: null,
    $: $,
    $$: $$,
    Animation: Animation,
    Dimensions: Dimensions,
    MouseTracker: MouseTracker,
    Transition: Transition,
    addClass: addClass,
    after: after,
    append: append,
    apply: apply,
    assign: assign,
    attr: attr,
    before: before,
    boxModelAdjust: boxModelAdjust,
    camelize: camelize,
    children: _children,
    clamp: clamp,
    closest: closest,
    createEvent: createEvent,
    css: css,
    data: data,
    dimensions: dimensions$1,
    each: each,
    empty: empty,
    endsWith: endsWith,
    escape: escape,
    fastdom: fastdom,
    filter: filter$1,
    find: find,
    findAll: findAll,
    findIndex: findIndex,
    flipPosition: flipPosition,
    fragment: fragment,
    getCoveringElement: getCoveringElement,
    getEventPos: getEventPos,
    getIndex: _getIndex,
    getTargetedElement: getTargetedElement,
    hasAttr: hasAttr,
    hasClass: hasClass,
    hasOwn: hasOwn,
    hasTouch: hasTouch,
    height: height,
    html: html,
    hyphenate: hyphenate,
    inBrowser: inBrowser,
    includes: includes,
    index: index,
    intersectRect: intersectRect,
    isArray: isArray,
    isBoolean: isBoolean,
    isDocument: isDocument,
    isElement: isElement,
    isEmpty: isEmpty,
    isEqual: isEqual,
    isFocusable: isFocusable,
    isFunction: isFunction,
    isInView: isInView,
    isInput: isInput,
    isNode: isNode,
    isNumber: isNumber,
    isNumeric: isNumeric,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isRtl: isRtl,
    isSameSiteAnchor: isSameSiteAnchor,
    isString: isString,
    isTag: isTag,
    isTouch: isTouch,
    isUndefined: isUndefined,
    isVideo: isVideo,
    isVisible: isVisible,
    isVoidElement: isVoidElement,
    isWindow: isWindow,
    last: last,
    matches: matches,
    memoize: memoize,
    mute: mute,
    noop: noop,
    observeIntersection: observeIntersection,
    observeMutation: observeMutation,
    observeResize: observeResize,
    observeViewportResize: observeViewportResize,
    off: off,
    offset: offset,
    offsetPosition: offsetPosition,
    offsetViewport: offsetViewport,
    on: on,
    once: once,
    overflowParents: overflowParents,
    parent: parent,
    parents: parents,
    pause: pause,
    pick: pick,
    play: play,
    pointInRect: pointInRect,
    pointerCancel: pointerCancel,
    pointerDown: pointerDown$1,
    pointerEnter: pointerEnter,
    pointerLeave: pointerLeave,
    pointerMove: pointerMove$1,
    pointerUp: pointerUp$1,
    position: position,
    positionAt: _positionAt,
    prepend: prepend,
    propName: propName,
    query: query,
    queryAll: queryAll,
    ready: ready,
    remove: remove$1,
    removeAttr: removeAttr,
    removeClass: removeClass,
    removeClasses: removeClasses,
    replaceClass: replaceClass,
    scrollIntoView: scrollIntoView,
    scrollParent: scrollParent,
    scrollParents: scrollParents,
    scrolledOver: scrolledOver,
    selFocusable: selFocusable,
    selInput: selInput,
    sortBy: sortBy,
    startsWith: startsWith,
    sumBy: sumBy,
    swap: swap,
    toArray: toArray,
    toBoolean: toBoolean,
    toEventTargets: toEventTargets,
    toFloat: toFloat,
    toNode: toNode,
    toNodes: toNodes,
    toNumber: toNumber,
    toPx: toPx,
    toWindow: toWindow,
    toggleClass: toggleClass,
    trigger: trigger,
    ucfirst: ucfirst,
    uniqueBy: uniqueBy,
    unwrap: unwrap,
    width: width,
    within: within,
    wrapAll: wrapAll,
    wrapInner: wrapInner
  });
  var Class = {
    connected: function connected() {
      addClass(this.$el, this.$options.id);
    }
  };
  var units = ["days", "hours", "minutes", "seconds"];
  var countdown = {
    mixins: [Class],
    props: {
      date: String,
      clsWrapper: String,
      role: String
    },
    data: {
      date: "",
      clsWrapper: ".uk-countdown-%unit%",
      role: "timer"
    },
    connected: function connected() {
      attr(this.$el, "role", this.role);
      this.date = toFloat(Date.parse(this.$props.date));
      this.end = false;
      this.start();
    },
    disconnected: function disconnected() {
      this.stop();
    },
    events: {
      name: "visibilitychange",
      el: function el() {
        return document;
      },
      handler: function handler() {
        if (document.hidden) {
          this.stop();
        } else {
          this.start();
        }
      }
    },
    methods: {
      start: function start() {
        this.stop();
        this.update();
        if (!this.timer) {
          trigger(this.$el, "countdownstart");
          this.timer = setInterval(this.update, 1e3);
        }
      },
      stop: function stop() {
        if (this.timer) {
          clearInterval(this.timer);
          trigger(this.$el, "countdownstop");
          this.timer = null;
        }
      },
      update: function update() {
        var _this3 = this;
        var timespan = getTimeSpan(this.date);
        if (!timespan.total) {
          this.stop();
          if (!this.end) {
            trigger(this.$el, "countdownend");
            this.end = true;
          }
        }
        var _loop3 = function _loop3() {
          var unit = _units[_i9];
          var el = $(_this3.clsWrapper.replace("%unit%", unit), _this3.$el);
          if (!el) {
            return "continue";
          }
          var digits = String(Math.trunc(timespan[unit]));
          digits = digits.length < 2 ? "0".concat(digits) : digits;
          if (el.textContent !== digits) {
            digits = digits.split("");
            if (digits.length !== el.children.length) {
              html(el, digits.map(function () {
                return "<span></span>";
              }).join(""));
            }
            digits.forEach(function (digit, i) {
              return el.children[i].textContent = digit;
            });
          }
        };
        for (var _i9 = 0, _units = units; _i9 < _units.length; _i9++) {
          var _ret = _loop3();
          if (_ret === "continue") continue;
        }
      }
    }
  };
  function getTimeSpan(date) {
    var total = Math.max(0, date - Date.now()) / 1e3;
    return {
      total: total,
      seconds: total % 60,
      minutes: total / 60 % 60,
      hours: total / 60 / 60 % 24,
      days: total / 60 / 60 / 24
    };
  }
  var strats = {};
  strats.events = strats.watch = strats.observe = strats.created = strats.beforeConnect = strats.connected = strats.beforeDisconnect = strats.disconnected = strats.destroy = concatStrat;
  strats.args = function (parentVal, childVal) {
    return childVal !== false && concatStrat(childVal || parentVal);
  };
  strats.update = function (parentVal, childVal) {
    return sortBy(concatStrat(parentVal, isFunction(childVal) ? {
      read: childVal
    } : childVal), "order");
  };
  strats.props = function (parentVal, childVal) {
    if (isArray(childVal)) {
      var value = {};
      var _iterator18 = _createForOfIteratorHelper(childVal),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var key = _step18.value;
          value[key] = String;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      childVal = value;
    }
    return strats.methods(parentVal, childVal);
  };
  strats.computed = strats.methods = function (parentVal, childVal) {
    return childVal ? parentVal ? _objectSpread(_objectSpread({}, parentVal), childVal) : childVal : parentVal;
  };
  strats.i18n = strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
      if (!childVal) {
        return parentVal;
      }
      if (!parentVal) {
        return childVal;
      }
      return function (vm2) {
        return mergeFnData(parentVal, childVal, vm2);
      };
    }
    return mergeFnData(parentVal, childVal, vm);
  };
  function mergeFnData(parentVal, childVal, vm) {
    return strats.computed(isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal, isFunction(childVal) ? childVal.call(vm, vm) : childVal);
  }
  function concatStrat(parentVal, childVal) {
    parentVal = parentVal && !isArray(parentVal) ? [parentVal] : parentVal;
    return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
  }
  function defaultStrat(parentVal, childVal) {
    return isUndefined(childVal) ? parentVal : childVal;
  }
  function mergeOptions(parent, child, vm) {
    var options = {};
    if (isFunction(child)) {
      child = child.options;
    }
    if (child["extends"]) {
      parent = mergeOptions(parent, child["extends"], vm);
    }
    if (child.mixins) {
      var _iterator19 = _createForOfIteratorHelper(child.mixins),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var mixin = _step19.value;
          parent = mergeOptions(parent, mixin, vm);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }
    for (var key in parent) {
      mergeKey(key);
    }
    for (var _key10 in child) {
      if (!hasOwn(parent, _key10)) {
        mergeKey(_key10);
      }
    }
    function mergeKey(key) {
      options[key] = (strats[key] || defaultStrat)(parent[key], child[key], vm);
    }
    return options;
  }
  function parseOptions(options) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    try {
      return options ? startsWith(options, "{") ? JSON.parse(options) : args.length && !includes(options, ":") ? (0, _defineProperty2["default"])({}, args[0], options) : options.split(";").reduce(function (options2, option) {
        var _option$split = option.split(/:(.*)/),
          _option$split2 = (0, _slicedToArray2["default"])(_option$split, 2),
          key = _option$split2[0],
          value = _option$split2[1];
        if (key && !isUndefined(value)) {
          options2[key.trim()] = value.trim();
        }
        return options2;
      }, {}) : {};
    } catch (e) {
      return {};
    }
  }
  function coerce$1(type, value) {
    if (type === Boolean) {
      return toBoolean(value);
    } else if (type === Number) {
      return toNumber(value);
    } else if (type === "list") {
      return toList(value);
    } else if (type === Object && isString(value)) {
      return parseOptions(value);
    }
    return type ? type(value) : value;
  }
  var listRe = /,(?![^(]*\))/;
  function toList(value) {
    return isArray(value) ? value : isString(value) ? value.split(listRe).map(function (value2) {
      return isNumeric(value2) ? toNumber(value2) : toBoolean(value2.trim());
    }) : [value];
  }
  function initUpdates(instance) {
    instance._data = {};
    instance._updates = (0, _toConsumableArray2["default"])(instance.$options.update || []);
  }
  function prependUpdate(instance, update) {
    instance._updates.unshift(update);
  }
  function clearUpdateData(instance) {
    delete instance._data;
  }
  function callUpdate(instance) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "update";
    if (!instance._connected) {
      return;
    }
    if (!instance._updates.length) {
      return;
    }
    if (!instance._queued) {
      instance._queued = /* @__PURE__ */new Set();
      fastdom.read(function () {
        if (instance._connected) {
          runUpdates(instance, instance._queued);
        }
        delete instance._queued;
      });
    }
    instance._queued.add(e.type || e);
  }
  function runUpdates(instance, types) {
    var _iterator20 = _createForOfIteratorHelper(instance._updates),
      _step20;
    try {
      var _loop4 = function _loop4() {
        var _step20$value = _step20.value,
          read = _step20$value.read,
          write = _step20$value.write,
          _step20$value$events = _step20$value.events,
          events = _step20$value$events === void 0 ? [] : _step20$value$events;
        if (!types.has("update") && !events.some(function (type) {
          return types.has(type);
        })) {
          return "continue";
        }
        var result;
        if (read) {
          result = read.call(instance, instance._data, types);
          if (result && isPlainObject(result)) {
            assign(instance._data, result);
          }
        }
        if (write && result !== false) {
          fastdom.write(function () {
            if (instance._connected) {
              write.call(instance, instance._data, types);
            }
          });
        }
      };
      for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
        var _ret2 = _loop4();
        if (_ret2 === "continue") continue;
      }
    } catch (err) {
      _iterator20.e(err);
    } finally {
      _iterator20.f();
    }
  }
  function resize(options) {
    return observe(observeResize, options, "resize");
  }
  function intersection(options) {
    return observe(observeIntersection, options);
  }
  function mutation(options) {
    return observe(observeMutation, options);
  }
  function lazyload() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return intersection(_objectSpread({
      handler: function handler(entries, observer) {
        var _options$targets = options.targets,
          targets = _options$targets === void 0 ? this.$el : _options$targets,
          _options$preload = options.preload,
          preload = _options$preload === void 0 ? 5 : _options$preload;
        var _iterator21 = _createForOfIteratorHelper(toNodes(isFunction(targets) ? targets(this) : targets)),
          _step21;
        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var el = _step21.value;
            $$('[loading="lazy"]', el).slice(0, preload - 1).forEach(function (el2) {
              return removeAttr(el2, "loading");
            });
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
        var _iterator22 = _createForOfIteratorHelper(entries.filter(function (_ref22) {
            var isIntersecting = _ref22.isIntersecting;
            return isIntersecting;
          }).map(function (_ref23) {
            var target = _ref23.target;
            return target;
          })),
          _step22;
        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var _el = _step22.value;
            observer.unobserve(_el);
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
      }
    }, options));
  }
  function viewport(options) {
    return observe(function (target, handler) {
      return observeViewportResize(handler);
    }, options, "resize");
  }
  function scroll$1(options) {
    return observe(function (target, handler) {
      return {
        disconnect: on(toScrollTargets(target), "scroll", handler, {
          passive: true
        })
      };
    }, options, "scroll");
  }
  function swipe(options) {
    return _objectSpread({
      observe: function observe(target, handler) {
        return {
          observe: noop,
          unobserve: noop,
          disconnect: on(target, pointerDown$1, handler, {
            passive: true
          })
        };
      },
      handler: function handler(e) {
        if (!isTouch(e)) {
          return;
        }
        var pos = getEventPos(e);
        var target = "tagName" in e.target ? e.target : parent(e.target);
        once(document, "".concat(pointerUp$1, " ").concat(pointerCancel, " scroll"), function (e2) {
          var _getEventPos = getEventPos(e2),
            x = _getEventPos.x,
            y = _getEventPos.y;
          if (e2.type !== "scroll" && target && x && Math.abs(pos.x - x) > 100 || y && Math.abs(pos.y - y) > 100) {
            setTimeout(function () {
              trigger(target, "swipe");
              trigger(target, "swipe".concat(swipeDirection(pos.x, pos.y, x, y)));
            });
          }
        });
      }
    }, options);
  }
  function observe(observe2, options, emit) {
    return _objectSpread({
      observe: observe2,
      handler: function handler() {
        callUpdate(this, emit);
      }
    }, options);
  }
  function swipeDirection(x1, y1, x2, y2) {
    return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? x1 - x2 > 0 ? "Left" : "Right" : y1 - y2 > 0 ? "Up" : "Down";
  }
  function toScrollTargets(elements) {
    return toNodes(elements).map(function (node) {
      var ownerDocument = node.ownerDocument;
      var parent2 = scrollParent(node, true);
      return parent2 === ownerDocument.scrollingElement ? ownerDocument : parent2;
    });
  }
  var Margin = {
    props: {
      margin: String,
      firstColumn: Boolean
    },
    data: {
      margin: "uk-margin-small-top",
      firstColumn: "uk-first-column"
    },
    observe: [mutation({
      options: {
        childList: true,
        attributes: true,
        attributeFilter: ["style"]
      }
    }), resize({
      target: function target(_ref24) {
        var $el = _ref24.$el;
        return [$el].concat((0, _toConsumableArray2["default"])(_children($el)));
      }
    })],
    update: {
      read: function read() {
        return {
          rows: getRows(toArray(this.$el.children))
        };
      },
      write: function write(_ref25) {
        var rows = _ref25.rows;
        var _iterator23 = _createForOfIteratorHelper(rows),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var row = _step23.value;
            var _iterator24 = _createForOfIteratorHelper(row),
              _step24;
            try {
              for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                var el = _step24.value;
                toggleClass(el, this.margin, rows[0] !== row);
                toggleClass(el, this.firstColumn, row[isRtl ? row.length - 1 : 0] === el);
              }
            } catch (err) {
              _iterator24.e(err);
            } finally {
              _iterator24.f();
            }
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      },
      events: ["resize"]
    }
  };
  function getRows(elements) {
    var sorted = [[]];
    var withOffset = elements.some(function (el, i) {
      return i && elements[i - 1].offsetParent !== el.offsetParent;
    });
    var _iterator25 = _createForOfIteratorHelper(elements),
      _step25;
    try {
      for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
        var el = _step25.value;
        if (!isVisible(el)) {
          continue;
        }
        var _offset2 = getOffset(el, withOffset);
        for (var i = sorted.length - 1; i >= 0; i--) {
          var current = sorted[i];
          if (!current[0]) {
            current.push(el);
            break;
          }
          var offsetCurrent = getOffset(current[0], withOffset);
          if (_offset2.top >= offsetCurrent.bottom - 1 && _offset2.top !== offsetCurrent.top) {
            sorted.push([el]);
            break;
          }
          if (_offset2.bottom - 1 > offsetCurrent.top || _offset2.top === offsetCurrent.top) {
            var j = current.length - 1;
            for (; j >= 0; j--) {
              var offsetCurrent2 = getOffset(current[j], withOffset);
              if (_offset2.left >= offsetCurrent2.left) {
                break;
              }
            }
            current.splice(j + 1, 0, el);
            break;
          }
          if (i === 0) {
            sorted.unshift([el]);
            break;
          }
        }
      }
    } catch (err) {
      _iterator25.e(err);
    } finally {
      _iterator25.f();
    }
    return sorted;
  }
  function getOffset(element) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var offsetTop = element.offsetTop,
      offsetLeft = element.offsetLeft,
      offsetHeight = element.offsetHeight,
      offsetWidth = element.offsetWidth;
    if (offset) {
      var _offsetPosition = offsetPosition(element);
      var _offsetPosition2 = (0, _slicedToArray2["default"])(_offsetPosition, 2);
      offsetTop = _offsetPosition2[0];
      offsetLeft = _offsetPosition2[1];
    }
    return {
      top: offsetTop,
      left: offsetLeft,
      bottom: offsetTop + offsetHeight,
      right: offsetLeft + offsetWidth
    };
  }
  var clsLeave = "uk-transition-leave";
  var clsEnter = "uk-transition-enter";
  function fade(action, target, duration) {
    var stagger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var index = transitionIndex(target, true);
    var propsIn = {
      opacity: 1
    };
    var propsOut = {
      opacity: 0
    };
    var wrapIndexFn = function wrapIndexFn(fn) {
      return function () {
        return index === transitionIndex(target) ? fn() : Promise.reject();
      };
    };
    var leaveFn = wrapIndexFn( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            addClass(target, clsLeave);
            _context3.next = 3;
            return Promise.all(getTransitionNodes(target).map(function (child, i) {
              return new Promise(function (resolve) {
                return setTimeout(function () {
                  return Transition.start(child, propsOut, duration / 2, "ease").then(resolve);
                }, i * stagger);
              });
            }));
          case 3:
            removeClass(target, clsLeave);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    var enterFn = wrapIndexFn( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var oldHeight, nodes, newHeight, transitionNodes, transitions;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            oldHeight = height(target);
            addClass(target, clsEnter);
            action();
            css(_children(target), {
              opacity: 0
            });
            _context5.next = 6;
            return awaitFrame$1();
          case 6:
            nodes = _children(target);
            newHeight = height(target);
            css(target, "alignContent", "flex-start");
            height(target, oldHeight);
            transitionNodes = getTransitionNodes(target);
            css(nodes, propsOut);
            transitions = transitionNodes.map( /*#__PURE__*/function () {
              var _ref28 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(child, i) {
                return _regenerator["default"].wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return awaitTimeout(i * stagger);
                    case 2:
                      _context4.next = 4;
                      return Transition.start(child, propsIn, duration / 2, "ease");
                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x3, _x4) {
                return _ref28.apply(this, arguments);
              };
            }());
            if (oldHeight !== newHeight) {
              transitions.push(Transition.start(target, {
                height: newHeight
              }, duration / 2 + transitionNodes.length * stagger, "ease"));
            }
            _context5.next = 16;
            return Promise.all(transitions).then(function () {
              removeClass(target, clsEnter);
              if (index === transitionIndex(target)) {
                css(target, {
                  height: "",
                  alignContent: ""
                });
                css(nodes, {
                  opacity: ""
                });
                delete target.dataset.transition;
              }
            });
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    return hasClass(target, clsLeave) ? waitTransitionend(target).then(enterFn) : hasClass(target, clsEnter) ? waitTransitionend(target).then(leaveFn).then(enterFn) : leaveFn().then(enterFn);
  }
  function transitionIndex(target, next) {
    if (next) {
      target.dataset.transition = 1 + transitionIndex(target);
    }
    return toNumber(target.dataset.transition) || 0;
  }
  function waitTransitionend(target) {
    return Promise.all(_children(target).filter(Transition.inProgress).map(function (el) {
      return new Promise(function (resolve) {
        return once(el, "transitionend transitioncanceled", resolve);
      });
    }));
  }
  function getTransitionNodes(target) {
    return getRows(_children(target)).flat().filter(function (node) {
      return isVisible(node);
    });
  }
  function awaitFrame$1() {
    return new Promise(function (resolve) {
      return requestAnimationFrame(resolve);
    });
  }
  function awaitTimeout(timeout) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, timeout);
    });
  }
  function slide(_x5, _x6, _x7) {
    return _slide.apply(this, arguments);
  }
  function _slide() {
    _slide = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee33(action, target, duration) {
      var nodes, currentProps, targetProps, targetStyle, targetPropsTo, _getTransitionProps, _getTransitionProps2, propsTo, propsFrom, attrsTo, transitions;
      return _regenerator["default"].wrap(function _callee33$(_context33) {
        while (1) switch (_context33.prev = _context33.next) {
          case 0:
            _context33.next = 2;
            return awaitFrame();
          case 2:
            nodes = _children(target);
            currentProps = nodes.map(function (el) {
              return getProps$1(el, true);
            });
            targetProps = _objectSpread(_objectSpread({}, css(target, ["height", "padding"])), {}, {
              display: "block"
            });
            _context33.next = 7;
            return Promise.all(nodes.concat(target).map(Transition.cancel));
          case 7:
            action();
            nodes = nodes.concat(_children(target).filter(function (el) {
              return !includes(nodes, el);
            }));
            _context33.next = 11;
            return Promise.resolve();
          case 11:
            fastdom.flush();
            targetStyle = attr(target, "style");
            targetPropsTo = css(target, ["height", "padding"]);
            _getTransitionProps = getTransitionProps(target, nodes, currentProps), _getTransitionProps2 = (0, _slicedToArray2["default"])(_getTransitionProps, 2), propsTo = _getTransitionProps2[0], propsFrom = _getTransitionProps2[1];
            attrsTo = nodes.map(function (el) {
              return {
                style: attr(el, "style")
              };
            });
            nodes.forEach(function (el, i) {
              return propsFrom[i] && css(el, propsFrom[i]);
            });
            css(target, targetProps);
            trigger(target, "scroll");
            fastdom.flush();
            _context33.next = 22;
            return awaitFrame();
          case 22:
            transitions = nodes.map(function (el, i) {
              return parent(el) === target && Transition.start(el, propsTo[i], duration, "ease");
            }).concat(Transition.start(target, targetPropsTo, duration, "ease"));
            _context33.prev = 23;
            _context33.next = 26;
            return Promise.all(transitions);
          case 26:
            nodes.forEach(function (el, i) {
              attr(el, attrsTo[i]);
              if (parent(el) === target) {
                css(el, "display", propsTo[i].opacity === 0 ? "none" : "");
              }
            });
            attr(target, "style", targetStyle);
            _context33.next = 34;
            break;
          case 30:
            _context33.prev = 30;
            _context33.t0 = _context33["catch"](23);
            attr(nodes, "style", "");
            resetProps(target, targetProps);
          case 34:
          case "end":
            return _context33.stop();
        }
      }, _callee33, null, [[23, 30]]);
    }));
    return _slide.apply(this, arguments);
  }
  function getProps$1(el, opacity) {
    var zIndex = css(el, "zIndex");
    return isVisible(el) ? _objectSpread({
      display: "",
      opacity: opacity ? css(el, "opacity") : "0",
      pointerEvents: "none",
      position: "absolute",
      zIndex: zIndex === "auto" ? index(el) : zIndex
    }, getPositionWithMargin(el)) : false;
  }
  function getTransitionProps(target, nodes, currentProps) {
    var propsTo = nodes.map(function (el, i) {
      return parent(el) && i in currentProps ? currentProps[i] ? isVisible(el) ? getPositionWithMargin(el) : {
        opacity: 0
      } : {
        opacity: isVisible(el) ? 1 : 0
      } : false;
    });
    var propsFrom = propsTo.map(function (props, i) {
      var from = parent(nodes[i]) === target && (currentProps[i] || getProps$1(nodes[i]));
      if (!from) {
        return false;
      }
      if (!props) {
        delete from.opacity;
      } else if (!("opacity" in props)) {
        var opacity = from.opacity;
        if (opacity % 1) {
          props.opacity = 1;
        } else {
          delete from.opacity;
        }
      }
      return from;
    });
    return [propsTo, propsFrom];
  }
  function resetProps(el, props) {
    for (var prop in props) {
      css(el, prop, "");
    }
  }
  function getPositionWithMargin(el) {
    var _offset3 = offset(el),
      height = _offset3.height,
      width = _offset3.width;
    return _objectSpread(_objectSpread({
      height: height,
      width: width,
      transform: ""
    }, position(el)), css(el, ["marginTop", "marginLeft"]));
  }
  function awaitFrame() {
    return new Promise(function (resolve) {
      return requestAnimationFrame(resolve);
    });
  }
  var Animate = {
    props: {
      duration: Number,
      animation: Boolean
    },
    data: {
      duration: 150,
      animation: "slide"
    },
    methods: {
      animate: function animate(action) {
        var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$el;
        var name = this.animation;
        var animationFn = name === "fade" ? fade : name === "delayed-fade" ? function () {
          for (var _len10 = arguments.length, args = new Array(_len10), _key11 = 0; _key11 < _len10; _key11++) {
            args[_key11] = arguments[_key11];
          }
          return fade.apply(void 0, args.concat([40]));
        } : name ? slide : function () {
          action();
          return Promise.resolve();
        };
        return animationFn(action, target, this.duration)["catch"](noop);
      }
    }
  };
  var keyMap = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
  };
  var filter = {
    mixins: [Animate],
    args: "target",
    props: {
      target: String,
      selActive: Boolean
    },
    data: {
      target: "",
      selActive: false,
      attrItem: "uk-filter-control",
      cls: "uk-active",
      duration: 250
    },
    computed: {
      children: function children(_ref29, $el) {
        var target = _ref29.target;
        return $$("".concat(target, " > *"), $el);
      },
      toggles: function toggles(_ref30, $el) {
        var attrItem = _ref30.attrItem;
        return $$("[".concat(attrItem, "],[data-").concat(attrItem, "]"), $el);
      }
    },
    watch: {
      toggles: function toggles(_toggles) {
        this.updateState();
        var actives = $$(this.selActive, this.$el);
        var _iterator26 = _createForOfIteratorHelper(_toggles),
          _step26;
        try {
          for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
            var _toggle2 = _step26.value;
            if (this.selActive !== false) {
              toggleClass(_toggle2, this.cls, includes(actives, _toggle2));
            }
            var button = findButton(_toggle2);
            if (isTag(button, "a")) {
              attr(button, "role", "button");
            }
          }
        } catch (err) {
          _iterator26.e(err);
        } finally {
          _iterator26.f();
        }
      },
      children: function children(list, prev) {
        if (prev) {
          this.updateState();
        }
      }
    },
    events: {
      name: "click keydown",
      delegate: function delegate() {
        return "[".concat(this.attrItem, "],[data-").concat(this.attrItem, "]");
      },
      handler: function handler(e) {
        if (e.type === "keydown" && e.keyCode !== keyMap.SPACE) {
          return;
        }
        if (e.target.closest("a,button")) {
          e.preventDefault();
          this.apply(e.current);
        }
      }
    },
    methods: {
      apply: function apply(el) {
        var prevState = this.getState();
        var newState = mergeState(el, this.attrItem, this.getState());
        if (!isEqualState(prevState, newState)) {
          this.setState(newState);
        }
      },
      getState: function getState() {
        var _this4 = this;
        return this.toggles.filter(function (item) {
          return hasClass(item, _this4.cls);
        }).reduce(function (state, el) {
          return mergeState(el, _this4.attrItem, state);
        }, {
          filter: {
            "": ""
          },
          sort: []
        });
      },
      setState: function setState(state) {
        var _arguments = arguments,
          _this5 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
          var animate, _iterator27, _step27, _toggle3;
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                animate = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
                state = _objectSpread({
                  filter: {
                    "": ""
                  },
                  sort: []
                }, state);
                trigger(_this5.$el, "beforeFilter", [_this5, state]);
                _iterator27 = _createForOfIteratorHelper(_this5.toggles);
                try {
                  for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                    _toggle3 = _step27.value;
                    toggleClass(_toggle3, _this5.cls, matchFilter(_toggle3, _this5.attrItem, state));
                  }
                } catch (err) {
                  _iterator27.e(err);
                } finally {
                  _iterator27.f();
                }
                _context6.next = 7;
                return Promise.all($$(_this5.target, _this5.$el).map(function (target) {
                  var filterFn = function filterFn() {
                    applyState(state, target, _children(target));
                    _this5.$update(_this5.$el);
                  };
                  return animate ? _this5.animate(filterFn, target) : filterFn();
                }));
              case 7:
                trigger(_this5.$el, "afterFilter", [_this5]);
              case 8:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }))();
      },
      updateState: function updateState() {
        var _this6 = this;
        fastdom.write(function () {
          return _this6.setState(_this6.getState(), false);
        });
      }
    }
  };
  function getFilter(el, attr2) {
    return parseOptions(data(el, attr2), ["filter"]);
  }
  function isEqualState(stateA, stateB) {
    return ["filter", "sort"].every(function (prop) {
      return isEqual(stateA[prop], stateB[prop]);
    });
  }
  function applyState(state, target, children) {
    var selector = getSelector(state);
    children.forEach(function (el) {
      return css(el, "display", selector && !matches(el, selector) ? "none" : "");
    });
    var _state$sort = (0, _slicedToArray2["default"])(state.sort, 2),
      sort = _state$sort[0],
      order = _state$sort[1];
    if (sort) {
      var sorted = sortItems(children, sort, order);
      if (!isEqual(sorted, children)) {
        append(target, sorted);
      }
    }
  }
  function mergeState(el, attr2, state) {
    var _getFilter = getFilter(el, attr2),
      filter = _getFilter.filter,
      group = _getFilter.group,
      sort = _getFilter.sort,
      _getFilter$order = _getFilter.order,
      order = _getFilter$order === void 0 ? "asc" : _getFilter$order;
    if (filter || isUndefined(sort)) {
      if (group) {
        if (filter) {
          delete state.filter[""];
          state.filter[group] = filter;
        } else {
          delete state.filter[group];
          if (isEmpty(state.filter) || "" in state.filter) {
            state.filter = {
              "": filter || ""
            };
          }
        }
      } else {
        state.filter = {
          "": filter || ""
        };
      }
    }
    if (!isUndefined(sort)) {
      state.sort = [sort, order];
    }
    return state;
  }
  function matchFilter(el, attr2, _ref31) {
    var _ref31$filter = _ref31.filter,
      stateFilter = _ref31$filter === void 0 ? {
        "": ""
      } : _ref31$filter,
      _ref31$sort = (0, _slicedToArray2["default"])(_ref31.sort, 2),
      stateSort = _ref31$sort[0],
      stateOrder = _ref31$sort[1];
    var _getFilter2 = getFilter(el, attr2),
      _getFilter2$filter = _getFilter2.filter,
      filter = _getFilter2$filter === void 0 ? "" : _getFilter2$filter,
      _getFilter2$group = _getFilter2.group,
      group = _getFilter2$group === void 0 ? "" : _getFilter2$group,
      sort = _getFilter2.sort,
      _getFilter2$order = _getFilter2.order,
      order = _getFilter2$order === void 0 ? "asc" : _getFilter2$order;
    return isUndefined(sort) ? group in stateFilter && filter === stateFilter[group] || !filter && group && !(group in stateFilter) && !stateFilter[""] : stateSort === sort && stateOrder === order;
  }
  function getSelector(_ref32) {
    var filter = _ref32.filter;
    var selector = "";
    each(filter, function (value) {
      return selector += value || "";
    });
    return selector;
  }
  function sortItems(nodes, sort, order) {
    return (0, _toConsumableArray2["default"])(nodes).sort(function (a, b) {
      return data(a, sort).localeCompare(data(b, sort), void 0, {
        numeric: true
      }) * (order === "asc" || -1);
    });
  }
  function findButton(el) {
    return $("a,button", el) || el;
  }
  var prevented;
  function preventBackgroundScroll(el) {
    var off = on(el, "touchstart", function (e) {
      if (e.targetTouches.length !== 1 || matches(e.target, 'input[type="range"')) {
        return;
      }
      var prev = getEventPos(e).y;
      var offMove = on(el, "touchmove", function (e2) {
        var pos = getEventPos(e2).y;
        if (pos === prev) {
          return;
        }
        prev = pos;
        if (!scrollParents(e2.target).some(function (scrollParent) {
          if (!el.contains(scrollParent)) {
            return false;
          }
          var scrollHeight = scrollParent.scrollHeight,
            clientHeight = scrollParent.clientHeight;
          return clientHeight < scrollHeight;
        })) {
          e2.preventDefault();
        }
      }, {
        passive: false
      });
      once(el, "scroll touchend touchcanel", offMove, {
        capture: true
      });
    });
    if (prevented) {
      return off;
    }
    prevented = true;
    var _document = document,
      scrollingElement = _document.scrollingElement;
    css(scrollingElement, {
      overflowY: CSS.supports("overflow", "clip") ? "clip" : "hidden",
      touchAction: "none",
      paddingRight: width(window) - scrollingElement.clientWidth || ""
    });
    return function () {
      prevented = false;
      off();
      css(scrollingElement, {
        overflowY: "",
        touchAction: "",
        paddingRight: ""
      });
    };
  }
  var Container = {
    props: {
      container: Boolean
    },
    data: {
      container: true
    },
    computed: {
      container: function container(_ref33) {
        var container = _ref33.container;
        return container === true && this.$container || container && $(container);
      }
    }
  };
  var Togglable = {
    props: {
      cls: Boolean,
      animation: "list",
      duration: Number,
      velocity: Number,
      origin: String,
      transition: String
    },
    data: {
      cls: false,
      animation: [false],
      duration: 200,
      velocity: 0.2,
      origin: false,
      transition: "ease",
      clsEnter: "uk-togglable-enter",
      clsLeave: "uk-togglable-leave"
    },
    computed: {
      hasAnimation: function hasAnimation(_ref34) {
        var animation = _ref34.animation;
        return !!animation[0];
      },
      hasTransition: function hasTransition(_ref35) {
        var animation = _ref35.animation;
        return ["slide", "reveal"].some(function (transition) {
          return startsWith(animation[0], transition);
        });
      }
    },
    methods: {
      toggleElement: function toggleElement(targets, toggle, animate) {
        var _this7 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
          return _regenerator["default"].wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return Promise.all(toNodes(targets).map(function (el) {
                  var show = isBoolean(toggle) ? toggle : !_this7.isToggled(el);
                  if (!trigger(el, "before".concat(show ? "show" : "hide"), [_this7])) {
                    return Promise.reject();
                  }
                  var promise = (isFunction(animate) ? animate : animate === false || !_this7.hasAnimation ? toggleInstant : _this7.hasTransition ? toggleTransition : toggleAnimation)(el, show, _this7);
                  var cls = show ? _this7.clsEnter : _this7.clsLeave;
                  addClass(el, cls);
                  trigger(el, show ? "show" : "hide", [_this7]);
                  var done = function done() {
                    removeClass(el, cls);
                    trigger(el, show ? "shown" : "hidden", [_this7]);
                  };
                  return promise ? promise.then(done, function () {
                    removeClass(el, cls);
                    return Promise.reject();
                  }) : done();
                }));
              case 3:
                return _context7.abrupt("return", true);
              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", false);
              case 9:
              case "end":
                return _context7.stop();
            }
          }, _callee7, null, [[0, 6]]);
        }))();
      },
      isToggled: function isToggled() {
        var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$el;
        el = toNode(el);
        return hasClass(el, this.clsEnter) ? true : hasClass(el, this.clsLeave) ? false : this.cls ? hasClass(el, this.cls.split(" ")[0]) : isVisible(el);
      },
      _toggle: function _toggle(el, toggled) {
        if (!el) {
          return;
        }
        toggled = Boolean(toggled);
        var changed;
        if (this.cls) {
          changed = includes(this.cls, " ") || toggled !== hasClass(el, this.cls);
          changed && toggleClass(el, this.cls, includes(this.cls, " ") ? void 0 : toggled);
        } else {
          changed = toggled === el.hidden;
          changed && (el.hidden = !toggled);
        }
        $$("[autofocus]", el).some(function (el2) {
          return isVisible(el2) ? el2.focus() || true : el2.blur();
        });
        if (changed) {
          trigger(el, "toggled", [toggled, this]);
        }
      }
    }
  };
  function toggleInstant(el, show, _ref36) {
    var _toggle = _ref36._toggle;
    Animation.cancel(el);
    Transition.cancel(el);
    return _toggle(el, show);
  }
  function toggleTransition(_x8, _x9, _x10) {
    return _toggleTransition.apply(this, arguments);
  }
  function _toggleTransition() {
    _toggleTransition = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee34(el, show, _ref37) {
      var _css3;
      var animation, duration, velocity, transition, _toggle, _a, _ref193, _ref194, _ref194$, mode, _ref194$2, startProp, dirs, dir, end, props, dimProp, marginProp, marginStartProp, currentDim, inProgress, prevProps, dim, currentMargin, marginStart, endDim, _wrapInner3, _wrapInner4, wrapper, percent, endProps;
      return _regenerator["default"].wrap(function _callee34$(_context34) {
        while (1) switch (_context34.prev = _context34.next) {
          case 0:
            animation = _ref37.animation, duration = _ref37.duration, velocity = _ref37.velocity, transition = _ref37.transition, _toggle = _ref37._toggle;
            _ref193 = ((_a = animation[0]) == null ? void 0 : _a.split("-")) || [], _ref194 = (0, _slicedToArray2["default"])(_ref193, 2), _ref194$ = _ref194[0], mode = _ref194$ === void 0 ? "reveal" : _ref194$, _ref194$2 = _ref194[1], startProp = _ref194$2 === void 0 ? "top" : _ref194$2;
            dirs = [["left", "right"], ["top", "bottom"]];
            dir = dirs[includes(dirs[0], startProp) ? 0 : 1];
            end = dir[1] === startProp;
            props = ["width", "height"];
            dimProp = props[dirs.indexOf(dir)];
            marginProp = "margin-".concat(dir[0]);
            marginStartProp = "margin-".concat(startProp);
            currentDim = dimensions$1(el)[dimProp];
            inProgress = Transition.inProgress(el);
            _context34.next = 13;
            return Transition.cancel(el);
          case 13:
            if (show) {
              _toggle(el, true);
            }
            prevProps = Object.fromEntries(["padding", "border", "width", "height", "minWidth", "minHeight", "overflowY", "overflowX", marginProp, marginStartProp].map(function (key) {
              return [key, el.style[key]];
            }));
            dim = dimensions$1(el);
            currentMargin = toFloat(css(el, marginProp));
            marginStart = toFloat(css(el, marginStartProp));
            endDim = dim[dimProp] + marginStart;
            if (!inProgress && !show) {
              currentDim += marginStart;
            }
            _wrapInner3 = wrapInner(el, "<div>"), _wrapInner4 = (0, _slicedToArray2["default"])(_wrapInner3, 1), wrapper = _wrapInner4[0];
            css(wrapper, _objectSpread({
              boxSizing: "border-box",
              height: dim.height,
              width: dim.width
            }, css(el, ["overflow", "padding", "borderTop", "borderRight", "borderBottom", "borderLeft", "borderImage", marginStartProp])));
            css(el, (_css3 = {
              padding: 0,
              border: 0,
              minWidth: 0,
              minHeight: 0
            }, (0, _defineProperty2["default"])(_css3, marginStartProp, 0), (0, _defineProperty2["default"])(_css3, "width", dim.width), (0, _defineProperty2["default"])(_css3, "height", dim.height), (0, _defineProperty2["default"])(_css3, "overflow", "hidden"), (0, _defineProperty2["default"])(_css3, dimProp, currentDim), _css3));
            percent = currentDim / endDim;
            duration = (velocity * endDim + duration) * (show ? 1 - percent : percent);
            endProps = (0, _defineProperty2["default"])({}, dimProp, show ? endDim : 0);
            if (end) {
              css(el, marginProp, endDim - currentDim + currentMargin);
              endProps[marginProp] = show ? currentMargin : endDim + currentMargin;
            }
            if (!end ^ mode === "reveal") {
              css(wrapper, marginProp, -endDim + currentDim);
              Transition.start(wrapper, (0, _defineProperty2["default"])({}, marginProp, show ? 0 : -endDim), duration, transition);
            }
            _context34.prev = 28;
            _context34.next = 31;
            return Transition.start(el, endProps, duration, transition);
          case 31:
            _context34.prev = 31;
            css(el, prevProps);
            unwrap(wrapper.firstChild);
            if (!show) {
              _toggle(el, false);
            }
            return _context34.finish(31);
          case 36:
          case "end":
            return _context34.stop();
        }
      }, _callee34, null, [[28,, 31, 36]]);
    }));
    return _toggleTransition.apply(this, arguments);
  }
  function toggleAnimation(el, show, cmp) {
    var animation = cmp.animation,
      duration = cmp.duration,
      _toggle = cmp._toggle;
    if (show) {
      _toggle(el, true);
      return Animation["in"](el, animation[0], duration, cmp.origin);
    }
    return Animation.out(el, animation[1] || animation[0], duration, cmp.origin).then(function () {
      return _toggle(el, false);
    });
  }
  var active$1 = [];
  var Modal = {
    mixins: [Class, Container, Togglable],
    props: {
      selPanel: String,
      selClose: String,
      escClose: Boolean,
      bgClose: Boolean,
      stack: Boolean,
      role: String
    },
    data: {
      cls: "uk-open",
      escClose: true,
      bgClose: true,
      overlay: true,
      stack: false,
      role: "dialog"
    },
    computed: {
      panel: function panel(_ref38, $el) {
        var selPanel = _ref38.selPanel;
        return $(selPanel, $el);
      },
      transitionElement: function transitionElement() {
        return this.panel;
      },
      bgClose: function bgClose(_ref39) {
        var bgClose = _ref39.bgClose;
        return bgClose && this.panel;
      }
    },
    connected: function connected() {
      attr(this.panel || this.$el, "role", this.role);
      if (this.overlay) {
        attr(this.panel || this.$el, "aria-modal", true);
      }
    },
    beforeDisconnect: function beforeDisconnect() {
      if (includes(active$1, this)) {
        this.toggleElement(this.$el, false, false);
      }
    },
    events: [{
      name: "click",
      delegate: function delegate() {
        return "".concat(this.selClose, ",a[href*=\"#\"]");
      },
      handler: function handler(e) {
        var current = e.current,
          defaultPrevented = e.defaultPrevented;
        var hash = current.hash;
        if (!defaultPrevented && hash && isSameSiteAnchor(current) && !this.$el.contains($(hash))) {
          this.hide();
        } else if (matches(current, this.selClose)) {
          e.preventDefault();
          this.hide();
        }
      }
    }, {
      name: "toggle",
      self: true,
      handler: function handler(e) {
        if (e.defaultPrevented) {
          return;
        }
        e.preventDefault();
        if (this.isToggled() === includes(active$1, this)) {
          this.toggle();
        }
      }
    }, {
      name: "beforeshow",
      self: true,
      handler: function handler(e) {
        if (includes(active$1, this)) {
          return false;
        }
        if (!this.stack && active$1.length) {
          Promise.all(active$1.map(function (modal) {
            return modal.hide();
          })).then(this.show);
          e.preventDefault();
        } else {
          active$1.push(this);
        }
      }
    }, {
      name: "show",
      self: true,
      handler: function handler() {
        if (this.stack) {
          css(this.$el, "zIndex", toFloat(css(this.$el, "zIndex")) + active$1.length);
        }
        var handlers = [this.overlay && preventBackgroundFocus(this), this.overlay && preventBackgroundScroll(this.$el), this.bgClose && listenForBackgroundClose$1(this), this.escClose && listenForEscClose$1(this)];
        once(this.$el, "hidden", function () {
          return handlers.forEach(function (handler) {
            return handler && handler();
          });
        }, {
          self: true
        });
        addClass(document.documentElement, this.clsPage);
      }
    }, {
      name: "shown",
      self: true,
      handler: function handler() {
        if (!isFocusable(this.$el)) {
          attr(this.$el, "tabindex", "-1");
        }
        if (!matches(this.$el, ":focus-within")) {
          this.$el.focus();
        }
      }
    }, {
      name: "hidden",
      self: true,
      handler: function handler() {
        var _this8 = this;
        if (includes(active$1, this)) {
          active$1.splice(active$1.indexOf(this), 1);
        }
        css(this.$el, "zIndex", "");
        if (!active$1.some(function (modal) {
          return modal.clsPage === _this8.clsPage;
        })) {
          removeClass(document.documentElement, this.clsPage);
        }
      }
    }],
    methods: {
      toggle: function toggle() {
        return this.isToggled() ? this.hide() : this.show();
      },
      show: function show() {
        var _this9 = this;
        if (this.container && parent(this.$el) !== this.container) {
          append(this.container, this.$el);
          return new Promise(function (resolve) {
            return requestAnimationFrame(function () {
              return _this9.show().then(resolve);
            });
          });
        }
        return this.toggleElement(this.$el, true, animate$1);
      },
      hide: function hide() {
        return this.toggleElement(this.$el, false, animate$1);
      }
    }
  };
  function animate$1(el, show, _ref40) {
    var transitionElement = _ref40.transitionElement,
      _toggle = _ref40._toggle;
    return new Promise(function (resolve, reject) {
      return once(el, "show hide", function () {
        var _a;
        (_a = el._reject) == null ? void 0 : _a.call(el);
        el._reject = reject;
        _toggle(el, show);
        var off = once(transitionElement, "transitionstart", function () {
          once(transitionElement, "transitionend transitioncancel", resolve, {
            self: true
          });
          clearTimeout(timer);
        }, {
          self: true
        });
        var timer = setTimeout(function () {
          off();
          resolve();
        }, toMs(css(transitionElement, "transitionDuration")));
      });
    }).then(function () {
      return delete el._reject;
    });
  }
  function toMs(time) {
    return time ? endsWith(time, "ms") ? toFloat(time) : toFloat(time) * 1e3 : 0;
  }
  function preventBackgroundFocus(modal) {
    return on(document, "focusin", function (e) {
      if (last(active$1) === modal && !modal.$el.contains(e.target)) {
        modal.$el.focus();
      }
    });
  }
  function listenForBackgroundClose$1(modal) {
    return on(document, pointerDown$1, function (_ref41) {
      var target = _ref41.target;
      if (last(active$1) !== modal || modal.overlay && !modal.$el.contains(target) || modal.panel.contains(target)) {
        return;
      }
      once(document, "".concat(pointerUp$1, " ").concat(pointerCancel, " scroll"), function (_ref42) {
        var defaultPrevented = _ref42.defaultPrevented,
          type = _ref42.type,
          newTarget = _ref42.target;
        if (!defaultPrevented && type === pointerUp$1 && target === newTarget) {
          modal.hide();
        }
      }, true);
    });
  }
  function listenForEscClose$1(modal) {
    return on(document, "keydown", function (e) {
      if (e.keyCode === 27 && last(active$1) === modal) {
        modal.hide();
      }
    });
  }
  var Animations$2 = {
    slide: {
      show: function show(dir) {
        return [{
          transform: _translate(dir * -100)
        }, {
          transform: _translate()
        }];
      },
      percent: function percent(current) {
        return translated(current);
      },
      translate: function translate(percent, dir) {
        return [{
          transform: _translate(dir * -100 * percent)
        }, {
          transform: _translate(dir * 100 * (1 - percent))
        }];
      }
    }
  };
  function translated(el) {
    return Math.abs(css(el, "transform").split(",")[4] / el.offsetWidth);
  }
  function _translate() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "%";
    value += value ? unit : "";
    return "translate3d(".concat(value, ", 0, 0)");
  }
  function scale3d(value) {
    return "scale3d(".concat(value, ", ").concat(value, ", 1)");
  }
  function Transitioner$1(prev, next, dir, _ref43) {
    var animation = _ref43.animation,
      easing = _ref43.easing;
    var _percent = animation.percent,
      _translate2 = animation.translate,
      _animation$show = animation.show,
      show = _animation$show === void 0 ? noop : _animation$show;
    var props = show(dir);
    var resolve;
    return {
      dir: dir,
      show: function show(duration) {
        var _this10 = this;
        var percent2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var linear = arguments.length > 2 ? arguments[2] : undefined;
        var timing = linear ? "linear" : easing;
        duration -= Math.round(duration * clamp(percent2, -1, 1));
        this.translate(percent2);
        triggerUpdate$1(next, "itemin", {
          percent: percent2,
          duration: duration,
          timing: timing,
          dir: dir
        });
        triggerUpdate$1(prev, "itemout", {
          percent: 1 - percent2,
          duration: duration,
          timing: timing,
          dir: dir
        });
        return new Promise(function (res) {
          resolve || (resolve = res);
          Promise.all([Transition.start(next, props[1], duration, timing), Transition.start(prev, props[0], duration, timing)]).then(function () {
            _this10.reset();
            resolve();
          }, noop);
        });
      },
      cancel: function cancel() {
        return Transition.cancel([next, prev]);
      },
      reset: function reset() {
        for (var prop in props[0]) {
          css([next, prev], prop, "");
        }
      },
      forward: function forward(duration) {
        var _arguments2 = arguments,
          _this11 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
          var percent2;
          return _regenerator["default"].wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                percent2 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : _this11.percent();
                _context8.next = 3;
                return _this11.cancel();
              case 3:
                return _context8.abrupt("return", _this11.show(duration, percent2, true));
              case 4:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }))();
      },
      translate: function translate(percent2) {
        this.reset();
        var props2 = _translate2(percent2, dir);
        css(next, props2[1]);
        css(prev, props2[0]);
        triggerUpdate$1(next, "itemtranslatein", {
          percent: percent2,
          dir: dir
        });
        triggerUpdate$1(prev, "itemtranslateout", {
          percent: 1 - percent2,
          dir: dir
        });
      },
      percent: function percent() {
        return _percent(prev || next, next, dir);
      },
      getDistance: function getDistance() {
        return prev == null ? void 0 : prev.offsetWidth;
      }
    };
  }
  function triggerUpdate$1(el, type, data) {
    trigger(el, createEvent(type, false, false, data));
  }
  var I18n = {
    props: {
      i18n: Object
    },
    data: {
      i18n: null
    },
    methods: {
      t: function t(key) {
        for (var _len11 = arguments.length, params = new Array(_len11 > 1 ? _len11 - 1 : 0), _key12 = 1; _key12 < _len11; _key12++) {
          params[_key12 - 1] = arguments[_key12];
        }
        var _a, _b, _c;
        var i = 0;
        return ((_c = ((_a = this.i18n) == null ? void 0 : _a[key]) || ((_b = this.$options.i18n) == null ? void 0 : _b[key])) == null ? void 0 : _c.replace(/%s/g, function () {
          return params[i++] || "";
        })) || "";
      }
    }
  };
  var SliderAutoplay = {
    props: {
      autoplay: Boolean,
      autoplayInterval: Number,
      pauseOnHover: Boolean
    },
    data: {
      autoplay: false,
      autoplayInterval: 7e3,
      pauseOnHover: true
    },
    connected: function connected() {
      attr(this.list, "aria-live", this.autoplay ? "off" : "polite");
      this.autoplay && this.startAutoplay();
    },
    disconnected: function disconnected() {
      this.stopAutoplay();
    },
    update: function update() {
      attr(this.slides, "tabindex", "-1");
    },
    events: [{
      name: "visibilitychange",
      el: function el() {
        return document;
      },
      filter: function filter() {
        return this.autoplay;
      },
      handler: function handler() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }
    }],
    methods: {
      startAutoplay: function startAutoplay() {
        var _this12 = this;
        this.stopAutoplay();
        this.interval = setInterval(function () {
          if (!(_this12.stack.length || _this12.draggable && matches(_this12.$el, ":focus-within") && !matches(_this12.$el, ":focus") || _this12.pauseOnHover && matches(_this12.$el, ":hover"))) {
            _this12.show("next");
          }
        }, this.autoplayInterval);
      },
      stopAutoplay: function stopAutoplay() {
        clearInterval(this.interval);
      }
    }
  };
  var pointerOptions = {
    passive: false,
    capture: true
  };
  var pointerUpOptions = {
    passive: true,
    capture: true
  };
  var pointerDown = "touchstart mousedown";
  var pointerMove = "touchmove mousemove";
  var pointerUp = "touchend touchcancel mouseup click input scroll";
  var preventClick = function preventClick(e) {
    return e.preventDefault();
  };
  var SliderDrag = {
    props: {
      draggable: Boolean
    },
    data: {
      draggable: true,
      threshold: 10
    },
    created: function created() {
      var _this13 = this;
      var _loop5 = function _loop5() {
        var key = _arr6[_i10];
        var fn = _this13[key];
        _this13[key] = function (e) {
          var pos = getEventPos(e).x * (isRtl ? -1 : 1);
          _this13.prevPos = pos === _this13.pos ? _this13.prevPos : _this13.pos;
          _this13.pos = pos;
          fn(e);
        };
      };
      for (var _i10 = 0, _arr6 = ["start", "move", "end"]; _i10 < _arr6.length; _i10++) {
        _loop5();
      }
    },
    events: [{
      name: pointerDown,
      passive: true,
      delegate: function delegate() {
        return "".concat(this.selList, " > *");
      },
      handler: function handler(e) {
        if (!this.draggable || this.parallax || !isTouch(e) && hasSelectableText(e.target) || e.target.closest(selInput) || e.button > 0 || this.length < 2) {
          return;
        }
        this.start(e);
      }
    }, {
      name: "dragstart",
      handler: function handler(e) {
        e.preventDefault();
      }
    }, _objectSpread({
      // iOS workaround for slider stopping if swiping fast
      name: pointerMove,
      el: function el() {
        return this.list;
      },
      handler: noop
    }, pointerOptions)],
    methods: {
      start: function start() {
        this.drag = this.pos;
        if (this._transitioner) {
          this.percent = this._transitioner.percent();
          this.drag += this._transitioner.getDistance() * this.percent * this.dir;
          this._transitioner.cancel();
          this._transitioner.translate(this.percent);
          this.dragging = true;
          this.stack = [];
        } else {
          this.prevIndex = this.index;
        }
        on(document, pointerMove, this.move, pointerOptions);
        on(document, pointerUp, this.end, pointerUpOptions);
        css(this.list, "userSelect", "none");
      },
      move: function move(e) {
        var distance = this.pos - this.drag;
        if (distance === 0 || this.prevPos === this.pos || !this.dragging && Math.abs(distance) < this.threshold) {
          return;
        }
        if (!this.dragging) {
          on(this.list, "click", preventClick, pointerOptions);
        }
        e.cancelable && e.preventDefault();
        this.dragging = true;
        this.dir = distance < 0 ? 1 : -1;
        var slides = this.slides,
          prevIndex = this.prevIndex;
        var dis = Math.abs(distance);
        var nextIndex = this.getIndex(prevIndex + this.dir);
        var width = getDistance.call(this, prevIndex, nextIndex);
        while (nextIndex !== prevIndex && dis > width) {
          this.drag -= width * this.dir;
          prevIndex = nextIndex;
          dis -= width;
          nextIndex = this.getIndex(prevIndex + this.dir);
          width = getDistance.call(this, prevIndex, nextIndex);
        }
        this.percent = dis / width;
        var prev = slides[prevIndex];
        var next = slides[nextIndex];
        var changed = this.index !== nextIndex;
        var edge = prevIndex === nextIndex;
        var itemShown;
        for (var _i11 = 0, _arr7 = [this.index, this.prevIndex]; _i11 < _arr7.length; _i11++) {
          var i = _arr7[_i11];
          if (!includes([nextIndex, prevIndex], i)) {
            trigger(slides[i], "itemhidden", [this]);
            if (edge) {
              itemShown = true;
              this.prevIndex = prevIndex;
            }
          }
        }
        if (this.index === prevIndex && this.prevIndex !== prevIndex || itemShown) {
          trigger(slides[this.index], "itemshown", [this]);
        }
        if (changed) {
          this.prevIndex = prevIndex;
          this.index = nextIndex;
          if (!edge) {
            trigger(prev, "beforeitemhide", [this]);
            trigger(prev, "itemhide", [this]);
          }
          trigger(next, "beforeitemshow", [this]);
          trigger(next, "itemshow", [this]);
        }
        this._transitioner = this._translate(Math.abs(this.percent), prev, !edge && next);
      },
      end: function end() {
        var _this14 = this;
        off(document, pointerMove, this.move, pointerOptions);
        off(document, pointerUp, this.end, pointerUpOptions);
        if (this.dragging) {
          this.dragging = null;
          if (this.index === this.prevIndex) {
            this.percent = 1 - this.percent;
            this.dir *= -1;
            this._show(false, this.index, true);
            this._transitioner = null;
          } else {
            var dirChange = (isRtl ? this.dir * (isRtl ? 1 : -1) : this.dir) < 0 === this.prevPos > this.pos;
            this.index = dirChange ? this.index : this.prevIndex;
            if (dirChange) {
              this.percent = 1 - this.percent;
            }
            this.show(this.dir > 0 && !dirChange || this.dir < 0 && dirChange ? "next" : "previous", true);
          }
        }
        setTimeout(function () {
          return off(_this14.list, "click", preventClick, pointerOptions);
        });
        css(this.list, {
          userSelect: ""
        });
        this.drag = this.percent = null;
      }
    }
  };
  function getDistance(prev, next) {
    return this._getTransitioner(prev, prev !== next && next).getDistance() || this.slides[prev].offsetWidth;
  }
  function hasSelectableText(el) {
    return css(el, "userSelect") !== "none" && toArray(el.childNodes).some(function (el2) {
      return el2.nodeType === 3 && el2.textContent.trim();
    });
  }
  function initWatches(instance) {
    instance._watches = [];
    var _iterator28 = _createForOfIteratorHelper(instance.$options.watch || []),
      _step28;
    try {
      for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
        var watches = _step28.value;
        for (var _i12 = 0, _Object$entries3 = Object.entries(watches); _i12 < _Object$entries3.length; _i12++) {
          var _Object$entries3$_i = (0, _slicedToArray2["default"])(_Object$entries3[_i12], 2),
            name = _Object$entries3$_i[0],
            watch = _Object$entries3$_i[1];
          registerWatch(instance, watch, name);
        }
      }
    } catch (err) {
      _iterator28.e(err);
    } finally {
      _iterator28.f();
    }
    instance._initial = true;
  }
  function registerWatch(instance, watch, name) {
    instance._watches.push(_objectSpread({
      name: name
    }, isPlainObject(watch) ? watch : {
      handler: watch
    }));
  }
  function runWatches(instance, values) {
    var _iterator29 = _createForOfIteratorHelper(instance._watches),
      _step29;
    try {
      for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
        var _step29$value = _step29.value,
          name = _step29$value.name,
          handler = _step29$value.handler,
          _step29$value$immedia = _step29$value.immediate,
          immediate = _step29$value$immedia === void 0 ? true : _step29$value$immedia;
        if (instance._initial && immediate || hasOwn(values, name) && !isEqual(values[name], instance[name])) {
          handler.call(instance, instance[name], values[name]);
        }
      }
    } catch (err) {
      _iterator29.e(err);
    } finally {
      _iterator29.f();
    }
    instance._initial = false;
  }
  function initComputed(instance) {
    var computed = instance.$options.computed;
    instance._computed = {};
    if (computed) {
      for (var key in computed) {
        registerComputed(instance, key, computed[key]);
      }
    }
  }
  function registerComputed(instance, key, cb) {
    instance._hasComputed = true;
    Object.defineProperty(instance, key, {
      enumerable: true,
      get: function get() {
        var _computed = instance._computed,
          $props = instance.$props,
          $el = instance.$el;
        if (!hasOwn(_computed, key)) {
          _computed[key] = (cb.get || cb).call(instance, $props, $el);
        }
        return _computed[key];
      },
      set: function set(value) {
        var _computed = instance._computed;
        _computed[key] = cb.set ? cb.set.call(instance, value) : value;
        if (isUndefined(_computed[key])) {
          delete _computed[key];
        }
      }
    });
  }
  function initComputedUpdates(instance) {
    if (!instance._hasComputed) {
      return;
    }
    prependUpdate(instance, {
      read: function read() {
        return runWatches(instance, resetComputed(instance));
      },
      events: ["resize", "computed"]
    });
    registerComputedObserver();
    instances$1.add(instance);
  }
  function disconnectComputedUpdates(instance) {
    instances$1 == null ? void 0 : instances$1["delete"](instance);
    resetComputed(instance);
  }
  function resetComputed(instance) {
    var values = _objectSpread({}, instance._computed);
    instance._computed = {};
    return values;
  }
  var observer;
  var instances$1;
  function registerComputedObserver() {
    if (observer) {
      return;
    }
    instances$1 = /* @__PURE__ */new Set();
    observer = new MutationObserver(function () {
      var _iterator30 = _createForOfIteratorHelper(instances$1),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var instance = _step30.value;
          callUpdate(instance, "computed");
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    });
    observer.observe(document, {
      subtree: true,
      childList: true
    });
  }
  function initEvents(instance) {
    instance._events = [];
    var _iterator31 = _createForOfIteratorHelper(instance.$options.events || []),
      _step31;
    try {
      for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
        var event = _step31.value;
        if (hasOwn(event, "handler")) {
          registerEvent(instance, event);
        } else {
          for (var key in event) {
            registerEvent(instance, event[key], key);
          }
        }
      }
    } catch (err) {
      _iterator31.e(err);
    } finally {
      _iterator31.f();
    }
  }
  function unbindEvents(instance) {
    instance._events.forEach(function (unbind) {
      return unbind();
    });
    delete instance._events;
  }
  function registerEvent(instance, event, key) {
    var _ref44 = isPlainObject(event) ? event : {
        name: key,
        handler: event
      },
      name = _ref44.name,
      el = _ref44.el,
      handler = _ref44.handler,
      capture = _ref44.capture,
      passive = _ref44.passive,
      delegate = _ref44.delegate,
      filter = _ref44.filter,
      self = _ref44.self;
    el = isFunction(el) ? el.call(instance, instance) : el || instance.$el;
    if (!el || isArray(el) && !el.length || filter && !filter.call(instance)) {
      return;
    }
    instance._events.push(on(el, name, delegate ? isString(delegate) ? delegate : delegate.call(instance, instance) : null, isString(handler) ? instance[handler] : handler.bind(instance), {
      passive: passive,
      capture: capture,
      self: self
    }));
  }
  function initObservers(instance) {
    instance._observers = [];
    var _iterator32 = _createForOfIteratorHelper(instance.$options.observe || []),
      _step32;
    try {
      for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
        var _observer = _step32.value;
        if (hasOwn(_observer, "handler")) {
          registerObservable(instance, _observer);
        } else {
          var _iterator33 = _createForOfIteratorHelper(_observer),
            _step33;
          try {
            for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
              var observable = _step33.value;
              registerObservable(instance, observable);
            }
          } catch (err) {
            _iterator33.e(err);
          } finally {
            _iterator33.f();
          }
        }
      }
    } catch (err) {
      _iterator32.e(err);
    } finally {
      _iterator32.f();
    }
  }
  function registerObserver(instance) {
    var _instance$_observers;
    for (var _len12 = arguments.length, observer = new Array(_len12 > 1 ? _len12 - 1 : 0), _key13 = 1; _key13 < _len12; _key13++) {
      observer[_key13 - 1] = arguments[_key13];
    }
    (_instance$_observers = instance._observers).push.apply(_instance$_observers, observer);
  }
  function disconnectObservers(instance) {
    var _iterator34 = _createForOfIteratorHelper(instance._observers),
      _step34;
    try {
      for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
        var _observer2 = _step34.value;
        _observer2.disconnect();
      }
    } catch (err) {
      _iterator34.e(err);
    } finally {
      _iterator34.f();
    }
  }
  function registerObservable(instance, observable) {
    var observe = observable.observe,
      _observable$target = observable.target,
      target = _observable$target === void 0 ? instance.$el : _observable$target,
      handler = observable.handler,
      options = observable.options,
      filter = observable.filter,
      args = observable.args;
    if (filter && !filter.call(instance, instance)) {
      return;
    }
    var key = "_observe".concat(instance._observers.length);
    if (isFunction(target) && !hasOwn(instance, key)) {
      registerComputed(instance, key, function () {
        return target.call(instance, instance);
      });
    }
    handler = isString(handler) ? instance[handler] : handler.bind(instance);
    if (isFunction(options)) {
      options = options.call(instance, instance);
    }
    var targets = hasOwn(instance, key) ? instance[key] : target;
    var observer = observe(targets, handler, options, args);
    if (isFunction(target) && isArray(instance[key]) && observer.unobserve) {
      registerWatch(instance, {
        handler: updateTargets(observer),
        immediate: false
      }, key);
    }
    registerObserver(instance, observer);
  }
  function updateTargets(observer) {
    return function (targets, prev) {
      var _iterator35 = _createForOfIteratorHelper(prev),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var target = _step35.value;
          !includes(targets, target) && observer.unobserve(target);
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      var _iterator36 = _createForOfIteratorHelper(targets),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var _target = _step36.value;
          !includes(prev, _target) && observer.observe(_target);
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
    };
  }
  function initProps(instance) {
    var $options = instance.$options,
      $props = instance.$props;
    var props = getProps($options);
    assign($props, props);
    var computed = $options.computed,
      methods = $options.methods;
    for (var key in $props) {
      if (key in props && (!computed || !hasOwn(computed, key)) && (!methods || !hasOwn(methods, key))) {
        instance[key] = $props[key];
      }
    }
  }
  function getProps(opts) {
    var data$1 = {};
    var _opts$args = opts.args,
      args = _opts$args === void 0 ? [] : _opts$args,
      _opts$props = opts.props,
      props = _opts$props === void 0 ? {} : _opts$props,
      el = opts.el,
      id = opts.id;
    if (!props) {
      return data$1;
    }
    for (var key in props) {
      var prop = hyphenate(key);
      var value = data(el, prop);
      if (isUndefined(value)) {
        continue;
      }
      value = props[key] === Boolean && value === "" ? true : coerce$1(props[key], value);
      if (prop === "target" && startsWith(value, "_")) {
        continue;
      }
      data$1[key] = value;
    }
    var options = parseOptions(data(el, id), args);
    for (var _key14 in options) {
      var _prop3 = camelize(_key14);
      if (!isUndefined(props[_prop3])) {
        data$1[_prop3] = coerce$1(props[_prop3], options[_key14]);
      }
    }
    return data$1;
  }
  var getAttributes = memoize(function (id, props) {
    var attributes = Object.keys(props);
    var filter = attributes.concat(id).map(function (key) {
      return [hyphenate(key), "data-".concat(hyphenate(key))];
    }).flat();
    return {
      attributes: attributes,
      filter: filter
    };
  });
  function initPropsObserver(instance) {
    var $options = instance.$options,
      $props = instance.$props;
    var id = $options.id,
      props = $options.props,
      el = $options.el;
    if (!props) {
      return;
    }
    var _getAttributes = getAttributes(id, props),
      attributes = _getAttributes.attributes,
      filter = _getAttributes.filter;
    var observer = new MutationObserver(function (records) {
      var data = getProps($options);
      if (records.some(function (_ref45) {
        var attributeName = _ref45.attributeName;
        var prop = attributeName.replace("data-", "");
        return (prop === id ? attributes : [camelize(prop), camelize(attributeName)]).some(function (prop2) {
          return !isUndefined(data[prop2]) && data[prop2] !== $props[prop2];
        });
      })) {
        instance.$reset();
      }
    });
    observer.observe(el, {
      attributes: true,
      attributeFilter: filter
    });
    registerObserver(instance, observer);
  }
  function callHook(instance, hook) {
    var _a;
    (_a = instance.$options[hook]) == null ? void 0 : _a.forEach(function (handler) {
      return handler.call(instance);
    });
  }
  function callConnected(instance) {
    if (instance._connected) {
      return;
    }
    initProps(instance);
    callHook(instance, "beforeConnect");
    instance._connected = true;
    initEvents(instance);
    initUpdates(instance);
    initWatches(instance);
    initObservers(instance);
    initPropsObserver(instance);
    initComputedUpdates(instance);
    callHook(instance, "connected");
    callUpdate(instance);
  }
  function callDisconnected(instance) {
    if (!instance._connected) {
      return;
    }
    callHook(instance, "beforeDisconnect");
    unbindEvents(instance);
    clearUpdateData(instance);
    disconnectObservers(instance);
    disconnectComputedUpdates(instance);
    callHook(instance, "disconnected");
    instance._connected = false;
  }
  var uid = 0;
  function init$1(instance) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options.data = normalizeData(options, instance.constructor.options);
    instance.$options = mergeOptions(instance.constructor.options, options, instance);
    instance.$props = {};
    instance._uid = uid++;
    initData(instance);
    initMethods(instance);
    initComputed(instance);
    callHook(instance, "created");
    if (options.el) {
      instance.$mount(options.el);
    }
  }
  function initData(instance) {
    var _instance$$options$da = instance.$options.data,
      data = _instance$$options$da === void 0 ? {} : _instance$$options$da;
    for (var key in data) {
      instance.$props[key] = instance[key] = data[key];
    }
  }
  function initMethods(instance) {
    var methods = instance.$options.methods;
    if (methods) {
      for (var key in methods) {
        instance[key] = methods[key].bind(instance);
      }
    }
  }
  function normalizeData(_ref46, _ref47) {
    var _ref46$data = _ref46.data,
      data = _ref46$data === void 0 ? {} : _ref46$data;
    var _ref47$args = _ref47.args,
      args = _ref47$args === void 0 ? [] : _ref47$args,
      _ref47$props = _ref47.props,
      props = _ref47$props === void 0 ? {} : _ref47$props;
    if (isArray(data)) {
      data = data.slice(0, args.length).reduce(function (data2, value, index) {
        if (isPlainObject(value)) {
          assign(data2, value);
        } else {
          data2[args[index]] = value;
        }
        return data2;
      }, {});
    }
    for (var key in data) {
      if (isUndefined(data[key])) {
        delete data[key];
      } else if (props[key]) {
        data[key] = coerce$1(props[key], data[key]);
      }
    }
    return data;
  }
  var App = function App(options) {
    init$1(this, options);
  };
  App.util = util;
  App.options = {};
  App.version = "3.19.4";
  var PREFIX = "uk-";
  var DATA = "__uikit__";
  var components$2 = {};
  function component(name, options) {
    var _a;
    var id = PREFIX + hyphenate(name);
    if (!options) {
      if (isPlainObject(components$2[id])) {
        components$2[id] = App.extend(components$2[id]);
      }
      return components$2[id];
    }
    name = camelize(name);
    App[name] = function (element, data) {
      return createComponent(name, element, data);
    };
    var opt = isPlainObject(options) ? _objectSpread({}, options) : options.options;
    opt.id = id;
    opt.name = name;
    (_a = opt.install) == null ? void 0 : _a.call(opt, App, opt, name);
    if (App._initialized && !opt.functional) {
      requestAnimationFrame(function () {
        return createComponent(name, "[".concat(id, "],[data-").concat(id, "]"));
      });
    }
    return components$2[id] = opt;
  }
  function createComponent(name, element, data) {
    var Component = component(name);
    for (var _len13 = arguments.length, args = new Array(_len13 > 3 ? _len13 - 3 : 0), _key15 = 3; _key15 < _len13; _key15++) {
      args[_key15 - 3] = arguments[_key15];
    }
    return Component.options.functional ? new Component({
      data: isPlainObject(element) ? element : [element, data].concat(args)
    }) : element ? $$(element).map(init)[0] : init();
    function init(element2) {
      var instance = getComponent(element2, name);
      if (instance) {
        if (data) {
          instance.$destroy();
        } else {
          return instance;
        }
      }
      return new Component({
        el: element2,
        data: data
      });
    }
  }
  function getComponents(element) {
    return (element == null ? void 0 : element[DATA]) || {};
  }
  function getComponent(element, name) {
    return getComponents(element)[name];
  }
  function attachToElement(element, instance) {
    if (!element[DATA]) {
      element[DATA] = {};
    }
    element[DATA][instance.$options.name] = instance;
  }
  function detachFromElement(element, instance) {
    var _a;
    (_a = element[DATA]) == null ? true : delete _a[instance.$options.name];
    if (!isEmpty(element[DATA])) {
      delete element[DATA];
    }
  }
  function globalApi(App) {
    App.component = component;
    App.getComponents = getComponents;
    App.getComponent = getComponent;
    App.update = update;
    App.use = function (plugin) {
      if (plugin.installed) {
        return;
      }
      plugin.call(null, this);
      plugin.installed = true;
      return this;
    };
    App.mixin = function (mixin, component2) {
      component2 = (isString(component2) ? this.component(component2) : component2) || this;
      component2.options = mergeOptions(component2.options, mixin);
    };
    App.extend = function (options) {
      options || (options = {});
      var Super = this;
      var Sub = function UIkitComponent(options2) {
        init$1(this, options2);
      };
      Sub.prototype = Object.create(Super.prototype);
      Sub.prototype.constructor = Sub;
      Sub.options = mergeOptions(Super.options, options);
      Sub["super"] = Super;
      Sub.extend = Super.extend;
      return Sub;
    };
    var container;
    Object.defineProperty(App, "container", {
      get: function get() {
        return container || document.body;
      },
      set: function set(element) {
        container = $(element);
      }
    });
  }
  function update(element, e) {
    element = element ? toNode(element) : document.body;
    var _iterator37 = _createForOfIteratorHelper(parents(element).reverse()),
      _step37;
    try {
      for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
        var parentEl = _step37.value;
        updateElement(parentEl, e);
      }
    } catch (err) {
      _iterator37.e(err);
    } finally {
      _iterator37.f();
    }
    apply(element, function (element2) {
      return updateElement(element2, e);
    });
  }
  function updateElement(element, e) {
    var components = getComponents(element);
    for (var name in components) {
      callUpdate(components[name], e);
    }
  }
  function instanceApi(App) {
    App.prototype.$mount = function (el) {
      var instance = this;
      attachToElement(el, instance);
      instance.$options.el = el;
      if (document.contains(el)) {
        callConnected(instance);
      }
    };
    App.prototype.$destroy = function () {
      var removeEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var instance = this;
      var el = instance.$options.el;
      if (el) {
        callDisconnected(instance);
      }
      callHook(instance, "destroy");
      detachFromElement(el, instance);
      if (removeEl) {
        remove$1(instance.$el);
      }
    };
    App.prototype.$create = createComponent;
    App.prototype.$emit = function (e) {
      callUpdate(this, e);
    };
    App.prototype.$update = function () {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$el;
      var e = arguments.length > 1 ? arguments[1] : undefined;
      update(element, e);
    };
    App.prototype.$reset = function () {
      callDisconnected(this);
      callConnected(this);
    };
    App.prototype.$getComponent = getComponent;
    Object.defineProperties(App.prototype, {
      $el: {
        get: function get() {
          return this.$options.el;
        }
      },
      $container: Object.getOwnPropertyDescriptor(App, "container")
    });
  }
  var id = 1;
  function generateId(instance) {
    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return (el == null ? void 0 : el.id) || "".concat(instance.$options.id, "-").concat(id++);
  }
  var SliderNav = {
    i18n: {
      next: "Next slide",
      previous: "Previous slide",
      slideX: "Slide %s",
      slideLabel: "%s of %s",
      role: "String"
    },
    data: {
      selNav: false,
      role: "region"
    },
    computed: {
      nav: function nav(_ref48, $el) {
        var selNav = _ref48.selNav;
        return $(selNav, $el);
      },
      navChildren: function navChildren() {
        return _children(this.nav);
      },
      selNavItem: function selNavItem(_ref49) {
        var attrItem = _ref49.attrItem;
        return "[".concat(attrItem, "],[data-").concat(attrItem, "]");
      },
      navItems: function navItems(_, $el) {
        return $$(this.selNavItem, $el);
      }
    },
    watch: {
      nav: function nav(_nav, prev) {
        attr(_nav, "role", "tablist");
        if (prev) {
          this.$emit();
        }
      },
      list: function list(_list) {
        if (isTag(_list, "ul")) {
          attr(_list, "role", "presentation");
        }
      },
      navChildren: function navChildren(children2) {
        attr(children2, "role", "presentation");
      },
      navItems: function navItems(items) {
        var _iterator38 = _createForOfIteratorHelper(items),
          _step38;
        try {
          for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
            var el = _step38.value;
            var cmd = data(el, this.attrItem);
            var button = $("a,button", el) || el;
            var ariaLabel = void 0;
            var ariaControls = null;
            if (isNumeric(cmd)) {
              var item = toNumber(cmd);
              var _slide2 = this.slides[item];
              if (_slide2) {
                if (!_slide2.id) {
                  _slide2.id = generateId(this, _slide2);
                }
                ariaControls = _slide2.id;
              }
              ariaLabel = this.t("slideX", toFloat(cmd) + 1);
              attr(button, "role", "tab");
            } else {
              if (this.list) {
                if (!this.list.id) {
                  this.list.id = generateId(this, this.list);
                }
                ariaControls = this.list.id;
              }
              ariaLabel = this.t(cmd);
            }
            attr(button, {
              "aria-controls": ariaControls,
              "aria-label": attr(button, "aria-label") || ariaLabel
            });
          }
        } catch (err) {
          _iterator38.e(err);
        } finally {
          _iterator38.f();
        }
      },
      slides: function slides(_slides) {
        var _this15 = this;
        _slides.forEach(function (slide, i) {
          return attr(slide, {
            role: _this15.nav ? "tabpanel" : "group",
            "aria-label": _this15.t("slideLabel", i + 1, _this15.length),
            "aria-roledescription": _this15.nav ? null : "slide"
          });
        });
      },
      length: function length(_length) {
        var navLength = this.navChildren.length;
        if (this.nav && _length !== navLength) {
          empty(this.nav);
          for (var i = 0; i < _length; i++) {
            append(this.nav, "<li ".concat(this.attrItem, "=\"").concat(i, "\"><a href></a></li>"));
          }
        }
      }
    },
    connected: function connected() {
      attr(this.$el, {
        role: this.role,
        "aria-roledescription": "carousel"
      });
    },
    update: [{
      write: function write() {
        var _this16 = this;
        this.navItems.concat(this.nav).forEach(function (el) {
          return el && (el.hidden = !_this16.maxIndex);
        });
        this.updateNav();
      },
      events: ["resize"]
    }],
    events: [{
      name: "click keydown",
      delegate: function delegate() {
        return this.selNavItem;
      },
      filter: function filter() {
        return !this.parallax;
      },
      handler: function handler(e) {
        if (e.target.closest("a,button") && (e.type === "click" || e.keyCode === keyMap.SPACE)) {
          e.preventDefault();
          this.show(data(e.current, this.attrItem));
        }
      }
    }, {
      name: "itemshow",
      handler: "updateNav"
    }, {
      name: "keydown",
      delegate: function delegate() {
        return this.selNavItem;
      },
      filter: function filter() {
        return !this.parallax;
      },
      handler: function handler(e) {
        var current = e.current,
          keyCode = e.keyCode;
        var cmd = data(current, this.attrItem);
        if (!isNumeric(cmd)) {
          return;
        }
        var i = keyCode === keyMap.HOME ? 0 : keyCode === keyMap.END ? "last" : keyCode === keyMap.LEFT ? "previous" : keyCode === keyMap.RIGHT ? "next" : -1;
        if (~i) {
          e.preventDefault();
          this.show(i);
        }
      }
    }],
    methods: {
      updateNav: function updateNav() {
        var index = this.getValidIndex();
        var _iterator39 = _createForOfIteratorHelper(this.navItems),
          _step39;
        try {
          for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
            var el = _step39.value;
            var cmd = data(el, this.attrItem);
            var button = $("a,button", el) || el;
            if (isNumeric(cmd)) {
              var item = toNumber(cmd);
              var _active = item === index;
              toggleClass(el, this.clsActive, _active);
              toggleClass(button, "uk-disabled", this.parallax);
              attr(button, {
                "aria-selected": _active,
                tabindex: _active && !this.parallax ? null : -1
              });
              if (_active && button && matches(parent(el), ":focus-within")) {
                button.focus();
              }
            } else {
              toggleClass(el, "uk-invisible", this.finite && (cmd === "previous" && index === 0 || cmd === "next" && index >= this.maxIndex));
            }
          }
        } catch (err) {
          _iterator39.e(err);
        } finally {
          _iterator39.f();
        }
      }
    }
  };
  var Slider = {
    mixins: [SliderAutoplay, SliderDrag, SliderNav, I18n],
    props: {
      clsActivated: String,
      easing: String,
      index: Number,
      finite: Boolean,
      velocity: Number
    },
    data: function data() {
      return {
        easing: "ease",
        finite: false,
        velocity: 1,
        index: 0,
        prevIndex: -1,
        stack: [],
        percent: 0,
        clsActive: "uk-active",
        clsActivated: "",
        clsEnter: "uk-slide-enter",
        clsLeave: "uk-slide-leave",
        clsSlideActive: "uk-slide-active",
        Transitioner: false,
        transitionOptions: {}
      };
    },
    connected: function connected() {
      this.prevIndex = -1;
      this.index = this.getValidIndex(this.$props.index);
      this.stack = [];
    },
    disconnected: function disconnected() {
      removeClass(this.slides, this.clsActive);
    },
    computed: {
      duration: function duration(_ref50, $el) {
        var velocity = _ref50.velocity;
        return speedUp($el.offsetWidth / velocity);
      },
      list: function list(_ref51, $el) {
        var selList = _ref51.selList;
        return $(selList, $el);
      },
      maxIndex: function maxIndex() {
        return this.length - 1;
      },
      slides: function slides() {
        return _children(this.list);
      },
      length: function length() {
        return this.slides.length;
      }
    },
    watch: {
      slides: function slides(_slides2, prev) {
        if (prev) {
          this.$emit();
        }
      }
    },
    observe: resize(),
    events: {
      itemshow: function itemshow(_ref52) {
        var target = _ref52.target;
        addClass(target, this.clsEnter, this.clsSlideActive);
      },
      itemshown: function itemshown(_ref53) {
        var target = _ref53.target;
        removeClass(target, this.clsEnter);
      },
      itemhide: function itemhide(_ref54) {
        var target = _ref54.target;
        addClass(target, this.clsLeave);
      },
      itemhidden: function itemhidden(_ref55) {
        var target = _ref55.target;
        removeClass(target, this.clsLeave, this.clsSlideActive);
      }
    },
    methods: {
      show: function show(index) {
        var _this17 = this;
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _a;
        if (this.dragging || !this.length || this.parallax) {
          return;
        }
        var stack = this.stack;
        var queueIndex = force ? 0 : stack.length;
        var reset = function reset() {
          stack.splice(queueIndex, 1);
          if (stack.length) {
            _this17.show(stack.shift(), true);
          }
        };
        stack[force ? "unshift" : "push"](index);
        if (!force && stack.length > 1) {
          if (stack.length === 2) {
            (_a = this._transitioner) == null ? void 0 : _a.forward(Math.min(this.duration, 200));
          }
          return;
        }
        var prevIndex = this.getIndex(this.index);
        var prev = hasClass(this.slides, this.clsActive) && this.slides[prevIndex];
        var nextIndex = this.getIndex(index, this.index);
        var next = this.slides[nextIndex];
        if (prev === next) {
          reset();
          return;
        }
        this.dir = getDirection(index, prevIndex);
        this.prevIndex = prevIndex;
        this.index = nextIndex;
        if (prev && !trigger(prev, "beforeitemhide", [this]) || !trigger(next, "beforeitemshow", [this, prev])) {
          this.index = this.prevIndex;
          reset();
          return;
        }
        var promise = this._show(prev, next, force).then(function () {
          prev && trigger(prev, "itemhidden", [_this17]);
          trigger(next, "itemshown", [_this17]);
          stack.shift();
          _this17._transitioner = null;
          requestAnimationFrame(function () {
            return stack.length && _this17.show(stack.shift(), true);
          });
        });
        prev && trigger(prev, "itemhide", [this]);
        trigger(next, "itemshow", [this]);
        return promise;
      },
      getIndex: function getIndex() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
        var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.index;
        return clamp(_getIndex(index, this.slides, prev, this.finite), 0, Math.max(0, this.maxIndex));
      },
      getValidIndex: function getValidIndex() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
        var prevIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.prevIndex;
        return this.getIndex(index, prevIndex);
      },
      _show: function _show(prev, next, force) {
        this._transitioner = this._getTransitioner(prev, next, this.dir, _objectSpread({
          easing: force ? next.offsetWidth < 600 ? "cubic-bezier(0.25, 0.46, 0.45, 0.94)" : "cubic-bezier(0.165, 0.84, 0.44, 1)" : this.easing
        }, this.transitionOptions));
        if (!force && !prev) {
          this._translate(1);
          return Promise.resolve();
        }
        var length = this.stack.length;
        return this._transitioner[length > 1 ? "forward" : "show"](length > 1 ? Math.min(this.duration, 75 + 75 / (length - 1)) : this.duration, this.percent);
      },
      _translate: function _translate(percent) {
        var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.prevIndex;
        var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.index;
        var transitioner = this._getTransitioner(prev === next ? false : prev, next);
        transitioner.translate(percent);
        return transitioner;
      },
      _getTransitioner: function _getTransitioner() {
        var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.prevIndex;
        var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.index;
        var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.dir || 1;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.transitionOptions;
        return new this.Transitioner(isNumber(prev) ? this.slides[prev] : prev, isNumber(next) ? this.slides[next] : next, dir * (isRtl ? -1 : 1), options);
      }
    }
  };
  function getDirection(index, prevIndex) {
    return index === "next" ? 1 : index === "previous" ? -1 : index < prevIndex ? -1 : 1;
  }
  function speedUp(x) {
    return 0.5 * x + 300;
  }
  var Slideshow = {
    mixins: [Slider],
    props: {
      animation: String
    },
    data: {
      animation: "slide",
      clsActivated: "uk-transition-active",
      Animations: Animations$2,
      Transitioner: Transitioner$1
    },
    computed: {
      animation: function animation(_ref56) {
        var animation = _ref56.animation,
          Animations2 = _ref56.Animations;
        return _objectSpread(_objectSpread({}, Animations2[animation] || Animations2.slide), {}, {
          name: animation
        });
      },
      transitionOptions: function transitionOptions() {
        return {
          animation: this.animation
        };
      }
    },
    events: {
      beforeitemshow: function beforeitemshow(_ref57) {
        var target = _ref57.target;
        addClass(target, this.clsActive);
      },
      itemshown: function itemshown(_ref58) {
        var target = _ref58.target;
        addClass(target, this.clsActivated);
      },
      itemhidden: function itemhidden(_ref59) {
        var target = _ref59.target;
        removeClass(target, this.clsActive, this.clsActivated);
      }
    }
  };
  var Animations$1 = _objectSpread(_objectSpread({}, Animations$2), {}, {
    fade: {
      show: function show() {
        return [{
          opacity: 0
        }, {
          opacity: 1
        }];
      },
      percent: function percent(current) {
        return 1 - css(current, "opacity");
      },
      translate: function translate(percent) {
        return [{
          opacity: 1 - percent
        }, {
          opacity: percent
        }];
      }
    },
    scale: {
      show: function show() {
        return [{
          opacity: 0,
          transform: scale3d(1 - 0.2)
        }, {
          opacity: 1,
          transform: scale3d(1)
        }];
      },
      percent: function percent(current) {
        return 1 - css(current, "opacity");
      },
      translate: function translate(percent) {
        return [{
          opacity: 1 - percent,
          transform: scale3d(1 - 0.2 * percent)
        }, {
          opacity: percent,
          transform: scale3d(1 - 0.2 + 0.2 * percent)
        }];
      }
    }
  });
  var LightboxPanel = {
    mixins: [Modal, Slideshow],
    functional: true,
    props: {
      delayControls: Number,
      preload: Number,
      videoAutoplay: Boolean,
      template: String
    },
    data: function data() {
      return {
        preload: 1,
        videoAutoplay: false,
        delayControls: 3e3,
        items: [],
        cls: "uk-open",
        clsPage: "uk-lightbox-page",
        selList: ".uk-lightbox-items",
        attrItem: "uk-lightbox-item",
        selClose: ".uk-close-large",
        selCaption: ".uk-lightbox-caption",
        pauseOnHover: false,
        velocity: 2,
        Animations: Animations$1,
        template: "<div class=\"uk-lightbox uk-overflow-hidden\"> <ul class=\"uk-lightbox-items\"></ul> <div class=\"uk-lightbox-toolbar uk-position-top uk-text-right uk-transition-slide-top uk-transition-opaque\"> <button class=\"uk-lightbox-toolbar-icon uk-close-large\" type=\"button\" uk-close></button> </div> <a class=\"uk-lightbox-button uk-position-center-left uk-position-medium uk-transition-fade\" href uk-slidenav-previous uk-lightbox-item=\"previous\"></a> <a class=\"uk-lightbox-button uk-position-center-right uk-position-medium uk-transition-fade\" href uk-slidenav-next uk-lightbox-item=\"next\"></a> <div class=\"uk-lightbox-toolbar uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque\"></div> </div>"
      };
    },
    created: function created() {
      var $el = $(this.template);
      var list = $(this.selList, $el);
      this.items.forEach(function () {
        return append(list, "<li>");
      });
      var close = $("[uk-close]", $el);
      var closeLabel = this.t("close");
      if (close && closeLabel) {
        close.dataset.i18n = JSON.stringify({
          label: closeLabel
        });
      }
      this.$mount(append(this.container, $el));
    },
    computed: {
      caption: function caption(_ref60, $el) {
        var selCaption = _ref60.selCaption;
        return $(selCaption, $el);
      }
    },
    events: [{
      name: "".concat(pointerMove$1, " ").concat(pointerDown$1, " keydown"),
      handler: "showControls"
    }, {
      name: "click",
      self: true,
      delegate: function delegate() {
        return "".concat(this.selList, " > *");
      },
      handler: function handler(e) {
        if (!e.defaultPrevented) {
          this.hide();
        }
      }
    }, {
      name: "shown",
      self: true,
      handler: "showControls"
    }, {
      name: "hide",
      self: true,
      handler: function handler() {
        this.hideControls();
        removeClass(this.slides, this.clsActive);
        Transition.stop(this.slides);
      }
    }, {
      name: "hidden",
      self: true,
      handler: function handler() {
        this.$destroy(true);
      }
    }, {
      name: "keyup",
      el: function el() {
        return document;
      },
      handler: function handler(_ref61) {
        var keyCode = _ref61.keyCode;
        if (!this.isToggled(this.$el) || !this.draggable) {
          return;
        }
        var i = -1;
        if (keyCode === keyMap.LEFT) {
          i = "previous";
        } else if (keyCode === keyMap.RIGHT) {
          i = "next";
        } else if (keyCode === keyMap.HOME) {
          i = 0;
        } else if (keyCode === keyMap.END) {
          i = "last";
        }
        if (~i) {
          this.show(i);
        }
      }
    }, {
      name: "beforeitemshow",
      handler: function handler(e) {
        if (this.isToggled()) {
          return;
        }
        this.draggable = false;
        e.preventDefault();
        this.toggleElement(this.$el, true, false);
        this.animation = Animations$1["scale"];
        removeClass(e.target, this.clsActive);
        this.stack.splice(1, 0, this.index);
      }
    }, {
      name: "itemshow",
      handler: function handler() {
        html(this.caption, this.getItem().caption || "");
        for (var j = -this.preload; j <= this.preload; j++) {
          this.loadItem(this.index + j);
        }
      }
    }, {
      name: "itemshown",
      handler: function handler() {
        this.draggable = this.$props.draggable;
      }
    }, {
      name: "itemload",
      handler: function handler(_, item) {
        var _this18 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
          var src, type, _item$alt, alt, poster, _item$attrs, attrs, matches, iframeAttrs, _img, video, _yield$yield$fetch$js, _height2, _width2;
          return _regenerator["default"].wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                src = item.source, type = item.type, _item$alt = item.alt, alt = _item$alt === void 0 ? "" : _item$alt, poster = item.poster, _item$attrs = item.attrs, attrs = _item$attrs === void 0 ? {} : _item$attrs;
                _this18.setItem(item, "<span uk-spinner></span>");
                if (src) {
                  _context9.next = 4;
                  break;
                }
                return _context9.abrupt("return");
              case 4:
                iframeAttrs = {
                  allowfullscreen: "",
                  style: "max-width: 100%; box-sizing: border-box;",
                  "uk-responsive": "",
                  "uk-video": "".concat(_this18.videoAutoplay)
                };
                if (!(type === "image" || src.match(/\.(avif|jpe?g|jfif|a?png|gif|svg|webp)($|\?)/i))) {
                  _context9.next = 11;
                  break;
                }
                _img = createEl("img", _objectSpread({
                  src: src,
                  alt: alt
                }, attrs));
                on(_img, "load", function () {
                  return _this18.setItem(item, _img);
                });
                on(_img, "error", function () {
                  return _this18.setError(item);
                });
                _context9.next = 40;
                break;
              case 11:
                if (!(type === "video" || src.match(/\.(mp4|webm|ogv)($|\?)/i))) {
                  _context9.next = 17;
                  break;
                }
                video = createEl("video", _objectSpread({
                  src: src,
                  poster: poster,
                  controls: "",
                  playsinline: "",
                  "uk-video": "".concat(_this18.videoAutoplay)
                }, attrs));
                on(video, "loadedmetadata", function () {
                  return _this18.setItem(item, video);
                });
                on(video, "error", function () {
                  return _this18.setError(item);
                });
                _context9.next = 40;
                break;
              case 17:
                if (!(type === "iframe" || src.match(/\.(html|php)($|\?)/i))) {
                  _context9.next = 21;
                  break;
                }
                _this18.setItem(item, createEl("iframe", _objectSpread({
                  src: src,
                  allowfullscreen: "",
                  "class": "uk-lightbox-iframe"
                }, attrs)));
                _context9.next = 40;
                break;
              case 21:
                if (!(matches = src.match(/\/\/(?:.*?youtube(-nocookie)?\..*?(?:[?&]v=|\/shorts\/)|youtu\.be\/)([\w-]{11})[&?]?(.*)?/))) {
                  _context9.next = 25;
                  break;
                }
                _this18.setItem(item, createEl("iframe", _objectSpread(_objectSpread({
                  src: "https://www.youtube".concat(matches[1] || "", ".com/embed/").concat(matches[2]).concat(matches[3] ? "?".concat(matches[3]) : ""),
                  width: 1920,
                  height: 1080
                }, iframeAttrs), attrs)));
                _context9.next = 40;
                break;
              case 25:
                if (!(matches = src.match(/\/\/.*?vimeo\.[a-z]+\/(\d+)[&?]?(.*)?/))) {
                  _context9.next = 40;
                  break;
                }
                _context9.prev = 26;
                _context9.next = 29;
                return fetch("https://vimeo.com/api/oembed.json?maxwidth=1920&url=".concat(encodeURI(src)), {
                  credentials: "omit"
                });
              case 29:
                _context9.next = 31;
                return _context9.sent.json();
              case 31:
                _yield$yield$fetch$js = _context9.sent;
                _height2 = _yield$yield$fetch$js.height;
                _width2 = _yield$yield$fetch$js.width;
                _this18.setItem(item, createEl("iframe", _objectSpread(_objectSpread({
                  src: "https://player.vimeo.com/video/".concat(matches[1]).concat(matches[2] ? "?".concat(matches[2]) : ""),
                  width: _width2,
                  height: _height2
                }, iframeAttrs), attrs)));
                _context9.next = 40;
                break;
              case 37:
                _context9.prev = 37;
                _context9.t0 = _context9["catch"](26);
                _this18.setError(item);
              case 40:
              case "end":
                return _context9.stop();
            }
          }, _callee9, null, [[26, 37]]);
        }))();
      }
    }],
    methods: {
      loadItem: function loadItem() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
        var item = this.getItem(index);
        if (!this.getSlide(item).childElementCount) {
          trigger(this.$el, "itemload", [item]);
        }
      },
      getItem: function getItem() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
        return this.items[_getIndex(index, this.slides)];
      },
      setItem: function setItem(item, content) {
        trigger(this.$el, "itemloaded", [this, html(this.getSlide(item), content)]);
      },
      getSlide: function getSlide(item) {
        return this.slides[this.items.indexOf(item)];
      },
      setError: function setError(item) {
        this.setItem(item, '<span uk-icon="icon: bolt; ratio: 2"></span>');
      },
      showControls: function showControls() {
        clearTimeout(this.controlsTimer);
        this.controlsTimer = setTimeout(this.hideControls, this.delayControls);
        addClass(this.$el, "uk-active", "uk-transition-active");
      },
      hideControls: function hideControls() {
        removeClass(this.$el, "uk-active", "uk-transition-active");
      }
    }
  };
  function createEl(tag, attrs) {
    var el = fragment("<".concat(tag, ">"));
    attr(el, attrs);
    return el;
  }
  var lightbox = {
    install: install$3,
    props: {
      toggle: String
    },
    data: {
      toggle: "a"
    },
    computed: {
      toggles: function toggles(_ref62, $el) {
        var toggle = _ref62.toggle;
        return $$(toggle, $el);
      }
    },
    watch: {
      toggles: function toggles(_toggles2) {
        this.hide();
        var _iterator40 = _createForOfIteratorHelper(_toggles2),
          _step40;
        try {
          for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
            var _toggle4 = _step40.value;
            if (isTag(_toggle4, "a")) {
              attr(_toggle4, "role", "button");
            }
          }
        } catch (err) {
          _iterator40.e(err);
        } finally {
          _iterator40.f();
        }
      }
    },
    disconnected: function disconnected() {
      this.hide();
    },
    events: {
      name: "click",
      delegate: function delegate() {
        return "".concat(this.toggle, ":not(.uk-disabled)");
      },
      handler: function handler(e) {
        e.preventDefault();
        this.show(e.current);
      }
    },
    methods: {
      show: function show(index) {
        var _this19 = this;
        var items = uniqueBy(this.toggles.map(toItem), "source");
        if (isElement(index)) {
          var _toItem = toItem(index),
            source = _toItem.source;
          index = findIndex(items, function (_ref63) {
            var src = _ref63.source;
            return source === src;
          });
        }
        this.panel = this.panel || this.$create("lightboxPanel", _objectSpread(_objectSpread({}, this.$props), {}, {
          items: items
        }));
        on(this.panel.$el, "hidden", function () {
          return _this19.panel = null;
        });
        return this.panel.show(index);
      },
      hide: function hide() {
        var _a;
        return (_a = this.panel) == null ? void 0 : _a.hide();
      }
    }
  };
  function install$3(UIkit, Lightbox) {
    if (!UIkit.lightboxPanel) {
      UIkit.component("lightboxPanel", LightboxPanel);
    }
    assign(Lightbox.props, UIkit.component("lightboxPanel").options.props);
  }
  function toItem(el) {
    var item = {};
    for (var _i13 = 0, _arr8 = ["href", "caption", "type", "poster", "alt", "attrs"]; _i13 < _arr8.length; _i13++) {
      var attr2 = _arr8[_i13];
      item[attr2 === "href" ? "source" : attr2] = data(el, attr2);
    }
    item.attrs = parseOptions(item.attrs);
    return item;
  }
  var notification = {
    mixins: [Container],
    functional: true,
    args: ["message", "status"],
    data: {
      message: "",
      status: "",
      timeout: 5e3,
      group: "",
      pos: "top-center",
      clsContainer: "uk-notification",
      clsClose: "uk-notification-close",
      clsMsg: "uk-notification-message"
    },
    install: install$2,
    computed: {
      marginProp: function marginProp(_ref64) {
        var pos = _ref64.pos;
        return "margin-".concat(pos.match(/[a-z]+(?=-)/)[0]);
      },
      startProps: function startProps() {
        return (0, _defineProperty2["default"])({
          opacity: 0
        }, this.marginProp, -this.$el.offsetHeight);
      }
    },
    created: function created() {
      var posClass = "".concat(this.clsContainer, "-").concat(this.pos);
      var containerAttr = "data-".concat(this.clsContainer, "-container");
      var container = $(".".concat(posClass, "[").concat(containerAttr, "]"), this.container) || append(this.container, "<div class=\"".concat(this.clsContainer, " ").concat(posClass, "\" ").concat(containerAttr, "></div>"));
      this.$mount(append(container, "<div class=\"".concat(this.clsMsg).concat(this.status ? " ".concat(this.clsMsg, "-").concat(this.status) : "", "\" role=\"alert\"> <a href class=\"").concat(this.clsClose, "\" data-uk-close></a> <div>").concat(this.message, "</div> </div>")));
    },
    connected: function connected() {
      var _this20 = this;
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
        var margin;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              margin = toFloat(css(_this20.$el, _this20.marginProp));
              _context10.next = 3;
              return Transition.start(css(_this20.$el, _this20.startProps), (0, _defineProperty2["default"])({
                opacity: 1
              }, _this20.marginProp, margin));
            case 3:
              if (_this20.timeout) {
                _this20.timer = setTimeout(_this20.close, _this20.timeout);
              }
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    events: (_events = {
      click: function click(e) {
        if (e.target.closest('a[href="#"],a[href=""]')) {
          e.preventDefault();
        }
        this.close();
      }
    }, (0, _defineProperty2["default"])(_events, pointerEnter, function () {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }), (0, _defineProperty2["default"])(_events, pointerLeave, function () {
      if (this.timeout) {
        this.timer = setTimeout(this.close, this.timeout);
      }
    }), _events),
    methods: {
      close: function close(immediate) {
        var _this21 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
          var removeFn;
          return _regenerator["default"].wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                removeFn = function removeFn(el) {
                  var container = parent(el);
                  trigger(el, "close", [_this21]);
                  remove$1(el);
                  if (!(container == null ? void 0 : container.hasChildNodes())) {
                    remove$1(container);
                  }
                };
                if (_this21.timer) {
                  clearTimeout(_this21.timer);
                }
                if (immediate) {
                  _context11.next = 5;
                  break;
                }
                _context11.next = 5;
                return Transition.start(_this21.$el, _this21.startProps);
              case 5:
                removeFn(_this21.$el);
              case 6:
              case "end":
                return _context11.stop();
            }
          }, _callee11);
        }))();
      }
    }
  };
  function install$2(UIkit) {
    UIkit.notification.closeAll = function (group, immediate) {
      apply(document.body, function (el) {
        var notification = UIkit.getComponent(el, "notification");
        if (notification && (!group || group === notification.group)) {
          notification.close(immediate);
        }
      });
    };
  }
  var Media = {
    props: {
      media: Boolean
    },
    data: {
      media: false
    },
    connected: function connected() {
      var _this22 = this;
      var media = toMedia(this.media, this.$el);
      this.matchMedia = true;
      if (media) {
        this.mediaObj = window.matchMedia(media);
        var handler = function handler() {
          _this22.matchMedia = _this22.mediaObj.matches;
          trigger(_this22.$el, createEvent("mediachange", false, true, [_this22.mediaObj]));
        };
        this.offMediaObj = on(this.mediaObj, "change", function () {
          handler();
          _this22.$emit("resize");
        });
        handler();
      }
    },
    disconnected: function disconnected() {
      var _a;
      (_a = this.offMediaObj) == null ? void 0 : _a.call(this);
    }
  };
  function toMedia(value, element) {
    if (isString(value)) {
      if (startsWith(value, "@")) {
        value = toFloat(css(element, "--uk-breakpoint-".concat(value.substr(1))));
      } else if (isNaN(value)) {
        return value;
      }
    }
    return value && isNumeric(value) ? "(min-width: ".concat(value, "px)") : "";
  }
  function getMaxPathLength(el) {
    return Math.ceil(Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])($$("[stroke]", el).map(function (stroke) {
      try {
        return stroke.getTotalLength();
      } catch (e) {
        return 0;
      }
    })))));
  }
  var _props2 = {
    x: transformFn,
    y: transformFn,
    rotate: transformFn,
    scale: transformFn,
    color: colorFn,
    backgroundColor: colorFn,
    borderColor: colorFn,
    blur: filterFn,
    hue: filterFn,
    fopacity: filterFn,
    grayscale: filterFn,
    invert: filterFn,
    saturate: filterFn,
    sepia: filterFn,
    opacity: cssPropFn,
    stroke: strokeFn,
    bgx: backgroundFn,
    bgy: backgroundFn
  };
  var keys = Object.keys;
  var Parallax = {
    mixins: [Media],
    props: fillObject(keys(_props2), "list"),
    data: fillObject(keys(_props2), void 0),
    computed: {
      props: function props(properties, $el) {
        var stops = {};
        for (var prop in properties) {
          if (prop in _props2 && !isUndefined(properties[prop])) {
            stops[prop] = properties[prop].slice();
          }
        }
        var result = {};
        for (var _prop4 in stops) {
          result[_prop4] = _props2[_prop4](_prop4, $el, stops[_prop4], stops);
        }
        return result;
      }
    },
    events: {
      load: function load() {
        this.$emit();
      }
    },
    methods: {
      reset: function reset() {
        for (var prop in this.getCss(0)) {
          css(this.$el, prop, "");
        }
      },
      getCss: function getCss(percent) {
        var css2 = {};
        for (var prop in this.props) {
          this.props[prop](css2, clamp(percent));
        }
        css2.willChange = Object.keys(css2).map(propName).join(",");
        return css2;
      }
    }
  };
  function transformFn(prop, el, stops) {
    var unit = getUnit(stops) || {
      x: "px",
      y: "px",
      rotate: "deg"
    }[prop] || "";
    var transformFn2;
    if (prop === "x" || prop === "y") {
      prop = "translate".concat(ucfirst(prop));
      transformFn2 = function transformFn2(stop) {
        return toFloat(toFloat(stop).toFixed(unit === "px" ? 0 : 6));
      };
    } else if (prop === "scale") {
      unit = "";
      transformFn2 = function transformFn2(stop) {
        var _a;
        return getUnit([stop]) ? toPx(stop, "width", el, true) / el["offset".concat(((_a = stop.endsWith) == null ? void 0 : _a.call(stop, "vh")) ? "Height" : "Width")] : toFloat(stop);
      };
    }
    if (stops.length === 1) {
      stops.unshift(prop === "scale" ? 1 : 0);
    }
    stops = parseStops(stops, transformFn2);
    return function (css2, percent) {
      css2.transform = "".concat(css2.transform || "", " ").concat(prop, "(").concat(getValue(stops, percent)).concat(unit, ")");
    };
  }
  function colorFn(prop, el, stops) {
    if (stops.length === 1) {
      stops.unshift(getCssValue(el, prop, ""));
    }
    stops = parseStops(stops, function (stop) {
      return parseColor(el, stop);
    });
    return function (css2, percent) {
      var _getStop = getStop(stops, percent),
        _getStop2 = (0, _slicedToArray2["default"])(_getStop, 3),
        start = _getStop2[0],
        end = _getStop2[1],
        p = _getStop2[2];
      var value = start.map(function (value2, i) {
        value2 += p * (end[i] - value2);
        return i === 3 ? toFloat(value2) : parseInt(value2, 10);
      }).join(",");
      css2[prop] = "rgba(".concat(value, ")");
    };
  }
  function parseColor(el, color) {
    return getCssValue(el, "color", color).split(/[(),]/g).slice(1, -1).concat(1).slice(0, 4).map(toFloat);
  }
  function filterFn(prop, el, stops) {
    if (stops.length === 1) {
      stops.unshift(0);
    }
    var unit = getUnit(stops) || {
      blur: "px",
      hue: "deg"
    }[prop] || "%";
    prop = {
      fopacity: "opacity",
      hue: "hue-rotate"
    }[prop] || prop;
    stops = parseStops(stops);
    return function (css2, percent) {
      var value = getValue(stops, percent);
      css2.filter = "".concat(css2.filter || "", " ").concat(prop, "(").concat(value + unit, ")");
    };
  }
  function cssPropFn(prop, el, stops) {
    if (stops.length === 1) {
      stops.unshift(getCssValue(el, prop, ""));
    }
    stops = parseStops(stops);
    return function (css2, percent) {
      css2[prop] = getValue(stops, percent);
    };
  }
  function strokeFn(prop, el, stops) {
    if (stops.length === 1) {
      stops.unshift(0);
    }
    var unit = getUnit(stops);
    var length = getMaxPathLength(el);
    stops = parseStops(stops.reverse(), function (stop) {
      stop = toFloat(stop);
      return unit === "%" ? stop * length / 100 : stop;
    });
    if (!stops.some(function (_ref66) {
      var _ref67 = (0, _slicedToArray2["default"])(_ref66, 1),
        value = _ref67[0];
      return value;
    })) {
      return noop;
    }
    css(el, "strokeDasharray", length);
    return function (css2, percent) {
      css2.strokeDashoffset = getValue(stops, percent);
    };
  }
  function backgroundFn(prop, el, stops, props2) {
    if (stops.length === 1) {
      stops.unshift(0);
    }
    var attr = prop === "bgy" ? "height" : "width";
    props2[prop] = parseStops(stops, function (stop) {
      return toPx(stop, attr, el);
    });
    var bgProps = ["bgx", "bgy"].filter(function (prop2) {
      return prop2 in props2;
    });
    if (bgProps.length === 2 && prop === "bgx") {
      return noop;
    }
    if (getCssValue(el, "backgroundSize", "") === "cover") {
      return backgroundCoverFn(prop, el, stops, props2);
    }
    var positions = {};
    var _iterator41 = _createForOfIteratorHelper(bgProps),
      _step41;
    try {
      for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
        var prop2 = _step41.value;
        positions[prop2] = getBackgroundPos(el, prop2);
      }
    } catch (err) {
      _iterator41.e(err);
    } finally {
      _iterator41.f();
    }
    return setBackgroundPosFn(bgProps, positions, props2);
  }
  function backgroundCoverFn(prop, el, stops, props2) {
    var dimImage = getBackgroundImageDimensions(el);
    if (!dimImage.width) {
      return noop;
    }
    var dimEl = {
      width: el.offsetWidth,
      height: el.offsetHeight
    };
    var bgProps = ["bgx", "bgy"].filter(function (prop2) {
      return prop2 in props2;
    });
    var positions = {};
    var _iterator42 = _createForOfIteratorHelper(bgProps),
      _step42;
    try {
      for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
        var prop2 = _step42.value;
        var values = props2[prop2].map(function (_ref68) {
          var _ref69 = (0, _slicedToArray2["default"])(_ref68, 1),
            value = _ref69[0];
          return value;
        });
        var min = Math.min.apply(Math, (0, _toConsumableArray2["default"])(values));
        var max = Math.max.apply(Math, (0, _toConsumableArray2["default"])(values));
        var down = values.indexOf(min) < values.indexOf(max);
        var diff = max - min;
        positions[prop2] = "".concat((down ? -diff : 0) - (down ? min : max), "px");
        dimEl[prop2 === "bgy" ? "height" : "width"] += diff;
      }
    } catch (err) {
      _iterator42.e(err);
    } finally {
      _iterator42.f();
    }
    var dim = Dimensions.cover(dimImage, dimEl);
    var _iterator43 = _createForOfIteratorHelper(bgProps),
      _step43;
    try {
      for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
        var _prop5 = _step43.value;
        var _attr = _prop5 === "bgy" ? "height" : "width";
        var overflow = dim[_attr] - dimEl[_attr];
        positions[_prop5] = "max(".concat(getBackgroundPos(el, _prop5), ",-").concat(overflow, "px) + ").concat(positions[_prop5]);
      }
    } catch (err) {
      _iterator43.e(err);
    } finally {
      _iterator43.f();
    }
    var fn = setBackgroundPosFn(bgProps, positions, props2);
    return function (css2, percent) {
      fn(css2, percent);
      css2.backgroundSize = "".concat(dim.width, "px ").concat(dim.height, "px");
      css2.backgroundRepeat = "no-repeat";
    };
  }
  function getBackgroundPos(el, prop) {
    return getCssValue(el, "background-position-".concat(prop.substr(-1)), "");
  }
  function setBackgroundPosFn(bgProps, positions, props2) {
    return function (css2, percent) {
      var _iterator44 = _createForOfIteratorHelper(bgProps),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var prop = _step44.value;
          var value = getValue(props2[prop], percent);
          css2["background-position-".concat(prop.substr(-1))] = "calc(".concat(positions[prop], " + ").concat(value, "px)");
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
    };
  }
  var dimensions = {};
  function getBackgroundImageDimensions(el) {
    var src = css(el, "backgroundImage").replace(/^none|url\(["']?(.+?)["']?\)$/, "$1");
    if (dimensions[src]) {
      return dimensions[src];
    }
    var image = new Image();
    if (src) {
      image.src = src;
      if (!image.naturalWidth) {
        image.onload = function () {
          dimensions[src] = toDimensions(image);
          trigger(el, createEvent("load", false));
        };
        return toDimensions(image);
      }
    }
    return dimensions[src] = toDimensions(image);
  }
  function toDimensions(image) {
    return {
      width: image.naturalWidth,
      height: image.naturalHeight
    };
  }
  function parseStops(stops) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : toFloat;
    var result = [];
    var length = stops.length;
    var nullIndex = 0;
    for (var i = 0; i < length; i++) {
      var _ref70 = isString(stops[i]) ? stops[i].trim().split(/ (?![^(]*\))/) : [stops[i]],
        _ref71 = (0, _slicedToArray2["default"])(_ref70, 2),
        value = _ref71[0],
        _percent2 = _ref71[1];
      value = fn(value);
      _percent2 = _percent2 ? toFloat(_percent2) / 100 : null;
      if (i === 0) {
        if (_percent2 === null) {
          _percent2 = 0;
        } else if (_percent2) {
          result.push([value, 0]);
        }
      } else if (i === length - 1) {
        if (_percent2 === null) {
          _percent2 = 1;
        } else if (_percent2 !== 1) {
          result.push([value, _percent2]);
          _percent2 = 1;
        }
      }
      result.push([value, _percent2]);
      if (_percent2 === null) {
        nullIndex++;
      } else if (nullIndex) {
        var leftPercent = result[i - nullIndex - 1][1];
        var p = (_percent2 - leftPercent) / (nullIndex + 1);
        for (var j = nullIndex; j > 0; j--) {
          result[i - j][1] = leftPercent + p * (nullIndex - j + 1);
        }
        nullIndex = 0;
      }
    }
    return result;
  }
  function getStop(stops, percent) {
    var index = findIndex(stops.slice(1), function (_ref72) {
      var _ref73 = (0, _slicedToArray2["default"])(_ref72, 2),
        targetPercent = _ref73[1];
      return percent <= targetPercent;
    }) + 1;
    return [stops[index - 1][0], stops[index][0], (percent - stops[index - 1][1]) / (stops[index][1] - stops[index - 1][1])];
  }
  function getValue(stops, percent) {
    var _getStop3 = getStop(stops, percent),
      _getStop4 = (0, _slicedToArray2["default"])(_getStop3, 3),
      start = _getStop4[0],
      end = _getStop4[1],
      p = _getStop4[2];
    return start + Math.abs(start - end) * p * (start < end ? 1 : -1);
  }
  var unitRe = /^-?\d+(?:\.\d+)?(\S+)?/;
  function getUnit(stops, defaultUnit) {
    var _a;
    var _iterator45 = _createForOfIteratorHelper(stops),
      _step45;
    try {
      for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
        var _stop = _step45.value;
        var _match = (_a = _stop.match) == null ? void 0 : _a.call(_stop, unitRe);
        if (_match) {
          return _match[1];
        }
      }
    } catch (err) {
      _iterator45.e(err);
    } finally {
      _iterator45.f();
    }
    return defaultUnit;
  }
  function getCssValue(el, prop, value) {
    var prev = el.style[prop];
    var val = css(css(el, prop, value), prop);
    el.style[prop] = prev;
    return val;
  }
  function fillObject(keys2, value) {
    return keys2.reduce(function (data, prop) {
      data[prop] = value;
      return data;
    }, {});
  }
  function ease(percent, easing) {
    return easing >= 0 ? Math.pow(percent, easing + 1) : 1 - Math.pow(1 - percent, 1 - easing);
  }
  var parallax = {
    mixins: [Parallax],
    props: {
      target: String,
      viewport: Number,
      // Deprecated
      easing: Number,
      start: String,
      end: String
    },
    data: {
      target: false,
      viewport: 1,
      easing: 1,
      start: 0,
      end: 0
    },
    computed: {
      target: function target(_ref74, $el) {
        var _target2 = _ref74.target;
        return getOffsetElement(_target2 && query(_target2, $el) || $el);
      },
      start: function start(_ref75) {
        var start = _ref75.start;
        return toPx(start, "height", this.target, true);
      },
      end: function end(_ref76) {
        var end = _ref76.end,
          viewport2 = _ref76.viewport;
        return toPx(end || (viewport2 = (1 - viewport2) * 100) && "".concat(viewport2, "vh+").concat(viewport2, "%"), "height", this.target, true);
      }
    },
    observe: [viewport(), scroll$1({
      target: function target(_ref77) {
        var _target3 = _ref77.target;
        return _target3;
      }
    }), resize({
      target: function target(_ref78) {
        var $el = _ref78.$el,
          _target4 = _ref78.target;
        return [$el, _target4, scrollParent(_target4, true)];
      }
    })],
    update: {
      read: function read(_ref79, types) {
        var percent = _ref79.percent;
        if (!types.has("scroll")) {
          percent = false;
        }
        if (!isVisible(this.$el)) {
          return false;
        }
        if (!this.matchMedia) {
          return;
        }
        var prev = percent;
        percent = ease(scrolledOver(this.target, this.start, this.end), this.easing);
        return {
          percent: percent,
          style: prev === percent ? false : this.getCss(percent)
        };
      },
      write: function write(_ref80) {
        var style = _ref80.style;
        if (!this.matchMedia) {
          this.reset();
          return;
        }
        style && css(this.$el, style);
      },
      events: ["scroll", "resize"]
    }
  };
  function getOffsetElement(el) {
    return el ? "offsetTop" in el ? el : getOffsetElement(parent(el)) : document.documentElement;
  }
  var SliderParallax = {
    props: {
      parallax: Boolean,
      parallaxTarget: Boolean,
      parallaxStart: String,
      parallaxEnd: String,
      parallaxEasing: Number
    },
    data: {
      parallax: false,
      parallaxTarget: false,
      parallaxStart: 0,
      parallaxEnd: 0,
      parallaxEasing: 0
    },
    observe: [resize({
      target: function target(_ref81) {
        var $el = _ref81.$el,
          parallaxTarget = _ref81.parallaxTarget;
        return [$el, parallaxTarget];
      },
      filter: function filter(_ref82) {
        var parallax = _ref82.parallax;
        return parallax;
      }
    }), scroll$1({
      filter: function filter(_ref83) {
        var parallax = _ref83.parallax;
        return parallax;
      }
    })],
    computed: {
      parallaxTarget: function parallaxTarget(_ref84, $el) {
        var parallaxTarget = _ref84.parallaxTarget;
        return parallaxTarget && query(parallaxTarget, $el) || this.list;
      }
    },
    update: {
      write: function write() {
        if (!this.parallax) {
          return;
        }
        var target = this.parallaxTarget;
        var start = toPx(this.parallaxStart, "height", target, true);
        var end = toPx(this.parallaxEnd, "height", target, true);
        var percent = ease(scrolledOver(target, start, end), this.parallaxEasing);
        var _this$getIndexAt = this.getIndexAt(percent),
          _this$getIndexAt2 = (0, _slicedToArray2["default"])(_this$getIndexAt, 2),
          prevIndex = _this$getIndexAt2[0],
          slidePercent = _this$getIndexAt2[1];
        var nextIndex = this.getValidIndex(prevIndex + Math.ceil(slidePercent));
        var prev = this.slides[prevIndex];
        var next = this.slides[nextIndex];
        var _useTriggers = useTriggers(this),
          triggerShow = _useTriggers.triggerShow,
          triggerShown = _useTriggers.triggerShown,
          triggerHide = _useTriggers.triggerHide,
          triggerHidden = _useTriggers.triggerHidden;
        if (~this.prevIndex) {
          var _iterator46 = _createForOfIteratorHelper( /* @__PURE__ */new Set([this.index, this.prevIndex])),
            _step46;
          try {
            for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
              var i = _step46.value;
              if (!includes([nextIndex, prevIndex], i)) {
                triggerHide(this.slides[i]);
                triggerHidden(this.slides[i]);
              }
            }
          } catch (err) {
            _iterator46.e(err);
          } finally {
            _iterator46.f();
          }
        }
        var changed = this.prevIndex !== prevIndex || this.index !== nextIndex;
        this.dir = 1;
        this.prevIndex = prevIndex;
        this.index = nextIndex;
        if (prev !== next) {
          triggerHide(prev);
        }
        triggerShow(next);
        if (changed) {
          triggerShown(prev);
        }
        this._translate(prev === next ? 1 : slidePercent, prev, next);
      },
      events: ["scroll", "resize"]
    },
    methods: {
      getIndexAt: function getIndexAt(percent) {
        var index = percent * (this.length - 1);
        return [Math.floor(index), index % 1];
      }
    }
  };
  function useTriggers(cmp) {
    var clsSlideActive = cmp.clsSlideActive,
      clsEnter = cmp.clsEnter,
      clsLeave = cmp.clsLeave;
    return {
      triggerShow: triggerShow,
      triggerShown: triggerShown,
      triggerHide: triggerHide,
      triggerHidden: triggerHidden
    };
    function triggerShow(el) {
      if (hasClass(el, clsLeave)) {
        triggerHide(el);
        triggerHidden(el);
      }
      if (!hasClass(el, clsSlideActive)) {
        trigger(el, "beforeitemshow", [cmp]);
        trigger(el, "itemshow", [cmp]);
      }
    }
    function triggerShown(el) {
      if (hasClass(el, clsEnter)) {
        trigger(el, "itemshown", [cmp]);
      }
    }
    function triggerHide(el) {
      if (!hasClass(el, clsSlideActive)) {
        triggerShow(el);
      }
      if (hasClass(el, clsEnter)) {
        triggerShown(el);
      }
      if (!hasClass(el, clsLeave)) {
        trigger(el, "beforeitemhide", [cmp]);
        trigger(el, "itemhide", [cmp]);
      }
    }
    function triggerHidden(el) {
      if (hasClass(el, clsLeave)) {
        trigger(el, "itemhidden", [cmp]);
      }
    }
  }
  var SliderReactive = {
    update: {
      write: function write() {
        if (this.stack.length || this.dragging || this.parallax) {
          return;
        }
        var index = this.getValidIndex();
        if (!~this.prevIndex || this.index !== index) {
          this.show(index);
        } else {
          this._translate(1, this.prevIndex, this.index);
        }
      },
      events: ["resize"]
    }
  };
  var SliderPreload = {
    observe: lazyload({
      target: function target(_ref85) {
        var slides = _ref85.slides;
        return slides;
      },
      targets: function targets(instance) {
        return instance.getAdjacentSlides();
      }
    }),
    methods: {
      getAdjacentSlides: function getAdjacentSlides() {
        var _this23 = this;
        return [1, -1].map(function (i) {
          return _this23.slides[_this23.getIndex(_this23.index + i)];
        });
      }
    }
  };
  function Transitioner(prev, next, dir, _ref86) {
    var center = _ref86.center,
      easing = _ref86.easing,
      list = _ref86.list;
    var from = prev ? getLeft(prev, list, center) : getLeft(next, list, center) + dimensions$1(next).width * dir;
    var to = next ? getLeft(next, list, center) : from + dimensions$1(prev).width * dir * (isRtl ? -1 : 1);
    var resolve;
    return {
      dir: dir,
      show: function show(duration) {
        var percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var linear = arguments.length > 2 ? arguments[2] : undefined;
        var timing = linear ? "linear" : easing;
        duration -= Math.round(duration * clamp(percent, -1, 1));
        this.translate(percent);
        percent = prev ? percent : clamp(percent, 0, 1);
        triggerUpdate(this.getItemIn(), "itemin", {
          percent: percent,
          duration: duration,
          timing: timing,
          dir: dir
        });
        prev && triggerUpdate(this.getItemIn(true), "itemout", {
          percent: 1 - percent,
          duration: duration,
          timing: timing,
          dir: dir
        });
        return new Promise(function (res) {
          resolve || (resolve = res);
          Transition.start(list, {
            transform: _translate(-to * (isRtl ? -1 : 1), "px")
          }, duration, timing).then(resolve, noop);
        });
      },
      cancel: function cancel() {
        return Transition.cancel(list);
      },
      reset: function reset() {
        css(list, "transform", "");
      },
      forward: function forward(duration) {
        var _arguments3 = arguments,
          _this24 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
          var percent;
          return _regenerator["default"].wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                percent = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : _this24.percent();
                _context12.next = 3;
                return _this24.cancel();
              case 3:
                return _context12.abrupt("return", _this24.show(duration, percent, true));
              case 4:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }))();
      },
      translate: function translate(percent) {
        var distance = this.getDistance() * dir * (isRtl ? -1 : 1);
        css(list, "transform", _translate(clamp(-to + (distance - distance * percent), -getWidth(list), dimensions$1(list).width) * (isRtl ? -1 : 1), "px"));
        var actives = this.getActives();
        var itemIn = this.getItemIn();
        var itemOut = this.getItemIn(true);
        percent = prev ? clamp(percent, -1, 1) : 0;
        var _iterator47 = _createForOfIteratorHelper(_children(list)),
          _step47;
        try {
          for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
            var _slide3 = _step47.value;
            var isActive = includes(actives, _slide3);
            var _isIn = _slide3 === itemIn;
            var isOut = _slide3 === itemOut;
            var translateIn = _isIn || !isOut && (isActive || dir * (isRtl ? -1 : 1) === -1 ^ getElLeft(_slide3, list) > getElLeft(prev || next));
            triggerUpdate(_slide3, "itemtranslate".concat(translateIn ? "in" : "out"), {
              dir: dir,
              percent: isOut ? 1 - percent : _isIn ? percent : isActive ? 1 : 0
            });
          }
        } catch (err) {
          _iterator47.e(err);
        } finally {
          _iterator47.f();
        }
      },
      percent: function percent() {
        return Math.abs((css(list, "transform").split(",")[4] * (isRtl ? -1 : 1) + from) / (to - from));
      },
      getDistance: function getDistance() {
        return Math.abs(to - from);
      },
      getItemIn: function getItemIn() {
        var out = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var actives = this.getActives();
        var nextActives = inView(list, getLeft(next || prev, list, center));
        if (out) {
          var temp = actives;
          actives = nextActives;
          nextActives = temp;
        }
        return nextActives[findIndex(nextActives, function (el) {
          return !includes(actives, el);
        })];
      },
      getActives: function getActives() {
        return inView(list, getLeft(prev || next, list, center));
      }
    };
  }
  function getLeft(el, list, center) {
    var left = getElLeft(el, list);
    return center ? left - centerEl(el, list) : Math.min(left, getMax(list));
  }
  function getMax(list) {
    return Math.max(0, getWidth(list) - dimensions$1(list).width);
  }
  function getWidth(list, index) {
    return sumBy(_children(list).slice(0, index), function (el) {
      return dimensions$1(el).width;
    });
  }
  function centerEl(el, list) {
    return dimensions$1(list).width / 2 - dimensions$1(el).width / 2;
  }
  function getElLeft(el, list) {
    return el && (position(el).left + (isRtl ? dimensions$1(el).width - dimensions$1(list).width : 0)) * (isRtl ? -1 : 1) || 0;
  }
  function inView(list, listLeft) {
    listLeft -= 1;
    var listWidth = dimensions$1(list).width;
    var listRight = listLeft + listWidth + 2;
    return _children(list).filter(function (slide) {
      var slideLeft = getElLeft(slide, list);
      var slideRight = slideLeft + Math.min(dimensions$1(slide).width, listWidth);
      return slideLeft >= listLeft && slideRight <= listRight;
    });
  }
  function triggerUpdate(el, type, data) {
    trigger(el, createEvent(type, false, false, data));
  }
  var slider = {
    mixins: [Class, Slider, SliderReactive, SliderParallax, SliderPreload],
    props: {
      center: Boolean,
      sets: Boolean,
      active: String
    },
    data: {
      center: false,
      sets: false,
      attrItem: "uk-slider-item",
      selList: ".uk-slider-items",
      selNav: ".uk-slider-nav",
      clsContainer: "uk-slider-container",
      active: "all",
      Transitioner: Transitioner
    },
    computed: {
      finite: function finite(_ref87) {
        var finite = _ref87.finite;
        return finite || isFinite(this.list, this.center);
      },
      maxIndex: function maxIndex() {
        if (!this.finite || this.center && !this.sets) {
          return this.length - 1;
        }
        if (this.center) {
          return last(this.sets);
        }
        var lft = 0;
        var max = getMax(this.list);
        var index = findIndex(this.slides, function (el) {
          if (lft >= max) {
            return true;
          }
          lft += dimensions$1(el).width;
        });
        return ~index ? index : this.length - 1;
      },
      sets: function sets(_ref88) {
        var enabled = _ref88.sets;
        if (!enabled || this.parallax) {
          return;
        }
        var left = 0;
        var sets = [];
        var width = dimensions$1(this.list).width;
        for (var i = 0; i < this.length; i++) {
          var slideWidth = dimensions$1(this.slides[i]).width;
          if (left + slideWidth > width) {
            left = 0;
          }
          if (this.center) {
            if (left < width / 2 && left + slideWidth + dimensions$1(this.slides[_getIndex(+i + 1, this.slides)]).width / 2 > width / 2) {
              sets.push(+i);
              left = width / 2 - slideWidth / 2;
            }
          } else if (left === 0) {
            sets.push(Math.min(+i, this.maxIndex));
          }
          left += slideWidth;
        }
        if (sets.length) {
          return sets;
        }
      },
      transitionOptions: function transitionOptions() {
        return {
          center: this.center,
          list: this.list
        };
      },
      slides: function slides() {
        return _children(this.list).filter(isVisible);
      }
    },
    connected: function connected() {
      toggleClass(this.$el, this.clsContainer, !$(".".concat(this.clsContainer), this.$el));
    },
    observe: resize({
      target: function target(_ref89) {
        var slides = _ref89.slides;
        return slides;
      }
    }),
    update: {
      write: function write() {
        var _iterator48 = _createForOfIteratorHelper(this.navItems),
          _step48;
        try {
          for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
            var el = _step48.value;
            var _index2 = toNumber(data(el, this.attrItem));
            if (_index2 !== false) {
              el.hidden = !this.maxIndex || _index2 > this.maxIndex || this.sets && !includes(this.sets, _index2);
            }
          }
        } catch (err) {
          _iterator48.e(err);
        } finally {
          _iterator48.f();
        }
        this.reorder();
        this.updateActiveClasses();
      },
      events: ["resize"]
    },
    events: {
      beforeitemshow: function beforeitemshow(e) {
        if (!this.dragging && this.sets && this.stack.length < 2 && !includes(this.sets, this.index)) {
          this.index = this.getValidIndex();
        }
        var diff = Math.abs(this.index - this.prevIndex + (this.dir > 0 && this.index < this.prevIndex || this.dir < 0 && this.index > this.prevIndex ? (this.maxIndex + 1) * this.dir : 0));
        if (!this.dragging && diff > 1) {
          for (var i = 0; i < diff; i++) {
            this.stack.splice(1, 0, this.dir > 0 ? "next" : "previous");
          }
          e.preventDefault();
          return;
        }
        var index = this.dir < 0 || !this.slides[this.prevIndex] ? this.index : this.prevIndex;
        var avgWidth = getWidth(this.list) / this.length;
        this.duration = speedUp(avgWidth / this.velocity) * (dimensions$1(this.slides[index]).width / avgWidth);
        this.reorder();
      },
      itemshow: function itemshow() {
        if (~this.prevIndex) {
          addClass(this._getTransitioner().getItemIn(), this.clsActive);
        }
        this.updateActiveClasses(this.prevIndex);
      },
      itemshown: function itemshown() {
        this.updateActiveClasses();
      }
    },
    methods: {
      reorder: function reorder() {
        var _this25 = this;
        if (this.finite) {
          css(this.slides, "order", "");
          return;
        }
        var index = this.dir > 0 && this.slides[this.prevIndex] ? this.prevIndex : this.index;
        this.slides.forEach(function (slide, i) {
          return css(slide, "order", _this25.dir > 0 && i < index ? 1 : _this25.dir < 0 && i >= _this25.index ? -1 : "");
        });
        if (!this.center) {
          return;
        }
        var next = this.slides[index];
        var width = dimensions$1(this.list).width / 2 - dimensions$1(next).width / 2;
        var j = 0;
        while (width > 0) {
          var slideIndex = this.getIndex(--j + index, index);
          var _slide4 = this.slides[slideIndex];
          css(_slide4, "order", slideIndex > index ? -2 : -1);
          width -= dimensions$1(_slide4).width;
        }
      },
      updateActiveClasses: function updateActiveClasses() {
        var currentIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
        var actives = this._getTransitioner(currentIndex).getActives();
        if (this.active !== "all") {
          actives = [this.slides[this.getValidIndex(currentIndex)]];
        }
        var activeClasses = [this.clsActive, !this.sets || includes(this.sets, toFloat(this.index)) ? this.clsActivated : ""];
        var _iterator49 = _createForOfIteratorHelper(this.slides),
          _step49;
        try {
          for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
            var _slide5 = _step49.value;
            var _active2 = includes(actives, _slide5);
            toggleClass(_slide5, activeClasses, _active2);
            attr(_slide5, "aria-hidden", !_active2);
            var _iterator50 = _createForOfIteratorHelper($$(selFocusable, _slide5)),
              _step50;
            try {
              for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                var focusable = _step50.value;
                if (!hasOwn(focusable, "_tabindex")) {
                  focusable._tabindex = attr(focusable, "tabindex");
                }
                attr(focusable, "tabindex", _active2 ? focusable._tabindex : -1);
              }
            } catch (err) {
              _iterator50.e(err);
            } finally {
              _iterator50.f();
            }
          }
        } catch (err) {
          _iterator49.e(err);
        } finally {
          _iterator49.f();
        }
      },
      getValidIndex: function getValidIndex() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
        var prevIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.prevIndex;
        index = this.getIndex(index, prevIndex);
        if (!this.sets) {
          return index;
        }
        var prev;
        do {
          if (includes(this.sets, index)) {
            return index;
          }
          prev = index;
          index = this.getIndex(index + this.dir, prevIndex);
        } while (index !== prev);
        return index;
      },
      getAdjacentSlides: function getAdjacentSlides() {
        var _dimensions$2 = dimensions$1(this.list),
          width = _dimensions$2.width;
        var left = -width;
        var right = width * 2;
        var slideWidth = dimensions$1(this.slides[this.index]).width;
        var slideLeft = this.center ? width / 2 - slideWidth / 2 : 0;
        var slides = /* @__PURE__ */new Set();
        for (var _i14 = 0, _arr9 = [-1, 1]; _i14 < _arr9.length; _i14++) {
          var i = _arr9[_i14];
          var currentLeft = slideLeft + (i > 0 ? slideWidth : 0);
          var j = 0;
          do {
            var _slide6 = this.slides[this.getIndex(this.index + i + j++ * i)];
            currentLeft += dimensions$1(_slide6).width * i;
            slides.add(_slide6);
          } while (this.length > j && currentLeft > left && currentLeft < right);
        }
        return Array.from(slides);
      },
      getIndexAt: function getIndexAt(percent) {
        var index = -1;
        var scrollDist = this.center ? getWidth(this.list) - (dimensions$1(this.slides[0]).width / 2 + dimensions$1(last(this.slides)).width / 2) : getWidth(this.list, this.maxIndex);
        var dist = percent * scrollDist;
        var slidePercent = 0;
        do {
          var slideWidth = dimensions$1(this.slides[++index]).width;
          var slideDist = this.center ? slideWidth / 2 + dimensions$1(this.slides[index + 1]).width / 2 : slideWidth;
          slidePercent = dist / slideDist % 1;
          dist -= slideDist;
        } while (dist >= 0 && index < this.maxIndex);
        return [index, slidePercent];
      }
    }
  };
  function isFinite(list, center) {
    if (!list || list.length < 2) {
      return true;
    }
    var _dimensions$3 = dimensions$1(list),
      listWidth = _dimensions$3.width;
    if (!center) {
      return Math.ceil(getWidth(list)) < Math.trunc(listWidth + getMaxElWidth(list));
    }
    var slides = _children(list);
    var listHalf = Math.trunc(listWidth / 2);
    var _loop6 = function _loop6() {
      var slide = slides[_index3];
      var slideWidth = dimensions$1(slide).width;
      var slidesInView = /* @__PURE__ */new Set([slide]);
      var diff = 0;
      for (var _i15 = 0, _arr10 = [-1, 1]; _i15 < _arr10.length; _i15++) {
        var i = _arr10[_i15];
        var left = slideWidth / 2;
        var j = 0;
        while (left < listHalf) {
          var nextSlide = slides[_getIndex(+_index3 + i + j++ * i, slides)];
          if (slidesInView.has(nextSlide)) {
            return {
              v: true
            };
          }
          left += dimensions$1(nextSlide).width;
          slidesInView.add(nextSlide);
        }
        diff = Math.max(diff, slideWidth / 2 + dimensions$1(slides[_getIndex(+_index3 + i, slides)]).width / 2 - (left - listHalf));
      }
      if (Math.trunc(diff) > sumBy(slides.filter(function (slide2) {
        return !slidesInView.has(slide2);
      }), function (slide2) {
        return dimensions$1(slide2).width;
      })) {
        return {
          v: true
        };
      }
    };
    for (var _index3 in slides) {
      var _ret3 = _loop6();
      if ((0, _typeof2["default"])(_ret3) === "object") return _ret3.v;
    }
    return false;
  }
  function getMaxElWidth(list) {
    return Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(_children(list).map(function (el) {
      return dimensions$1(el).width;
    }))));
  }
  var sliderParallax = {
    mixins: [Parallax],
    beforeConnect: function beforeConnect() {
      this.item = closest(this.$el, ".".concat(this.$options.id.replace("parallax", "items"), " > *"));
    },
    disconnected: function disconnected() {
      this.item = null;
    },
    events: [{
      name: "itemin itemout",
      self: true,
      el: function el() {
        return this.item;
      },
      handler: function handler(_ref90) {
        var _this26 = this;
        var type = _ref90.type,
          _ref90$detail = _ref90.detail,
          percent = _ref90$detail.percent,
          duration = _ref90$detail.duration,
          timing = _ref90$detail.timing,
          dir = _ref90$detail.dir;
        fastdom.read(function () {
          if (!_this26.matchMedia) {
            return;
          }
          var propsFrom = _this26.getCss(getCurrentPercent(type, dir, percent));
          var propsTo = _this26.getCss(isIn(type) ? 0.5 : dir > 0 ? 1 : 0);
          fastdom.write(function () {
            css(_this26.$el, propsFrom);
            Transition.start(_this26.$el, propsTo, duration, timing)["catch"](noop);
          });
        });
      }
    }, {
      name: "transitioncanceled transitionend",
      self: true,
      el: function el() {
        return this.item;
      },
      handler: function handler() {
        Transition.cancel(this.$el);
      }
    }, {
      name: "itemtranslatein itemtranslateout",
      self: true,
      el: function el() {
        return this.item;
      },
      handler: function handler(_ref91) {
        var _this27 = this;
        var type = _ref91.type,
          _ref91$detail = _ref91.detail,
          percent = _ref91$detail.percent,
          dir = _ref91$detail.dir;
        fastdom.read(function () {
          if (!_this27.matchMedia) {
            _this27.reset();
            return;
          }
          var props = _this27.getCss(getCurrentPercent(type, dir, percent));
          fastdom.write(function () {
            return css(_this27.$el, props);
          });
        });
      }
    }]
  };
  function isIn(type) {
    return endsWith(type, "in");
  }
  function getCurrentPercent(type, dir, percent) {
    percent /= 2;
    return isIn(type) ^ dir < 0 ? percent : 1 - percent;
  }
  var Animations = _objectSpread(_objectSpread({}, Animations$2), {}, {
    fade: {
      show: function show() {
        return [{
          opacity: 0,
          zIndex: 0
        }, {
          zIndex: -1
        }];
      },
      percent: function percent(current) {
        return 1 - css(current, "opacity");
      },
      translate: function translate(percent) {
        return [{
          opacity: 1 - percent,
          zIndex: 0
        }, {
          zIndex: -1
        }];
      }
    },
    scale: {
      show: function show() {
        return [{
          opacity: 0,
          transform: scale3d(1 + 0.5),
          zIndex: 0
        }, {
          zIndex: -1
        }];
      },
      percent: function percent(current) {
        return 1 - css(current, "opacity");
      },
      translate: function translate(percent) {
        return [{
          opacity: 1 - percent,
          transform: scale3d(1 + 0.5 * percent),
          zIndex: 0
        }, {
          zIndex: -1
        }];
      }
    },
    pull: {
      show: function show(dir) {
        return dir < 0 ? [{
          transform: _translate(30),
          zIndex: -1
        }, {
          transform: _translate(),
          zIndex: 0
        }] : [{
          transform: _translate(-100),
          zIndex: 0
        }, {
          transform: _translate(),
          zIndex: -1
        }];
      },
      percent: function percent(current, next, dir) {
        return dir < 0 ? 1 - translated(next) : translated(current);
      },
      translate: function translate(percent, dir) {
        return dir < 0 ? [{
          transform: _translate(30 * percent),
          zIndex: -1
        }, {
          transform: _translate(-100 * (1 - percent)),
          zIndex: 0
        }] : [{
          transform: _translate(-percent * 100),
          zIndex: 0
        }, {
          transform: _translate(30 * (1 - percent)),
          zIndex: -1
        }];
      }
    },
    push: {
      show: function show(dir) {
        return dir < 0 ? [{
          transform: _translate(100),
          zIndex: 0
        }, {
          transform: _translate(),
          zIndex: -1
        }] : [{
          transform: _translate(-30),
          zIndex: -1
        }, {
          transform: _translate(),
          zIndex: 0
        }];
      },
      percent: function percent(current, next, dir) {
        return dir > 0 ? 1 - translated(next) : translated(current);
      },
      translate: function translate(percent, dir) {
        return dir < 0 ? [{
          transform: _translate(percent * 100),
          zIndex: 0
        }, {
          transform: _translate(-30 * (1 - percent)),
          zIndex: -1
        }] : [{
          transform: _translate(-30 * percent),
          zIndex: -1
        }, {
          transform: _translate(100 * (1 - percent)),
          zIndex: 0
        }];
      }
    }
  });
  var slideshow = {
    mixins: [Class, Slideshow, SliderReactive, SliderParallax, SliderPreload],
    props: {
      ratio: String,
      minHeight: String,
      maxHeight: String
    },
    data: {
      ratio: "16:9",
      minHeight: void 0,
      maxHeight: void 0,
      selList: ".uk-slideshow-items",
      attrItem: "uk-slideshow-item",
      selNav: ".uk-slideshow-nav",
      Animations: Animations
    },
    watch: {
      list: function list(_list2) {
        css(_list2, {
          aspectRatio: this.ratio ? this.ratio.replace(":", "/") : void 0,
          minHeight: this.minHeight,
          maxHeight: this.maxHeight,
          minWidth: "100%",
          maxWidth: "100%"
        });
      }
    },
    methods: {
      getAdjacentSlides: function getAdjacentSlides() {
        var _this28 = this;
        return [1, -1].map(function (i) {
          return _this28.slides[_this28.getIndex(_this28.index + i)];
        });
      }
    }
  };
  var sortable = {
    mixins: [Class, Animate],
    props: {
      group: String,
      threshold: Number,
      clsItem: String,
      clsPlaceholder: String,
      clsDrag: String,
      clsDragState: String,
      clsBase: String,
      clsNoDrag: String,
      clsEmpty: String,
      clsCustom: String,
      handle: String
    },
    data: {
      group: false,
      threshold: 5,
      clsItem: "uk-sortable-item",
      clsPlaceholder: "uk-sortable-placeholder",
      clsDrag: "uk-sortable-drag",
      clsDragState: "uk-drag",
      clsBase: "uk-sortable",
      clsNoDrag: "uk-sortable-nodrag",
      clsEmpty: "uk-sortable-empty",
      clsCustom: "",
      handle: false,
      pos: {}
    },
    created: function created() {
      var _this29 = this;
      var _loop7 = function _loop7() {
        var key = _arr11[_i16];
        var fn = _this29[key];
        _this29[key] = function (e) {
          assign(_this29.pos, getEventPos(e));
          fn(e);
        };
      };
      for (var _i16 = 0, _arr11 = ["init", "start", "move", "end"]; _i16 < _arr11.length; _i16++) {
        _loop7();
      }
    },
    events: {
      name: pointerDown$1,
      passive: false,
      handler: "init"
    },
    computed: {
      target: function target(_, $el) {
        return ($el.tBodies || [$el])[0];
      },
      items: function items() {
        return _children(this.target);
      },
      isEmpty: function isEmpty() {
        return !this.items.length;
      },
      handles: function handles(_ref92, $el) {
        var handle = _ref92.handle;
        return handle ? $$(handle, $el) : this.items;
      }
    },
    watch: {
      isEmpty: function isEmpty(empty) {
        toggleClass(this.target, this.clsEmpty, empty);
      },
      handles: function handles(_handles, prev) {
        css(prev, {
          touchAction: "",
          userSelect: ""
        });
        css(_handles, {
          touchAction: "none",
          userSelect: "none"
        });
      }
    },
    update: {
      write: function write(data) {
        if (!this.drag || !parent(this.placeholder)) {
          return;
        }
        var _this$pos = this.pos,
          x = _this$pos.x,
          y = _this$pos.y,
          _this$origin = this.origin,
          offsetTop = _this$origin.offsetTop,
          offsetLeft = _this$origin.offsetLeft,
          placeholder = this.placeholder;
        css(this.drag, {
          top: y - offsetTop,
          left: x - offsetLeft
        });
        var sortable = this.getSortable(document.elementFromPoint(x, y));
        if (!sortable) {
          return;
        }
        var items = sortable.items;
        if (items.some(Transition.inProgress)) {
          return;
        }
        var target = findTarget(items, {
          x: x,
          y: y
        });
        if (items.length && (!target || target === placeholder)) {
          return;
        }
        var previous = this.getSortable(placeholder);
        var insertTarget = findInsertTarget(sortable.target, target, placeholder, x, y, sortable === previous && data.moved !== target);
        if (insertTarget === false) {
          return;
        }
        if (insertTarget && placeholder === insertTarget) {
          return;
        }
        if (sortable !== previous) {
          previous.remove(placeholder);
          data.moved = target;
        } else {
          delete data.moved;
        }
        sortable.insert(placeholder, insertTarget);
        this.touched.add(sortable);
      },
      events: ["move"]
    },
    methods: {
      init: function init(e) {
        var target = e.target,
          button = e.button,
          defaultPrevented = e.defaultPrevented;
        var _this$items$filter = this.items.filter(function (el) {
            return el.contains(target);
          }),
          _this$items$filter2 = (0, _slicedToArray2["default"])(_this$items$filter, 1),
          placeholder = _this$items$filter2[0];
        if (!placeholder || defaultPrevented || button > 0 || isInput(target) || target.closest(".".concat(this.clsNoDrag)) || this.handle && !target.closest(this.handle)) {
          return;
        }
        e.preventDefault();
        this.touched = /* @__PURE__ */new Set([this]);
        this.placeholder = placeholder;
        this.origin = _objectSpread({
          target: target,
          index: index(placeholder)
        }, this.pos);
        on(document, pointerMove$1, this.move);
        on(document, pointerUp$1, this.end);
        if (!this.threshold) {
          this.start(e);
        }
      },
      start: function start(e) {
        this.drag = appendDrag(this.$container, this.placeholder);
        var _dimensions$4 = dimensions$1(this.placeholder),
          left = _dimensions$4.left,
          top = _dimensions$4.top;
        assign(this.origin, {
          offsetLeft: this.pos.x - left,
          offsetTop: this.pos.y - top
        });
        addClass(this.drag, this.clsDrag, this.clsCustom);
        addClass(this.placeholder, this.clsPlaceholder);
        addClass(this.items, this.clsItem);
        addClass(document.documentElement, this.clsDragState);
        trigger(this.$el, "start", [this, this.placeholder]);
        trackScroll(this.pos);
        this.move(e);
      },
      move: function move(e) {
        if (this.drag) {
          this.$emit("move");
        } else if (Math.abs(this.pos.x - this.origin.x) > this.threshold || Math.abs(this.pos.y - this.origin.y) > this.threshold) {
          this.start(e);
        }
      },
      end: function end() {
        off(document, pointerMove$1, this.move);
        off(document, pointerUp$1, this.end);
        if (!this.drag) {
          return;
        }
        untrackScroll();
        var sortable = this.getSortable(this.placeholder);
        if (this === sortable) {
          if (this.origin.index !== index(this.placeholder)) {
            trigger(this.$el, "moved", [this, this.placeholder]);
          }
        } else {
          trigger(sortable.$el, "added", [sortable, this.placeholder]);
          trigger(this.$el, "removed", [this, this.placeholder]);
        }
        trigger(this.$el, "stop", [this, this.placeholder]);
        remove$1(this.drag);
        this.drag = null;
        var _iterator51 = _createForOfIteratorHelper(this.touched),
          _step51;
        try {
          for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
            var _step51$value = _step51.value,
              clsPlaceholder = _step51$value.clsPlaceholder,
              clsItem = _step51$value.clsItem;
            var _iterator52 = _createForOfIteratorHelper(this.touched),
              _step52;
            try {
              for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
                var sortable2 = _step52.value;
                removeClass(sortable2.items, clsPlaceholder, clsItem);
              }
            } catch (err) {
              _iterator52.e(err);
            } finally {
              _iterator52.f();
            }
          }
        } catch (err) {
          _iterator51.e(err);
        } finally {
          _iterator51.f();
        }
        this.touched = null;
        removeClass(document.documentElement, this.clsDragState);
      },
      insert: function insert(element, target) {
        var _this30 = this;
        addClass(this.items, this.clsItem);
        var insert = function insert() {
          return target ? before(target, element) : append(_this30.target, element);
        };
        this.animate(insert);
      },
      remove: function remove(element) {
        if (!this.target.contains(element)) {
          return;
        }
        this.animate(function () {
          return remove$1(element);
        });
      },
      getSortable: function getSortable(element) {
        do {
          var _sortable = this.$getComponent(element, "sortable");
          if (_sortable && (_sortable === this || this.group !== false && _sortable.group === this.group)) {
            return _sortable;
          }
        } while (element = parent(element));
      }
    }
  };
  var trackTimer;
  function trackScroll(pos) {
    var last = Date.now();
    trackTimer = setInterval(function () {
      var x = pos.x,
        y = pos.y;
      y += document.scrollingElement.scrollTop;
      var dist = (Date.now() - last) * 0.3;
      last = Date.now();
      scrollParents(document.elementFromPoint(x, pos.y)).reverse().some(function (scrollEl) {
        var scroll = scrollEl.scrollTop,
          scrollHeight = scrollEl.scrollHeight;
        var _offsetViewport3 = offsetViewport(scrollEl),
          top = _offsetViewport3.top,
          bottom = _offsetViewport3.bottom,
          height2 = _offsetViewport3.height;
        if (top < y && top + 35 > y) {
          scroll -= dist;
        } else if (bottom > y && bottom - 35 < y) {
          scroll += dist;
        } else {
          return;
        }
        if (scroll > 0 && scroll < scrollHeight - height2) {
          scrollEl.scrollTop = scroll;
          return true;
        }
      });
    }, 15);
  }
  function untrackScroll() {
    clearInterval(trackTimer);
  }
  function appendDrag(container, element) {
    var clone;
    if (isTag(element, "li", "tr")) {
      clone = $("<div>");
      append(clone, element.cloneNode(true).children);
      var _iterator53 = _createForOfIteratorHelper(element.getAttributeNames()),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var attribute = _step53.value;
          attr(clone, attribute, element.getAttribute(attribute));
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    } else {
      clone = element.cloneNode(true);
    }
    append(container, clone);
    css(clone, "margin", "0", "important");
    css(clone, {
      boxSizing: "border-box",
      width: element.offsetWidth,
      height: element.offsetHeight,
      padding: css(element, "padding")
    });
    height(clone.firstElementChild, height(element.firstElementChild));
    return clone;
  }
  function findTarget(items, point) {
    return items[findIndex(items, function (item) {
      return pointInRect(point, dimensions$1(item));
    })];
  }
  function findInsertTarget(list, target, placeholder, x, y, sameList) {
    if (!_children(list).length) {
      return;
    }
    var rect = dimensions$1(target);
    if (!sameList) {
      if (!isHorizontal(list, placeholder)) {
        return y < rect.top + rect.height / 2 ? target : target.nextElementSibling;
      }
      return target;
    }
    var placeholderRect = dimensions$1(placeholder);
    var sameRow = linesIntersect([rect.top, rect.bottom], [placeholderRect.top, placeholderRect.bottom]);
    var _ref93 = sameRow ? [x, "width", "left", "right"] : [y, "height", "top", "bottom"],
      _ref94 = (0, _slicedToArray2["default"])(_ref93, 4),
      pointerPos = _ref94[0],
      lengthProp = _ref94[1],
      startProp = _ref94[2],
      endProp = _ref94[3];
    var diff = placeholderRect[lengthProp] < rect[lengthProp] ? rect[lengthProp] - placeholderRect[lengthProp] : 0;
    if (placeholderRect[startProp] < rect[startProp]) {
      if (diff && pointerPos < rect[startProp] + diff) {
        return false;
      }
      return target.nextElementSibling;
    }
    if (diff && pointerPos > rect[endProp] - diff) {
      return false;
    }
    return target;
  }
  function isHorizontal(list, placeholder) {
    var single = _children(list).length === 1;
    if (single) {
      append(list, placeholder);
    }
    var items = _children(list);
    var isHorizontal2 = items.some(function (el, i) {
      var rectA = dimensions$1(el);
      return items.slice(i + 1).some(function (el2) {
        var rectB = dimensions$1(el2);
        return !linesIntersect([rectA.left, rectA.right], [rectB.left, rectB.right]);
      });
    });
    if (single) {
      remove$1(placeholder);
    }
    return isHorizontal2;
  }
  function linesIntersect(lineA, lineB) {
    return lineA[1] > lineB[0] && lineB[1] > lineA[0];
  }
  var Position = {
    props: {
      pos: String,
      offset: null,
      flip: Boolean,
      shift: Boolean,
      inset: Boolean
    },
    data: {
      pos: "bottom-".concat(isRtl ? "right" : "left"),
      offset: false,
      flip: true,
      shift: true,
      inset: false
    },
    connected: function connected() {
      this.pos = this.$props.pos.split("-").concat("center").slice(0, 2);
      var _this$pos2 = (0, _slicedToArray2["default"])(this.pos, 2);
      this.dir = _this$pos2[0];
      this.align = _this$pos2[1];
      this.axis = includes(["top", "bottom"], this.dir) ? "y" : "x";
    },
    methods: {
      positionAt: function positionAt(element, target, boundary) {
        var offset = [this.getPositionOffset(element), this.getShiftOffset(element)];
        var placement = [this.flip && "flip", this.shift && "shift"];
        var attach = {
          element: [this.inset ? this.dir : flipPosition(this.dir), this.align],
          target: [this.dir, this.align]
        };
        if (this.axis === "y") {
          for (var prop in attach) {
            attach[prop].reverse();
          }
          offset.reverse();
          placement.reverse();
        }
        var restoreScrollPosition = storeScrollPosition(element);
        var elDim = dimensions$1(element);
        css(element, {
          top: -elDim.height,
          left: -elDim.width
        });
        _positionAt(element, target, {
          attach: attach,
          offset: offset,
          boundary: boundary,
          placement: placement,
          viewportOffset: this.getViewportOffset(element)
        });
        restoreScrollPosition();
      },
      getPositionOffset: function getPositionOffset() {
        var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$el;
        return toPx(this.offset === false ? css(element, "--uk-position-offset") : this.offset, this.axis === "x" ? "width" : "height", element) * (includes(["left", "top"], this.dir) ? -1 : 1) * (this.inset ? -1 : 1);
      },
      getShiftOffset: function getShiftOffset() {
        var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$el;
        return this.align === "center" ? 0 : toPx(css(element, "--uk-position-shift-offset"), this.axis === "y" ? "width" : "height", element) * (includes(["left", "top"], this.align) ? 1 : -1);
      },
      getViewportOffset: function getViewportOffset(element) {
        return toPx(css(element, "--uk-position-viewport-offset"));
      }
    }
  };
  function storeScrollPosition(element) {
    var scrollElement = scrollParent(element);
    var scrollTop = scrollElement.scrollTop;
    return function () {
      if (scrollTop !== scrollElement.scrollTop) {
        scrollElement.scrollTop = scrollTop;
      }
    };
  }
  var tooltip = {
    mixins: [Container, Togglable, Position],
    data: {
      pos: "top",
      animation: ["uk-animation-scale-up"],
      duration: 100,
      cls: "uk-active"
    },
    connected: function connected() {
      makeFocusable(this.$el);
    },
    disconnected: function disconnected() {
      this.hide();
    },
    methods: {
      show: function show() {
        var _this31 = this;
        if (this.isToggled(this.tooltip || null)) {
          return;
        }
        var _parseProps = parseProps(this.$options),
          _parseProps$delay = _parseProps.delay,
          delay = _parseProps$delay === void 0 ? 0 : _parseProps$delay,
          title = _parseProps.title;
        if (!title) {
          return;
        }
        var titleAttr = attr(this.$el, "title");
        var off = on(this.$el, ["blur", pointerLeave], function (e) {
          return !isTouch(e) && _this31.hide();
        });
        this.reset = function () {
          attr(_this31.$el, {
            title: titleAttr,
            "aria-describedby": null
          });
          off();
        };
        var id = generateId(this);
        attr(this.$el, {
          title: null,
          "aria-describedby": id
        });
        clearTimeout(this.showTimer);
        this.showTimer = setTimeout(function () {
          return _this31._show(title, id);
        }, delay);
      },
      hide: function hide() {
        var _this32 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
          var _a;
          return _regenerator["default"].wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                if (!matches(_this32.$el, "input:focus")) {
                  _context13.next = 2;
                  break;
                }
                return _context13.abrupt("return");
              case 2:
                clearTimeout(_this32.showTimer);
                if (!_this32.isToggled(_this32.tooltip || null)) {
                  _context13.next = 6;
                  break;
                }
                _context13.next = 6;
                return _this32.toggleElement(_this32.tooltip, false, false);
              case 6:
                (_a = _this32.reset) == null ? void 0 : _a.call(_this32);
                remove$1(_this32.tooltip);
                _this32.tooltip = null;
              case 9:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        }))();
      },
      _show: function _show(title, id) {
        var _this33 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
          return _regenerator["default"].wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                _this33.tooltip = append(_this33.container, "<div id=\"".concat(id, "\" class=\"uk-").concat(_this33.$options.name, "\" role=\"tooltip\"> <div class=\"uk-").concat(_this33.$options.name, "-inner\">").concat(title, "</div> </div>"));
                on(_this33.tooltip, "toggled", function (e, toggled) {
                  if (!toggled) {
                    return;
                  }
                  var update = function update() {
                    return _this33.positionAt(_this33.tooltip, _this33.$el);
                  };
                  update();
                  var _getAlignment = getAlignment(_this33.tooltip, _this33.$el, _this33.pos),
                    _getAlignment2 = (0, _slicedToArray2["default"])(_getAlignment, 2),
                    dir = _getAlignment2[0],
                    align = _getAlignment2[1];
                  _this33.origin = _this33.axis === "y" ? "".concat(flipPosition(dir), "-").concat(align) : "".concat(align, "-").concat(flipPosition(dir));
                  var handlers = [once(document, "keydown ".concat(pointerDown$1), _this33.hide, false, function (e2) {
                    return e2.type === pointerDown$1 && !_this33.$el.contains(e2.target) || e2.type === "keydown" && e2.keyCode === keyMap.ESC;
                  }), on([document].concat((0, _toConsumableArray2["default"])(overflowParents(_this33.$el))), "scroll", update, {
                    passive: true
                  })];
                  once(_this33.tooltip, "hide", function () {
                    return handlers.forEach(function (handler) {
                      return handler();
                    });
                  }, {
                    self: true
                  });
                });
                _context14.next = 4;
                return _this33.toggleElement(_this33.tooltip, true);
              case 4:
                if (_context14.sent) {
                  _context14.next = 6;
                  break;
                }
                _this33.hide();
              case 6:
              case "end":
                return _context14.stop();
            }
          }, _callee14);
        }))();
      }
    },
    events: (0, _defineProperty2["default"])({}, "focus ".concat(pointerEnter, " ").concat(pointerDown$1), function focus(e) {
      if (!isTouch(e) || e.type === pointerDown$1) {
        this.show();
      }
    })
  };
  function makeFocusable(el) {
    if (!isFocusable(el)) {
      attr(el, "tabindex", "0");
    }
  }
  function getAlignment(el, target, _ref95) {
    var _ref96 = (0, _slicedToArray2["default"])(_ref95, 2),
      dir = _ref96[0],
      align = _ref96[1];
    var elOffset = offset(el);
    var targetOffset = offset(target);
    var properties = [["left", "right"], ["top", "bottom"]];
    for (var _i17 = 0, _properties = properties; _i17 < _properties.length; _i17++) {
      var props2 = _properties[_i17];
      if (elOffset[props2[0]] >= targetOffset[props2[1]]) {
        dir = props2[1];
        break;
      }
      if (elOffset[props2[1]] <= targetOffset[props2[0]]) {
        dir = props2[0];
        break;
      }
    }
    var props = includes(properties[0], dir) ? properties[1] : properties[0];
    align = props.find(function (prop) {
      return elOffset[prop] === targetOffset[prop];
    }) || "center";
    return [dir, align];
  }
  function parseProps(options) {
    var el = options.el,
      id = options.id,
      data$1 = options.data;
    return ["delay", "title"].reduce(function (obj, key) {
      return _objectSpread((0, _defineProperty2["default"])({}, key, data(el, key)), obj);
    }, _objectSpread(_objectSpread({}, parseOptions(data(el, id), ["title"])), data$1));
  }
  var upload = {
    mixins: [I18n],
    i18n: {
      invalidMime: "Invalid File Type: %s",
      invalidName: "Invalid File Name: %s",
      invalidSize: "Invalid File Size: %s Kilobytes Max"
    },
    props: {
      allow: String,
      clsDragover: String,
      concurrent: Number,
      maxSize: Number,
      method: String,
      mime: String,
      multiple: Boolean,
      name: String,
      params: Object,
      type: String,
      url: String
    },
    data: {
      allow: false,
      clsDragover: "uk-dragover",
      concurrent: 1,
      maxSize: 0,
      method: "POST",
      mime: false,
      multiple: false,
      name: "files[]",
      params: {},
      type: "",
      url: "",
      abort: noop,
      beforeAll: noop,
      beforeSend: noop,
      complete: noop,
      completeAll: noop,
      error: noop,
      fail: noop,
      load: noop,
      loadEnd: noop,
      loadStart: noop,
      progress: noop
    },
    events: {
      change: function change(e) {
        if (!matches(e.target, 'input[type="file"]')) {
          return;
        }
        e.preventDefault();
        if (e.target.files) {
          this.upload(e.target.files);
        }
        e.target.value = "";
      },
      drop: function drop(e) {
        stop(e);
        var transfer = e.dataTransfer;
        if (!(transfer == null ? void 0 : transfer.files)) {
          return;
        }
        removeClass(this.$el, this.clsDragover);
        this.upload(transfer.files);
      },
      dragenter: function dragenter(e) {
        stop(e);
      },
      dragover: function dragover(e) {
        stop(e);
        addClass(this.$el, this.clsDragover);
      },
      dragleave: function dragleave(e) {
        stop(e);
        removeClass(this.$el, this.clsDragover);
      }
    },
    methods: {
      upload: function upload(files) {
        var _this34 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
          var _iterator54, _step54, file, chunks, upload;
          return _regenerator["default"].wrap(function _callee16$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                files = toArray(files);
                if (files.length) {
                  _context16.next = 3;
                  break;
                }
                return _context16.abrupt("return");
              case 3:
                trigger(_this34.$el, "upload", [files]);
                _iterator54 = _createForOfIteratorHelper(files);
                _context16.prev = 5;
                _iterator54.s();
              case 7:
                if ((_step54 = _iterator54.n()).done) {
                  _context16.next = 20;
                  break;
                }
                file = _step54.value;
                if (!(_this34.maxSize && _this34.maxSize * 1e3 < file.size)) {
                  _context16.next = 12;
                  break;
                }
                _this34.fail(_this34.t("invalidSize", _this34.maxSize));
                return _context16.abrupt("return");
              case 12:
                if (!(_this34.allow && !match$1(_this34.allow, file.name))) {
                  _context16.next = 15;
                  break;
                }
                _this34.fail(_this34.t("invalidName", _this34.allow));
                return _context16.abrupt("return");
              case 15:
                if (!(_this34.mime && !match$1(_this34.mime, file.type))) {
                  _context16.next = 18;
                  break;
                }
                _this34.fail(_this34.t("invalidMime", _this34.mime));
                return _context16.abrupt("return");
              case 18:
                _context16.next = 7;
                break;
              case 20:
                _context16.next = 25;
                break;
              case 22:
                _context16.prev = 22;
                _context16.t0 = _context16["catch"](5);
                _iterator54.e(_context16.t0);
              case 25:
                _context16.prev = 25;
                _iterator54.f();
                return _context16.finish(25);
              case 28:
                if (!_this34.multiple) {
                  files = files.slice(0, 1);
                }
                _this34.beforeAll(_this34, files);
                chunks = chunk(files, _this34.concurrent);
                upload = /*#__PURE__*/function () {
                  var _ref97 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(files2) {
                    var data, key, xhr;
                    return _regenerator["default"].wrap(function _callee15$(_context15) {
                      while (1) switch (_context15.prev = _context15.next) {
                        case 0:
                          data = new FormData();
                          files2.forEach(function (file) {
                            return data.append(_this34.name, file);
                          });
                          for (key in _this34.params) {
                            data.append(key, _this34.params[key]);
                          }
                          _context15.prev = 3;
                          _context15.next = 6;
                          return ajax(_this34.url, {
                            data: data,
                            method: _this34.method,
                            responseType: _this34.type,
                            beforeSend: function beforeSend(env) {
                              var xhr2 = env.xhr;
                              on(xhr2.upload, "progress", _this34.progress);
                              for (var _i18 = 0, _arr12 = ["loadStart", "load", "loadEnd", "abort"]; _i18 < _arr12.length; _i18++) {
                                var type = _arr12[_i18];
                                on(xhr2, type.toLowerCase(), _this34[type]);
                              }
                              return _this34.beforeSend(env);
                            }
                          });
                        case 6:
                          xhr = _context15.sent;
                          _this34.complete(xhr);
                          if (!chunks.length) {
                            _context15.next = 13;
                            break;
                          }
                          _context15.next = 11;
                          return upload(chunks.shift());
                        case 11:
                          _context15.next = 14;
                          break;
                        case 13:
                          _this34.completeAll(xhr);
                        case 14:
                          _context15.next = 19;
                          break;
                        case 16:
                          _context15.prev = 16;
                          _context15.t0 = _context15["catch"](3);
                          _this34.error(_context15.t0);
                        case 19:
                        case "end":
                          return _context15.stop();
                      }
                    }, _callee15, null, [[3, 16]]);
                  }));
                  return function upload(_x11) {
                    return _ref97.apply(this, arguments);
                  };
                }();
                _context16.next = 34;
                return upload(chunks.shift());
              case 34:
              case "end":
                return _context16.stop();
            }
          }, _callee16, null, [[5, 22, 25, 28]]);
        }))();
      }
    }
  };
  function match$1(pattern, path) {
    return path.match(new RegExp("^".concat(pattern.replace(/\//g, "\\/").replace(/\*\*/g, "(\\/[^\\/]+)*").replace(/\*/g, "[^\\/]+").replace(/((?!\\))\?/g, "$1."), "$"), "i"));
  }
  function chunk(files, size) {
    var chunks = [];
    for (var i = 0; i < files.length; i += size) {
      chunks.push(files.slice(i, i + size));
    }
    return chunks;
  }
  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  function ajax(url, options) {
    var env = _objectSpread({
      data: null,
      method: "GET",
      headers: {},
      xhr: new XMLHttpRequest(),
      beforeSend: noop,
      responseType: ""
    }, options);
    return Promise.resolve().then(function () {
      return env.beforeSend(env);
    }).then(function () {
      return send(url, env);
    });
  }
  function send(url, env) {
    return new Promise(function (resolve, reject) {
      var xhr = env.xhr;
      for (var prop in env) {
        if (prop in xhr) {
          try {
            xhr[prop] = env[prop];
          } catch (e) {}
        }
      }
      xhr.open(env.method.toUpperCase(), url);
      for (var header in env.headers) {
        xhr.setRequestHeader(header, env.headers[header]);
      }
      on(xhr, "load", function () {
        if (xhr.status === 0 || xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
          resolve(xhr);
        } else {
          reject(assign(Error(xhr.statusText), {
            xhr: xhr,
            status: xhr.status
          }));
        }
      });
      on(xhr, "error", function () {
        return reject(assign(Error("Network Error"), {
          xhr: xhr
        }));
      });
      on(xhr, "timeout", function () {
        return reject(assign(Error("Network Timeout"), {
          xhr: xhr
        }));
      });
      xhr.send(env.data);
    });
  }
  var components$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Countdown: countdown,
    Filter: filter,
    Lightbox: lightbox,
    LightboxPanel: LightboxPanel,
    Notification: notification,
    Parallax: parallax,
    Slider: slider,
    SliderParallax: sliderParallax,
    Slideshow: slideshow,
    SlideshowParallax: sliderParallax,
    Sortable: sortable,
    Tooltip: tooltip,
    Upload: upload
  });
  function boot(App) {
    if (inBrowser && window.MutationObserver) {
      if (document.body) {
        requestAnimationFrame(function () {
          return init(App);
        });
      } else {
        new MutationObserver(function (records, observer) {
          if (document.body) {
            init(App);
            observer.disconnect();
          }
        }).observe(document.documentElement, {
          childList: true
        });
      }
    }
  }
  function init(App) {
    trigger(document, "uikit:init", App);
    if (document.body) {
      apply(document.body, connect);
    }
    new MutationObserver(function (records) {
      return records.forEach(applyChildListMutation);
    }).observe(document, {
      subtree: true,
      childList: true
    });
    new MutationObserver(function (records) {
      return records.forEach(applyAttributeMutation);
    }).observe(document, {
      subtree: true,
      attributes: true
    });
    App._initialized = true;
  }
  function applyChildListMutation(_ref98) {
    var addedNodes = _ref98.addedNodes,
      removedNodes = _ref98.removedNodes;
    var _iterator55 = _createForOfIteratorHelper(addedNodes),
      _step55;
    try {
      for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
        var node = _step55.value;
        apply(node, connect);
      }
    } catch (err) {
      _iterator55.e(err);
    } finally {
      _iterator55.f();
    }
    var _iterator56 = _createForOfIteratorHelper(removedNodes),
      _step56;
    try {
      for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
        var _node = _step56.value;
        apply(_node, disconnect);
      }
    } catch (err) {
      _iterator56.e(err);
    } finally {
      _iterator56.f();
    }
  }
  function applyAttributeMutation(_ref99) {
    var target = _ref99.target,
      attributeName = _ref99.attributeName;
    var _a;
    var name = getComponentName(attributeName);
    if (name) {
      if (hasAttr(target, attributeName)) {
        createComponent(name, target);
        return;
      }
      (_a = getComponent(target, name)) == null ? void 0 : _a.$destroy();
    }
  }
  function connect(node) {
    var components2 = getComponents(node);
    for (var name in getComponents(node)) {
      callConnected(components2[name]);
    }
    var _iterator57 = _createForOfIteratorHelper(node.getAttributeNames()),
      _step57;
    try {
      for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
        var attributeName = _step57.value;
        var _name = getComponentName(attributeName);
        _name && createComponent(_name, node);
      }
    } catch (err) {
      _iterator57.e(err);
    } finally {
      _iterator57.f();
    }
  }
  function disconnect(node) {
    var components2 = getComponents(node);
    for (var name in getComponents(node)) {
      callDisconnected(components2[name]);
    }
  }
  function getComponentName(attribute) {
    if (startsWith(attribute, "data-")) {
      attribute = attribute.slice(5);
    }
    var cmp = components$2[attribute];
    return cmp && (isPlainObject(cmp) ? cmp : cmp.options).name;
  }
  globalApi(App);
  instanceApi(App);
  var Accordion = {
    mixins: [Class, Togglable],
    props: {
      animation: Boolean,
      targets: String,
      active: null,
      collapsible: Boolean,
      multiple: Boolean,
      toggle: String,
      content: String,
      offset: Number
    },
    data: {
      targets: "> *",
      active: false,
      animation: true,
      collapsible: true,
      multiple: false,
      clsOpen: "uk-open",
      toggle: "> .uk-accordion-title",
      content: "> .uk-accordion-content",
      offset: 0
    },
    computed: {
      items: function items(_ref100, $el) {
        var targets = _ref100.targets;
        return $$(targets, $el);
      },
      toggles: function toggles(_ref101) {
        var toggle = _ref101.toggle;
        return this.items.map(function (item) {
          return $(toggle, item);
        });
      },
      contents: function contents(_ref102) {
        var content = _ref102.content;
        return this.items.map(function (item) {
          var _a;
          return ((_a = item._wrapper) == null ? void 0 : _a.firstElementChild) || $(content, item);
        });
      }
    },
    watch: {
      items: function items(_items, prev) {
        if (prev || hasClass(_items, this.clsOpen)) {
          return;
        }
        var active = this.active !== false && _items[Number(this.active)] || !this.collapsible && _items[0];
        if (active) {
          this.toggle(active, false);
        }
      },
      toggles: function toggles() {
        this.$emit();
      },
      contents: function contents(items) {
        var _this35 = this;
        var _iterator58 = _createForOfIteratorHelper(items),
          _step58;
        try {
          var _loop8 = function _loop8() {
            var el = _step58.value;
            var isOpen = hasClass(_this35.items.find(function (item) {
              return item.contains(el);
            }), _this35.clsOpen);
            hide(el, !isOpen);
          };
          for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
            _loop8();
          }
        } catch (err) {
          _iterator58.e(err);
        } finally {
          _iterator58.f();
        }
        this.$emit();
      }
    },
    observe: lazyload(),
    events: [{
      name: "click keydown",
      delegate: function delegate() {
        return "".concat(this.targets, " ").concat(this.$props.toggle);
      },
      handler: function handler(e) {
        var _this36 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
          var _a;
          return _regenerator["default"].wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                if (!(e.type === "keydown" && e.keyCode !== keyMap.SPACE)) {
                  _context17.next = 2;
                  break;
                }
                return _context17.abrupt("return");
              case 2:
                e.preventDefault();
                (_a = _this36._off) == null ? void 0 : _a.call(_this36);
                _this36._off = keepScrollPosition(e.target);
                _context17.next = 7;
                return _this36.toggle(index(_this36.toggles, e.current));
              case 7:
                _this36._off();
              case 8:
              case "end":
                return _context17.stop();
            }
          }, _callee17);
        }))();
      }
    }, {
      name: "shown hidden",
      self: true,
      delegate: function delegate() {
        return this.targets;
      },
      handler: function handler() {
        this.$emit();
      }
    }],
    update: function update() {
      var activeItems = filter$1(this.items, ".".concat(this.clsOpen));
      for (var index2 in this.items) {
        var _toggle5 = this.toggles[index2];
        var content = this.contents[index2];
        if (!_toggle5 || !content) {
          continue;
        }
        _toggle5.id = generateId(this, _toggle5);
        content.id = generateId(this, content);
        var _active3 = includes(activeItems, this.items[index2]);
        attr(_toggle5, {
          role: isTag(_toggle5, "a") ? "button" : null,
          "aria-controls": content.id,
          "aria-expanded": _active3,
          "aria-disabled": !this.collapsible && activeItems.length < 2 && _active3
        });
        attr(content, {
          role: "region",
          "aria-labelledby": _toggle5.id
        });
        if (isTag(content, "ul")) {
          attr(_children(content), "role", "presentation");
        }
      }
    },
    methods: {
      toggle: function toggle(item, animate) {
        var _this37 = this;
        item = this.items[_getIndex(item, this.items)];
        var items = [item];
        var activeItems = filter$1(this.items, ".".concat(this.clsOpen));
        if (!this.multiple && !includes(activeItems, items[0])) {
          items = items.concat(activeItems);
        }
        if (!this.collapsible && activeItems.length < 2 && includes(activeItems, item)) {
          return;
        }
        return Promise.all(items.map(function (el) {
          return _this37.toggleElement(el, !includes(activeItems, el), function (el2, show) {
            toggleClass(el2, _this37.clsOpen, show);
            if (animate === false || !_this37.animation) {
              hide($(_this37.content, el2), !show);
              return;
            }
            return transition(el2, show, _this37);
          });
        }));
      }
    }
  };
  function hide(el, hide2) {
    el && (el.hidden = hide2);
  }
  function transition(_x12, _x13, _x14) {
    return _transition.apply(this, arguments);
  }
  function _transition() {
    _transition = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee35(el, show, _ref103) {
      var content, duration, velocity, transition2, _a, wrapper, currentHeight, endHeight, percent;
      return _regenerator["default"].wrap(function _callee35$(_context35) {
        while (1) switch (_context35.prev = _context35.next) {
          case 0:
            content = _ref103.content, duration = _ref103.duration, velocity = _ref103.velocity, transition2 = _ref103.transition;
            content = ((_a = el._wrapper) == null ? void 0 : _a.firstElementChild) || $(content, el);
            if (!el._wrapper) {
              el._wrapper = wrapAll(content, "<div>");
            }
            wrapper = el._wrapper;
            css(wrapper, "overflow", "hidden");
            currentHeight = toFloat(css(wrapper, "height"));
            _context35.next = 8;
            return Transition.cancel(wrapper);
          case 8:
            hide(content, false);
            endHeight = sumBy(["marginTop", "marginBottom"], function (prop) {
              return css(content, prop);
            }) + dimensions$1(content).height;
            percent = currentHeight / endHeight;
            duration = (velocity * endHeight + duration) * (show ? 1 - percent : percent);
            css(wrapper, "height", currentHeight);
            _context35.next = 15;
            return Transition.start(wrapper, {
              height: show ? endHeight : 0
            }, duration, transition2);
          case 15:
            unwrap(content);
            delete el._wrapper;
            if (!show) {
              hide(content, true);
            }
          case 18:
          case "end":
            return _context35.stop();
        }
      }, _callee35);
    }));
    return _transition.apply(this, arguments);
  }
  function keepScrollPosition(el) {
    var scrollElement = scrollParent(el, true);
    var frame;
    (function scroll() {
      frame = requestAnimationFrame(function () {
        var _dimensions$5 = dimensions$1(el),
          top = _dimensions$5.top;
        if (top < 0) {
          scrollElement.scrollTop += top;
        }
        scroll();
      });
    })();
    return function () {
      return requestAnimationFrame(function () {
        return cancelAnimationFrame(frame);
      });
    };
  }
  var alert = {
    mixins: [Class, Togglable],
    args: "animation",
    props: {
      animation: Boolean,
      close: String
    },
    data: {
      animation: true,
      selClose: ".uk-alert-close",
      duration: 150
    },
    events: {
      name: "click",
      delegate: function delegate() {
        return this.selClose;
      },
      handler: function handler(e) {
        e.preventDefault();
        this.close();
      }
    },
    methods: {
      close: function close() {
        var _this38 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18() {
          return _regenerator["default"].wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return _this38.toggleElement(_this38.$el, false, animate);
              case 2:
                _this38.$destroy(true);
              case 3:
              case "end":
                return _context18.stop();
            }
          }, _callee18);
        }))();
      }
    }
  };
  function animate(el, show, _ref104) {
    var duration = _ref104.duration,
      transition = _ref104.transition,
      velocity = _ref104.velocity;
    var height = toFloat(css(el, "height"));
    css(el, "height", height);
    return Transition.start(el, {
      height: 0,
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      borderTop: 0,
      borderBottom: 0,
      opacity: 0
    }, velocity * height + duration, transition);
  }
  var Video = {
    args: "autoplay",
    props: {
      automute: Boolean,
      autoplay: Boolean
    },
    data: {
      automute: false,
      autoplay: true
    },
    beforeConnect: function beforeConnect() {
      if (this.autoplay === "inview" && !hasAttr(this.$el, "preload")) {
        this.$el.preload = "none";
      }
      if (isTag(this.$el, "iframe") && !hasAttr(this.$el, "allow")) {
        this.$el.allow = "autoplay";
      }
      if (this.autoplay === "hover") {
        if (isTag(this.$el, "video")) {
          this.$el.tabindex = 0;
        } else {
          this.autoplay = true;
        }
      }
      if (this.automute) {
        mute(this.$el);
      }
    },
    events: [{
      name: "".concat(pointerEnter, " focusin"),
      filter: function filter() {
        return includes(this.autoplay, "hover");
      },
      handler: function handler(e) {
        if (!isTouch(e) || !isPlaying(this.$el)) {
          play(this.$el);
        } else {
          pause(this.$el);
        }
      }
    }, {
      name: "".concat(pointerLeave, " focusout"),
      filter: function filter() {
        return includes(this.autoplay, "hover");
      },
      handler: function handler(e) {
        if (!isTouch(e)) {
          pause(this.$el);
        }
      }
    }],
    observe: [intersection({
      filter: function filter(_ref105) {
        var $el = _ref105.$el,
          autoplay = _ref105.autoplay;
        return autoplay && autoplay !== "hover" && isVideo($el);
      },
      handler: function handler(_ref106) {
        var _ref107 = (0, _slicedToArray2["default"])(_ref106, 1),
          isIntersecting = _ref107[0].isIntersecting;
        if (!document.fullscreenElement) {
          if (isIntersecting) {
            play(this.$el);
          } else {
            pause(this.$el);
          }
        }
      },
      args: {
        intersecting: false
      },
      options: function options(_ref108) {
        var $el = _ref108.$el,
          autoplay = _ref108.autoplay;
        return {
          root: autoplay === "inview" ? null : parent($el)
        };
      }
    })]
  };
  function isPlaying(videoEl) {
    return !videoEl.paused && !videoEl.ended;
  }
  var cover = {
    mixins: [Video],
    props: {
      width: Number,
      height: Number
    },
    data: {
      automute: true
    },
    events: {
      "load loadedmetadata": function loadLoadedmetadata() {
        this.$emit("resize");
      }
    },
    observe: resize({
      target: function target(_ref109) {
        var $el = _ref109.$el;
        return [getPositionedParent($el) || parent($el)];
      },
      filter: function filter(_ref110) {
        var $el = _ref110.$el;
        return !useObjectFit($el);
      }
    }),
    update: {
      read: function read() {
        if (useObjectFit(this.$el)) {
          return;
        }
        var ratio = Dimensions.ratio,
          cover = Dimensions.cover;
        var $el = this.$el,
          width = this.width,
          height = this.height;
        var dim = {
          width: width,
          height: height
        };
        if (!width || !height) {
          var intrinsic = {
            width: $el.naturalWidth || $el.videoWidth || $el.clientWidth,
            height: $el.naturalHeight || $el.videoHeight || $el.clientHeight
          };
          if (width) {
            dim = ratio(intrinsic, "width", width);
          } else if (height) {
            dim = ratio(intrinsic, "height", height);
          } else {
            dim = intrinsic;
          }
        }
        var _ref111 = getPositionedParent($el) || parent($el),
          coverHeight = _ref111.offsetHeight,
          coverWidth = _ref111.offsetWidth;
        var coverDim = cover(dim, {
          width: coverWidth + (coverWidth % 2 ? 1 : 0),
          height: coverHeight + (coverHeight % 2 ? 1 : 0)
        });
        if (!coverDim.width || !coverDim.height) {
          return false;
        }
        return coverDim;
      },
      write: function write(_ref112) {
        var height = _ref112.height,
          width = _ref112.width;
        css(this.$el, {
          height: height,
          width: width
        });
      },
      events: ["resize"]
    }
  };
  function getPositionedParent(el) {
    while (el = parent(el)) {
      if (css(el, "position") !== "static") {
        return el;
      }
    }
  }
  function useObjectFit(el) {
    return isTag(el, "img", "video");
  }
  var active;
  var drop = {
    mixins: [Container, Position, Togglable],
    args: "pos",
    props: {
      mode: "list",
      toggle: Boolean,
      boundary: Boolean,
      boundaryX: Boolean,
      boundaryY: Boolean,
      target: Boolean,
      targetX: Boolean,
      targetY: Boolean,
      stretch: Boolean,
      delayShow: Number,
      delayHide: Number,
      autoUpdate: Boolean,
      clsDrop: String,
      animateOut: Boolean,
      bgScroll: Boolean,
      closeOnScroll: Boolean
    },
    data: {
      mode: ["click", "hover"],
      toggle: "- *",
      boundary: false,
      boundaryX: false,
      boundaryY: false,
      target: false,
      targetX: false,
      targetY: false,
      stretch: false,
      delayShow: 0,
      delayHide: 800,
      autoUpdate: true,
      clsDrop: false,
      animateOut: false,
      bgScroll: true,
      animation: ["uk-animation-fade"],
      cls: "uk-open",
      container: false,
      closeOnScroll: false
    },
    computed: {
      boundary: function boundary(_ref113, $el) {
        var boundary = _ref113.boundary,
          boundaryX = _ref113.boundaryX,
          boundaryY = _ref113.boundaryY;
        return [query(boundaryX || boundary, $el) || window, query(boundaryY || boundary, $el) || window];
      },
      target: function target(_ref114, $el) {
        var target = _ref114.target,
          targetX = _ref114.targetX,
          targetY = _ref114.targetY;
        targetX || (targetX = target || this.targetEl);
        targetY || (targetY = target || this.targetEl);
        return [targetX === true ? window : query(targetX, $el), targetY === true ? window : query(targetY, $el)];
      }
    },
    created: function created() {
      this.tracker = new MouseTracker();
    },
    beforeConnect: function beforeConnect() {
      this.clsDrop = this.$props.clsDrop || "uk-".concat(this.$options.name);
    },
    connected: function connected() {
      addClass(this.$el, "uk-drop", this.clsDrop);
      if (this.toggle && !this.targetEl) {
        this.targetEl = createToggleComponent(this);
      }
      this._style = pick(this.$el.style, ["width", "height"]);
    },
    disconnected: function disconnected() {
      if (this.isActive()) {
        this.hide(false);
        active = null;
      }
      css(this.$el, this._style);
    },
    observe: lazyload({
      target: function target(_ref115) {
        var toggle = _ref115.toggle,
          $el = _ref115.$el;
        return query(toggle, $el);
      },
      targets: function targets(_ref116) {
        var $el = _ref116.$el;
        return $el;
      }
    }),
    events: [{
      name: "click",
      delegate: function delegate() {
        return ".uk-drop-close";
      },
      handler: function handler(e) {
        e.preventDefault();
        this.hide(false);
      }
    }, {
      name: "click",
      delegate: function delegate() {
        return 'a[href*="#"]';
      },
      handler: function handler(_ref117) {
        var defaultPrevented = _ref117.defaultPrevented,
          current = _ref117.current;
        var hash = current.hash;
        if (!defaultPrevented && hash && isSameSiteAnchor(current) && !this.$el.contains($(hash))) {
          this.hide(false);
        }
      }
    }, {
      name: "beforescroll",
      handler: function handler() {
        this.hide(false);
      }
    }, {
      name: "toggle",
      self: true,
      handler: function handler(e, toggle) {
        e.preventDefault();
        if (this.isToggled()) {
          this.hide(false);
        } else {
          this.show(toggle == null ? void 0 : toggle.$el, false);
        }
      }
    }, {
      name: "toggleshow",
      self: true,
      handler: function handler(e, toggle) {
        e.preventDefault();
        this.show(toggle == null ? void 0 : toggle.$el);
      }
    }, {
      name: "togglehide",
      self: true,
      handler: function handler(e) {
        e.preventDefault();
        if (!matches(this.$el, ":focus,:hover")) {
          this.hide();
        }
      }
    }, {
      name: "".concat(pointerEnter, " focusin"),
      filter: function filter() {
        return includes(this.mode, "hover");
      },
      handler: function handler(e) {
        if (!isTouch(e)) {
          this.clearTimers();
        }
      }
    }, {
      name: "".concat(pointerLeave, " focusout"),
      filter: function filter() {
        return includes(this.mode, "hover");
      },
      handler: function handler(e) {
        if (!isTouch(e) && e.relatedTarget) {
          this.hide();
        }
      }
    }, {
      name: "toggled",
      self: true,
      handler: function handler(e, toggled) {
        if (toggled) {
          this.clearTimers();
          this.position();
        }
      }
    }, {
      name: "show",
      self: true,
      handler: function handler() {
        active = this;
        this.tracker.init();
        attr(this.targetEl, "aria-expanded", true);
        var handlers = [listenForResize(this), listenForEscClose(this), listenForBackgroundClose(this), this.autoUpdate && listenForScroll(this), this.closeOnScroll && listenForScrollClose(this)];
        once(this.$el, "hide", function () {
          return handlers.forEach(function (handler) {
            return handler && handler();
          });
        }, {
          self: true
        });
        if (!this.bgScroll) {
          once(this.$el, "hidden", preventBackgroundScroll(this.$el), {
            self: true
          });
        }
      }
    }, {
      name: "beforehide",
      self: true,
      handler: "clearTimers"
    }, {
      name: "hide",
      handler: function handler(_ref118) {
        var target = _ref118.target;
        if (this.$el !== target) {
          active = active === null && this.$el.contains(target) && this.isToggled() ? this : active;
          return;
        }
        active = this.isActive() ? null : active;
        this.tracker.cancel();
        attr(this.targetEl, "aria-expanded", null);
      }
    }],
    update: {
      write: function write() {
        if (this.isToggled() && !hasClass(this.$el, this.clsEnter)) {
          this.position();
        }
      }
    },
    methods: {
      show: function show() {
        var _this39 = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.targetEl;
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (this.isToggled() && target && this.targetEl && target !== this.targetEl) {
          this.hide(false, false);
        }
        this.targetEl = target;
        this.clearTimers();
        if (this.isActive()) {
          return;
        }
        if (active) {
          if (delay && active.isDelaying) {
            this.showTimer = setTimeout(function () {
              return matches(target, ":hover") && _this39.show();
            }, 10);
            return;
          }
          var prev;
          while (active && prev !== active && !active.$el.contains(this.$el)) {
            prev = active;
            active.hide(false, false);
          }
        }
        if (this.container && parent(this.$el) !== this.container) {
          append(this.container, this.$el);
        }
        this.showTimer = setTimeout(function () {
          return _this39.toggleElement(_this39.$el, true);
        }, delay && this.delayShow || 0);
      },
      hide: function hide() {
        var _this40 = this;
        var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var hide = function hide() {
          return _this40.toggleElement(_this40.$el, false, _this40.animateOut && animate);
        };
        this.clearTimers();
        this.isDelayedHide = delay;
        this.isDelaying = getPositionedElements(this.$el).some(function (el) {
          return _this40.tracker.movesTo(el);
        });
        if (delay && this.isDelaying) {
          this.hideTimer = setTimeout(this.hide, 50);
        } else if (delay && this.delayHide) {
          this.hideTimer = setTimeout(hide, this.delayHide);
        } else {
          hide();
        }
      },
      clearTimers: function clearTimers() {
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
        this.showTimer = null;
        this.hideTimer = null;
        this.isDelaying = false;
      },
      isActive: function isActive() {
        return active === this;
      },
      position: function position() {
        var _this41 = this;
        removeClass(this.$el, "uk-drop-stack");
        css(this.$el, this._style);
        this.$el.hidden = true;
        var viewports = this.target.map(function (target) {
          return getViewport$1(_this41.$el, target);
        });
        var viewportOffset = this.getViewportOffset(this.$el);
        var dirs = [[0, ["x", "width", "left", "right"]], [1, ["y", "height", "top", "bottom"]]];
        for (var _i19 = 0, _dirs = dirs; _i19 < _dirs.length; _i19++) {
          var _dirs$_i = (0, _slicedToArray2["default"])(_dirs[_i19], 2),
            i = _dirs$_i[0],
            _dirs$_i$ = (0, _slicedToArray2["default"])(_dirs$_i[1], 2),
            axis = _dirs$_i$[0],
            prop = _dirs$_i$[1];
          if (this.axis !== axis && includes([axis, true], this.stretch)) {
            var _css;
            css(this.$el, (_css = {}, (0, _defineProperty2["default"])(_css, prop, Math.min(offset(this.boundary[i])[prop], viewports[i][prop] - 2 * viewportOffset)), (0, _defineProperty2["default"])(_css, "overflow-".concat(axis), "auto"), _css));
          }
        }
        var maxWidth = viewports[0].width - 2 * viewportOffset;
        this.$el.hidden = false;
        css(this.$el, "maxWidth", "");
        if (this.$el.offsetWidth > maxWidth) {
          addClass(this.$el, "uk-drop-stack");
        }
        css(this.$el, "maxWidth", maxWidth);
        this.positionAt(this.$el, this.target, this.boundary);
        for (var _i20 = 0, _dirs2 = dirs; _i20 < _dirs2.length; _i20++) {
          var _dirs2$_i = (0, _slicedToArray2["default"])(_dirs2[_i20], 2),
            _i21 = _dirs2$_i[0],
            _dirs2$_i$ = (0, _slicedToArray2["default"])(_dirs2$_i[1], 4),
            _axis = _dirs2$_i$[0],
            _prop6 = _dirs2$_i$[1],
            start = _dirs2$_i$[2],
            end = _dirs2$_i$[3];
          if (this.axis === _axis && includes([_axis, true], this.stretch)) {
            var _css2;
            var positionOffset = Math.abs(this.getPositionOffset());
            var targetOffset = offset(this.target[_i21]);
            var elOffset = offset(this.$el);
            css(this.$el, (_css2 = {}, (0, _defineProperty2["default"])(_css2, _prop6, (targetOffset[start] > elOffset[start] ? targetOffset[this.inset ? end : start] - Math.max(offset(this.boundary[_i21])[start], viewports[_i21][start] + viewportOffset) : Math.min(offset(this.boundary[_i21])[end], viewports[_i21][end] - viewportOffset) - targetOffset[this.inset ? start : end]) - positionOffset), (0, _defineProperty2["default"])(_css2, "overflow-".concat(_axis), "auto"), _css2));
            this.positionAt(this.$el, this.target, this.boundary);
          }
        }
      }
    }
  };
  function getPositionedElements(el) {
    var result = [];
    apply(el, function (el2) {
      return css(el2, "position") !== "static" && result.push(el2);
    });
    return result;
  }
  function getViewport$1(el, target) {
    return offsetViewport(overflowParents(target).find(function (parent2) {
      return parent2.contains(el);
    }));
  }
  function createToggleComponent(drop) {
    var _drop$$create = drop.$create("toggle", query(drop.toggle, drop.$el), {
        target: drop.$el,
        mode: drop.mode
      }),
      $el = _drop$$create.$el;
    attr($el, "aria-haspopup", true);
    return $el;
  }
  function listenForResize(drop) {
    var update = function update() {
      return drop.$emit();
    };
    var off = [observeViewportResize(update), observeResize(overflowParents(drop.$el).concat(drop.target), update)];
    return function () {
      return off.map(function (observer) {
        return observer.disconnect();
      });
    };
  }
  function listenForScroll(drop) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return drop.$emit();
    };
    return on([document].concat((0, _toConsumableArray2["default"])(overflowParents(drop.$el))), "scroll", fn, {
      passive: true
    });
  }
  function listenForEscClose(drop) {
    return on(document, "keydown", function (e) {
      if (e.keyCode === keyMap.ESC) {
        drop.hide(false);
      }
    });
  }
  function listenForScrollClose(drop) {
    return listenForScroll(drop, function () {
      return drop.hide(false);
    });
  }
  function listenForBackgroundClose(drop) {
    return on(document, pointerDown$1, function (_ref119) {
      var target = _ref119.target;
      if (drop.$el.contains(target)) {
        return;
      }
      once(document, "".concat(pointerUp$1, " ").concat(pointerCancel, " scroll"), function (_ref120) {
        var defaultPrevented = _ref120.defaultPrevented,
          type = _ref120.type,
          newTarget = _ref120.target;
        if (!defaultPrevented && type === pointerUp$1 && target === newTarget && !(drop.targetEl && within(target, drop.targetEl))) {
          drop.hide(false);
        }
      }, true);
    });
  }
  var Dropnav = {
    mixins: [Class, Container],
    props: {
      align: String,
      clsDrop: String,
      boundary: Boolean,
      dropbar: Boolean,
      dropbarAnchor: Boolean,
      duration: Number,
      mode: Boolean,
      offset: Boolean,
      stretch: Boolean,
      delayShow: Boolean,
      delayHide: Boolean,
      target: Boolean,
      targetX: Boolean,
      targetY: Boolean,
      animation: Boolean,
      animateOut: Boolean,
      closeOnScroll: Boolean
    },
    data: {
      align: isRtl ? "right" : "left",
      clsDrop: "uk-dropdown",
      clsDropbar: "uk-dropnav-dropbar",
      boundary: true,
      dropbar: false,
      dropbarAnchor: false,
      duration: 200,
      container: false,
      selNavItem: "> li > a, > ul > li > a"
    },
    computed: {
      dropbarAnchor: function dropbarAnchor(_ref121, $el) {
        var _dropbarAnchor = _ref121.dropbarAnchor;
        return query(_dropbarAnchor, $el) || $el;
      },
      dropbar: function dropbar(_ref122) {
        var dropbar = _ref122.dropbar;
        if (!dropbar) {
          return null;
        }
        dropbar = this._dropbar || query(dropbar, this.$el) || $("+ .".concat(this.clsDropbar), this.$el);
        return dropbar ? dropbar : this._dropbar = $("<div></div>");
      },
      dropContainer: function dropContainer(_, $el) {
        return this.container || $el;
      },
      dropdowns: function dropdowns(_ref123, $el) {
        var clsDrop = _ref123.clsDrop;
        var _a;
        var dropdowns = $$(".".concat(clsDrop), $el);
        if (this.dropContainer !== $el) {
          var _iterator59 = _createForOfIteratorHelper($$(".".concat(clsDrop), this.dropContainer)),
            _step59;
          try {
            for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
              var el = _step59.value;
              var target = (_a = this.getDropdown(el)) == null ? void 0 : _a.targetEl;
              if (!includes(dropdowns, el) && target && this.$el.contains(target)) {
                dropdowns.push(el);
              }
            }
          } catch (err) {
            _iterator59.e(err);
          } finally {
            _iterator59.f();
          }
        }
        return dropdowns;
      },
      items: function items(_ref124, $el) {
        var selNavItem = _ref124.selNavItem;
        return $$(selNavItem, $el);
      }
    },
    watch: {
      dropbar: function dropbar(_dropbar) {
        addClass(_dropbar, "uk-dropbar", "uk-dropbar-top", this.clsDropbar, "uk-".concat(this.$options.name, "-dropbar"));
      },
      dropdowns: function dropdowns() {
        this.initializeDropdowns();
      }
    },
    connected: function connected() {
      this.initializeDropdowns();
    },
    disconnected: function disconnected() {
      remove$1(this._dropbar);
      delete this._dropbar;
    },
    events: [{
      name: "mouseover focusin",
      delegate: function delegate() {
        return this.selNavItem;
      },
      handler: function handler(_ref125) {
        var current = _ref125.current;
        var active2 = this.getActive();
        if (active2 && includes(active2.mode, "hover") && active2.targetEl && !current.contains(active2.targetEl) && !active2.isDelaying) {
          active2.hide(false);
        }
      }
    }, {
      name: "keydown",
      self: true,
      delegate: function delegate() {
        return this.selNavItem;
      },
      handler: function handler(e) {
        var _a;
        var current = e.current,
          keyCode = e.keyCode;
        var active2 = this.getActive();
        if (keyCode === keyMap.DOWN && (active2 == null ? void 0 : active2.targetEl) === current) {
          e.preventDefault();
          (_a = $(selFocusable, active2.$el)) == null ? void 0 : _a.focus();
        }
        handleNavItemNavigation(e, this.items, active2);
      }
    }, {
      name: "keydown",
      el: function el() {
        return this.dropContainer;
      },
      delegate: function delegate() {
        return ".".concat(this.clsDrop);
      },
      handler: function handler(e) {
        var _a;
        var current = e.current,
          keyCode = e.keyCode;
        if (!includes(this.dropdowns, current)) {
          return;
        }
        var active2 = this.getActive();
        var next = -1;
        if (keyCode === keyMap.HOME) {
          next = 0;
        } else if (keyCode === keyMap.END) {
          next = "last";
        } else if (keyCode === keyMap.UP) {
          next = "previous";
        } else if (keyCode === keyMap.DOWN) {
          next = "next";
        } else if (keyCode === keyMap.ESC) {
          (_a = active2.targetEl) == null ? void 0 : _a.focus();
        }
        if (~next) {
          e.preventDefault();
          var elements = $$(selFocusable, current);
          elements[_getIndex(next, elements, findIndex(elements, function (el) {
            return matches(el, ":focus");
          }))].focus();
        }
        handleNavItemNavigation(e, this.items, active2);
      }
    }, {
      name: "mouseleave",
      el: function el() {
        return this.dropbar;
      },
      filter: function filter() {
        return this.dropbar;
      },
      handler: function handler() {
        var active2 = this.getActive();
        if (active2 && includes(active2.mode, "hover") && !this.dropdowns.some(function (el) {
          return matches(el, ":hover");
        })) {
          active2.hide();
        }
      }
    }, {
      name: "beforeshow",
      el: function el() {
        return this.dropContainer;
      },
      filter: function filter() {
        return this.dropbar;
      },
      handler: function handler(_ref126) {
        var target = _ref126.target;
        if (!this.isDropbarDrop(target)) {
          return;
        }
        if (this.dropbar.previousElementSibling !== this.dropbarAnchor) {
          after(this.dropbarAnchor, this.dropbar);
        }
        addClass(target, "".concat(this.clsDrop, "-dropbar"));
      }
    }, {
      name: "show",
      el: function el() {
        return this.dropContainer;
      },
      filter: function filter() {
        return this.dropbar;
      },
      handler: function handler(_ref127) {
        var _this42 = this;
        var target = _ref127.target;
        if (!this.isDropbarDrop(target)) {
          return;
        }
        var drop = this.getDropdown(target);
        var adjustHeight = function adjustHeight() {
          var maxBottom = Math.max.apply(Math, (0, _toConsumableArray2["default"])(parents(target, ".".concat(_this42.clsDrop)).concat(target).map(function (el) {
            return offset(el).bottom;
          })));
          offset(_this42.dropbar, {
            left: offset(_this42.dropbar).left,
            top: _this42.getDropbarOffset(drop.getPositionOffset())
          });
          _this42.transitionTo(maxBottom - offset(_this42.dropbar).top + toFloat(css(target, "marginBottom")), target);
        };
        this._observer = observeResize([drop.$el].concat((0, _toConsumableArray2["default"])(drop.target)), adjustHeight);
        adjustHeight();
      }
    }, {
      name: "beforehide",
      el: function el() {
        return this.dropContainer;
      },
      filter: function filter() {
        return this.dropbar;
      },
      handler: function handler(e) {
        var active2 = this.getActive();
        if (matches(this.dropbar, ":hover") && active2.$el === e.target && this.isDropbarDrop(active2.$el) && includes(active2.mode, "hover") && active2.isDelayedHide && !this.items.some(function (el) {
          return active2.targetEl !== el && matches(el, ":focus");
        })) {
          e.preventDefault();
        }
      }
    }, {
      name: "hide",
      el: function el() {
        return this.dropContainer;
      },
      filter: function filter() {
        return this.dropbar;
      },
      handler: function handler(_ref128) {
        var target = _ref128.target;
        var _a;
        if (!this.isDropbarDrop(target)) {
          return;
        }
        (_a = this._observer) == null ? void 0 : _a.disconnect();
        var active2 = this.getActive();
        if (!active2 || active2.$el === target) {
          this.transitionTo(0);
        }
      }
    }],
    methods: {
      getActive: function getActive() {
        var _a;
        return includes(this.dropdowns, (_a = active) == null ? void 0 : _a.$el) && active;
      },
      transitionTo: function transitionTo(newHeight, el) {
        var _this43 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
          var dropbar, oldHeight, diff;
          return _regenerator["default"].wrap(function _callee19$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                dropbar = _this43.dropbar;
                oldHeight = height(dropbar);
                el = oldHeight < newHeight && el;
                _context19.next = 5;
                return Transition.cancel([el, dropbar]);
              case 5:
                if (el) {
                  diff = offset(el).top - offset(dropbar).top - oldHeight;
                  if (diff > 0) {
                    css(el, "transitionDelay", "".concat(diff / newHeight * _this43.duration, "ms"));
                  }
                }
                css(el, "clipPath", "polygon(0 0,100% 0,100% ".concat(oldHeight, "px,0 ").concat(oldHeight, "px)"));
                height(dropbar, oldHeight);
                _context19.next = 10;
                return Promise.all([Transition.start(dropbar, {
                  height: newHeight
                }, _this43.duration), Transition.start(el, {
                  clipPath: "polygon(0 0,100% 0,100% ".concat(newHeight, "px,0 ").concat(newHeight, "px)")
                }, _this43.duration)["finally"](function () {
                  return css(el, {
                    clipPath: "",
                    transitionDelay: ""
                  });
                })])["catch"](noop);
              case 10:
              case "end":
                return _context19.stop();
            }
          }, _callee19);
        }))();
      },
      getDropdown: function getDropdown(el) {
        return this.$getComponent(el, "drop") || this.$getComponent(el, "dropdown");
      },
      isDropbarDrop: function isDropbarDrop(el) {
        return includes(this.dropdowns, el) && hasClass(el, this.clsDrop);
      },
      getDropbarOffset: function getDropbarOffset(offsetTop) {
        var $el = this.$el,
          target = this.target,
          targetY = this.targetY;
        var _offset4 = offset(query(targetY || target || $el, $el)),
          top = _offset4.top,
          height2 = _offset4.height;
        return top + height2 + offsetTop;
      },
      initializeDropdowns: function initializeDropdowns() {
        var _this44 = this;
        this.$create("drop", this.dropdowns.filter(function (el) {
          return !_this44.getDropdown(el);
        }), _objectSpread(_objectSpread({}, this.$props), {}, {
          flip: false,
          shift: true,
          pos: "bottom-".concat(this.align),
          boundary: this.boundary === true ? this.$el : this.boundary
        }));
      }
    }
  };
  function handleNavItemNavigation(e, toggles, active2) {
    var _a, _b, _c;
    var current = e.current,
      keyCode = e.keyCode;
    var next = -1;
    if (keyCode === keyMap.HOME) {
      next = 0;
    } else if (keyCode === keyMap.END) {
      next = "last";
    } else if (keyCode === keyMap.LEFT) {
      next = "previous";
    } else if (keyCode === keyMap.RIGHT) {
      next = "next";
    } else if (keyCode === keyMap.TAB) {
      (_a = active2.targetEl) == null ? void 0 : _a.focus();
      (_b = active2.hide) == null ? void 0 : _b.call(active2, false);
    }
    if (~next) {
      e.preventDefault();
      (_c = active2.hide) == null ? void 0 : _c.call(active2, false);
      toggles[_getIndex(next, toggles, toggles.indexOf(active2.targetEl || current))].focus();
    }
  }
  var formCustom = {
    mixins: [Class],
    args: "target",
    props: {
      target: Boolean
    },
    data: {
      target: false
    },
    computed: {
      input: function input(_, $el) {
        return $(selInput, $el);
      },
      state: function state() {
        return this.input.nextElementSibling;
      },
      target: function target(_ref129, $el) {
        var target = _ref129.target;
        return target && (target === true && parent(this.input) === $el && this.input.nextElementSibling || $(target, $el));
      }
    },
    update: function update() {
      var _a;
      var target = this.target,
        input = this.input;
      if (!target) {
        return;
      }
      var option;
      var prop = isInput(target) ? "value" : "textContent";
      var prev = target[prop];
      var value = ((_a = input.files) == null ? void 0 : _a[0]) ? input.files[0].name : matches(input, "select") && (option = $$("option", input).filter(function (el) {
        return el.selected;
      })[0]) ? option.textContent : input.value;
      if (prev !== value) {
        target[prop] = value;
      }
    },
    events: [{
      name: "change",
      handler: function handler() {
        this.$emit();
      }
    }, {
      name: "reset",
      el: function el() {
        return this.$el.closest("form");
      },
      handler: function handler() {
        this.$emit();
      }
    }]
  };
  var grid = {
    "extends": Margin,
    mixins: [Class],
    name: "grid",
    props: {
      masonry: Boolean,
      parallax: String,
      parallaxStart: String,
      parallaxEnd: String,
      parallaxJustify: Boolean
    },
    data: {
      margin: "uk-grid-margin",
      clsStack: "uk-grid-stack",
      masonry: false,
      parallax: 0,
      parallaxStart: 0,
      parallaxEnd: 0,
      parallaxJustify: false
    },
    connected: function connected() {
      this.masonry && addClass(this.$el, "uk-flex-top", "uk-flex-wrap-top");
    },
    observe: scroll$1({
      filter: function filter(_ref130) {
        var parallax = _ref130.parallax,
          parallaxJustify = _ref130.parallaxJustify;
        return parallax || parallaxJustify;
      }
    }),
    update: [{
      write: function write(_ref131) {
        var rows = _ref131.rows;
        toggleClass(this.$el, this.clsStack, !rows.some(function (row) {
          return row.length > 1;
        }));
      },
      events: ["resize"]
    }, {
      read: function read(data) {
        var rows = data.rows;
        var masonry = this.masonry,
          parallax = this.parallax,
          parallaxJustify = this.parallaxJustify,
          margin = this.margin;
        parallax = Math.max(0, toPx(parallax));
        if (!(masonry || parallax || parallaxJustify) || positionedAbsolute(rows) || rows[0].some(function (el, i) {
          return rows.some(function (row) {
            return row[i] && row[i].offsetWidth !== el.offsetWidth;
          });
        })) {
          return data.translates = data.scrollColumns = false;
        }
        var gutter = getGutter(rows, margin);
        var columns;
        var translates;
        if (masonry) {
          var _applyMasonry = applyMasonry(rows, gutter, masonry === "next");
          var _applyMasonry2 = (0, _slicedToArray2["default"])(_applyMasonry, 2);
          columns = _applyMasonry2[0];
          translates = _applyMasonry2[1];
        } else {
          columns = transpose(rows);
        }
        var columnHeights = columns.map(function (column) {
          return sumBy(column, "offsetHeight") + gutter * (column.length - 1);
        });
        var height = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(columnHeights)));
        var scrollColumns;
        var parallaxStart;
        var parallaxEnd;
        if (parallax || parallaxJustify) {
          scrollColumns = columnHeights.map(function (hgt, i) {
            return parallaxJustify ? height - hgt + parallax : parallax / (i % 2 || 8);
          });
          if (!parallaxJustify) {
            parallax = Math.max.apply(Math, (0, _toConsumableArray2["default"])(columnHeights.map(function (hgt, i) {
              return hgt + scrollColumns[i] - height;
            })));
          }
          parallaxStart = toPx(this.parallaxStart, "height", this.$el, true);
          parallaxEnd = toPx(this.parallaxEnd, "height", this.$el, true);
        }
        return {
          columns: columns,
          translates: translates,
          scrollColumns: scrollColumns,
          parallaxStart: parallaxStart,
          parallaxEnd: parallaxEnd,
          padding: parallax,
          height: translates ? height : ""
        };
      },
      write: function write(_ref132) {
        var height = _ref132.height,
          padding = _ref132.padding;
        css(this.$el, "paddingBottom", padding || "");
        height !== false && css(this.$el, "height", height);
      },
      events: ["resize"]
    }, {
      read: function read(_ref133) {
        var rows = _ref133.rows,
          scrollColumns = _ref133.scrollColumns,
          parallaxStart = _ref133.parallaxStart,
          parallaxEnd = _ref133.parallaxEnd;
        if (scrollColumns && positionedAbsolute(rows)) {
          return false;
        }
        return {
          scrolled: scrollColumns ? scrolledOver(this.$el, parallaxStart, parallaxEnd) : false
        };
      },
      write: function write(_ref134) {
        var columns = _ref134.columns,
          scrolled = _ref134.scrolled,
          scrollColumns = _ref134.scrollColumns,
          translates = _ref134.translates;
        if (!scrolled && !translates) {
          return;
        }
        columns.forEach(function (column, i) {
          return column.forEach(function (el, j) {
            var _ref135 = translates && translates[i][j] || [0, 0],
              _ref136 = (0, _slicedToArray2["default"])(_ref135, 2),
              x = _ref136[0],
              y = _ref136[1];
            if (scrolled) {
              y += scrolled * scrollColumns[i];
            }
            css(el, "transform", "translate(".concat(x, "px, ").concat(y, "px)"));
          });
        });
      },
      events: ["scroll", "resize"]
    }]
  };
  function positionedAbsolute(rows) {
    return rows.flat().some(function (el) {
      return css(el, "position") === "absolute";
    });
  }
  function applyMasonry(rows, gutter, next) {
    var columns = [];
    var translates = [];
    var columnHeights = Array(rows[0].length).fill(0);
    var rowHeights = 0;
    var _iterator60 = _createForOfIteratorHelper(rows),
      _step60;
    try {
      for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
        var row = _step60.value;
        if (isRtl) {
          row = row.reverse();
        }
        var _height3 = 0;
        for (var j in row) {
          var _row$j = row[j],
            offsetWidth = _row$j.offsetWidth,
            offsetHeight = _row$j.offsetHeight;
          var _index4 = next ? j : columnHeights.indexOf(Math.min.apply(Math, (0, _toConsumableArray2["default"])(columnHeights)));
          push(columns, _index4, row[j]);
          push(translates, _index4, [(_index4 - j) * offsetWidth * (isRtl ? -1 : 1), columnHeights[_index4] - rowHeights]);
          columnHeights[_index4] += offsetHeight + gutter;
          _height3 = Math.max(_height3, offsetHeight);
        }
        rowHeights += _height3 + gutter;
      }
    } catch (err) {
      _iterator60.e(err);
    } finally {
      _iterator60.f();
    }
    return [columns, translates];
  }
  function getGutter(rows, cls) {
    var node = rows.flat().find(function (el) {
      return hasClass(el, cls);
    });
    return toFloat(node ? css(node, "marginTop") : css(rows[0][0], "paddingLeft"));
  }
  function transpose(rows) {
    var columns = [];
    var _iterator61 = _createForOfIteratorHelper(rows),
      _step61;
    try {
      for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
        var row = _step61.value;
        for (var i in row) {
          push(columns, i, row[i]);
        }
      }
    } catch (err) {
      _iterator61.e(err);
    } finally {
      _iterator61.f();
    }
    return columns;
  }
  function push(array, index, value) {
    if (!array[index]) {
      array[index] = [];
    }
    array[index].push(value);
  }
  var heightMatch = {
    args: "target",
    props: {
      target: String,
      row: Boolean
    },
    data: {
      target: "> *",
      row: true
    },
    computed: {
      elements: function elements(_ref137, $el) {
        var target = _ref137.target;
        return $$(target, $el);
      }
    },
    observe: resize({
      target: function target(_ref138) {
        var $el = _ref138.$el,
          elements = _ref138.elements;
        return elements.reduce(function (elements2, el) {
          return elements2.concat.apply(elements2, [el].concat((0, _toConsumableArray2["default"])(el.children)));
        }, [$el]);
      }
    }),
    events: {
      // Hidden elements may change height when fonts load
      name: "loadingdone",
      el: function el() {
        return document.fonts;
      },
      handler: function handler() {
        this.$emit("resize");
      }
    },
    update: {
      read: function read() {
        return {
          rows: (this.row ? getRows(this.elements) : [this.elements]).map(match)
        };
      },
      write: function write(_ref139) {
        var rows = _ref139.rows;
        var _iterator62 = _createForOfIteratorHelper(rows),
          _step62;
        try {
          var _loop9 = function _loop9() {
            var _step62$value = _step62.value,
              heights = _step62$value.heights,
              elements = _step62$value.elements;
            elements.forEach(function (el, i) {
              return css(el, "minHeight", heights[i]);
            });
          };
          for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
            _loop9();
          }
        } catch (err) {
          _iterator62.e(err);
        } finally {
          _iterator62.f();
        }
      },
      events: ["resize"]
    }
  };
  function match(elements) {
    if (elements.length < 2) {
      return {
        heights: [""],
        elements: elements
      };
    }
    var heights = elements.map(getHeight);
    var max = Math.max.apply(Math, (0, _toConsumableArray2["default"])(heights));
    return {
      heights: elements.map(function (el, i) {
        return heights[i].toFixed(2) === max.toFixed(2) ? "" : max;
      }),
      elements: elements
    };
  }
  function getHeight(element) {
    var style = pick(element.style, ["display", "minHeight"]);
    if (!isVisible(element)) {
      css(element, "display", "block", "important");
    }
    css(element, "minHeight", "");
    var height = dimensions$1(element).height - boxModelAdjust(element, "height", "content-box");
    css(element, style);
    return height;
  }
  var heightPlaceholder = {
    args: "target",
    props: {
      target: String
    },
    data: {
      target: ""
    },
    computed: {
      target: function target(_ref140, $el) {
        var _target5 = _ref140.target;
        return query(_target5, $el);
      }
    },
    observe: resize({
      target: function target(_ref141) {
        var _target6 = _ref141.target;
        return _target6;
      }
    }),
    update: {
      read: function read() {
        return {
          height: this.target.offsetHeight
        };
      },
      write: function write(_ref142) {
        var height = _ref142.height;
        css(this.$el, {
          minHeight: height
        });
      },
      events: ["resize"]
    }
  };
  var heightViewport = {
    props: {
      expand: Boolean,
      offsetTop: Boolean,
      offsetBottom: Boolean,
      minHeight: Number
    },
    data: {
      expand: false,
      offsetTop: false,
      offsetBottom: false,
      minHeight: 0
    },
    // check for offsetTop change
    observe: [viewport({
      filter: function filter(_ref143) {
        var expand = _ref143.expand;
        return expand;
      }
    }), resize({
      target: function target(_ref144) {
        var $el = _ref144.$el;
        return scrollParents($el);
      }
    })],
    update: {
      read: function read() {
        if (!isVisible(this.$el)) {
          return false;
        }
        var minHeight = "";
        var box = boxModelAdjust(this.$el, "height", "content-box");
        var _document2 = document,
          body = _document2.body,
          scrollingElement = _document2.scrollingElement;
        var scrollElement = scrollParent(this.$el);
        var _offsetViewport4 = offsetViewport(scrollElement === body ? scrollingElement : scrollElement),
          viewportHeight = _offsetViewport4.height;
        var isScrollingElement = scrollingElement === scrollElement || body === scrollElement;
        minHeight = "calc(".concat(isScrollingElement ? "100vh" : "".concat(viewportHeight, "px"));
        if (this.expand) {
          var diff = dimensions$1(scrollElement).height - dimensions$1(this.$el).height;
          minHeight += " - ".concat(diff, "px");
        } else {
          if (this.offsetTop) {
            if (isScrollingElement) {
              var offsetTopEl = this.offsetTop === true ? this.$el : query(this.offsetTop, this.$el);
              var top = offsetPosition(offsetTopEl)[0] - offsetPosition(scrollElement)[0];
              minHeight += top > 0 && top < viewportHeight / 2 ? " - ".concat(top, "px") : "";
            } else {
              minHeight += " - ".concat(css(scrollElement, "paddingTop"));
            }
          }
          if (this.offsetBottom === true) {
            minHeight += " - ".concat(dimensions$1(this.$el.nextElementSibling).height, "px");
          } else if (isNumeric(this.offsetBottom)) {
            minHeight += " - ".concat(this.offsetBottom, "vh");
          } else if (this.offsetBottom && endsWith(this.offsetBottom, "px")) {
            minHeight += " - ".concat(toFloat(this.offsetBottom), "px");
          } else if (isString(this.offsetBottom)) {
            minHeight += " - ".concat(dimensions$1(query(this.offsetBottom, this.$el)).height, "px");
          }
        }
        minHeight += "".concat(box ? " - ".concat(box, "px") : "", ")");
        return {
          minHeight: minHeight
        };
      },
      write: function write(_ref145) {
        var minHeight = _ref145.minHeight;
        css(this.$el, "minHeight", "max(".concat(this.minHeight || 0, "px, ").concat(minHeight, ")"));
      },
      events: ["resize"]
    }
  };
  var closeIcon = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"1\" y1=\"1\" x2=\"13\" y2=\"13\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"13\" y1=\"1\" x2=\"1\" y2=\"13\"/></svg>";
  var closeLarge = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" x1=\"1\" y1=\"1\" x2=\"19\" y2=\"19\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" x1=\"19\" y1=\"1\" x2=\"1\" y2=\"19\"/></svg>";
  var dropParentIcon = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"1 3.5 6 8.5 11 3.5\"/></svg>";
  var marker = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><rect width=\"1\" height=\"11\" x=\"9\" y=\"4\"/><rect width=\"11\" height=\"1\" x=\"4\" y=\"9\"/></svg>";
  var navParentIconLarge = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"1 4 7 10 13 4\"/></svg>";
  var navParentIcon = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"1 3.5 6 8.5 11 3.5\"/></svg>";
  var navbarParentIcon = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"1 3.5 6 8.5 11 3.5\"/></svg>";
  var navbarToggleIcon = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><style>.uk-navbar-toggle-icon svg&gt;[class*=&quot;line-&quot;]{transition:0.2s ease-in-out;transition-property:transform, opacity;transform-origin:center;opacity:1}.uk-navbar-toggle-icon svg&gt;.line-3{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{opacity:1}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-2{transform:rotate(45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-3{transform:rotate(-45deg)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1,.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{opacity:0}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-1{transform:translateY(6px) scaleX(0)}.uk-navbar-toggle-animate[aria-expanded=&quot;true&quot;] svg&gt;.line-4{transform:translateY(-6px) scaleX(0)}</style><rect width=\"20\" height=\"2\" y=\"3\" class=\"line-1\"/><rect width=\"20\" height=\"2\" y=\"9\" class=\"line-2\"/><rect width=\"20\" height=\"2\" y=\"9\" class=\"line-3\"/><rect width=\"20\" height=\"2\" y=\"15\" class=\"line-4\"/></svg>";
  var overlayIcon = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><rect width=\"1\" height=\"40\" x=\"19\" y=\"0\"/><rect width=\"40\" height=\"1\" x=\"0\" y=\"19\"/></svg>";
  var paginationNext = "<svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"1 1 6 6 1 11\"/></svg>";
  var paginationPrevious = "<svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"6 1 1 6 6 11\"/></svg>";
  var searchIcon = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9\" cy=\"9\" r=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M14,14 L18,18 L14,14 Z\"/></svg>";
  var searchLarge = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.8\" cx=\"17.5\" cy=\"17.5\" r=\"16.5\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.8\" x1=\"38\" y1=\"39\" x2=\"29\" y2=\"30\"/></svg>";
  var searchNavbar = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10.5\" cy=\"10.5\" r=\"9.5\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"23\" y1=\"23\" x2=\"17\" y2=\"17\"/></svg>";
  var slidenavNextLarge = "<svg width=\"25\" height=\"40\" viewBox=\"0 0 25 40\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"2\" points=\"4.002,38.547 22.527,20.024 4,1.5\"/></svg>";
  var slidenavNext = "<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"1.225,23 12.775,12 1.225,1\"/></svg>";
  var slidenavPreviousLarge = "<svg width=\"25\" height=\"40\" viewBox=\"0 0 25 40\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"2\" points=\"20.527,1.5 2,20.024 20.525,38.547\"/></svg>";
  var slidenavPrevious = "<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"12.775,1 1.225,12 12.775,23\"/></svg>";
  var spinner = "<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\"><circle fill=\"none\" stroke=\"#000\" cx=\"15\" cy=\"15\" r=\"14\"/></svg>";
  var totop = "<svg width=\"18\" height=\"10\" viewBox=\"0 0 18 10\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"1 9 9 1 17 9\"/></svg>";
  var Svg = {
    args: "src",
    props: {
      width: Number,
      height: Number,
      ratio: Number
    },
    data: {
      ratio: 1
    },
    connected: function connected() {
      var _this45 = this;
      this.svg = this.getSvg().then(function (el) {
        if (!_this45._connected) {
          return;
        }
        var svg = insertSVG(el, _this45.$el);
        if (_this45.svgEl && svg !== _this45.svgEl) {
          remove$1(_this45.svgEl);
        }
        applyWidthAndHeight.call(_this45, svg, el);
        return _this45.svgEl = svg;
      }, noop);
    },
    disconnected: function disconnected() {
      var _this46 = this;
      this.svg.then(function (svg) {
        if (_this46._connected) {
          return;
        }
        if (isVoidElement(_this46.$el)) {
          _this46.$el.hidden = false;
        }
        remove$1(svg);
        _this46.svgEl = null;
      });
      this.svg = null;
    },
    methods: {
      getSvg: function getSvg() {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20() {
          return _regenerator["default"].wrap(function _callee20$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
              case "end":
                return _context20.stop();
            }
          }, _callee20);
        }))();
      }
    }
  };
  function insertSVG(el, root) {
    if (isVoidElement(root) || isTag(root, "canvas")) {
      root.hidden = true;
      var next = root.nextElementSibling;
      return equals(el, next) ? next : after(root, el);
    }
    var last = root.lastElementChild;
    return equals(el, last) ? last : append(root, el);
  }
  function equals(el, other) {
    return isTag(el, "svg") && isTag(other, "svg") && el.innerHTML === other.innerHTML;
  }
  function applyWidthAndHeight(el, ref) {
    var _this47 = this;
    var props = ["width", "height"];
    var dimensions = props.map(function (prop) {
      return _this47[prop];
    });
    if (!dimensions.some(function (val) {
      return val;
    })) {
      dimensions = props.map(function (prop) {
        return attr(ref, prop);
      });
    }
    var viewBox = attr(ref, "viewBox");
    if (viewBox && !dimensions.some(function (val) {
      return val;
    })) {
      dimensions = viewBox.split(" ").slice(2);
    }
    dimensions.forEach(function (val, i) {
      return attr(el, props[i], toFloat(val) * _this47.ratio || null);
    });
  }
  var icons = {
    spinner: spinner,
    totop: totop,
    marker: marker,
    "close-icon": closeIcon,
    "close-large": closeLarge,
    "drop-parent-icon": dropParentIcon,
    "nav-parent-icon": navParentIcon,
    "nav-parent-icon-large": navParentIconLarge,
    "navbar-parent-icon": navbarParentIcon,
    "navbar-toggle-icon": navbarToggleIcon,
    "overlay-icon": overlayIcon,
    "pagination-next": paginationNext,
    "pagination-previous": paginationPrevious,
    "search-icon": searchIcon,
    "search-large": searchLarge,
    "search-navbar": searchNavbar,
    "search-toggle-icon": searchIcon,
    "slidenav-next": slidenavNext,
    "slidenav-next-large": slidenavNextLarge,
    "slidenav-previous": slidenavPrevious,
    "slidenav-previous-large": slidenavPreviousLarge
  };
  var Icon = {
    install: install$1,
    mixins: [Svg],
    args: "icon",
    props: {
      icon: String
    },
    isIcon: true,
    beforeConnect: function beforeConnect() {
      addClass(this.$el, "uk-icon");
    },
    methods: {
      getSvg: function getSvg() {
        var _this48 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
          var icon;
          return _regenerator["default"].wrap(function _callee21$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                icon = getIcon(_this48.icon);
                if (icon) {
                  _context21.next = 3;
                  break;
                }
                throw "Icon not found.";
              case 3:
                return _context21.abrupt("return", icon);
              case 4:
              case "end":
                return _context21.stop();
            }
          }, _callee21);
        }))();
      }
    }
  };
  var IconComponent = {
    args: false,
    "extends": Icon,
    data: function data(vm) {
      return {
        icon: hyphenate(vm.constructor.options.name)
      };
    },
    beforeConnect: function beforeConnect() {
      addClass(this.$el, this.$options.id);
    }
  };
  var NavParentIcon = {
    "extends": IconComponent,
    beforeConnect: function beforeConnect() {
      var icon = this.$props.icon;
      this.icon = this.$el.closest(".uk-nav-primary") ? "".concat(icon, "-large") : icon;
    }
  };
  var Search = {
    "extends": IconComponent,
    mixins: [I18n],
    i18n: {
      toggle: "Open Search",
      submit: "Submit Search"
    },
    beforeConnect: function beforeConnect() {
      var isToggle = hasClass(this.$el, "uk-search-toggle") || hasClass(this.$el, "uk-navbar-toggle");
      this.icon = isToggle ? "search-toggle-icon" : hasClass(this.$el, "uk-search-icon") && closest(this.$el, ".uk-search-large") ? "search-large" : closest(this.$el, ".uk-search-navbar") ? "search-navbar" : this.$props.icon;
      if (hasAttr(this.$el, "aria-label")) {
        return;
      }
      if (isToggle) {
        var label = this.t("toggle");
        attr(this.$el, "aria-label", label);
      } else {
        var button = this.$el.closest("a,button");
        if (button) {
          var _label = this.t("submit");
          attr(button, "aria-label", _label);
        }
      }
    }
  };
  var Spinner = {
    "extends": IconComponent,
    beforeConnect: function beforeConnect() {
      attr(this.$el, "role", "status");
    },
    methods: {
      getSvg: function getSvg() {
        var _this49 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
          var icon;
          return _regenerator["default"].wrap(function _callee22$(_context22) {
            while (1) switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return Icon.methods.getSvg.call(_this49);
              case 2:
                icon = _context22.sent;
                if (_this49.ratio !== 1) {
                  css($("circle", icon), "strokeWidth", 1 / _this49.ratio);
                }
                return _context22.abrupt("return", icon);
              case 5:
              case "end":
                return _context22.stop();
            }
          }, _callee22);
        }))();
      }
    }
  };
  var ButtonComponent = {
    "extends": IconComponent,
    mixins: [I18n],
    beforeConnect: function beforeConnect() {
      var button = this.$el.closest("a,button");
      attr(button, "role", this.role !== null && isTag(button, "a") ? "button" : this.role);
      var label = this.t("label");
      if (label && !hasAttr(button, "aria-label")) {
        attr(button, "aria-label", label);
      }
    }
  };
  var Slidenav = {
    "extends": ButtonComponent,
    beforeConnect: function beforeConnect() {
      addClass(this.$el, "uk-slidenav");
      var icon = this.$props.icon;
      this.icon = hasClass(this.$el, "uk-slidenav-large") ? "".concat(icon, "-large") : icon;
    }
  };
  var NavbarToggleIcon = {
    "extends": ButtonComponent,
    i18n: {
      label: "Open menu"
    }
  };
  var Close = {
    "extends": ButtonComponent,
    i18n: {
      label: "Close"
    },
    beforeConnect: function beforeConnect() {
      this.icon = "close-".concat(hasClass(this.$el, "uk-close-large") ? "large" : "icon");
    }
  };
  var Marker = {
    "extends": ButtonComponent,
    i18n: {
      label: "Open"
    }
  };
  var Totop = {
    "extends": ButtonComponent,
    i18n: {
      label: "Back to top"
    }
  };
  var PaginationNext = {
    "extends": ButtonComponent,
    i18n: {
      label: "Next page"
    },
    data: {
      role: null
    }
  };
  var PaginationPrevious = {
    "extends": ButtonComponent,
    i18n: {
      label: "Previous page"
    },
    data: {
      role: null
    }
  };
  var parsed = {};
  function install$1(UIkit) {
    UIkit.icon.add = function (name, svg) {
      var added = isString(name) ? (0, _defineProperty2["default"])({}, name, svg) : name;
      each(added, function (svg2, name2) {
        icons[name2] = svg2;
        delete parsed[name2];
      });
      if (UIkit._initialized) {
        apply(document.body, function (el) {
          return each(UIkit.getComponents(el), function (cmp) {
            cmp.$options.isIcon && cmp.icon in added && cmp.$reset();
          });
        });
      }
    };
  }
  var aliases = {
    twitter: "x"
  };
  function getIcon(icon) {
    icon = aliases[icon] || icon;
    if (!icons[icon]) {
      return null;
    }
    if (!parsed[icon]) {
      parsed[icon] = $((icons[applyRtl(icon)] || icons[icon]).trim());
    }
    return parsed[icon].cloneNode(true);
  }
  function applyRtl(icon) {
    return isRtl ? swap(swap(icon, "left", "right"), "previous", "next") : icon;
  }
  var img = {
    args: "dataSrc",
    props: {
      dataSrc: String,
      sources: String,
      margin: String,
      target: String,
      loading: String
    },
    data: {
      dataSrc: "",
      sources: false,
      margin: "50%",
      target: false,
      loading: "lazy"
    },
    connected: function connected() {
      if (this.loading !== "lazy") {
        this.load();
      } else if (isImg(this.$el)) {
        this.$el.loading = "lazy";
        setSrcAttrs(this.$el);
      }
    },
    disconnected: function disconnected() {
      if (this.img) {
        this.img.onload = "";
      }
      delete this.img;
    },
    observe: intersection({
      target: function target(_ref147) {
        var $el = _ref147.$el,
          $props = _ref147.$props;
        return [$el].concat((0, _toConsumableArray2["default"])(queryAll($props.target, $el)));
      },
      handler: function handler(entries, observer) {
        this.load();
        observer.disconnect();
      },
      options: function options(_ref148) {
        var margin = _ref148.margin;
        return {
          rootMargin: margin
        };
      },
      filter: function filter(_ref149) {
        var loading = _ref149.loading;
        return loading === "lazy";
      }
    }),
    methods: {
      load: function load() {
        if (this.img) {
          return this.img;
        }
        var image = isImg(this.$el) ? this.$el : getImageFromElement(this.$el, this.dataSrc, this.sources);
        removeAttr(image, "loading");
        setSrcAttrs(this.$el, image.currentSrc);
        return this.img = image;
      }
    }
  };
  function setSrcAttrs(el, src) {
    if (isImg(el)) {
      var parentNode = parent(el);
      var elements = isTag(parentNode, "picture") ? _children(parentNode) : [el];
      elements.forEach(function (el2) {
        return setSourceProps(el2, el2);
      });
    } else if (src) {
      var change = !includes(el.style.backgroundImage, src);
      if (change) {
        css(el, "backgroundImage", "url(".concat(escape(src), ")"));
        trigger(el, createEvent("load", false));
      }
    }
  }
  var srcProps = ["data-src", "data-srcset", "sizes"];
  function setSourceProps(sourceEl, targetEl) {
    var _iterator63 = _createForOfIteratorHelper(srcProps),
      _step63;
    try {
      for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
        var prop = _step63.value;
        var value = data(sourceEl, prop);
        if (value) {
          attr(targetEl, prop.replace(/^(data-)+/, ""), value);
        }
      }
    } catch (err) {
      _iterator63.e(err);
    } finally {
      _iterator63.f();
    }
  }
  function getImageFromElement(el, src, sources) {
    var img = new Image();
    wrapInPicture(img, sources);
    setSourceProps(el, img);
    img.onload = function () {
      setSrcAttrs(el, img.currentSrc);
    };
    attr(img, "src", src);
    return img;
  }
  function wrapInPicture(img, sources) {
    sources = parseSources(sources);
    if (sources.length) {
      var picture = fragment("<picture>");
      var _iterator64 = _createForOfIteratorHelper(sources),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var attrs = _step64.value;
          var source = fragment("<source>");
          attr(source, attrs);
          append(picture, source);
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
      append(picture, img);
    }
  }
  function parseSources(sources) {
    if (!sources) {
      return [];
    }
    if (startsWith(sources, "[")) {
      try {
        sources = JSON.parse(sources);
      } catch (e) {
        sources = [];
      }
    } else {
      sources = parseOptions(sources);
    }
    if (!isArray(sources)) {
      sources = [sources];
    }
    return sources.filter(function (source) {
      return !isEmpty(source);
    });
  }
  function isImg(el) {
    return isTag(el, "img");
  }
  var inverse = {
    props: {
      target: String,
      selActive: String
    },
    data: {
      target: false,
      selActive: false
    },
    computed: {
      target: function target(_ref150, $el) {
        var _target7 = _ref150.target;
        return _target7 ? $$(_target7, $el) : [$el];
      }
    },
    observe: [mutation({
      target: function target(_ref151) {
        var _target8 = _ref151.target;
        return _target8;
      },
      options: {
        attributes: true,
        attributeFilter: ["class"],
        attributeOldValue: true
      }
    }), {
      target: function target(_ref152) {
        var _target9 = _ref152.target;
        return _target9;
      },
      observe: function observe(target, handler) {
        var observer = observeResize([].concat((0, _toConsumableArray2["default"])(target), [document.documentElement]), handler);
        var listener = [on(document, "scroll itemshown itemhidden", handler, {
          passive: true,
          capture: true
        }), on(document, "show hide transitionstart", function (e) {
          handler();
          return observer.observe(e.target);
        }), on(document, "shown hidden transitionend transitioncancel", function (e) {
          handler();
          return observer.unobserve(e.target);
        })];
        return {
          disconnect: function disconnect() {
            observer.disconnect();
            listener.map(function (off) {
              return off();
            });
          }
        };
      },
      handler: function handler() {
        this.$emit();
      }
    }],
    update: {
      read: function read() {
        var _iterator65 = _createForOfIteratorHelper(this.target),
          _step65;
        try {
          for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
            var target = _step65.value;
            replaceClass(target, "uk-light,uk-dark", !this.selActive || matches(target, this.selActive) ? findTargetColor(target) : "");
          }
        } catch (err) {
          _iterator65.e(err);
        } finally {
          _iterator65.f();
        }
      }
    }
  };
  function findTargetColor(target) {
    var _dimensions$6 = dimensions$1(target),
      left = _dimensions$6.left,
      top = _dimensions$6.top,
      height = _dimensions$6.height,
      width = _dimensions$6.width;
    var last;
    for (var _i22 = 0, _arr13 = [0.25, 0.5, 0.75]; _i22 < _arr13.length; _i22++) {
      var _percent3 = _arr13[_i22];
      var elements = target.ownerDocument.elementsFromPoint(Math.max(0, left) + width * _percent3, Math.max(0, top) + height / 2);
      var _iterator66 = _createForOfIteratorHelper(elements),
        _step66;
      try {
        var _loop10 = function _loop10() {
          var element = _step66.value;
          if (target.contains(element) || element.closest('[class*="-leave"]') && elements.some(function (el) {
            return element !== el && matches(el, '[class*="-enter"]');
          })) {
            return "continue";
          }
          var color = css(element, "--uk-inverse");
          if (color) {
            if (color === last) {
              return {
                v: "uk-".concat(color)
              };
            }
            last = color;
            return "break";
          }
        };
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var _ret4 = _loop10();
          if (_ret4 === "continue") continue;
          if (_ret4 === "break") break;
          if ((0, _typeof2["default"])(_ret4) === "object") return _ret4.v;
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }
    }
    return last ? "uk-".concat(last) : "";
  }
  var leader = {
    mixins: [Class, Media],
    props: {
      fill: String
    },
    data: {
      fill: "",
      clsWrapper: "uk-leader-fill",
      clsHide: "uk-leader-hide",
      attrFill: "data-fill"
    },
    computed: {
      fill: function fill(_ref153, $el) {
        var _fill = _ref153.fill;
        return _fill || css($el, "--uk-leader-fill-content");
      }
    },
    connected: function connected() {
      var _wrapInner = wrapInner(this.$el, "<span class=\"".concat(this.clsWrapper, "\">"));
      var _wrapInner2 = (0, _slicedToArray2["default"])(_wrapInner, 1);
      this.wrapper = _wrapInner2[0];
    },
    disconnected: function disconnected() {
      unwrap(this.wrapper.childNodes);
    },
    observe: resize(),
    update: {
      read: function read() {
        var width = Math.trunc(this.$el.offsetWidth / 2);
        return {
          width: width,
          fill: this.fill,
          hide: !this.matchMedia
        };
      },
      write: function write(_ref154) {
        var width = _ref154.width,
          fill = _ref154.fill,
          hide = _ref154.hide;
        toggleClass(this.wrapper, this.clsHide, hide);
        attr(this.wrapper, this.attrFill, new Array(width).join(fill));
      },
      events: ["resize"]
    }
  };
  var modal = {
    install: install,
    mixins: [Modal],
    data: {
      clsPage: "uk-modal-page",
      selPanel: ".uk-modal-dialog",
      selClose: ".uk-modal-close, .uk-modal-close-default, .uk-modal-close-outside, .uk-modal-close-full"
    },
    events: [{
      name: "fullscreenchange webkitendfullscreen",
      capture: true,
      handler: function handler(e) {
        if (isTag(e.target, "video") && this.isToggled() && !document.fullscreenElement) {
          this.hide();
        }
      }
    }, {
      name: "show",
      self: true,
      handler: function handler() {
        if (hasClass(this.panel, "uk-margin-auto-vertical")) {
          addClass(this.$el, "uk-flex");
        } else {
          css(this.$el, "display", "block");
        }
        height(this.$el);
      }
    }, {
      name: "hidden",
      self: true,
      handler: function handler() {
        css(this.$el, "display", "");
        removeClass(this.$el, "uk-flex");
      }
    }]
  };
  function install(_ref155) {
    var modal = _ref155.modal;
    modal.dialog = function (content, options) {
      var dialog = modal("<div class=\"uk-modal\"> <div class=\"uk-modal-dialog\">".concat(content, "</div> </div>"), _objectSpread({
        stack: true,
        role: "alertdialog"
      }, options));
      dialog.show();
      on(dialog.$el, "hidden", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return Promise.resolve();
            case 2:
              dialog.$destroy(true);
            case 3:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      })), {
        self: true
      });
      return dialog;
    };
    modal.alert = function (message, options) {
      return openDialog(function (_ref157) {
        var i18n = _ref157.i18n;
        return "<div class=\"uk-modal-body\">".concat(isString(message) ? message : html(message), "</div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-primary uk-modal-close\" autofocus>").concat(i18n.ok, "</button> </div>");
      }, options);
    };
    modal.confirm = function (message, options) {
      return openDialog(function (_ref158) {
        var i18n = _ref158.i18n;
        return "<form> <div class=\"uk-modal-body\">".concat(isString(message) ? message : html(message), "</div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-default uk-modal-close\" type=\"button\">").concat(i18n.cancel, "</button> <button class=\"uk-button uk-button-primary\" autofocus>").concat(i18n.ok, "</button> </div> </form>");
      }, options, function () {
        return Promise.reject();
      });
    };
    modal.prompt = function (message, value, options) {
      var promise = openDialog(function (_ref159) {
        var i18n = _ref159.i18n;
        return "<form class=\"uk-form-stacked\"> <div class=\"uk-modal-body\"> <label>".concat(isString(message) ? message : html(message), "</label> <input class=\"uk-input\" value=\"").concat(value || "", "\" autofocus> </div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-default uk-modal-close\" type=\"button\">").concat(i18n.cancel, "</button> <button class=\"uk-button uk-button-primary\">").concat(i18n.ok, "</button> </div> </form>");
      }, options, function () {
        return null;
      }, function () {
        return input.value;
      });
      var $el = promise.dialog.$el;
      var input = $("input", $el);
      on($el, "show", function () {
        return input.select();
      });
      return promise;
    };
    modal.i18n = {
      ok: "Ok",
      cancel: "Cancel"
    };
    function openDialog(tmpl, options) {
      var hideFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
      var submitFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
      options = _objectSpread(_objectSpread({
        bgClose: false,
        escClose: true
      }, options), {}, {
        i18n: _objectSpread(_objectSpread({}, modal.i18n), options == null ? void 0 : options.i18n)
      });
      var dialog = modal.dialog(tmpl(options), options);
      return assign(new Promise(function (resolve) {
        var off = on(dialog.$el, "hide", function () {
          return resolve(hideFn());
        });
        on(dialog.$el, "submit", "form", function (e) {
          e.preventDefault();
          resolve(submitFn(dialog));
          off();
          dialog.hide();
        });
      }), {
        dialog: dialog
      });
    }
  }
  var nav = {
    "extends": Accordion,
    data: {
      targets: "> .uk-parent",
      toggle: "> a",
      content: "> ul"
    }
  };
  var clsNavbarTransparent = "uk-navbar-transparent";
  var navbar = {
    "extends": Dropnav,
    props: {
      dropbarTransparentMode: Boolean
    },
    data: {
      clsDrop: "uk-navbar-dropdown",
      selNavItem: ".uk-navbar-nav > li > a,a.uk-navbar-item,button.uk-navbar-item,.uk-navbar-item a,.uk-navbar-item button,.uk-navbar-toggle",
      // Simplify with :where() selector once browser target is Safari 14+
      dropbarTransparentMode: false
    },
    computed: {
      navbarContainer: function navbarContainer(_, $el) {
        return $el.closest(".uk-navbar-container");
      }
    },
    watch: {
      items: function items() {
        var justify = hasClass(this.$el, "uk-navbar-justify");
        var containers = $$(".uk-navbar-nav, .uk-navbar-left, .uk-navbar-right", this.$el);
        var _iterator67 = _createForOfIteratorHelper(containers),
          _step67;
        try {
          for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
            var container = _step67.value;
            var items = justify ? $$(".uk-navbar-nav > li > a, .uk-navbar-item, .uk-navbar-toggle", container).length : "";
            css(container, "flexGrow", items);
          }
        } catch (err) {
          _iterator67.e(err);
        } finally {
          _iterator67.f();
        }
      }
    },
    events: [{
      name: "show",
      el: function el() {
        return this.dropContainer;
      },
      handler: function handler(_ref160) {
        var target = _ref160.target;
        if (this.getTransparentMode(target) === "remove" && hasClass(this.navbarContainer, clsNavbarTransparent)) {
          removeClass(this.navbarContainer, clsNavbarTransparent);
          this._transparent = true;
        }
      }
    }, {
      name: "hide",
      el: function el() {
        return this.dropContainer;
      },
      handler: function handler() {
        var _this50 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24() {
          return _regenerator["default"].wrap(function _callee24$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return awaitMacroTask();
              case 2:
                if (!_this50.getActive() && _this50._transparent) {
                  addClass(_this50.navbarContainer, clsNavbarTransparent);
                  _this50._transparent = null;
                }
              case 3:
              case "end":
                return _context24.stop();
            }
          }, _callee24);
        }))();
      }
    }],
    methods: {
      getTransparentMode: function getTransparentMode(el) {
        if (!this.navbarContainer) {
          return;
        }
        if (this.dropbar && this.isDropbarDrop(el)) {
          return this.dropbarTransparentMode;
        }
        var drop = this.getDropdown(el);
        if (drop && hasClass(el, "uk-dropbar")) {
          return drop.inset ? "behind" : "remove";
        }
      },
      getDropbarOffset: function getDropbarOffset(offsetTop) {
        var _offset5 = offset(this.navbarContainer),
          top = _offset5.top,
          height = _offset5.height;
        return top + (this.dropbarTransparentMode === "behind" ? 0 : height + offsetTop);
      }
    }
  };
  function awaitMacroTask() {
    return new Promise(function (resolve) {
      return setTimeout(resolve);
    });
  }
  var offcanvas = {
    mixins: [Modal],
    args: "mode",
    props: {
      mode: String,
      flip: Boolean,
      overlay: Boolean,
      swiping: Boolean
    },
    data: {
      mode: "slide",
      flip: false,
      overlay: false,
      clsPage: "uk-offcanvas-page",
      clsContainer: "uk-offcanvas-container",
      selPanel: ".uk-offcanvas-bar",
      clsFlip: "uk-offcanvas-flip",
      clsContainerAnimation: "uk-offcanvas-container-animation",
      clsSidebarAnimation: "uk-offcanvas-bar-animation",
      clsMode: "uk-offcanvas",
      clsOverlay: "uk-offcanvas-overlay",
      selClose: ".uk-offcanvas-close",
      container: false,
      swiping: true
    },
    computed: {
      clsFlip: function clsFlip(_ref161) {
        var flip = _ref161.flip,
          _clsFlip = _ref161.clsFlip;
        return flip ? _clsFlip : "";
      },
      clsOverlay: function clsOverlay(_ref162) {
        var overlay = _ref162.overlay,
          _clsOverlay = _ref162.clsOverlay;
        return overlay ? _clsOverlay : "";
      },
      clsMode: function clsMode(_ref163) {
        var mode = _ref163.mode,
          _clsMode = _ref163.clsMode;
        return "".concat(_clsMode, "-").concat(mode);
      },
      clsSidebarAnimation: function clsSidebarAnimation(_ref164) {
        var mode = _ref164.mode,
          _clsSidebarAnimation = _ref164.clsSidebarAnimation;
        return mode === "none" || mode === "reveal" ? "" : _clsSidebarAnimation;
      },
      clsContainerAnimation: function clsContainerAnimation(_ref165) {
        var mode = _ref165.mode,
          _clsContainerAnimation = _ref165.clsContainerAnimation;
        return mode !== "push" && mode !== "reveal" ? "" : _clsContainerAnimation;
      },
      transitionElement: function transitionElement(_ref166) {
        var mode = _ref166.mode;
        return mode === "reveal" ? parent(this.panel) : this.panel;
      }
    },
    observe: swipe({
      filter: function filter(_ref167) {
        var swiping = _ref167.swiping;
        return swiping;
      }
    }),
    update: {
      read: function read() {
        if (this.isToggled() && !isVisible(this.$el)) {
          this.hide();
        }
      },
      events: ["resize"]
    },
    events: [{
      name: "touchmove",
      self: true,
      passive: false,
      filter: function filter() {
        return this.overlay;
      },
      handler: function handler(e) {
        e.cancelable && e.preventDefault();
      }
    }, {
      name: "show",
      self: true,
      handler: function handler() {
        if (this.mode === "reveal" && !hasClass(parent(this.panel), this.clsMode)) {
          wrapAll(this.panel, "<div>");
          addClass(parent(this.panel), this.clsMode);
        }
        var _document3 = document,
          body = _document3.body,
          scrollingElement = _document3.scrollingElement;
        addClass(body, this.clsContainer, this.clsFlip);
        css(body, "touch-action", "pan-y pinch-zoom");
        css(this.$el, "display", "block");
        css(this.panel, "maxWidth", scrollingElement.clientWidth);
        addClass(this.$el, this.clsOverlay);
        addClass(this.panel, this.clsSidebarAnimation, this.mode === "reveal" ? "" : this.clsMode);
        height(body);
        addClass(body, this.clsContainerAnimation);
        this.clsContainerAnimation && suppressUserScale();
      }
    }, {
      name: "hide",
      self: true,
      handler: function handler() {
        removeClass(document.body, this.clsContainerAnimation);
        css(document.body, "touch-action", "");
      }
    }, {
      name: "hidden",
      self: true,
      handler: function handler() {
        this.clsContainerAnimation && resumeUserScale();
        if (this.mode === "reveal") {
          unwrap(this.panel);
        }
        removeClass(this.panel, this.clsSidebarAnimation, this.clsMode);
        removeClass(this.$el, this.clsOverlay);
        css(this.$el, "display", "");
        css(this.panel, "maxWidth", "");
        removeClass(document.body, this.clsContainer, this.clsFlip);
      }
    }, {
      name: "swipeLeft swipeRight",
      handler: function handler(e) {
        if (this.isToggled() && endsWith(e.type, "Left") ^ this.flip) {
          this.hide();
        }
      }
    }]
  };
  function suppressUserScale() {
    getViewport().content += ",user-scalable=0";
  }
  function resumeUserScale() {
    var viewport = getViewport();
    viewport.content = viewport.content.replace(/,user-scalable=0$/, "");
  }
  function getViewport() {
    return $('meta[name="viewport"]', document.head) || append(document.head, '<meta name="viewport">');
  }
  var overflowAuto = {
    mixins: [Class],
    props: {
      selContainer: String,
      selContent: String,
      minHeight: Number
    },
    data: {
      selContainer: ".uk-modal",
      selContent: ".uk-modal-dialog",
      minHeight: 150
    },
    computed: {
      container: function container(_ref168, $el) {
        var selContainer = _ref168.selContainer;
        return $el.closest(selContainer);
      },
      content: function content(_ref169, $el) {
        var selContent = _ref169.selContent;
        return $el.closest(selContent);
      }
    },
    observe: resize({
      target: function target(_ref170) {
        var container = _ref170.container,
          content = _ref170.content;
        return [container, content];
      }
    }),
    update: {
      read: function read() {
        if (!this.content || !this.container || !isVisible(this.$el)) {
          return false;
        }
        return {
          max: Math.max(this.minHeight, height(this.container) - (dimensions$1(this.content).height - height(this.$el)))
        };
      },
      write: function write(_ref171) {
        var max = _ref171.max;
        css(this.$el, {
          minHeight: this.minHeight,
          maxHeight: max
        });
      },
      events: ["resize"]
    }
  };
  var responsive = {
    props: ["width", "height"],
    connected: function connected() {
      addClass(this.$el, "uk-responsive-width");
      css(this.$el, "aspectRatio", "".concat(this.width, "/").concat(this.height));
    }
  };
  var scroll = {
    props: {
      offset: Number
    },
    data: {
      offset: 0
    },
    connected: function connected() {
      registerClick(this);
    },
    disconnected: function disconnected() {
      unregisterClick(this);
    },
    methods: {
      scrollTo: function scrollTo(el) {
        var _this51 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25() {
          return _regenerator["default"].wrap(function _callee25$(_context25) {
            while (1) switch (_context25.prev = _context25.next) {
              case 0:
                el = el && $(el) || document.body;
                if (!trigger(_this51.$el, "beforescroll", [_this51, el])) {
                  _context25.next = 5;
                  break;
                }
                _context25.next = 4;
                return scrollIntoView(el, {
                  offset: _this51.offset
                });
              case 4:
                trigger(_this51.$el, "scrolled", [_this51, el]);
              case 5:
              case "end":
                return _context25.stop();
            }
          }, _callee25);
        }))();
      }
    }
  };
  var instances = /* @__PURE__ */new Set();
  function registerClick(cmp) {
    if (!instances.size) {
      on(document, "click", clickHandler);
    }
    instances.add(cmp);
  }
  function unregisterClick(cmp) {
    instances["delete"](cmp);
    if (!instances.size) {
      off(document, "click", clickHandler);
    }
  }
  function clickHandler(e) {
    if (e.defaultPrevented) {
      return;
    }
    var _iterator68 = _createForOfIteratorHelper(instances),
      _step68;
    try {
      for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
        var instance = _step68.value;
        if (instance.$el.contains(e.target) && isSameSiteAnchor(instance.$el)) {
          e.preventDefault();
          if (window.location.href !== instance.$el.href) {
            window.history.pushState({}, "", instance.$el.href);
          }
          instance.scrollTo(getTargetedElement(instance.$el));
        }
      }
    } catch (err) {
      _iterator68.e(err);
    } finally {
      _iterator68.f();
    }
  }
  var scrollspy = {
    args: "cls",
    props: {
      cls: String,
      target: String,
      hidden: Boolean,
      margin: String,
      repeat: Boolean,
      delay: Number
    },
    data: function data() {
      return {
        cls: "",
        target: false,
        hidden: true,
        margin: "-1px",
        repeat: false,
        delay: 0,
        inViewClass: "uk-scrollspy-inview"
      };
    },
    computed: {
      elements: function elements(_ref172, $el) {
        var target = _ref172.target;
        return target ? $$(target, $el) : [$el];
      }
    },
    watch: {
      elements: function elements(_elements2) {
        if (this.hidden) {
          css(filter$1(_elements2, ":not(.".concat(this.inViewClass, ")")), "opacity", 0);
        }
      }
    },
    connected: function connected() {
      this.elementData = /* @__PURE__ */new Map();
    },
    disconnected: function disconnected() {
      var _iterator69 = _createForOfIteratorHelper(this.elementData.entries()),
        _step69;
      try {
        for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
          var _step69$value = (0, _slicedToArray2["default"])(_step69.value, 2),
            el = _step69$value[0],
            state = _step69$value[1];
          removeClass(el, this.inViewClass, (state == null ? void 0 : state.cls) || "");
        }
      } catch (err) {
        _iterator69.e(err);
      } finally {
        _iterator69.f();
      }
      delete this.elementData;
    },
    observe: intersection({
      target: function target(_ref173) {
        var elements = _ref173.elements;
        return elements;
      },
      handler: function handler(records) {
        var elements = this.elementData;
        var _iterator70 = _createForOfIteratorHelper(records),
          _step70;
        try {
          for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
            var _step70$value = _step70.value,
              el = _step70$value.target,
              isIntersecting = _step70$value.isIntersecting;
            if (!elements.has(el)) {
              elements.set(el, {
                cls: data(el, "uk-scrollspy-class") || this.cls
              });
            }
            var state = elements.get(el);
            if (!this.repeat && state.show) {
              continue;
            }
            state.show = isIntersecting;
          }
        } catch (err) {
          _iterator70.e(err);
        } finally {
          _iterator70.f();
        }
        this.$emit();
      },
      options: function options(_ref174) {
        var margin = _ref174.margin;
        return {
          rootMargin: margin
        };
      },
      args: {
        intersecting: false
      }
    }),
    update: [{
      write: function write(data) {
        var _this52 = this;
        var _iterator71 = _createForOfIteratorHelper(this.elementData.entries()),
          _step71;
        try {
          var _loop11 = function _loop11() {
            var _step71$value = (0, _slicedToArray2["default"])(_step71.value, 2),
              el = _step71$value[0],
              state = _step71$value[1];
            if (state.show && !state.inview && !state.queued) {
              state.queued = true;
              data.promise = (data.promise || Promise.resolve()).then(function () {
                return new Promise(function (resolve) {
                  return setTimeout(resolve, _this52.delay);
                });
              }).then(function () {
                _this52.toggle(el, true);
                setTimeout(function () {
                  state.queued = false;
                  _this52.$emit();
                }, 300);
              });
            } else if (!state.show && state.inview && !state.queued && _this52.repeat) {
              _this52.toggle(el, false);
            }
          };
          for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
            _loop11();
          }
        } catch (err) {
          _iterator71.e(err);
        } finally {
          _iterator71.f();
        }
      }
    }],
    methods: {
      toggle: function toggle(el, inview) {
        var _a;
        var state = this.elementData.get(el);
        if (!state) {
          return;
        }
        (_a = state.off) == null ? void 0 : _a.call(state);
        css(el, "opacity", !inview && this.hidden ? 0 : "");
        toggleClass(el, this.inViewClass, inview);
        toggleClass(el, state.cls);
        if (/\buk-animation-/.test(state.cls)) {
          var removeAnimationClasses = function removeAnimationClasses() {
            return removeClasses(el, "uk-animation-[\\w-]+");
          };
          if (inview) {
            state.off = once(el, "animationcancel animationend", removeAnimationClasses, {
              self: true
            });
          } else {
            removeAnimationClasses();
          }
        }
        trigger(el, inview ? "inview" : "outview");
        state.inview = inview;
        this.$update(el);
      }
    }
  };
  var scrollspyNav = {
    props: {
      cls: String,
      closest: Boolean,
      scroll: Boolean,
      overflow: Boolean,
      offset: Number
    },
    data: {
      cls: "uk-active",
      closest: false,
      scroll: false,
      overflow: true,
      offset: 0
    },
    computed: {
      links: function links(_, $el) {
        return $$('a[href*="#"]', $el).filter(function (el) {
          return el.hash && isSameSiteAnchor(el);
        });
      },
      elements: function elements(_ref175) {
        var selector = _ref175.closest;
        return this.links.map(function (el) {
          return el.closest(selector || "*");
        });
      }
    },
    watch: {
      links: function links(_links) {
        if (this.scroll) {
          this.$create("scroll", _links, {
            offset: this.offset
          });
        }
      }
    },
    observe: [intersection(), scroll$1()],
    update: [{
      read: function read() {
        var targets = this.links.map(getTargetedElement).filter(Boolean);
        var length = targets.length;
        if (!length || !isVisible(this.$el)) {
          return false;
        }
        var scrollElement = scrollParent(targets, true);
        var scrollTop = scrollElement.scrollTop,
          scrollHeight = scrollElement.scrollHeight;
        var viewport = offsetViewport(scrollElement);
        var max = scrollHeight - viewport.height;
        var active = false;
        if (scrollTop === max) {
          active = length - 1;
        } else {
          for (var i = 0; i < targets.length; i++) {
            var fixedEl = getCoveringElement(targets[i]);
            var offsetBy = this.offset + (fixedEl ? offset(fixedEl).height : 0);
            if (offset(targets[i]).top - viewport.top - offsetBy > 0) {
              break;
            }
            active = +i;
          }
          if (active === false && this.overflow) {
            active = 0;
          }
        }
        return {
          active: active
        };
      },
      write: function write(_ref176) {
        var active = _ref176.active;
        var changed = active !== false && !hasClass(this.elements[active], this.cls);
        this.links.forEach(function (el) {
          return el.blur();
        });
        for (var i = 0; i < this.elements.length; i++) {
          toggleClass(this.elements[i], this.cls, +i === active);
        }
        if (changed) {
          trigger(this.$el, "active", [active, this.elements[active]]);
        }
      },
      events: ["scroll", "resize"]
    }]
  };
  var sticky = {
    mixins: [Class, Media],
    props: {
      position: String,
      top: null,
      bottom: null,
      start: null,
      end: null,
      offset: String,
      overflowFlip: Boolean,
      animation: String,
      clsActive: String,
      clsInactive: String,
      clsFixed: String,
      clsBelow: String,
      selTarget: String,
      showOnUp: Boolean,
      targetOffset: Number
    },
    data: {
      position: "top",
      top: false,
      bottom: false,
      start: false,
      end: false,
      offset: 0,
      overflowFlip: false,
      animation: "",
      clsActive: "uk-active",
      clsInactive: "",
      clsFixed: "uk-sticky-fixed",
      clsBelow: "uk-sticky-below",
      selTarget: "",
      showOnUp: false,
      targetOffset: false
    },
    computed: {
      target: function target(_ref177, $el) {
        var selTarget = _ref177.selTarget;
        return selTarget && $(selTarget, $el) || $el;
      }
    },
    connected: function connected() {
      this.start = coerce(this.start || this.top);
      this.end = coerce(this.end || this.bottom);
      this.placeholder = $("+ .uk-sticky-placeholder", this.$el) || $('<div class="uk-sticky-placeholder"></div>');
      this.isFixed = false;
      this.setActive(false);
    },
    beforeDisconnect: function beforeDisconnect() {
      if (this.isFixed) {
        this.hide();
        removeClass(this.target, this.clsInactive);
      }
      reset(this.$el);
      remove$1(this.placeholder);
      this.placeholder = null;
    },
    observe: [viewport({
      handler: function handler() {
        if (toPx("100vh", "height") !== this._data.viewport) {
          this.$emit("resize");
        }
      }
    }), scroll$1({
      target: function target() {
        return document.scrollingElement;
      }
    }), resize({
      target: function target() {
        return document.scrollingElement;
      },
      options: {
        box: "content-box"
      }
    }), resize({
      target: function target(_ref178) {
        var $el = _ref178.$el;
        return $el;
      }
    })],
    events: [{
      name: "load hashchange popstate",
      el: function el() {
        return window;
      },
      filter: function filter() {
        return this.targetOffset !== false;
      },
      handler: function handler() {
        var _this53 = this;
        var _document4 = document,
          scrollingElement = _document4.scrollingElement;
        if (!location.hash || scrollingElement.scrollTop === 0) {
          return;
        }
        setTimeout(function () {
          var targetOffset = offset($(location.hash));
          var elOffset = offset(_this53.$el);
          if (_this53.isFixed && intersectRect(targetOffset, elOffset)) {
            scrollingElement.scrollTop = Math.ceil(targetOffset.top - elOffset.height - toPx(_this53.targetOffset, "height", _this53.placeholder) - toPx(_this53.offset, "height", _this53.placeholder));
          }
        });
      }
    }, {
      name: "transitionstart",
      handler: function handler() {
        var _this54 = this;
        this.transitionInProgress = once(this.$el, "transitionend transitioncancel", function () {
          return _this54.transitionInProgress = null;
        });
      }
    }],
    update: [{
      read: function read(_ref179) {
        var height$1 = _ref179.height,
          width = _ref179.width,
          margin = _ref179.margin,
          sticky = _ref179.sticky;
        this.inactive = !this.matchMedia || !isVisible(this.$el);
        if (this.inactive) {
          return;
        }
        var hide = this.isFixed && !this.transitionInProgress;
        if (hide) {
          preventTransition(this.target);
          this.hide();
        }
        if (!this.active) {
          var _offset6 = offset(this.$el);
          height$1 = _offset6.height;
          width = _offset6.width;
          margin = css(this.$el, "margin");
        }
        if (hide) {
          this.show();
        }
        var viewport2 = toPx("100vh", "height");
        var dynamicViewport = height(window);
        var maxScrollHeight = Math.max(0, document.scrollingElement.scrollHeight - viewport2);
        var position = this.position;
        if (this.overflowFlip && height$1 > viewport2) {
          position = position === "top" ? "bottom" : "top";
        }
        var referenceElement = this.isFixed ? this.placeholder : this.$el;
        var offset$1 = toPx(this.offset, "height", sticky ? this.$el : referenceElement);
        if (position === "bottom" && (height$1 < dynamicViewport || this.overflowFlip)) {
          offset$1 += dynamicViewport - height$1;
        }
        var overflow = this.overflowFlip ? 0 : Math.max(0, height$1 + offset$1 - viewport2);
        var topOffset = offset(referenceElement).top;
        var elHeight = offset(this.$el).height;
        var start = (this.start === false ? topOffset : parseProp(this.start, this.$el, topOffset)) - offset$1;
        var end = this.end === false ? maxScrollHeight : Math.min(maxScrollHeight, parseProp(this.end, this.$el, topOffset + height$1, true) - elHeight - offset$1 + overflow);
        sticky = maxScrollHeight && !this.showOnUp && start + offset$1 === topOffset && end === Math.min(maxScrollHeight, parseProp(true, this.$el, 0, true) - elHeight - offset$1 + overflow) && css(parent(this.$el), "overflowY") === "visible";
        return {
          start: start,
          end: end,
          offset: offset$1,
          overflow: overflow,
          height: height$1,
          elHeight: elHeight,
          width: width,
          margin: margin,
          top: offsetPosition(referenceElement)[0],
          sticky: sticky,
          viewport: viewport2
        };
      },
      write: function write(_ref180) {
        var height = _ref180.height,
          width = _ref180.width,
          margin = _ref180.margin,
          offset = _ref180.offset,
          sticky = _ref180.sticky;
        if (this.inactive || sticky || !this.isFixed) {
          reset(this.$el);
        }
        if (this.inactive) {
          return;
        }
        if (sticky) {
          height = width = margin = 0;
          css(this.$el, {
            position: "sticky",
            top: offset
          });
        }
        var placeholder = this.placeholder;
        css(placeholder, {
          height: height,
          width: width,
          margin: margin
        });
        if (parent(placeholder) !== parent(this.$el) || sticky ^ index(placeholder) < index(this.$el)) {
          (sticky ? before : after)(this.$el, placeholder);
          placeholder.hidden = true;
        }
      },
      events: ["resize"]
    }, {
      read: function read(_ref181) {
        var _ref181$scroll = _ref181.scroll,
          prevScroll = _ref181$scroll === void 0 ? 0 : _ref181$scroll,
          _ref181$dir = _ref181.dir,
          prevDir = _ref181$dir === void 0 ? "down" : _ref181$dir,
          overflow = _ref181.overflow,
          _ref181$overflowScrol = _ref181.overflowScroll,
          overflowScroll = _ref181$overflowScrol === void 0 ? 0 : _ref181$overflowScrol,
          start = _ref181.start,
          end = _ref181.end,
          elHeight = _ref181.elHeight,
          height = _ref181.height,
          sticky = _ref181.sticky;
        var scroll2 = document.scrollingElement.scrollTop;
        var dir = prevScroll <= scroll2 ? "down" : "up";
        var referenceElement = this.isFixed ? this.placeholder : this.$el;
        return {
          dir: dir,
          prevDir: prevDir,
          scroll: scroll2,
          prevScroll: prevScroll,
          below: scroll2 > offset(referenceElement).top + (sticky ? Math.min(height, elHeight) : height),
          offsetParentTop: offset(referenceElement.offsetParent).top,
          overflowScroll: clamp(overflowScroll + clamp(scroll2, start, end) - clamp(prevScroll, start, end), 0, overflow)
        };
      },
      write: function write(data, types) {
        var _this55 = this;
        var isScrollUpdate = types.has("scroll");
        var _data$initTimestamp = data.initTimestamp,
          initTimestamp = _data$initTimestamp === void 0 ? 0 : _data$initTimestamp,
          dir = data.dir,
          prevDir = data.prevDir,
          scroll2 = data.scroll,
          _data$prevScroll = data.prevScroll,
          prevScroll = _data$prevScroll === void 0 ? 0 : _data$prevScroll,
          top = data.top,
          start = data.start,
          below = data.below;
        if (scroll2 < 0 || scroll2 === prevScroll && isScrollUpdate || this.showOnUp && !isScrollUpdate && !this.isFixed) {
          return;
        }
        var now = Date.now();
        if (now - initTimestamp > 300 || dir !== prevDir) {
          data.initScroll = scroll2;
          data.initTimestamp = now;
        }
        if (this.showOnUp && !this.isFixed && Math.abs(data.initScroll - scroll2) <= 30 && Math.abs(prevScroll - scroll2) <= 10) {
          return;
        }
        if (this.inactive || scroll2 < start || this.showOnUp && (scroll2 <= start || dir === "down" && isScrollUpdate || dir === "up" && !this.isFixed && !below)) {
          if (!this.isFixed) {
            if (Animation.inProgress(this.$el) && top > scroll2) {
              Animation.cancel(this.$el);
              this.hide();
            }
            return;
          }
          if (this.animation && below) {
            if (hasClass(this.$el, "uk-animation-leave")) {
              return;
            }
            Animation.out(this.$el, this.animation).then(function () {
              return _this55.hide();
            }, noop);
          } else {
            this.hide();
          }
        } else if (this.isFixed) {
          this.update();
        } else if (this.animation && below) {
          this.show();
          Animation["in"](this.$el, this.animation)["catch"](noop);
        } else {
          preventTransition(this.target);
          this.show();
        }
      },
      events: ["resize", "resizeViewport", "scroll"]
    }],
    methods: {
      show: function show() {
        this.isFixed = true;
        this.update();
        this.placeholder.hidden = false;
      },
      hide: function hide() {
        var _this$_data = this._data,
          offset = _this$_data.offset,
          sticky = _this$_data.sticky;
        this.setActive(false);
        removeClass(this.$el, this.clsFixed, this.clsBelow);
        if (sticky) {
          css(this.$el, "top", offset);
        } else {
          css(this.$el, {
            position: "",
            top: "",
            width: "",
            marginTop: ""
          });
        }
        this.placeholder.hidden = true;
        this.isFixed = false;
      },
      update: function update() {
        var _this$_data2 = this._data,
          width = _this$_data2.width,
          _this$_data2$scroll = _this$_data2.scroll,
          scroll2 = _this$_data2$scroll === void 0 ? 0 : _this$_data2$scroll,
          overflow = _this$_data2.overflow,
          _this$_data2$overflow = _this$_data2.overflowScroll,
          overflowScroll = _this$_data2$overflow === void 0 ? 0 : _this$_data2$overflow,
          start = _this$_data2.start,
          end = _this$_data2.end,
          offset = _this$_data2.offset,
          offsetParentTop = _this$_data2.offsetParentTop,
          sticky = _this$_data2.sticky,
          below = _this$_data2.below;
        var active = start !== 0 || scroll2 > start;
        if (!sticky) {
          var _position = "fixed";
          if (scroll2 > end) {
            offset += end - offsetParentTop + overflowScroll - overflow;
            _position = "absolute";
          }
          css(this.$el, {
            position: _position,
            width: width,
            marginTop: 0
          }, "important");
        }
        css(this.$el, "top", offset - overflowScroll);
        this.setActive(active);
        toggleClass(this.$el, this.clsBelow, below);
        addClass(this.$el, this.clsFixed);
      },
      setActive: function setActive(active) {
        var prev = this.active;
        this.active = active;
        if (active) {
          replaceClass(this.target, this.clsInactive, this.clsActive);
          prev !== active && trigger(this.$el, "active");
        } else {
          replaceClass(this.target, this.clsActive, this.clsInactive);
          if (prev !== active) {
            preventTransition(this.target);
            trigger(this.$el, "inactive");
          }
        }
      }
    }
  };
  function parseProp(value, el, propOffset, padding) {
    if (!value) {
      return 0;
    }
    if (isNumeric(value) || isString(value) && value.match(/^-?\d/)) {
      return propOffset + toPx(value, "height", el, true);
    } else {
      var refElement = value === true ? parent(el) : query(value, el);
      return offset(refElement).bottom - (padding && (refElement == null ? void 0 : refElement.contains(el)) ? toFloat(css(refElement, "paddingBottom")) : 0);
    }
  }
  function coerce(value) {
    if (value === "true") {
      return true;
    } else if (value === "false") {
      return false;
    }
    return value;
  }
  function reset(el) {
    css(el, {
      position: "",
      top: "",
      marginTop: "",
      width: ""
    });
  }
  function preventTransition(el) {
    addClass(el, "uk-transition-disable");
    requestAnimationFrame(function () {
      return removeClass(el, "uk-transition-disable");
    });
  }
  var svg = {
    mixins: [Svg],
    args: "src",
    props: {
      src: String,
      icon: String,
      attributes: "list",
      strokeAnimation: Boolean
    },
    data: {
      strokeAnimation: false
    },
    observe: [mutation({
      handler: function handler() {
        var _this56 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26() {
          var svg;
          return _regenerator["default"].wrap(function _callee26$(_context26) {
            while (1) switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return _this56.svg;
              case 2:
                svg = _context26.sent;
                if (svg) {
                  applyAttributes.call(_this56, svg);
                }
              case 4:
              case "end":
                return _context26.stop();
            }
          }, _callee26);
        }))();
      },
      options: {
        attributes: true,
        attributeFilter: ["id", "class", "style"]
      }
    })],
    connected: function connected() {
      var _this57 = this;
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27() {
        var _this57$src$split, _this57$src$split2, svg;
        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (includes(_this57.src, "#")) {
                _this57$src$split = _this57.src.split("#");
                _this57$src$split2 = (0, _slicedToArray2["default"])(_this57$src$split, 2);
                _this57.src = _this57$src$split2[0];
                _this57.icon = _this57$src$split2[1];
              }
              _context27.next = 3;
              return _this57.svg;
            case 3:
              svg = _context27.sent;
              if (svg) {
                applyAttributes.call(_this57, svg);
                if (_this57.strokeAnimation) {
                  applyAnimation(svg);
                }
              }
            case 5:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }))();
    },
    methods: {
      getSvg: function getSvg() {
        var _this58 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28() {
          return _regenerator["default"].wrap(function _callee28$(_context28) {
            while (1) switch (_context28.prev = _context28.next) {
              case 0:
                if (!(isTag(_this58.$el, "img") && !_this58.$el.complete && _this58.$el.loading === "lazy")) {
                  _context28.next = 3;
                  break;
                }
                _context28.next = 3;
                return new Promise(function (resolve) {
                  return once(_this58.$el, "load", resolve);
                });
              case 3:
                _context28.t1 = parseSVG;
                _context28.next = 6;
                return loadSVG(_this58.src);
              case 6:
                _context28.t2 = _context28.sent;
                _context28.t3 = _this58.icon;
                _context28.t0 = (0, _context28.t1)(_context28.t2, _context28.t3);
                if (_context28.t0) {
                  _context28.next = 11;
                  break;
                }
                _context28.t0 = Promise.reject("SVG not found.");
              case 11:
                return _context28.abrupt("return", _context28.t0);
              case 12:
              case "end":
                return _context28.stop();
            }
          }, _callee28);
        }))();
      }
    }
  };
  function applyAttributes(el) {
    var $el = this.$el;
    addClass(el, attr($el, "class"), "uk-svg");
    for (var i = 0; i < $el.style.length; i++) {
      var prop = $el.style[i];
      css(el, prop, css($el, prop));
    }
    for (var attribute in this.attributes) {
      var _this$attributes$attr = this.attributes[attribute].split(":", 2),
        _this$attributes$attr2 = (0, _slicedToArray2["default"])(_this$attributes$attr, 2),
        _prop7 = _this$attributes$attr2[0],
        value = _this$attributes$attr2[1];
      attr(el, _prop7, value);
    }
    if (!this.$el.id) {
      removeAttr(el, "id");
    }
  }
  var loadSVG = memoize( /*#__PURE__*/function () {
    var _ref182 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee29(src) {
      return _regenerator["default"].wrap(function _callee29$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            if (!src) {
              _context29.next = 10;
              break;
            }
            if (!startsWith(src, "data:")) {
              _context29.next = 5;
              break;
            }
            return _context29.abrupt("return", decodeURIComponent(src.split(",")[1]));
          case 5:
            _context29.next = 7;
            return fetch(src);
          case 7:
            return _context29.abrupt("return", _context29.sent.text());
          case 8:
            _context29.next = 11;
            break;
          case 10:
            return _context29.abrupt("return", Promise.reject());
          case 11:
          case "end":
            return _context29.stop();
        }
      }, _callee29);
    }));
    return function (_x15) {
      return _ref182.apply(this, arguments);
    };
  }());
  function parseSVG(svg, icon) {
    if (icon && includes(svg, "<symbol")) {
      svg = parseSymbols(svg)[icon] || svg;
    }
    svg = $(svg.substr(svg.indexOf("<svg")));
    return (svg == null ? void 0 : svg.hasChildNodes()) && svg;
  }
  var symbolRe = /<symbol([^]*?id=(['"])(.+?)\2[^]*?<\/)symbol>/g;
  var parseSymbols = memoize(function (svg) {
    var symbols = {};
    symbolRe.lastIndex = 0;
    var match;
    while (match = symbolRe.exec(svg)) {
      symbols[match[3]] = "<svg ".concat(match[1], "svg>");
    }
    return symbols;
  });
  function applyAnimation(el) {
    var length = getMaxPathLength(el);
    if (length) {
      css(el, "--uk-animation-stroke", length);
    }
  }
  var selDisabled = ".uk-disabled *, .uk-disabled, [disabled]";
  var Switcher = {
    mixins: [Togglable],
    args: "connect",
    props: {
      connect: String,
      toggle: String,
      itemNav: String,
      active: Number,
      followFocus: Boolean,
      swiping: Boolean
    },
    data: {
      connect: "~.uk-switcher",
      toggle: "> * > :first-child",
      itemNav: false,
      active: 0,
      cls: "uk-active",
      attrItem: "uk-switcher-item",
      selVertical: ".uk-nav",
      followFocus: false,
      swiping: true
    },
    computed: {
      connects: function connects(_ref183, $el) {
        var connect = _ref183.connect;
        return queryAll(connect, $el);
      },
      connectChildren: function connectChildren() {
        return this.connects.map(function (el) {
          return _children(el);
        }).flat();
      },
      toggles: function toggles(_ref184, $el) {
        var toggle = _ref184.toggle;
        return $$(toggle, $el);
      },
      children: function children(_, $el) {
        var _this59 = this;
        return _children($el).filter(function (child) {
          return _this59.toggles.some(function (toggle) {
            return child.contains(toggle);
          });
        });
      }
    },
    watch: {
      connects: function connects(_connects) {
        if (this.swiping) {
          css(_connects, "touchAction", "pan-y pinch-zoom");
        }
        this.$emit();
      },
      connectChildren: function connectChildren() {
        var _this60 = this;
        var index = Math.max(0, this.index());
        var _iterator72 = _createForOfIteratorHelper(this.connects),
          _step72;
        try {
          for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
            var el = _step72.value;
            _children(el).forEach(function (child, i) {
              return toggleClass(child, _this60.cls, i === index);
            });
          }
        } catch (err) {
          _iterator72.e(err);
        } finally {
          _iterator72.f();
        }
        this.$emit();
      },
      toggles: function toggles(_toggles3) {
        this.$emit();
        var active = this.index();
        this.show(~active ? active : _toggles3[this.active] || _toggles3[0]);
      }
    },
    connected: function connected() {
      attr(this.$el, "role", "tablist");
    },
    observe: [lazyload({
      targets: function targets(_ref185) {
        var connectChildren = _ref185.connectChildren;
        return connectChildren;
      }
    }), swipe({
      target: function target(_ref186) {
        var connects = _ref186.connects;
        return connects;
      },
      filter: function filter(_ref187) {
        var swiping = _ref187.swiping;
        return swiping;
      }
    })],
    events: [{
      name: "click keydown",
      delegate: function delegate() {
        return this.toggle;
      },
      handler: function handler(e) {
        if (!matches(e.current, selDisabled) && (e.type === "click" || e.keyCode === keyMap.SPACE)) {
          e.preventDefault();
          this.show(e.current);
        }
      }
    }, {
      name: "keydown",
      delegate: function delegate() {
        return this.toggle;
      },
      handler: function handler(e) {
        var current = e.current,
          keyCode = e.keyCode;
        var isVertical = matches(this.$el, this.selVertical);
        var i = keyCode === keyMap.HOME ? 0 : keyCode === keyMap.END ? "last" : keyCode === keyMap.LEFT && !isVertical || keyCode === keyMap.UP && isVertical ? "previous" : keyCode === keyMap.RIGHT && !isVertical || keyCode === keyMap.DOWN && isVertical ? "next" : -1;
        if (~i) {
          e.preventDefault();
          var toggles = this.toggles.filter(function (el) {
            return !matches(el, selDisabled);
          });
          var next = toggles[_getIndex(i, toggles, toggles.indexOf(current))];
          next.focus();
          if (this.followFocus) {
            this.show(next);
          }
        }
      }
    }, {
      name: "click",
      el: function el() {
        return this.connects.concat(this.itemNav ? queryAll(this.itemNav, this.$el) : []);
      },
      delegate: function delegate() {
        return "[".concat(this.attrItem, "],[data-").concat(this.attrItem, "]");
      },
      handler: function handler(e) {
        if (e.target.closest("a,button")) {
          e.preventDefault();
          this.show(data(e.current, this.attrItem));
        }
      }
    }, {
      name: "swipeRight swipeLeft",
      filter: function filter() {
        return this.swiping;
      },
      el: function el() {
        return this.connects;
      },
      handler: function handler(_ref188) {
        var type = _ref188.type;
        this.show(endsWith(type, "Left") ? "next" : "previous");
      }
    }],
    update: function update() {
      var _a;
      attr(this.connects, "role", "presentation");
      attr(_children(this.$el), "role", "presentation");
      for (var _index5 in this.toggles) {
        var _toggle6 = this.toggles[_index5];
        var item = (_a = this.connects[0]) == null ? void 0 : _a.children[_index5];
        attr(_toggle6, "role", "tab");
        if (!item) {
          continue;
        }
        _toggle6.id = generateId(this, _toggle6);
        item.id = generateId(this, item);
        attr(_toggle6, "aria-controls", item.id);
        attr(item, {
          role: "tabpanel",
          "aria-labelledby": _toggle6.id
        });
      }
      attr(this.$el, "aria-orientation", matches(this.$el, this.selVertical) ? "vertical" : null);
    },
    methods: {
      index: function index() {
        var _this61 = this;
        return findIndex(this.children, function (el) {
          return hasClass(el, _this61.cls);
        });
      },
      show: function show(item) {
        var _this62 = this;
        var toggles = this.toggles.filter(function (el) {
          return !matches(el, selDisabled);
        });
        var prev = this.index();
        var next = _getIndex(!isNode(item) || includes(toggles, item) ? item : 0, toggles, _getIndex(this.toggles[prev], toggles));
        var active = _getIndex(toggles[next], this.toggles);
        this.children.forEach(function (child, i) {
          toggleClass(child, _this62.cls, active === i);
          attr(_this62.toggles[i], {
            "aria-selected": active === i,
            tabindex: active === i ? null : -1
          });
        });
        var animate = prev >= 0 && prev !== next;
        this.connects.forEach( /*#__PURE__*/function () {
          var _ref190 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee30(_ref189) {
            var children2, actives;
            return _regenerator["default"].wrap(function _callee30$(_context30) {
              while (1) switch (_context30.prev = _context30.next) {
                case 0:
                  children2 = _ref189.children;
                  actives = toArray(children2).filter(function (child, i) {
                    return i !== active && hasClass(child, _this62.cls);
                  });
                  _context30.next = 4;
                  return _this62.toggleElement(actives, false, animate);
                case 4:
                  _context30.next = 6;
                  return _this62.toggleElement(children2[active], true, animate);
                case 6:
                case "end":
                  return _context30.stop();
              }
            }, _callee30);
          }));
          return function (_x16) {
            return _ref190.apply(this, arguments);
          };
        }());
      }
    }
  };
  var tab = {
    mixins: [Class],
    "extends": Switcher,
    props: {
      media: Boolean
    },
    data: {
      media: 960,
      attrItem: "uk-tab-item",
      selVertical: ".uk-tab-left,.uk-tab-right"
    },
    connected: function connected() {
      var cls = hasClass(this.$el, "uk-tab-left") ? "uk-tab-left" : hasClass(this.$el, "uk-tab-right") ? "uk-tab-right" : false;
      if (cls) {
        this.$create("toggle", this.$el, {
          cls: cls,
          mode: "media",
          media: this.media
        });
      }
    }
  };
  var KEY_SPACE = 32;
  var toggle = {
    mixins: [Media, Togglable],
    args: "target",
    props: {
      href: String,
      target: null,
      mode: "list",
      queued: Boolean
    },
    data: {
      href: false,
      target: false,
      mode: "click",
      queued: true
    },
    computed: {
      target: function target(_ref191, $el) {
        var target = _ref191.target;
        target = queryAll(target || $el.hash, $el);
        return target.length ? target : [$el];
      }
    },
    connected: function connected() {
      if (!includes(this.mode, "media")) {
        if (!isFocusable(this.$el)) {
          attr(this.$el, "tabindex", "0");
        }
        if (!this.cls && isTag(this.$el, "a")) {
          attr(this.$el, "role", "button");
        }
      }
    },
    observe: lazyload({
      target: function target(_ref192) {
        var _target10 = _ref192.target;
        return _target10;
      }
    }),
    events: [{
      name: pointerDown$1,
      filter: function filter() {
        return includes(this.mode, "hover");
      },
      handler: function handler(e) {
        var _this63 = this;
        this._preventClick = null;
        if (!isTouch(e) || isBoolean(this._showState) || this.$el.disabled) {
          return;
        }
        trigger(this.$el, "focus");
        once(document, pointerDown$1, function () {
          return trigger(_this63.$el, "blur");
        }, true, function (e2) {
          return !_this63.$el.contains(e2.target);
        });
        if (includes(this.mode, "click")) {
          this._preventClick = true;
        }
      }
    }, {
      // mouseenter mouseleave are added because of Firefox bug,
      // where pointerleave is triggered immediately after pointerenter on scroll
      name: "mouseenter mouseleave ".concat(pointerEnter, " ").concat(pointerLeave, " focus blur"),
      filter: function filter() {
        return includes(this.mode, "hover");
      },
      handler: function handler(e) {
        if (isTouch(e) || this.$el.disabled) {
          return;
        }
        var show = includes(["mouseenter", pointerEnter, "focus"], e.type);
        var expanded = this.isToggled(this.target);
        if (!show && (!isBoolean(this._showState) || e.type !== "blur" && matches(this.$el, ":focus") || e.type === "blur" && matches(this.$el, ":hover"))) {
          if (expanded === this._showState) {
            this._showState = null;
          }
          return;
        }
        if (show && isBoolean(this._showState) && expanded !== this._showState) {
          return;
        }
        this._showState = show ? expanded : null;
        this.toggle("toggle".concat(show ? "show" : "hide"));
      }
    }, {
      name: "keydown",
      filter: function filter() {
        return includes(this.mode, "click") && !isTag(this.$el, "input");
      },
      handler: function handler(e) {
        if (e.keyCode === KEY_SPACE) {
          e.preventDefault();
          this.$el.click();
        }
      }
    }, {
      name: "click",
      filter: function filter() {
        var _this64 = this;
        return ["click", "hover"].some(function (mode) {
          return includes(_this64.mode, mode);
        });
      },
      handler: function handler(e) {
        var link;
        if (this._preventClick || e.target.closest('a[href="#"], a[href=""]') || (link = e.target.closest("a[href]")) && (!this.isToggled(this.target) || link.hash && matches(this.target, link.hash))) {
          e.preventDefault();
        }
        if (!this._preventClick && includes(this.mode, "click")) {
          this.toggle();
        }
      }
    }, {
      name: "mediachange",
      filter: function filter() {
        return includes(this.mode, "media");
      },
      el: function el() {
        return this.target;
      },
      handler: function handler(e, mediaObj) {
        if (mediaObj.matches ^ this.isToggled(this.target)) {
          this.toggle();
        }
      }
    }],
    methods: {
      toggle: function toggle(type) {
        var _this65 = this;
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee31() {
          var leaving, _iterator73, _step73, el, isLeaving, toggled;
          return _regenerator["default"].wrap(function _callee31$(_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                if (trigger(_this65.target, type || "toggle", [_this65])) {
                  _context31.next = 2;
                  break;
                }
                return _context31.abrupt("return");
              case 2:
                if (hasAttr(_this65.$el, "aria-expanded")) {
                  attr(_this65.$el, "aria-expanded", !_this65.isToggled(_this65.target));
                }
                if (_this65.queued) {
                  _context31.next = 5;
                  break;
                }
                return _context31.abrupt("return", _this65.toggleElement(_this65.target));
              case 5:
                leaving = _this65.target.filter(function (el) {
                  return hasClass(el, _this65.clsLeave);
                });
                if (!leaving.length) {
                  _context31.next = 10;
                  break;
                }
                _iterator73 = _createForOfIteratorHelper(_this65.target);
                try {
                  for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
                    el = _step73.value;
                    isLeaving = includes(leaving, el);
                    _this65.toggleElement(el, isLeaving, isLeaving);
                  }
                } catch (err) {
                  _iterator73.e(err);
                } finally {
                  _iterator73.f();
                }
                return _context31.abrupt("return");
              case 10:
                toggled = _this65.target.filter(_this65.isToggled);
                _context31.next = 13;
                return _this65.toggleElement(toggled, false);
              case 13:
                if (!_context31.sent) {
                  _context31.next = 16;
                  break;
                }
                _context31.next = 16;
                return _this65.toggleElement(_this65.target.filter(function (el) {
                  return !includes(toggled, el);
                }), true);
              case 16:
              case "end":
                return _context31.stop();
            }
          }, _callee31);
        }))();
      }
    }
  };
  var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Accordion: Accordion,
    Alert: alert,
    Close: Close,
    Cover: cover,
    Drop: drop,
    DropParentIcon: IconComponent,
    Dropdown: drop,
    Dropnav: Dropnav,
    FormCustom: formCustom,
    Grid: grid,
    HeightMatch: heightMatch,
    HeightPlaceholder: heightPlaceholder,
    HeightViewport: heightViewport,
    Icon: Icon,
    Img: img,
    Inverse: inverse,
    Leader: leader,
    Margin: Margin,
    Marker: Marker,
    Modal: modal,
    Nav: nav,
    NavParentIcon: NavParentIcon,
    Navbar: navbar,
    NavbarParentIcon: IconComponent,
    NavbarToggleIcon: NavbarToggleIcon,
    Offcanvas: offcanvas,
    OverflowAuto: overflowAuto,
    OverlayIcon: IconComponent,
    PaginationNext: PaginationNext,
    PaginationPrevious: PaginationPrevious,
    Responsive: responsive,
    Scroll: scroll,
    Scrollspy: scrollspy,
    ScrollspyNav: scrollspyNav,
    SearchIcon: Search,
    SlidenavNext: Slidenav,
    SlidenavPrevious: Slidenav,
    Spinner: Spinner,
    Sticky: sticky,
    Svg: svg,
    Switcher: Switcher,
    Tab: tab,
    Toggle: toggle,
    Totop: Totop,
    Video: Video
  });
  each(components, function (component, name) {
    return App.component(name, component);
  });
  boot(App);
  each(components$1, function (component, name) {
    return App.component(name, component);
  });
  return App;
});

},{"@babel/runtime/helpers/asyncToGenerator":4,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":8,"@babel/runtime/helpers/slicedToArray":14,"@babel/runtime/helpers/toConsumableArray":15,"@babel/runtime/helpers/typeof":18,"@babel/runtime/regenerator":20}],24:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _jquery = _interopRequireDefault(require("jquery"));
var _uikit = _interopRequireDefault(require("uikit"));
(0, _jquery["default"])(function () {
  if ((0, _jquery["default"])(".dc-step-3").length) {
    init_step_3();
  }
  if ((0, _jquery["default"])(".dc-step-1").length) {
    init_step_1();
  }
  (0, _jquery["default"])(".dc-step-1-1,.dc-step-1-2,.dc-step-1-3").on("change", "input", function () {
    init_step_1();
  });
  (0, _jquery["default"])(".dc-step-1-4").on("keyup", "input", function () {
    this.value = this.value.replace(/[^\d]/g, "");
    init_step_1();
  });
  (0, _jquery["default"])(".dc-step-3").on("change", "input", function () {
    init_step_3();
  });
  (0, _jquery["default"])('.question-list').on('change', ".dismiss input", function (e) {
    var li = (0, _jquery["default"])(this).parents('li');
    li.toggleClass('dc-disabled');
    init_step_3();
    var dismissed_count = (0, _jquery["default"])('.dc-step-3').find('.dismiss input[type=checkbox]:not(:checked)').length;
    if (dismissed_count % 4 == 0 && !(0, _jquery["default"])(this).first('input[type=checkbox]').prop('checked')) {
      _uikit["default"].modal((0, _jquery["default"])('#dismissed-info')).show();
    }
  });
  (0, _jquery["default"])('#qa-weiter-button,#to_result_button').on('click', function (e) {
    /*
    // Prüfung, ob Slider uninitialisiert sind
    if ($(this).parents('form').data('validated')) {
        return;
    }
    */
    (0, _jquery["default"])('.radio-slider,.radio-buttons').each(function () {
      var li_element = (0, _jquery["default"])(this).parents('li');
      if (li_element.hasClass('dc-disabled')) {
        return;
      }
      if (li_element.is(':visible')) {
        //            console.log(li_element.is(':hidden'));
        var checked = (0, _jquery["default"])(this).find('input[type=radio]:checked');
        if (0 == checked.length) {
          //                    console.log($(this).parents('form').data('validated'));
          //                    $(this).parents('form').data('validated',1);
          e.stopPropagation();
          e.preventDefault();
          //                    console.log($(this).parents('form'));
          _uikit["default"].modal((0, _jquery["default"])('#unfilled-info')).show();
          return;
        }
      }
    });
  });

  // Tachoscheiben aus data-antwort_value initialisieren
  (0, _jquery["default"])(".slider-round").each(function () {
    var $roundS = (0, _jquery["default"])(this),
      val = $roundS.data("antwort_value");
    $roundS.roundSlider({
      value: val,
      step: 10,
      radius: "80",
      width: 15,
      handleSize: "+7",
      sliderType: "min-range",
      startAngle: 90,
      editableTooltip: false,
      update: function update(e) {
        e.control.removeClass("dc-not-modified");
        (0, _jquery["default"])('input[name="a[' + e.control.data("antwort_id") + ']"]').val(e.value);
        init_step_3();
      }
    });
  });
  (0, _jquery["default"])(".range-slider").on("change", function (e) {
    (0, _jquery["default"])(e.target).removeClass("dc-not-modified");
  });
  function init_step_1() {
    (0, _jquery["default"])("button.dc-app-continue").removeAttr("disabled");
    return;
    (0, _jquery["default"])("button.dc-app-continue").attr("disabled", true);
    var v1 = (0, _jquery["default"])(".dc-step-1-1 input:radio[name='bereich']:checked").val();
    var v4 = true;
    if (v1 !== undefined) {
      (0, _jquery["default"])(".dc-hidden").hide();
      (0, _jquery["default"])(".dc-section-" + v1).show();
      (0, _jquery["default"])(".dc-section-beschaeftigte").show();
    }

    //        var v2 = $(".dc-step-1-2 .dc-cbx-segment:checked").length;

    var v3 = (0, _jquery["default"])(".dc-step-1-3 input:radio[name='beschaeftigte']:checked").val();
    var v5 = (0, _jquery["default"])('.dc-step-1-2[style*="display: list-item"] .dc-cbx-segment:checked').length;
    // plz Eingabe prüfen
    (0, _jquery["default"])(".dc-step-1-4 input").each(function () {
      if ((0, _jquery["default"])(this).val().length != 2) {
        v4 = false;
      }
    });
    if (v5 > 1) {
      (0, _jquery["default"])('.dc-step-1-2[style*="display: list-item"] .dc-cbx-segment:not(:checked)').attr("disabled", true);
    } else {
      (0, _jquery["default"])('.dc-step-1-2[style*="display: list-item"] .dc-cbx-segment:not(:checked)').removeAttr("disabled");
    }
    if (v5 > 0 && v3 !== undefined && v4 && v5 < 3) {
      (0, _jquery["default"])("button.dc-app-continue").removeAttr("disabled");
    }
  }
  function init_step_3() {
    //        return;
    //        $("button.dc-app-continue").attr("disabled", true);
    var all_edited = true;

    // beim Reload Status der Checkbox prüfen und li class dc-disabled setzen
    (0, _jquery["default"])(".question-list li").each(function () {
      if ((0, _jquery["default"])(this).find(".dismiss input[type=checkbox]").length) {
        var cbx = (0, _jquery["default"])(this).find(".dismiss input[type=checkbox]");
        if (!cbx.prop("checked")) {
          (0, _jquery["default"])(this).addClass("dc-disabled");
        }
      }
    });
    (0, _jquery["default"])(".dc-step-3 li:not(.dc-disabled) input").each(function () {
      // radios
      if ((0, _jquery["default"])('input[name="' + (0, _jquery["default"])(this).attr("name") + '"]').attr("type") == "radio") {
        if ((0, _jquery["default"])('input[name="' + (0, _jquery["default"])(this).attr("name") + '"]:checked').length == 0) {
          all_edited = false;
        }
      }
    });
    // Tachoscheiben && Rangeslider
    if ((0, _jquery["default"])(".dc-step-3 li:not(.dc-disabled) .dc-not-modified").length) {
      all_edited = false;
    }
    if (all_edited) {
      (0, _jquery["default"])("button.dc-app-continue").removeAttr("disabled");
    }
  }
  var timer;
  var util = _uikit["default"].util;
  var modalEl = util.$("#start-auswertung");
  var modalPdfSpinner = util.$("#start-pdf-download");

  // --- Wartefenster PDF-Download -------------------------------------------
  //
  // Beide PDF-Templates (TPL 59 barrierefrei, TPL 60 gestaltet) setzen mit der
  // fertigen Antwort das Cookie dlc=waiting_for_download. Darauf wird gepollt.
  // Kommt es nicht, wird das Fenster NICHT stillschweigend geschlossen, sondern
  // sagt nach PDF_HINT_AFTER ehrlich, dass es laenger dauert (WCAG 4.1.3).

  var PDF_POLL_INTERVAL = 100; // ms zwischen zwei Cookie-Pruefungen
  var PDF_HINT_AFTER = 40000; // ms bis zum Hinweis "dauert laenger"
  var PDF_POLL_MAX = 300000; // ms, danach Abbruch mit Fehlermeldung
  var PDF_CLOSE_DELAY = 2000; // ms, damit die Fertigmeldung noch ankommt

  var pdfPollTimer = null;
  var pdfCloseTimer = null;
  var pdfTrigger = null;
  function pdfStatusEl() {
    return document.getElementById("pdf-download-status");
  }

  // Text aus dem data-Attribut holen, damit die Uebersetzung ueber sprog im
  // Markup bleibt und nicht im gebauten JS festgetackert ist.
  function setPdfStatus(key) {
    var el = pdfStatusEl();
    if (!el) {
      return;
    }
    var text = el.getAttribute("data-msg-" + key);
    // Nur bei echter Aenderung schreiben - sonst kuendigt die Live-Region
    // denselben Text beim Oeffnen ein zweites Mal an.
    if (text && el.textContent.trim() !== text.trim()) {
      el.textContent = text;
    }
  }
  function pdfSpinnerVisible(visible) {
    var el = document.getElementById("pdf-download-spinner");
    if (el) {
      (0, _jquery["default"])(el).toggleClass("uk-hidden", !visible);
    }
  }
  function stopPdfPolling() {
    if (pdfPollTimer) {
      window.clearInterval(pdfPollTimer);
      pdfPollTimer = null;
    }
    if (pdfCloseTimer) {
      window.clearTimeout(pdfCloseTimer);
      pdfCloseTimer = null;
    }
  }
  (0, _jquery["default"])(document).on("click", "a.pdf-download-start", function () {
    if (!modalPdfSpinner) {
      return;
    }
    pdfTrigger = this;
    stopPdfPolling();
    setCookie("dlc", 0, 1);
    pdfSpinnerVisible(true);
    setPdfStatus("wait");
    _uikit["default"].modal(modalPdfSpinner).show();
    var elapsed = 0;
    pdfPollTimer = window.setInterval(function () {
      elapsed += PDF_POLL_INTERVAL;
      if (document.cookie.indexOf("dlc=waiting_for_download") !== -1) {
        stopPdfPolling();
        setCookie("dlc", 0, 1);
        pdfSpinnerVisible(false);
        setPdfStatus("done");
        pdfCloseTimer = window.setTimeout(function () {
          pdfCloseTimer = null;
          _uikit["default"].modal(modalPdfSpinner).hide();
        }, PDF_CLOSE_DELAY);
        return;
      }
      if (elapsed === PDF_HINT_AFTER) {
        setPdfStatus("slow");
      }
      if (elapsed >= PDF_POLL_MAX) {
        stopPdfPolling();
        pdfSpinnerVisible(false);
        setPdfStatus("timeout");
      }
    }, PDF_POLL_INTERVAL);
  });
  if (modalPdfSpinner) {
    // Aufraeumen und Fokus zurueck auf den ausloesenden Link - UIkit gibt den
    // Fokus beim Schliessen nicht von selbst zurueck.
    util.on(modalPdfSpinner, "hidden", function () {
      stopPdfPolling();
      if (pdfTrigger && document.body.contains(pdfTrigger)) {
        pdfTrigger.focus();
      }
      pdfTrigger = null;
    });
  }
  function setCookie(name, value, expiresInSeconds) {
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiresInSeconds * 1000);
    var c_value = escape(value) + (expiresInSeconds == null ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value + '; path=/';
  }
  ;
  (0, _jquery["default"])(document).on("click", "#to_result_button", function (e) {
    var btn;
    btn = this;
    if (!(0, _jquery["default"])(btn).hasClass("clicked")) {
      e.preventDefault();
      (0, _jquery["default"])(btn).addClass("clicked");
      _uikit["default"].modal(modalEl).show();
      timer = setTimeout(function () {
        _uikit["default"].modal(modalEl).hide();
        (0, _jquery["default"])(btn).trigger(e.type);
      }, Math.floor(Math.random() * 3000 + 3000));
    }
  });
  function init_condition() {
    (0, _jquery["default"])('.has-condition').each(function () {
      var condition = (0, _jquery["default"])(this).data('condition');
      check_condition((0, _jquery["default"])(this), condition);
      if ((0, _jquery["default"])(this).is(':hidden') && !(0, _jquery["default"])(this).hasClass('dc-step-1')) {
        var checkedradio = (0, _jquery["default"])(this).find('input[type=radio]:checked');
        checkedradio.each(function () {
          (0, _jquery["default"])(this).prop('checked', false);
        });
        (0, _jquery["default"])(this).find('.progress-bar-current').width('0');
      }
    });
  }
  init_condition();
  function check_condition(elem, condition) {
    var conditions = condition.split('||');
    elem.hide();
    //        elem.find('input').val(-2);
    _jquery["default"].each(conditions, function (index, val) {
      var cond = val.split('==');
      var field_name = cond[0].trim();
      var field_val = cond[1].trim();
      var check_elem_val = (0, _jquery["default"])("[data-pid=" + field_name + "]").find('input:checked').val();
      (0, _jquery["default"])("[data-pid=" + field_name + "]").addClass('is_filter');
      if (!(0, _jquery["default"])("[data-pid=" + field_name + "]").length) {
        // Immer alle anzeigen, wenn das Filterelement nicht vorhanden ist
        // wird auf allen Folgeseiten benötigt
        elem.show();
      }
      if (field_val == check_elem_val) {
        elem.show();
      }
    });
  }
  (0, _jquery["default"])('.is_filter input').on('change', function () {
    init_condition();
  });
  (0, _jquery["default"])(document).on("click", ".trackclick", function (e) {
    var elem = (0, _jquery["default"])(this);
    var bereichId = elem.parents(".clicktracker").data("bereich");
    var addressId = elem.data("address-id");
    _jquery["default"].ajax({
      method: "POST",
      url: "index.php",
      data: {
        bereich_id: bereichId,
        address_id: addressId,
        action: 'logclick'
      }
    });
  });
});

},{"@babel/runtime/helpers/interopRequireDefault":8,"jquery":21,"uikit":23}],25:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _jquery = _interopRequireDefault(require("jquery"));
var _uikit = _interopRequireDefault(require("uikit"));
var _uikitIconsDigicheck = _interopRequireDefault(require("../scripts/uikit-icons-digicheck"));
require("round-slider/dist/roundslider.min");
require("../scripts/dc-app");
// import jQuery

// import bootstrap components from node_modules folder
// see https://getbootstrap.com/docs/4.3/getting-started/webpack/
// import 'popper.js';
// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/tooltip';

// import Icons from 'uikit/dist/js/uikit-icons';

// import "ion-rangeslider/js/ion.rangeSlider.min";

_uikit["default"].use(_uikitIconsDigicheck["default"]);

// import demo
// import fooFighters from './demo-modules/foo-fighters';

// on document ready
(0, _jquery["default"])(function () {
  var $doc = (0, _jquery["default"])(document);
  // enable bootstrap tooltips
  //$('[data-toggle="tooltip"]').tooltip();

  // Learn to Fly!
  //console.dir(fooFighters);

  function initRoundSlider() {
    (0, _jquery["default"])(".slider-round-result").each(function () {
      var $sliderResult = (0, _jquery["default"])(this),
        val = $sliderResult.data("antwort_value");
      $sliderResult.roundSlider({
        value: val,
        step: 1,
        radius: "60",
        width: 16,
        readOnly: true,
        handleSize: "+7",
        sliderType: "min-range",
        startAngle: 90,
        editableTooltip: false,
        beforeCreate: function beforeCreate() {
          this.options.radius = this.control.parent().width() / 2;
          this["_bind"]((0, _jquery["default"])(window), "resize", function () {
            var radius = this.control.parent().width() / 2;
            this.option("radius", radius);
          });
        }
      });
    });
  }
  function initRangeSlider() {
    (0, _jquery["default"])(".range-slider").each(function () {
      var $rs = (0, _jquery["default"])(this);
      $rs.ionRangeSlider({
        skin: "big",
        grid: true,
        keyboard: true,
        hide_min_max: true,
        // show/hide MIN and MAX labels
        hide_from_to: true,
        // show/hide FROM and TO labels
        prettify: function prettify(n) {
          var values_p = $rs.data("labels");
          return values_p[n];
        }
      });
    });
  }
  function initMoreContent() {
    // Toggle more-content
    (0, _jquery["default"])(document).find(".more-content").hide();
    (0, _jquery["default"])(document).find(".more-link").each(function () {
      var l = (0, _jquery["default"])(this);
      l.find(".text").html((0, _jquery["default"])(this).data("text-closed"));
      l.click(function (e) {
        e.preventDefault();
        if (l.hasClass("open")) {
          l.removeClass("open").find(".text").html(l.data("text-closed")).end().find(".uk-icon").attr("uk-icon", "chevron-down").end().prev(".more-content").slideUp(300);
        } else {
          l.addClass("open").find(".text").html(l.data("text-opened")).end().find(".uk-icon").attr("uk-icon", "chevron-up").end().prev(".more-content").slideDown(300);
        }
      });
    });
  }
  function initSlideToggle() {
    $doc.find('[data-slidetoggle-hide]').hide();
    $doc.on('click', '[data-slidetoggle]', function (e) {
      e.preventDefault();
      var $el = (0, _jquery["default"])(this),
        target = (0, _jquery["default"])($el.data('slidetoggle')),
        txtClose = $el.data('text-close'),
        txtOpen = $el.data('text-open');
      if ($el.hasClass('open')) {
        target.slideToggle(300).removeClass('open');
        $el.attr('aria-label', txtOpen);
        $el.removeClass('open').blur();
      } else {
        target.slideToggle(300).addClass('open');
        $el.attr('aria-label', txtClose);
        $el.addClass('open').blur();
      }
    });
  }
  function initEvalOffcanvas() {
    var $ocElements = $doc.find('.offcanvas-evaluation'),
      $ocCount = $ocElements.length;
    $doc.find('.offcanvas-evaluation').each(function (i) {
      var $el = (0, _jquery["default"])(this),
        $prev = $el.find('.nav-prev'),
        $next = $el.find('.nav-next');
      if (i < 1) {
        // console.log(' ','#' + $el.next().attr('id'));
        $prev.addClass('uk-hidden');
      } else {
        $prev.attr('data-uk-toggle', 'target:#' + $el.prev().attr('id'));
      }
      if (i === $ocCount - 1) {
        $next.addClass('uk-hidden');
      } else {
        $next.attr('data-uk-toggle', 'target:#' + $el.next().attr('id'));
      }
    });
  }
  function initCopy2Clipboard() {
    function copyDivToClipboard(element) {
      var range = document.createRange();
      range.selectNode(document.getElementById(element));
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges(); // to deselect
    }

    (0, _jquery["default"])('body').on('click', '.copy2clipboard', function (e) {
      e.preventDefault();
      var el = (0, _jquery["default"])(this),
        target = el.data('target-id');
      copyDivToClipboard(target);
      el.attr('data-uk-tooltip', 'Der Link wurde in die Zwischenablage kopiert');
      _uikit["default"].tooltip(el).show();
      setTimeout(function () {
        el.removeAttr('data-uk-tooltip');
      }, 1750);
    });
  }
  function initProgress() {
    var progress_desktop = (0, _jquery["default"])('.progress-desktop'),
      progress_mobile = (0, _jquery["default"])('.progress-mobile'),
      q_count = (0, _jquery["default"])('.q-count');
    function countIndicators() {
      var spans = progress_desktop.find('.bereich:not(.inactive) span'),
        span_count = spans.length;
      spans.each(function (index) {
        // wenn das aktuelle Span die Klasse "active" hat, dann im Elternelement das Attribut aria-label setzen auf den Wert index+1 + ' von ' + span_count
        if ((0, _jquery["default"])(this).hasClass('active')) {
          (0, _jquery["default"])(this).parents('.progress-container').attr('aria-label', 'Sie befinden sich auf Seite ' + (index + 1) + ' von ' + span_count);
        }
        (0, _jquery["default"])(this).attr('data-no', index + 1).attr('data-sum', span_count);
      });
      progress_mobile.attr('max', span_count);
      q_count.fadeOut(300, function () {
        (0, _jquery["default"])(this).text(span_count).fadeIn(300);
      });
    }
    countIndicators();
    (0, _jquery["default"])('body').on('change', '.dc-cbx-segment', function () {
      var el = progress_desktop.find('[data-bereich=' + (0, _jquery["default"])(this).data('scheme') + ']');
      if ((0, _jquery["default"])(this).is(':checked')) {
        el.removeClass('inactive');
      } else {
        el.addClass('inactive');
      }
      countIndicators();
    });
  }
  function initScrollDown() {
    var $scrolldown = (0, _jquery["default"])('#scroll-down');
    if ($scrolldown != null) {
      window.addEventListener('scroll', function () {
        $scrolldown.fadeOut(400);
      });
      $scrolldown.on('click', function (e) {
        e.preventDefault();
        (0, _jquery["default"])('html,body').animate({
          scrollTop: '+=' + window.innerHeight
        });
      });
    }
  }
  function initRadioSubOptions() {
    var $radio = (0, _jquery["default"])('[data-has-suboption]'),
      $suboptions = (0, _jquery["default"])('.suboption');
    $radio.each(function () {
      if (!(0, _jquery["default"])(this)[0].checked) {
        (0, _jquery["default"])(this).siblings('.suboption').hide();
      }
    });
    $radio.change(function (e) {
      $suboptions.slideUp();
      (0, _jquery["default"])(this).siblings('.suboption').slideDown();
    });
  }
  initRoundSlider();
  initMoreContent();
  initSlideToggle();
  initRangeSlider();
  initEvalOffcanvas();
  initCopy2Clipboard();
  initProgress();
  initScrollDown();
  initRadioSubOptions();
});

// Modal auf Check-Startseite automatisch anzeigen
var util = _uikit["default"].util;
util.on(document, 'DOMContentLoaded', function () {
  var modalEl = util.$('#start-info');
  _uikit["default"].modal(modalEl).show();
});

},{"../scripts/dc-app":24,"../scripts/uikit-icons-digicheck":26,"@babel/runtime/helpers/interopRequireDefault":8,"jquery":21,"round-slider/dist/roundslider.min":22,"uikit":23}],26:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/*! UIkit 3.6.0 | https://www.getuikit.com | (c) 2014 - 2020 YOOtheme | MIT License */

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : (0, _typeof2["default"])(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define('uikiticons', factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.UIkitIcons = factory());
})(void 0, function () {
  'use strict';

  function plugin(UIkit) {
    if (plugin.installed) {
      return;
    }
    UIkit.icon.add({
      "500px": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.624,11.866c-0.141,0.132,0.479,0.658,0.662,0.418c0.051-0.046,0.607-0.61,0.662-0.664c0,0,0.738,0.719,0.814,0.719 c0.1,0,0.207-0.055,0.322-0.17c0.27-0.269,0.135-0.416,0.066-0.495l-0.631-0.616l0.658-0.668c0.146-0.156,0.021-0.314-0.1-0.449 c-0.182-0.18-0.359-0.226-0.471-0.125l-0.656,0.654l-0.654-0.654c-0.033-0.034-0.08-0.045-0.124-0.045 c-0.079,0-0.191,0.068-0.307,0.181c-0.202,0.202-0.247,0.351-0.133,0.462l0.665,0.665L9.624,11.866z\"/><path d=\"M11.066,2.884c-1.061,0-2.185,0.248-3.011,0.604c-0.087,0.034-0.141,0.106-0.15,0.205C7.893,3.784,7.919,3.909,7.982,4.066 c0.05,0.136,0.187,0.474,0.452,0.372c0.844-0.326,1.779-0.507,2.633-0.507c0.963,0,1.9,0.191,2.781,0.564 c0.695,0.292,1.357,0.719,2.078,1.34c0.051,0.044,0.105,0.068,0.164,0.068c0.143,0,0.273-0.137,0.389-0.271 c0.191-0.214,0.324-0.395,0.135-0.575c-0.686-0.654-1.436-1.138-2.363-1.533C13.24,3.097,12.168,2.884,11.066,2.884z\"/><path d=\"M16.43,15.747c-0.092-0.028-0.242,0.05-0.309,0.119l0,0c-0.652,0.652-1.42,1.169-2.268,1.521 c-0.877,0.371-1.814,0.551-2.779,0.551c-0.961,0-1.896-0.189-2.775-0.564c-0.848-0.36-1.612-0.879-2.268-1.53 c-0.682-0.688-1.196-1.455-1.529-2.268c-0.325-0.799-0.471-1.643-0.471-1.643c-0.045-0.24-0.258-0.249-0.567-0.203 c-0.128,0.021-0.519,0.079-0.483,0.36v0.01c0.105,0.644,0.289,1.284,0.545,1.895c0.417,0.969,1.002,1.849,1.756,2.604 c0.757,0.754,1.636,1.34,2.604,1.757C8.901,18.785,9.97,19,11.088,19c1.104,0,2.186-0.215,3.188-0.645 c1.838-0.896,2.604-1.757,2.604-1.757c0.182-0.204,0.227-0.317-0.1-0.643C16.779,15.956,16.525,15.774,16.43,15.747z\"/><path d=\"M5.633,13.287c0.293,0.71,0.723,1.341,1.262,1.882c0.54,0.54,1.172,0.971,1.882,1.264c0.731,0.303,1.509,0.461,2.298,0.461 c0.801,0,1.578-0.158,2.297-0.461c0.711-0.293,1.344-0.724,1.883-1.264c0.543-0.541,0.971-1.172,1.264-1.882 c0.314-0.721,0.463-1.5,0.463-2.298c0-0.79-0.148-1.569-0.463-2.289c-0.293-0.699-0.721-1.329-1.264-1.881 c-0.539-0.541-1.172-0.959-1.867-1.263c-0.721-0.303-1.5-0.461-2.299-0.461c-0.802,0-1.613,0.159-2.322,0.461 c-0.577,0.25-1.544,0.867-2.119,1.454v0.012V2.108h8.16C15.1,2.104,15.1,1.69,15.1,1.552C15.1,1.417,15.1,1,14.809,1H5.915 C5.676,1,5.527,1.192,5.527,1.384v6.84c0,0.214,0.273,0.372,0.529,0.428c0.5,0.105,0.614-0.056,0.737-0.224l0,0 c0.18-0.273,0.776-0.884,0.787-0.894c0.901-0.905,2.117-1.408,3.416-1.408c1.285,0,2.5,0.501,3.412,1.408 c0.914,0.914,1.408,2.122,1.408,3.405c0,1.288-0.508,2.496-1.408,3.405c-0.9,0.896-2.152,1.406-3.438,1.406 c-0.877,0-1.711-0.229-2.433-0.671v-4.158c0-0.553,0.237-1.151,0.643-1.614c0.462-0.519,1.094-0.799,1.782-0.799 c0.664,0,1.293,0.253,1.758,0.715c0.459,0.459,0.709,1.071,0.709,1.723c0,1.385-1.094,2.468-2.488,2.468 c-0.273,0-0.769-0.121-0.781-0.125c-0.281-0.087-0.405,0.306-0.438,0.436c-0.159,0.496,0.079,0.585,0.123,0.607 c0.452,0.137,0.743,0.157,1.129,0.157c1.973,0,3.572-1.6,3.572-3.57c0-1.964-1.6-3.552-3.572-3.552c-0.97,0-1.872,0.36-2.546,1.038 c-0.656,0.631-1.027,1.487-1.027,2.322v3.438v-0.011c-0.372-0.42-0.732-1.041-0.981-1.682c-0.102-0.248-0.315-0.202-0.607-0.113 c-0.135,0.035-0.519,0.157-0.44,0.439C5.372,12.799,5.577,13.164,5.633,13.287z\"/></svg>",
      "album": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"5\" y=\"2\" width=\"10\" height=\"1\"/><rect x=\"3\" y=\"4\" width=\"14\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"6.5\" width=\"17\" height=\"11\"/></svg>",
      "arrow-down": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66\"/><line fill=\"none\" stroke=\"#000\" x1=\"10.5\" y1=\"4\" x2=\"10.5\" y2=\"15\"/></svg>",
      "arrow-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"10 14 5 9.5 10 5\"/><line fill=\"none\" stroke=\"#000\" x1=\"16\" y1=\"9.5\" x2=\"5\" y2=\"9.52\"/></svg>",
      "arrow-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"10 5 15 9.5 10 14\"/><line fill=\"none\" stroke=\"#000\" x1=\"4\" y1=\"9.5\" x2=\"15\" y2=\"9.5\"/></svg>",
      "arrow-up": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4\"/><line fill=\"none\" stroke=\"#000\" x1=\"10.5\" y1=\"16\" x2=\"10.5\" y2=\"5\"/></svg>",
      "ban": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"4\" y1=\"3.5\" x2=\"16\" y2=\"16.5\"/></svg>",
      "behance": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.5,10.6c-0.4-0.5-0.9-0.9-1.6-1.1c1.7-1,2.2-3.2,0.7-4.7C7.8,4,6.3,4,5.2,4C3.5,4,1.7,4,0,4v12c1.7,0,3.4,0,5.2,0 c1,0,2.1,0,3.1-0.5C10.2,14.6,10.5,12.3,9.5,10.6L9.5,10.6z M5.6,6.1c1.8,0,1.8,2.7-0.1,2.7c-1,0-2,0-2.9,0V6.1H5.6z M2.6,13.8v-3.1 c1.1,0,2.1,0,3.2,0c2.1,0,2.1,3.2,0.1,3.2L2.6,13.8z\"/><path d=\"M19.9,10.9C19.7,9.2,18.7,7.6,17,7c-4.2-1.3-7.3,3.4-5.3,7.1c0.9,1.7,2.8,2.3,4.7,2.1c1.7-0.2,2.9-1.3,3.4-2.9h-2.2 c-0.4,1.3-2.4,1.5-3.5,0.6c-0.4-0.4-0.6-1.1-0.6-1.7H20C20,11.7,19.9,10.9,19.9,10.9z M13.5,10.6c0-1.6,2.3-2.7,3.5-1.4 c0.4,0.4,0.5,0.9,0.6,1.4H13.5L13.5,10.6z\"/><rect x=\"13\" y=\"4\" width=\"5\" height=\"1.4\"/></svg>",
      "bell": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M17,15.5 L3,15.5 C2.99,14.61 3.79,13.34 4.1,12.51 C4.58,11.3 4.72,10.35 5.19,7.01 C5.54,4.53 5.89,3.2 7.28,2.16 C8.13,1.56 9.37,1.5 9.81,1.5 L9.96,1.5 C9.96,1.5 11.62,1.41 12.67,2.17 C14.08,3.2 14.42,4.54 14.77,7.02 C15.26,10.35 15.4,11.31 15.87,12.52 C16.2,13.34 17.01,14.61 17,15.5 L17,15.5 Z\"/><path fill=\"none\" stroke=\"#000\" d=\"M12.39,16 C12.39,17.37 11.35,18.43 9.91,18.43 C8.48,18.43 7.42,17.37 7.42,16\"/></svg>",
      "bold": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5,15.3 C5.66,15.3 5.9,15 5.9,14.53 L5.9,5.5 C5.9,4.92 5.56,4.7 5,4.7 L5,4 L8.95,4 C12.6,4 13.7,5.37 13.7,6.9 C13.7,7.87 13.14,9.17 10.86,9.59 L10.86,9.7 C13.25,9.86 14.29,11.28 14.3,12.54 C14.3,14.47 12.94,16 9,16 L5,16 L5,15.3 Z M9,9.3 C11.19,9.3 11.8,8.5 11.85,7 C11.85,5.65 11.3,4.8 9,4.8 L7.67,4.8 L7.67,9.3 L9,9.3 Z M9.185,15.22 C11.97,15 12.39,14 12.4,12.58 C12.4,11.15 11.39,10 9,10 L7.67,10 L7.67,15 L9.18,15 Z\"/></svg>",
      "bolt": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.74,20 L7.73,12 L3,12 L15.43,1 L12.32,9 L17.02,9 L4.74,20 L4.74,20 L4.74,20 Z M9.18,11 L7.1,16.39 L14.47,10 L10.86,10 L12.99,4.67 L5.61,11 L9.18,11 L9.18,11 L9.18,11 Z\"/></svg>",
      "bookmark": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"5.5 1.5 15.5 1.5 15.5 17.5 10.5 12.5 5.5 17.5\"/></svg>",
      "calendar": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M 2,3 2,17 18,17 18,3 2,3 Z M 17,16 3,16 3,8 17,8 17,16 Z M 17,7 3,7 3,4 17,4 17,7 Z\"/><rect width=\"1\" height=\"3\" x=\"6\" y=\"2\"/><rect width=\"1\" height=\"3\" x=\"13\" y=\"2\"/></svg>",
      "camera": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10.8\" r=\"3.8\"/><path fill=\"none\" stroke=\"#000\" d=\"M1,4.5 C0.7,4.5 0.5,4.7 0.5,5 L0.5,17 C0.5,17.3 0.7,17.5 1,17.5 L19,17.5 C19.3,17.5 19.5,17.3 19.5,17 L19.5,5 C19.5,4.7 19.3,4.5 19,4.5 L13.5,4.5 L13.5,2.9 C13.5,2.6 13.3,2.5 13,2.5 L7,2.5 C6.7,2.5 6.5,2.6 6.5,2.9 L6.5,4.5 L1,4.5 L1,4.5 Z\"/></svg>",
      "cart": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"7.3\" cy=\"17.3\" r=\"1.4\"/><circle cx=\"13.3\" cy=\"17.3\" r=\"1.4\"/><polyline fill=\"none\" stroke=\"#000\" points=\"0 2 3.2 4 5.3 12.5 16 12.5 18 6.5 8 6.5\"/></svg>",
      "check": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"4,10 8,15 17,4\"/></svg>",
      "chevron-double-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"10 14 6 10 10 6\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"14 14 10 10 14 6\"/></svg>",
      "chevron-double-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"10 6 14 10 10 14\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"6 6 10 10 6 14\"/></svg>",
      "chevron-down": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"16 7 10 13 4 7\"/></svg>",
      "chevron-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"13 16 7 10 13 4\"/></svg>",
      "chevron-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"7 4 13 10 7 16\"/></svg>",
      "chevron-up": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" points=\"4 13 10 7 16 13\"/></svg>",
      "clock": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><rect x=\"9\" y=\"4\" width=\"1\" height=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M13.018,14.197 L9.445,10.625\"/></svg>",
      "close": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xml:space=\"preserve\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\"><path d=\"M22.202,0.384L23.616,1.798L13.414,12L23.616,22.202L22.202,23.616L12,13.414L1.798,23.616L0.384,22.202L10.586,12L0.384,1.798L1.798,0.384L12,10.586L22.202,0.384Z\" fill-rule=\"nonzero\" transform=\"matrix(.6887 0 0 .6887 1.736 1.736)\"/></svg>",
      "cloud-download": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M6.5,14.61 L3.75,14.61 C1.96,14.61 0.5,13.17 0.5,11.39 C0.5,9.76 1.72,8.41 3.3,8.2 C3.38,5.31 5.75,3 8.68,3 C11.19,3 13.31,4.71 13.89,7.02 C14.39,6.8 14.93,6.68 15.5,6.68 C17.71,6.68 19.5,8.45 19.5,10.64 C19.5,12.83 17.71,14.6 15.5,14.6 L12.5,14.6\"/><polyline fill=\"none\" stroke=\"#000\" points=\"11.75 16 9.5 18.25 7.25 16\"/><path fill=\"none\" stroke=\"#000\" d=\"M9.5,18 L9.5,9.5\"/></svg>",
      "cloud-upload": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M6.5,14.61 L3.75,14.61 C1.96,14.61 0.5,13.17 0.5,11.39 C0.5,9.76 1.72,8.41 3.31,8.2 C3.38,5.31 5.75,3 8.68,3 C11.19,3 13.31,4.71 13.89,7.02 C14.39,6.8 14.93,6.68 15.5,6.68 C17.71,6.68 19.5,8.45 19.5,10.64 C19.5,12.83 17.71,14.6 15.5,14.6 L12.5,14.6\"/><polyline fill=\"none\" stroke=\"#000\" points=\"7.25 11.75 9.5 9.5 11.75 11.75\"/><path fill=\"none\" stroke=\"#000\" d=\"M9.5,18 L9.5,9.5\"/></svg>",
      "code": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"13,4 19,10 13,16\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"7,4 1,10 7,16\"/></svg>",
      "cog": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" cx=\"9.997\" cy=\"10\" r=\"3.31\"/><path fill=\"none\" stroke=\"#000\" d=\"M18.488,12.285 L16.205,16.237 C15.322,15.496 14.185,15.281 13.303,15.791 C12.428,16.289 12.047,17.373 12.246,18.5 L7.735,18.5 C7.938,17.374 7.553,16.299 6.684,15.791 C5.801,15.27 4.655,15.492 3.773,16.237 L1.5,12.285 C2.573,11.871 3.317,10.999 3.317,9.991 C3.305,8.98 2.573,8.121 1.5,7.716 L3.765,3.784 C4.645,4.516 5.794,4.738 6.687,4.232 C7.555,3.722 7.939,2.637 7.735,1.5 L12.263,1.5 C12.072,2.637 12.441,3.71 13.314,4.22 C14.206,4.73 15.343,4.516 16.225,3.794 L18.487,7.714 C17.404,8.117 16.661,8.988 16.67,10.009 C16.672,11.018 17.415,11.88 18.488,12.285 L18.488,12.285 Z\"/></svg>",
      "comment": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6,18.71 L6,14 L1,14 L1,1 L19,1 L19,14 L10.71,14 L6,18.71 L6,18.71 Z M2,13 L7,13 L7,16.29 L10.29,13 L18,13 L18,2 L2,2 L2,13 L2,13 Z\"/></svg>",
      "commenting": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"1.5,1.5 18.5,1.5 18.5,13.5 10.5,13.5 6.5,17.5 6.5,13.5 1.5,13.5\"/><circle cx=\"10\" cy=\"8\" r=\"1\"/><circle cx=\"6\" cy=\"8\" r=\"1\"/><circle cx=\"14\" cy=\"8\" r=\"1\"/></svg>",
      "comments": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"2 0.5 19.5 0.5 19.5 13\"/><path d=\"M5,19.71 L5,15 L0,15 L0,2 L18,2 L18,15 L9.71,15 L5,19.71 L5,19.71 L5,19.71 Z M1,14 L6,14 L6,17.29 L9.29,14 L17,14 L17,3 L1,3 L1,14 L1,14 L1,14 Z\"/></svg>",
      "copy": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"2.5\" width=\"12\" height=\"16\"/><polyline fill=\"none\" stroke=\"#000\" points=\"5 0.5 17.5 0.5 17.5 17\"/></svg>",
      "credit-card": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"4.5\" width=\"17\" height=\"12\"/><rect x=\"1\" y=\"7\" width=\"18\" height=\"3\"/></svg>",
      "database": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><ellipse fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"4.64\" rx=\"7.5\" ry=\"3.14\"/><path fill=\"none\" stroke=\"#000\" d=\"M17.5,8.11 C17.5,9.85 14.14,11.25 10,11.25 C5.86,11.25 2.5,9.84 2.5,8.11\"/><path fill=\"none\" stroke=\"#000\" d=\"M17.5,11.25 C17.5,12.99 14.14,14.39 10,14.39 C5.86,14.39 2.5,12.98 2.5,11.25\"/><path fill=\"none\" stroke=\"#000\" d=\"M17.49,4.64 L17.5,14.36 C17.5,16.1 14.14,17.5 10,17.5 C5.86,17.5 2.5,16.09 2.5,14.36 L2.5,4.64\"/></svg>",
      "desktop": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"8\" y=\"15\" width=\"1\" height=\"2\"/><rect x=\"11\" y=\"15\" width=\"1\" height=\"2\"/><rect x=\"5\" y=\"16\" width=\"10\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"3.5\" width=\"17\" height=\"11\"/></svg>",
      "download": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"14,10 9.5,14.5 5,10\"/><rect x=\"3\" y=\"17\" width=\"13\" height=\"1\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"13.91\" x2=\"9.5\" y2=\"3\"/></svg>",
      "dribbble": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" d=\"M1.3,8.9c0,0,5,0.1,8.6-1c1.4-0.4,2.6-0.9,4-1.9 c1.4-1.1,2.5-2.5,2.5-2.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" d=\"M3.9,16.6c0,0,1.7-2.8,3.5-4.2 c1.8-1.3,4-2,5.7-2.2C16,10,19,10.6,19,10.6\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" d=\"M6.9,1.6c0,0,3.3,4.6,4.2,6.8 c0.4,0.9,1.3,3.1,1.9,5.2c0.6,2,0.9,4.4,0.9,4.4\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" cx=\"10\" cy=\"10\" r=\"9\"/></svg>",
      "etsy": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path d=\"M8,4.26C8,4.07,8,4,8.31,4h4.46c.79,0,1.22.67,1.53,1.91l.25,1h.76c.14-2.82.26-4,.26-4S13.65,3,12.52,3H6.81L3.75,2.92v.84l1,.2c.73.11.9.27,1,1,0,0,.06,2,.06,5.17s-.06,5.14-.06,5.14c0,.59-.23.81-1,.94l-1,.2v.84l3.06-.1h5.11c1.15,0,3.82.1,3.82.1,0-.7.45-3.88.51-4.22h-.73l-.76,1.69a2.25,2.25,0,0,1-2.45,1.47H9.4c-1,0-1.44-.4-1.44-1.24V10.44s2.16,0,2.86.06c.55,0,.85.19,1.06,1l.23,1H13L12.9,9.94,13,7.41h-.85l-.28,1.13c-.16.74-.28.84-1,1-1,.1-2.89.09-2.89.09Z\"/></svg>",
      "expand": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"13 2 18 2 18 7 17 7 17 3 13 3\"/><polygon points=\"2 13 3 13 3 17 7 17 7 18 2 18\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M11,9 L17,3\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M3,17 L9,11\"/></svg>",
      "facebook": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11,10h2.6l0.4-3H11V5.3c0-0.9,0.2-1.5,1.5-1.5H14V1.1c-0.3,0-1-0.1-2.1-0.1C9.6,1,8,2.4,8,5v2H5.5v3H8v8h3V10z\"/></svg>",
      "file-edit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M18.65,1.68 C18.41,1.45 18.109,1.33 17.81,1.33 C17.499,1.33 17.209,1.45 16.98,1.68 L8.92,9.76 L8,12.33 L10.55,11.41 L18.651,3.34 C19.12,2.87 19.12,2.15 18.65,1.68 L18.65,1.68 L18.65,1.68 Z\"/><polyline fill=\"none\" stroke=\"#000\" points=\"16.5 8.482 16.5 18.5 3.5 18.5 3.5 1.5 14.211 1.5\"/></svg>",
      "file-pdf": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" width=\"13\" height=\"17\" x=\"3.5\" y=\"1.5\"/><path d=\"M14.65 11.67c-.48.3-1.37-.19-1.79-.37a4.65 4.65 0 0 1 1.49.06c.35.1.36.28.3.31zm-6.3.06l.43-.79a14.7 14.7 0 0 0 .75-1.64 5.48 5.48 0 0 0 1.25 1.55l.2.15a16.36 16.36 0 0 0-2.63.73zM9.5 5.32c.2 0 .32.5.32.97a1.99 1.99 0 0 1-.23 1.04 5.05 5.05 0 0 1-.17-1.3s0-.71.08-.71zm-3.9 9a4.35 4.35 0 0 1 1.21-1.46l.24-.22a4.35 4.35 0 0 1-1.46 1.68zm9.23-3.3a2.05 2.05 0 0 0-1.32-.3 11.07 11.07 0 0 0-1.58.11 4.09 4.09 0 0 1-.74-.5 5.39 5.39 0 0 1-1.32-2.06 10.37 10.37 0 0 0 .28-2.62 1.83 1.83 0 0 0-.07-.25.57.57 0 0 0-.52-.4H9.4a.59.59 0 0 0-.6.38 6.95 6.95 0 0 0 .37 3.14c-.26.63-1 2.12-1 2.12-.3.58-.57 1.08-.82 1.5l-.8.44A3.11 3.11 0 0 0 5 14.16a.39.39 0 0 0 .15.42l.24.13c1.15.56 2.28-1.74 2.66-2.42a23.1 23.1 0 0 1 3.59-.85 4.56 4.56 0 0 0 2.91.8.5.5 0 0 0 .3-.21 1.1 1.1 0 0 0 .12-.75.84.84 0 0 0-.14-.25z\"/></svg>",
      "file-text": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" width=\"13\" height=\"17\" x=\"3.5\" y=\"1.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"12\" y1=\"12.5\" y2=\"12.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"14\" y1=\"8.5\" y2=\"8.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"14\" y1=\"6.5\" y2=\"6.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"6\" x2=\"14\" y1=\"10.5\" y2=\"10.5\"/></svg>",
      "file": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"1.5\" width=\"13\" height=\"17\"/></svg>",
      "flickr": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"5.5\" cy=\"9.5\" r=\"3.5\"/><circle cx=\"14.5\" cy=\"9.5\" r=\"3.5\"/></svg>",
      "folder": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"9.5 5.5 8.5 3.5 1.5 3.5 1.5 16.5 18.5 16.5 18.5 5.5\"/></svg>",
      "forward": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.47,13.11 C4.02,10.02 6.27,7.85 9.04,6.61 C9.48,6.41 10.27,6.13 11,5.91 L11,2 L18.89,9 L11,16 L11,12.13 C9.25,12.47 7.58,13.19 6.02,14.25 C3.03,16.28 1.63,18.54 1.63,18.54 C1.63,18.54 1.38,15.28 2.47,13.11 L2.47,13.11 Z M5.3,13.53 C6.92,12.4 9.04,11.4 12,10.92 L12,13.63 L17.36,9 L12,4.25 L12,6.8 C11.71,6.86 10.86,7.02 9.67,7.49 C6.79,8.65 4.58,10.96 3.49,13.08 C3.18,13.7 2.68,14.87 2.49,16 C3.28,15.05 4.4,14.15 5.3,13.53 L5.3,13.53 Z\"/></svg>",
      "foursquare": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.23,2 C15.96,2 16.4,2.41 16.5,2.86 C16.57,3.15 16.56,3.44 16.51,3.73 C16.46,4.04 14.86,11.72 14.75,12.03 C14.56,12.56 14.16,12.82 13.61,12.83 C13.03,12.84 11.09,12.51 10.69,13 C10.38,13.38 7.79,16.39 6.81,17.53 C6.61,17.76 6.4,17.96 6.08,17.99 C5.68,18.04 5.29,17.87 5.17,17.45 C5.12,17.28 5.1,17.09 5.1,16.91 C5.1,12.4 4.86,7.81 5.11,3.31 C5.17,2.5 5.81,2.12 6.53,2 L15.23,2 L15.23,2 Z M9.76,11.42 C9.94,11.19 10.17,11.1 10.45,11.1 L12.86,11.1 C13.12,11.1 13.31,10.94 13.36,10.69 C13.37,10.64 13.62,9.41 13.74,8.83 C13.81,8.52 13.53,8.28 13.27,8.28 C12.35,8.29 11.42,8.28 10.5,8.28 C9.84,8.28 9.83,7.69 9.82,7.21 C9.8,6.85 10.13,6.55 10.5,6.55 C11.59,6.56 12.67,6.55 13.76,6.55 C14.03,6.55 14.23,6.4 14.28,6.14 C14.34,5.87 14.67,4.29 14.67,4.29 C14.67,4.29 14.82,3.74 14.19,3.74 L7.34,3.74 C7,3.75 6.84,4.02 6.84,4.33 C6.84,7.58 6.85,14.95 6.85,14.99 C6.87,15 8.89,12.51 9.76,11.42 L9.76,11.42 Z\"/></svg>",
      "future": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline points=\"19 2 18 2 18 6 14 6 14 7 19 7 19 2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M18,6.548 C16.709,3.29 13.354,1 9.6,1 C4.6,1 0.6,5 0.6,10 C0.6,15 4.6,19 9.6,19 C14.6,19 18.6,15 18.6,10\"/><rect x=\"9\" y=\"4\" width=\"1\" height=\"7\"/><path d=\"M13.018,14.197 L9.445,10.625\" fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\"/></svg>",
      "git-branch": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"7\" cy=\"3\" r=\"2\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"14\" cy=\"6\" r=\"2\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"7\" cy=\"17\" r=\"2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"2\" d=\"M14,8 C14,10.41 12.43,10.87 10.56,11.25 C9.09,11.54 7,12.06 7,15 L7,5\"/></svg>",
      "git-fork": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"5.79\" cy=\"2.79\" r=\"1.79\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"14.19\" cy=\"2.79\" r=\"1.79\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" cx=\"10.03\" cy=\"16.79\" r=\"1.79\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"2\" d=\"M5.79,4.57 L5.79,6.56 C5.79,9.19 10.03,10.22 10.03,13.31 C10.03,14.86 10.04,14.55 10.04,14.55 C10.04,14.37 10.04,14.86 10.04,13.31 C10.04,10.22 14.2,9.19 14.2,6.56 L14.2,4.57\"/></svg>",
      "github-alt": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,0.5 C4.75,0.5 0.5,4.76 0.5,10.01 C0.5,15.26 4.75,19.51 10,19.51 C15.24,19.51 19.5,15.26 19.5,10.01 C19.5,4.76 15.25,0.5 10,0.5 L10,0.5 Z M12.81,17.69 C12.81,17.69 12.81,17.7 12.79,17.69 C12.47,17.75 12.35,17.59 12.35,17.36 L12.35,16.17 C12.35,15.45 12.09,14.92 11.58,14.56 C12.2,14.51 12.77,14.39 13.26,14.21 C13.87,13.98 14.36,13.69 14.74,13.29 C15.42,12.59 15.76,11.55 15.76,10.17 C15.76,9.25 15.45,8.46 14.83,7.8 C15.1,7.08 15.07,6.29 14.75,5.44 L14.51,5.42 C14.34,5.4 14.06,5.46 13.67,5.61 C13.25,5.78 12.79,6.03 12.31,6.35 C11.55,6.16 10.81,6.05 10.09,6.05 C9.36,6.05 8.61,6.15 7.88,6.35 C7.28,5.96 6.75,5.68 6.26,5.54 C6.07,5.47 5.9,5.44 5.78,5.44 L5.42,5.44 C5.06,6.29 5.04,7.08 5.32,7.8 C4.7,8.46 4.4,9.25 4.4,10.17 C4.4,11.94 4.96,13.16 6.08,13.84 C6.53,14.13 7.05,14.32 7.69,14.43 C8.03,14.5 8.32,14.54 8.55,14.55 C8.07,14.89 7.82,15.42 7.82,16.16 L7.82,17.51 C7.8,17.69 7.7,17.8 7.51,17.8 C4.21,16.74 1.82,13.65 1.82,10.01 C1.82,5.5 5.49,1.83 10,1.83 C14.5,1.83 18.17,5.5 18.17,10.01 C18.18,13.53 15.94,16.54 12.81,17.69 L12.81,17.69 Z\"/></svg>",
      "github": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,1 C5.03,1 1,5.03 1,10 C1,13.98 3.58,17.35 7.16,18.54 C7.61,18.62 7.77,18.34 7.77,18.11 C7.77,17.9 7.76,17.33 7.76,16.58 C5.26,17.12 4.73,15.37 4.73,15.37 C4.32,14.33 3.73,14.05 3.73,14.05 C2.91,13.5 3.79,13.5 3.79,13.5 C4.69,13.56 5.17,14.43 5.17,14.43 C5.97,15.8 7.28,15.41 7.79,15.18 C7.87,14.6 8.1,14.2 8.36,13.98 C6.36,13.75 4.26,12.98 4.26,9.53 C4.26,8.55 4.61,7.74 5.19,7.11 C5.1,6.88 4.79,5.97 5.28,4.73 C5.28,4.73 6.04,4.49 7.75,5.65 C8.47,5.45 9.24,5.35 10,5.35 C10.76,5.35 11.53,5.45 12.25,5.65 C13.97,4.48 14.72,4.73 14.72,4.73 C15.21,5.97 14.9,6.88 14.81,7.11 C15.39,7.74 15.73,8.54 15.73,9.53 C15.73,12.99 13.63,13.75 11.62,13.97 C11.94,14.25 12.23,14.8 12.23,15.64 C12.23,16.84 12.22,17.81 12.22,18.11 C12.22,18.35 12.38,18.63 12.84,18.54 C16.42,17.35 19,13.98 19,10 C19,5.03 14.97,1 10,1 L10,1 Z\"/></svg>",
      "gitter": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3.5\" y=\"1\" width=\"1.531\" height=\"11.471\"/><rect x=\"7.324\" y=\"4.059\" width=\"1.529\" height=\"15.294\"/><rect x=\"11.148\" y=\"4.059\" width=\"1.527\" height=\"15.294\"/><rect x=\"14.971\" y=\"4.059\" width=\"1.529\" height=\"8.412\"/></svg>",
      "google-plus": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.9,9c0,2.7-0.6,5-3.2,6.3c-3.7,1.8-8.1,0.2-9.4-3.6C-1.1,7.6,1.9,3.3,6.1,3c1.7-0.1,3.2,0.3,4.6,1.3 c0.1,0.1,0.3,0.2,0.4,0.4c-0.5,0.5-1.2,1-1.7,1.6c-1-0.8-2.1-1.1-3.5-0.9C5,5.6,4.2,6,3.6,6.7c-1.3,1.3-1.5,3.4-0.5,5 c1,1.7,2.6,2.3,4.6,1.9c1.4-0.3,2.4-1.2,2.6-2.6H6.9V9H12.9z\"/><polygon points=\"20,9 20,11 18,11 18,13 16,13 16,11 14,11 14,9 16,9 16,7 18,7 18,9\"/></svg>",
      "google": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.86,9.09 C18.46,12.12 17.14,16.05 13.81,17.56 C9.45,19.53 4.13,17.68 2.47,12.87 C0.68,7.68 4.22,2.42 9.5,2.03 C11.57,1.88 13.42,2.37 15.05,3.65 C15.22,3.78 15.37,3.93 15.61,4.14 C14.9,4.81 14.23,5.45 13.5,6.14 C12.27,5.08 10.84,4.72 9.28,4.98 C8.12,5.17 7.16,5.76 6.37,6.63 C4.88,8.27 4.62,10.86 5.76,12.82 C6.95,14.87 9.17,15.8 11.57,15.25 C13.27,14.87 14.76,13.33 14.89,11.75 L10.51,11.75 L10.51,9.09 L17.86,9.09 L17.86,9.09 Z\"/></svg>",
      "grid": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"2\" y=\"2\" width=\"3\" height=\"3\"/><rect x=\"8\" y=\"2\" width=\"3\" height=\"3\"/><rect x=\"14\" y=\"2\" width=\"3\" height=\"3\"/><rect x=\"2\" y=\"8\" width=\"3\" height=\"3\"/><rect x=\"8\" y=\"8\" width=\"3\" height=\"3\"/><rect x=\"14\" y=\"8\" width=\"3\" height=\"3\"/><rect x=\"2\" y=\"14\" width=\"3\" height=\"3\"/><rect x=\"8\" y=\"14\" width=\"3\" height=\"3\"/><rect x=\"14\" y=\"14\" width=\"3\" height=\"3\"/></svg>",
      "happy": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"13\" cy=\"7\" r=\"1\"/><circle cx=\"7\" cy=\"7\" r=\"1\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"10\" r=\"8.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M14.6,11.4 C13.9,13.3 12.1,14.5 10,14.5 C7.9,14.5 6.1,13.3 5.4,11.4\"/></svg>",
      "hashtag": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.431,8 L15.661,7 L12.911,7 L13.831,3 L12.901,3 L11.98,7 L9.29,7 L10.21,3 L9.281,3 L8.361,7 L5.23,7 L5,8 L8.13,8 L7.21,12 L4.23,12 L4,13 L6.98,13 L6.061,17 L6.991,17 L7.911,13 L10.601,13 L9.681,17 L10.611,17 L11.531,13 L14.431,13 L14.661,12 L11.76,12 L12.681,8 L15.431,8 Z M10.831,12 L8.141,12 L9.061,8 L11.75,8 L10.831,12 Z\"/></svg>",
      "heart": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.03\" d=\"M10,4 C10,4 8.1,2 5.74,2 C3.38,2 1,3.55 1,6.73 C1,8.84 2.67,10.44 2.67,10.44 L10,18 L17.33,10.44 C17.33,10.44 19,8.84 19,6.73 C19,3.55 16.62,2 14.26,2 C11.9,2 10,4 10,4 L10,4 Z\"/></svg>",
      "history": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"#000\" points=\"1 2 2 2 2 6 6 6 6 7 1 7 1 2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M2.1,6.548 C3.391,3.29 6.746,1 10.5,1 C15.5,1 19.5,5 19.5,10 C19.5,15 15.5,19 10.5,19 C5.5,19 1.5,15 1.5,10\"/><rect x=\"9\" y=\"4\" width=\"1\" height=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M13.018,14.197 L9.445,10.625\"/></svg>",
      "home": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"18.65 11.35 10 2.71 1.35 11.35 0.65 10.65 10 1.29 19.35 10.65\"/><polygon points=\"15 4 18 4 18 7 17 7 17 5 15 5\"/><polygon points=\"3 11 4 11 4 18 7 18 7 12 12 12 12 18 16 18 16 11 17 11 17 19 11 19 11 13 8 13 8 19 3 19\"/></svg>",
      "image": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"16.1\" cy=\"6.1\" r=\"1.1\"/><rect fill=\"none\" stroke=\"#000\" x=\".5\" y=\"2.5\" width=\"19\" height=\"15\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"4,13 8,9 13,14\"/><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"11,12 12.5,10.5 16,14\"/></svg>",
      "info": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xml:space=\"preserve\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\"><g fill=\"#298bd4\" transform=\"translate(1 1)\"><path d=\"M9,-0.71C3.637,-0.71 -0.71,3.637 -0.71,9C-0.71,14.363 3.637,18.71 9,18.71C14.363,18.71 18.71,14.363 18.71,9C18.71,3.637 14.363,-0.71 9,-0.71ZM9,1.29C13.258,1.29 16.71,4.742 16.71,9C16.71,13.258 13.258,16.71 9,16.71C4.742,16.71 1.29,13.258 1.29,9C1.29,4.742 4.742,1.29 9,1.29Z\" fill-rule=\"nonzero\"/><path d=\"M10,6.258L10,14.645L8,14.645L8,6.258L10,6.258Z\" fill-rule=\"nonzero\"/><circle cx=\"9\" cy=\"4.065\" r=\"1\"/></g></svg>",
      "instagram": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.55,1H6.46C3.45,1,1,3.44,1,6.44v7.12c0,3,2.45,5.44,5.46,5.44h7.08c3.02,0,5.46-2.44,5.46-5.44V6.44 C19.01,3.44,16.56,1,13.55,1z M17.5,14c0,1.93-1.57,3.5-3.5,3.5H6c-1.93,0-3.5-1.57-3.5-3.5V6c0-1.93,1.57-3.5,3.5-3.5h8 c1.93,0,3.5,1.57,3.5,3.5V14z\"/><circle cx=\"14.87\" cy=\"5.26\" r=\"1.09\"/><path d=\"M10.03,5.45c-2.55,0-4.63,2.06-4.63,4.6c0,2.55,2.07,4.61,4.63,4.61c2.56,0,4.63-2.061,4.63-4.61 C14.65,7.51,12.58,5.45,10.03,5.45L10.03,5.45L10.03,5.45z M10.08,13c-1.66,0-3-1.34-3-2.99c0-1.65,1.34-2.99,3-2.99s3,1.34,3,2.99 C13.08,11.66,11.74,13,10.08,13L10.08,13L10.08,13z\"/></svg>",
      "italic": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.63,5.48 L10.15,14.52 C10,15.08 10.37,15.25 11.92,15.3 L11.72,16 L6,16 L6.2,15.31 C7.78,15.26 8.19,15.09 8.34,14.53 L10.82,5.49 C10.97,4.92 10.63,4.76 9.09,4.71 L9.28,4 L15,4 L14.81,4.69 C13.23,4.75 12.78,4.91 12.63,5.48 L12.63,5.48 Z\"/></svg>",
      "joomla": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.8,13.4l1.7-1.7L5.9,8c-0.6-0.5-0.6-1.5,0-2c0.6-0.6,1.4-0.6,2,0l1.7-1.7c-1-1-2.3-1.3-3.6-1C5.8,2.2,4.8,1.4,3.7,1.4 c-1.3,0-2.3,1-2.3,2.3c0,1.1,0.8,2,1.8,2.3c-0.4,1.3-0.1,2.8,1,3.8L7.8,13.4L7.8,13.4z\"/><path d=\"M10.2,4.3c1-1,2.5-1.4,3.8-1c0.2-1.1,1.1-2,2.3-2c1.3,0,2.3,1,2.3,2.3c0,1.2-0.9,2.2-2,2.3c0.4,1.3,0,2.8-1,3.8L13.9,8 c0.6-0.5,0.6-1.5,0-2c-0.5-0.6-1.5-0.6-2,0L8.2,9.7L6.5,8\"/><path d=\"M14.1,16.8c-1.3,0.4-2.8,0.1-3.8-1l1.7-1.7c0.6,0.6,1.5,0.6,2,0c0.5-0.6,0.6-1.5,0-2l-3.7-3.7L12,6.7l3.7,3.7 c1,1,1.3,2.4,1,3.6c1.1,0.2,2,1.1,2,2.3c0,1.3-1,2.3-2.3,2.3C15.2,18.6,14.3,17.8,14.1,16.8\"/><path d=\"M13.2,12.2l-3.7,3.7c-1,1-2.4,1.3-3.6,1c-0.2,1-1.2,1.8-2.2,1.8c-1.3,0-2.3-1-2.3-2.3c0-1.1,0.8-2,1.8-2.3 c-0.3-1.3,0-2.7,1-3.7l1.7,1.7c-0.6,0.6-0.6,1.5,0,2c0.6,0.6,1.4,0.6,2,0l3.7-3.7\"/></svg>",
      "laptop": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect y=\"16\" width=\"20\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"2.5\" y=\"4.5\" width=\"15\" height=\"10\"/></svg>",
      "lifesaver": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,0.5 C4.76,0.5 0.5,4.76 0.5,10 C0.5,15.24 4.76,19.5 10,19.5 C15.24,19.5 19.5,15.24 19.5,10 C19.5,4.76 15.24,0.5 10,0.5 L10,0.5 Z M10,1.5 C11.49,1.5 12.89,1.88 14.11,2.56 L11.85,4.82 C11.27,4.61 10.65,4.5 10,4.5 C9.21,4.5 8.47,4.67 7.79,4.96 L5.58,2.75 C6.87,1.95 8.38,1.5 10,1.5 L10,1.5 Z M4.96,7.8 C4.67,8.48 4.5,9.21 4.5,10 C4.5,10.65 4.61,11.27 4.83,11.85 L2.56,14.11 C1.88,12.89 1.5,11.49 1.5,10 C1.5,8.38 1.95,6.87 2.75,5.58 L4.96,7.79 L4.96,7.8 L4.96,7.8 Z M10,18.5 C8.25,18.5 6.62,17.97 5.27,17.06 L7.46,14.87 C8.22,15.27 9.08,15.5 10,15.5 C10.79,15.5 11.53,15.33 12.21,15.04 L14.42,17.25 C13.13,18.05 11.62,18.5 10,18.5 L10,18.5 Z M10,14.5 C7.52,14.5 5.5,12.48 5.5,10 C5.5,7.52 7.52,5.5 10,5.5 C12.48,5.5 14.5,7.52 14.5,10 C14.5,12.48 12.48,14.5 10,14.5 L10,14.5 Z M15.04,12.21 C15.33,11.53 15.5,10.79 15.5,10 C15.5,9.08 15.27,8.22 14.87,7.46 L17.06,5.27 C17.97,6.62 18.5,8.25 18.5,10 C18.5,11.62 18.05,13.13 17.25,14.42 L15.04,12.21 L15.04,12.21 Z\"/></svg>",
      "link": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M10.625,12.375 L7.525,15.475 C6.825,16.175 5.925,16.175 5.225,15.475 L4.525,14.775 C3.825,14.074 3.825,13.175 4.525,12.475 L7.625,9.375\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M9.325,7.375 L12.425,4.275 C13.125,3.575 14.025,3.575 14.724,4.275 L15.425,4.975 C16.125,5.675 16.125,6.575 15.425,7.275 L12.325,10.375\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M7.925,11.875 L11.925,7.975\"/></svg>",
      "linkedin": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.77,17.89 L5.77,7.17 L2.21,7.17 L2.21,17.89 L5.77,17.89 L5.77,17.89 Z M3.99,5.71 C5.23,5.71 6.01,4.89 6.01,3.86 C5.99,2.8 5.24,2 4.02,2 C2.8,2 2,2.8 2,3.85 C2,4.88 2.77,5.7 3.97,5.7 L3.99,5.7 L3.99,5.71 L3.99,5.71 Z\"/><path d=\"M7.75,17.89 L11.31,17.89 L11.31,11.9 C11.31,11.58 11.33,11.26 11.43,11.03 C11.69,10.39 12.27,9.73 13.26,9.73 C14.55,9.73 15.06,10.71 15.06,12.15 L15.06,17.89 L18.62,17.89 L18.62,11.74 C18.62,8.45 16.86,6.92 14.52,6.92 C12.6,6.92 11.75,7.99 11.28,8.73 L11.3,8.73 L11.3,7.17 L7.75,7.17 C7.79,8.17 7.75,17.89 7.75,17.89 L7.75,17.89 L7.75,17.89 Z\"/></svg>",
      "list": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"6\" y=\"4\" width=\"12\" height=\"1\"/><rect x=\"6\" y=\"9\" width=\"12\" height=\"1\"/><rect x=\"6\" y=\"14\" width=\"12\" height=\"1\"/><rect x=\"2\" y=\"4\" width=\"2\" height=\"1\"/><rect x=\"2\" y=\"9\" width=\"2\" height=\"1\"/><rect x=\"2\" y=\"14\" width=\"2\" height=\"1\"/></svg>",
      "location": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" d=\"M10,0.5 C6.41,0.5 3.5,3.39 3.5,6.98 C3.5,11.83 10,19 10,19 C10,19 16.5,11.83 16.5,6.98 C16.5,3.39 13.59,0.5 10,0.5 L10,0.5 Z\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"6.8\" r=\"2.3\"/></svg>",
      "lock": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" height=\"10\" width=\"13\" y=\"8.5\" x=\"3.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M6.5,8 L6.5,4.88 C6.5,3.01 8.07,1.5 10,1.5 C11.93,1.5 13.5,3.01 13.5,4.88 L13.5,8\"/></svg>",
      "mail": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"1.4,6.5 10,11 18.6,6.5\"/><path d=\"M 1,4 1,16 19,16 19,4 1,4 Z M 18,15 2,15 2,5 18,5 18,15 Z\"/></svg>",
      "menu": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"2\" y=\"4\" width=\"16\" height=\"1\"/><rect x=\"2\" y=\"9\" width=\"16\" height=\"1\"/><rect x=\"2\" y=\"14\" width=\"16\" height=\"1\"/></svg>",
      "microphone": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" x1=\"10\" x2=\"10\" y1=\"16.44\" y2=\"18.5\"/><line fill=\"none\" stroke=\"#000\" x1=\"7\" x2=\"13\" y1=\"18.5\" y2=\"18.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M13.5 4.89v5.87a3.5 3.5 0 0 1-7 0V4.89a3.5 3.5 0 0 1 7 0z\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M15.5 10.36V11a5.5 5.5 0 0 1-11 0v-.6\"/></svg>",
      "minus-circle": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9.5\" cy=\"9.5\" r=\"9\"/><line fill=\"none\" stroke=\"#000\" x1=\"5\" y1=\"9.5\" x2=\"14\" y2=\"9.5\"/></svg>",
      "minus": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect height=\"1\" width=\"18\" y=\"9\" x=\"1\"/></svg>",
      "more-vertical": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"10\" cy=\"3\" r=\"2\"/><circle cx=\"10\" cy=\"10\" r=\"2\"/><circle cx=\"10\" cy=\"17\" r=\"2\"/></svg>",
      "more": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"3\" cy=\"10\" r=\"2\"/><circle cx=\"10\" cy=\"10\" r=\"2\"/><circle cx=\"17\" cy=\"10\" r=\"2\"/></svg>",
      "move": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"4,5 1,5 1,9 2,9 2,6 4,6\"/><polygon points=\"1,16 2,16 2,18 4,18 4,19 1,19\"/><polygon points=\"14,16 14,19 11,19 11,18 13,18 13,16\"/><rect fill=\"none\" stroke=\"#000\" x=\"5.5\" y=\"1.5\" width=\"13\" height=\"13\"/><rect x=\"1\" y=\"11\" width=\"1\" height=\"3\"/><rect x=\"6\" y=\"18\" width=\"3\" height=\"1\"/></svg>",
      "nut": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"2.5,5.7 10,1.3 17.5,5.7 17.5,14.3 10,18.7 2.5,14.3\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"10\" r=\"3.5\"/></svg>",
      "pagekit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"3,1 17,1 17,16 10,16 10,13 14,13 14,4 6,4 6,16 10,16 10,19 3,19\"/></svg>",
      "paint-bucket": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.21,1 L0,11.21 L8.1,19.31 L18.31,9.1 L10.21,1 L10.21,1 Z M16.89,9.1 L15,11 L1.7,11 L10.21,2.42 L16.89,9.1 Z\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M6.42,2.33 L11.7,7.61\"/><path d=\"M18.49,12 C18.49,12 20,14.06 20,15.36 C20,16.28 19.24,17 18.49,17 L18.49,17 C17.74,17 17,16.28 17,15.36 C17,14.06 18.49,12 18.49,12 L18.49,12 Z\"/></svg>",
      "pencil": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M17.25,6.01 L7.12,16.1 L3.82,17.2 L5.02,13.9 L15.12,3.88 C15.71,3.29 16.66,3.29 17.25,3.88 C17.83,4.47 17.83,5.42 17.25,6.01 L17.25,6.01 Z\"/><path fill=\"none\" stroke=\"#000\" d=\"M15.98,7.268 L13.851,5.148\"/></svg>",
      "phone-landscape": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M17,5.5 C17.8,5.5 18.5,6.2 18.5,7 L18.5,14 C18.5,14.8 17.8,15.5 17,15.5 L3,15.5 C2.2,15.5 1.5,14.8 1.5,14 L1.5,7 C1.5,6.2 2.2,5.5 3,5.5 L17,5.5 L17,5.5 L17,5.5 Z\"/><circle cx=\"3.8\" cy=\"10.5\" r=\".8\"/></svg>",
      "phone": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M15.5,17 C15.5,17.8 14.8,18.5 14,18.5 L7,18.5 C6.2,18.5 5.5,17.8 5.5,17 L5.5,3 C5.5,2.2 6.2,1.5 7,1.5 L14,1.5 C14.8,1.5 15.5,2.2 15.5,3 L15.5,17 L15.5,17 L15.5,17 Z\"/><circle cx=\"10.5\" cy=\"16.5\" r=\".8\"/></svg>",
      "pinterest": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.21,1 C5.5,1 3,4.16 3,7.61 C3,9.21 3.85,11.2 5.22,11.84 C5.43,11.94 5.54,11.89 5.58,11.69 C5.62,11.54 5.8,10.8 5.88,10.45 C5.91,10.34 5.89,10.24 5.8,10.14 C5.36,9.59 5,8.58 5,7.65 C5,5.24 6.82,2.91 9.93,2.91 C12.61,2.91 14.49,4.74 14.49,7.35 C14.49,10.3 13,12.35 11.06,12.35 C9.99,12.35 9.19,11.47 9.44,10.38 C9.75,9.08 10.35,7.68 10.35,6.75 C10.35,5.91 9.9,5.21 8.97,5.21 C7.87,5.21 6.99,6.34 6.99,7.86 C6.99,8.83 7.32,9.48 7.32,9.48 C7.32,9.48 6.24,14.06 6.04,14.91 C5.7,16.35 6.08,18.7 6.12,18.9 C6.14,19.01 6.26,19.05 6.33,18.95 C6.44,18.81 7.74,16.85 8.11,15.44 C8.24,14.93 8.79,12.84 8.79,12.84 C9.15,13.52 10.19,14.09 11.29,14.09 C14.58,14.09 16.96,11.06 16.96,7.3 C16.94,3.7 14,1 10.21,1\"/></svg>",
      "play-circle": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" points=\"8.5 7 13.5 10 8.5 13\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/></svg>",
      "play": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"6.5,5 14.5,10 6.5,15\"/></svg>",
      "plus-circle": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9.5\" cy=\"9.5\" r=\"9\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"5\" x2=\"9.5\" y2=\"14\"/><line fill=\"none\" stroke=\"#000\" x1=\"5\" y1=\"9.5\" x2=\"14\" y2=\"9.5\"/></svg>",
      "plus": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"9\" y=\"1\" width=\"1\" height=\"17\"/><rect x=\"1\" y=\"9\" width=\"17\" height=\"1\"/></svg>",
      "print": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"4.5 13.5 1.5 13.5 1.5 6.5 18.5 6.5 18.5 13.5 15.5 13.5\"/><polyline fill=\"none\" stroke=\"#000\" points=\"15.5 6.5 15.5 2.5 4.5 2.5 4.5 6.5\"/><rect fill=\"none\" stroke=\"#000\" width=\"11\" height=\"6\" x=\"4.5\" y=\"11.5\"/><rect width=\"8\" height=\"1\" x=\"6\" y=\"13\"/><rect width=\"8\" height=\"1\" x=\"6\" y=\"15\"/></svg>",
      "pull": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"6.85,8 9.5,10.6 12.15,8 12.85,8.7 9.5,12 6.15,8.7\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"11\" x2=\"9.5\" y2=\"2\"/><polyline fill=\"none\" stroke=\"#000\" points=\"6,5.5 3.5,5.5 3.5,18.5 15.5,18.5 15.5,5.5 13,5.5\"/></svg>",
      "push": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"12.15,4 9.5,1.4 6.85,4 6.15,3.3 9.5,0 12.85,3.3\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"10\" x2=\"9.5\" y2=\"1\"/><polyline fill=\"none\" stroke=\"#000\" points=\"6 5.5 3.5 5.5 3.5 18.5 15.5 18.5 15.5 5.5 13 5.5\"/></svg>",
      "question": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><circle cx=\"10.44\" cy=\"14.42\" r=\"1.05\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" d=\"M8.17,7.79 C8.17,4.75 12.72,4.73 12.72,7.72 C12.72,8.67 11.81,9.15 11.23,9.75 C10.75,10.24 10.51,10.73 10.45,11.4 C10.44,11.53 10.43,11.64 10.43,11.75\"/></svg>",
      "quote-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.27,7.79 C17.27,9.45 16.97,10.43 15.99,12.02 C14.98,13.64 13,15.23 11.56,15.97 L11.1,15.08 C12.34,14.2 13.14,13.51 14.02,11.82 C14.27,11.34 14.41,10.92 14.49,10.54 C14.3,10.58 14.09,10.6 13.88,10.6 C12.06,10.6 10.59,9.12 10.59,7.3 C10.59,5.48 12.06,4 13.88,4 C15.39,4 16.67,5.02 17.05,6.42 C17.19,6.82 17.27,7.27 17.27,7.79 L17.27,7.79 Z\"/><path d=\"M8.68,7.79 C8.68,9.45 8.38,10.43 7.4,12.02 C6.39,13.64 4.41,15.23 2.97,15.97 L2.51,15.08 C3.75,14.2 4.55,13.51 5.43,11.82 C5.68,11.34 5.82,10.92 5.9,10.54 C5.71,10.58 5.5,10.6 5.29,10.6 C3.47,10.6 2,9.12 2,7.3 C2,5.48 3.47,4 5.29,4 C6.8,4 8.08,5.02 8.46,6.42 C8.6,6.82 8.68,7.27 8.68,7.79 L8.68,7.79 Z\"/></svg>",
      "receiver": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" d=\"M6.189,13.611C8.134,15.525 11.097,18.239 13.867,18.257C16.47,18.275 18.2,16.241 18.2,16.241L14.509,12.551L11.539,13.639L6.189,8.29L7.313,5.355L3.76,1.8C3.76,1.8 1.732,3.537 1.7,6.092C1.667,8.809 4.347,11.738 6.189,13.611\"/></svg>",
      "reddit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 9.05a2.56 2.56 0 0 0-2.56-2.56 2.59 2.59 0 0 0-1.88.82 10.63 10.63 0 0 0-4.14-1v-.08c.58-1.62 1.58-3.89 2.7-4.1.38-.08.77.12 1.19.57a1.15 1.15 0 0 0-.06.37 1.48 1.48 0 1 0 1.51-1.45 1.43 1.43 0 0 0-.76.19A2.29 2.29 0 0 0 12.91 1c-2.11.43-3.39 4.38-3.63 5.19 0 0 0 .11-.06.11a10.65 10.65 0 0 0-3.75 1A2.56 2.56 0 0 0 1 9.05a2.42 2.42 0 0 0 .72 1.76A5.18 5.18 0 0 0 1.24 13c0 3.66 3.92 6.64 8.73 6.64s8.74-3 8.74-6.64a5.23 5.23 0 0 0-.46-2.13A2.58 2.58 0 0 0 19 9.05zm-16.88 0a1.44 1.44 0 0 1 2.27-1.19 7.68 7.68 0 0 0-2.07 1.91 1.33 1.33 0 0 1-.2-.72zM10 18.4c-4.17 0-7.55-2.4-7.55-5.4S5.83 7.53 10 7.53 17.5 10 17.5 13s-3.38 5.4-7.5 5.4zm7.69-8.61a7.62 7.62 0 0 0-2.09-1.91 1.41 1.41 0 0 1 .84-.28 1.47 1.47 0 0 1 1.44 1.45 1.34 1.34 0 0 1-.21.72z\"/><path d=\"M6.69 12.58a1.39 1.39 0 1 1 1.39-1.39 1.38 1.38 0 0 1-1.38 1.39z\"/><path d=\"M14.26 11.2a1.39 1.39 0 1 1-1.39-1.39 1.39 1.39 0 0 1 1.39 1.39z\"/><path d=\"M13.09 14.88a.54.54 0 0 1-.09.77 5.3 5.3 0 0 1-3.26 1.19 5.61 5.61 0 0 1-3.4-1.22.55.55 0 1 1 .73-.83 4.09 4.09 0 0 0 5.25 0 .56.56 0 0 1 .77.09z\"/></svg>",
      "refresh": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M17.08,11.15 C17.09,11.31 17.1,11.47 17.1,11.64 C17.1,15.53 13.94,18.69 10.05,18.69 C6.16,18.68 3,15.53 3,11.63 C3,7.74 6.16,4.58 10.05,4.58 C10.9,4.58 11.71,4.73 12.46,5\"/><polyline fill=\"none\" stroke=\"#000\" points=\"9.9 2 12.79 4.89 9.79 7.9\"/></svg>",
      "reply": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.7,13.11 C16.12,10.02 13.84,7.85 11.02,6.61 C10.57,6.41 9.75,6.13 9,5.91 L9,2 L1,9 L9,16 L9,12.13 C10.78,12.47 12.5,13.19 14.09,14.25 C17.13,16.28 18.56,18.54 18.56,18.54 C18.56,18.54 18.81,15.28 17.7,13.11 L17.7,13.11 Z M14.82,13.53 C13.17,12.4 11.01,11.4 8,10.92 L8,13.63 L2.55,9 L8,4.25 L8,6.8 C8.3,6.86 9.16,7.02 10.37,7.49 C13.3,8.65 15.54,10.96 16.65,13.08 C16.97,13.7 17.48,14.86 17.68,16 C16.87,15.05 15.73,14.15 14.82,13.53 L14.82,13.53 Z\"/></svg>",
      "rss": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"3.12\" cy=\"16.8\" r=\"1.85\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1.5,8.2 C1.78,8.18 2.06,8.16 2.35,8.16 C7.57,8.16 11.81,12.37 11.81,17.57 C11.81,17.89 11.79,18.19 11.76,18.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1.5,2.52 C1.78,2.51 2.06,2.5 2.35,2.5 C10.72,2.5 17.5,9.24 17.5,17.57 C17.5,17.89 17.49,18.19 17.47,18.5\"/></svg>",
      "search": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9\" cy=\"9\" r=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M14,14 L18,18 L14,14 Z\"/></svg>",
      "server": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"1\" height=\"2\"/><rect x=\"5\" y=\"3\" width=\"1\" height=\"2\"/><rect x=\"7\" y=\"3\" width=\"1\" height=\"2\"/><rect x=\"16\" y=\"3\" width=\"1\" height=\"1\"/><rect x=\"16\" y=\"10\" width=\"1\" height=\"1\"/><circle fill=\"none\" stroke=\"#000\" cx=\"9.9\" cy=\"17.4\" r=\"1.4\"/><rect x=\"3\" y=\"10\" width=\"1\" height=\"2\"/><rect x=\"5\" y=\"10\" width=\"1\" height=\"2\"/><rect x=\"9.5\" y=\"14\" width=\"1\" height=\"2\"/><rect x=\"3\" y=\"17\" width=\"6\" height=\"1\"/><rect x=\"11\" y=\"17\" width=\"6\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"1.5\" width=\"17\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"1.5\" y=\"8.5\" width=\"17\" height=\"5\"/></svg>",
      "settings": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><ellipse fill=\"none\" stroke=\"#000\" cx=\"6.11\" cy=\"3.55\" rx=\"2.11\" ry=\"2.15\"/><ellipse fill=\"none\" stroke=\"#000\" cx=\"6.11\" cy=\"15.55\" rx=\"2.11\" ry=\"2.15\"/><circle fill=\"none\" stroke=\"#000\" cx=\"13.15\" cy=\"9.55\" r=\"2.15\"/><rect x=\"1\" y=\"3\" width=\"3\" height=\"1\"/><rect x=\"10\" y=\"3\" width=\"8\" height=\"1\"/><rect x=\"1\" y=\"9\" width=\"8\" height=\"1\"/><rect x=\"15\" y=\"9\" width=\"3\" height=\"1\"/><rect x=\"1\" y=\"15\" width=\"3\" height=\"1\"/><rect x=\"10\" y=\"15\" width=\"8\" height=\"1\"/></svg>",
      "shrink": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"11 4 12 4 12 8 16 8 16 9 11 9\"/><polygon points=\"4 11 9 11 9 16 8 16 8 12 4 12\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M12,8 L18,2\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M2,18 L8,12\"/></svg>",
      "sign-in": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"7 2 17 2 17 17 7 17 7 16 16 16 16 3 7 3\"/><polygon points=\"9.1 13.4 8.5 12.8 11.28 10 4 10 4 9 11.28 9 8.5 6.2 9.1 5.62 13 9.5\"/></svg>",
      "sign-out": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"13.1 13.4 12.5 12.8 15.28 10 8 10 8 9 15.28 9 12.5 6.2 13.1 5.62 17 9.5\"/><polygon points=\"13 2 3 2 3 17 13 17 13 16 4 16 4 3 13 3\"/></svg>",
      "social": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"13.4\" y1=\"14\" x2=\"6.3\" y2=\"10.7\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"13.5\" y1=\"5.5\" x2=\"6.5\" y2=\"8.8\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"15.5\" cy=\"4.6\" r=\"2.3\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"15.5\" cy=\"14.8\" r=\"2.3\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"4.5\" cy=\"9.8\" r=\"2.3\"/></svg>",
      "soundcloud": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.2,9.4c-0.4,0-0.8,0.1-1.101,0.2c-0.199-2.5-2.399-4.5-5-4.5c-0.6,0-1.2,0.1-1.7,0.3C9.2,5.5,9.1,5.6,9.1,5.6V15h8 c1.601,0,2.801-1.2,2.801-2.8C20,10.7,18.7,9.4,17.2,9.4L17.2,9.4z\"/><rect x=\"6\" y=\"6.5\" width=\"1.5\" height=\"8.5\"/><rect x=\"3\" y=\"8\" width=\"1.5\" height=\"7\"/><rect y=\"10\" width=\"1.5\" height=\"5\"/></svg>",
      "star": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" stroke-width=\"1.01\" points=\"10 2 12.63 7.27 18.5 8.12 14.25 12.22 15.25 18 10 15.27 4.75 18 5.75 12.22 1.5 8.12 7.37 7.27\"/></svg>",
      "strikethrough": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6,13.02 L6.65,13.02 C7.64,15.16 8.86,16.12 10.41,16.12 C12.22,16.12 12.92,14.93 12.92,13.89 C12.92,12.55 11.99,12.03 9.74,11.23 C8.05,10.64 6.23,10.11 6.23,7.83 C6.23,5.5 8.09,4.09 10.4,4.09 C11.44,4.09 12.13,4.31 12.72,4.54 L13.33,4 L13.81,4 L13.81,7.59 L13.16,7.59 C12.55,5.88 11.52,4.89 10.07,4.89 C8.84,4.89 7.89,5.69 7.89,7.03 C7.89,8.29 8.89,8.78 10.88,9.45 C12.57,10.03 14.38,10.6 14.38,12.91 C14.38,14.75 13.27,16.93 10.18,16.93 C9.18,16.93 8.17,16.69 7.46,16.39 L6.52,17 L6,17 L6,13.02 L6,13.02 Z\"/><rect x=\"3\" y=\"10\" width=\"15\" height=\"1\"/></svg>",
      "table": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"1\" y=\"3\" width=\"18\" height=\"1\"/><rect x=\"1\" y=\"7\" width=\"18\" height=\"1\"/><rect x=\"1\" y=\"11\" width=\"18\" height=\"1\"/><rect x=\"1\" y=\"15\" width=\"18\" height=\"1\"/></svg>",
      "tablet-landscape": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M1.5,5 C1.5,4.2 2.2,3.5 3,3.5 L17,3.5 C17.8,3.5 18.5,4.2 18.5,5 L18.5,16 C18.5,16.8 17.8,17.5 17,17.5 L3,17.5 C2.2,17.5 1.5,16.8 1.5,16 L1.5,5 L1.5,5 L1.5,5 Z\"/><circle cx=\"3.7\" cy=\"10.5\" r=\".8\"/></svg>",
      "tablet": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M5,18.5 C4.2,18.5 3.5,17.8 3.5,17 L3.5,3 C3.5,2.2 4.2,1.5 5,1.5 L16,1.5 C16.8,1.5 17.5,2.2 17.5,3 L17.5,17 C17.5,17.8 16.8,18.5 16,18.5 L5,18.5 L5,18.5 L5,18.5 Z\"/><circle cx=\"10.5\" cy=\"16.3\" r=\".8\"/></svg>",
      "tag": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M17.5,3.71 L17.5,7.72 C17.5,7.96 17.4,8.2 17.21,8.39 L8.39,17.2 C7.99,17.6 7.33,17.6 6.93,17.2 L2.8,13.07 C2.4,12.67 2.4,12.01 2.8,11.61 L11.61,2.8 C11.81,2.6 12.08,2.5 12.34,2.5 L16.19,2.5 C16.52,2.5 16.86,2.63 17.11,2.88 C17.35,3.11 17.48,3.4 17.5,3.71 L17.5,3.71 Z\"/><circle cx=\"14\" cy=\"6\" r=\"1\"/></svg>",
      "thumbnails": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"3.5\" width=\"5\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"11.5\" y=\"3.5\" width=\"5\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"11.5\" y=\"11.5\" width=\"5\" height=\"5\"/><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"11.5\" width=\"5\" height=\"5\"/></svg>",
      "trash": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"6.5 3 6.5 1.5 13.5 1.5 13.5 3\"/><polyline fill=\"none\" stroke=\"#000\" points=\"4.5 4 4.5 18.5 15.5 18.5 15.5 4\"/><rect x=\"8\" y=\"7\" width=\"1\" height=\"9\"/><rect x=\"11\" y=\"7\" width=\"1\" height=\"9\"/><rect x=\"2\" y=\"3\" width=\"16\" height=\"1\"/></svg>",
      "triangle-down": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"5 7 15 7 10 12\"/></svg>",
      "triangle-left": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"12 5 7 10 12 15\"/></svg>",
      "triangle-right": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"8 5 13 10 8 15\"/></svg>",
      "triangle-up": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"5 13 10 8 15 13\"/></svg>",
      "tripadvisor": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.021,7.866C19.256,6.862,20,5.854,20,5.854h-3.346C14.781,4.641,12.504,4,9.98,4C7.363,4,4.999,4.651,3.135,5.876H0\tc0,0,0.738,0.987,0.976,1.988c-0.611,0.837-0.973,1.852-0.973,2.964c0,2.763,2.249,5.009,5.011,5.009\tc1.576,0,2.976-0.737,3.901-1.879l1.063,1.599l1.075-1.615c0.475,0.611,1.1,1.111,1.838,1.451c1.213,0.547,2.574,0.612,3.825,0.15\tc2.589-0.963,3.913-3.852,2.964-6.439c-0.175-0.463-0.4-0.876-0.675-1.238H19.021z M16.38,14.594\tc-1.002,0.371-2.088,0.328-3.06-0.119c-0.688-0.317-1.252-0.817-1.657-1.438c-0.164-0.25-0.313-0.52-0.417-0.811\tc-0.124-0.328-0.186-0.668-0.217-1.014c-0.063-0.689,0.037-1.396,0.339-2.043c0.448-0.971,1.251-1.71,2.25-2.079\tc2.075-0.765,4.375,0.3,5.14,2.366c0.762,2.066-0.301,4.37-2.363,5.134L16.38,14.594L16.38,14.594z M8.322,13.066\tc-0.72,1.059-1.935,1.76-3.309,1.76c-2.207,0-4.001-1.797-4.001-3.996c0-2.203,1.795-4.002,4.001-4.002\tc2.204,0,3.999,1.8,3.999,4.002c0,0.137-0.024,0.261-0.04,0.396c-0.067,0.678-0.284,1.313-0.648,1.853v-0.013H8.322z M2.472,10.775\tc0,1.367,1.112,2.479,2.476,2.479c1.363,0,2.472-1.11,2.472-2.479c0-1.359-1.11-2.468-2.472-2.468\tC3.584,8.306,2.473,9.416,2.472,10.775L2.472,10.775z M12.514,10.775c0,1.367,1.104,2.479,2.471,2.479\tc1.363,0,2.474-1.108,2.474-2.479c0-1.359-1.11-2.468-2.474-2.468c-1.364,0-2.477,1.109-2.477,2.468H12.514z M3.324,10.775\tc0-0.893,0.726-1.618,1.614-1.618c0.889,0,1.625,0.727,1.625,1.618c0,0.898-0.725,1.627-1.625,1.627\tc-0.901,0-1.625-0.729-1.625-1.627H3.324z M13.354,10.775c0-0.893,0.726-1.618,1.627-1.618c0.886,0,1.61,0.727,1.61,1.618\tc0,0.898-0.726,1.627-1.626,1.627s-1.625-0.729-1.625-1.627H13.354z M9.977,4.875c1.798,0,3.425,0.324,4.849,0.968\tc-0.535,0.015-1.061,0.108-1.586,0.3c-1.264,0.463-2.264,1.388-2.815,2.604c-0.262,0.551-0.398,1.133-0.448,1.72\tC9.79,7.905,7.677,5.873,5.076,5.82C6.501,5.208,8.153,4.875,9.94,4.875H9.977z\"/></svg>",
      "tumblr": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.885,8.598c0,0,0,3.393,0,4.996c0,0.282,0,0.66,0.094,0.942c0.377,1.509,1.131,2.545,2.545,3.11 c1.319,0.472,2.356,0.472,3.676,0c0.565-0.188,1.132-0.659,1.132-0.659l-0.849-2.263c0,0-1.036,0.378-1.603,0.283 c-0.565-0.094-1.226-0.66-1.226-1.508c0-1.603,0-4.902,0-4.902h2.828V5.771h-2.828V2H8.205c0,0-0.094,0.66-0.188,0.942 C7.828,3.791,7.262,4.733,6.603,5.394C5.848,6.147,5,6.43,5,6.43v2.168H6.885z\"/></svg>",
      "tv": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"7\" y=\"16\" width=\"6\" height=\"1\"/><rect fill=\"none\" stroke=\"#000\" x=\".5\" y=\"3.5\" width=\"19\" height=\"11\"/></svg>",
      "twitter": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19,4.74 C18.339,5.029 17.626,5.229 16.881,5.32 C17.644,4.86 18.227,4.139 18.503,3.28 C17.79,3.7 17.001,4.009 16.159,4.17 C15.485,3.45 14.526,3 13.464,3 C11.423,3 9.771,4.66 9.771,6.7 C9.771,6.99 9.804,7.269 9.868,7.539 C6.795,7.38 4.076,5.919 2.254,3.679 C1.936,4.219 1.754,4.86 1.754,5.539 C1.754,6.82 2.405,7.95 3.397,8.61 C2.79,8.589 2.22,8.429 1.723,8.149 L1.723,8.189 C1.723,9.978 2.997,11.478 4.686,11.82 C4.376,11.899 4.049,11.939 3.713,11.939 C3.475,11.939 3.245,11.919 3.018,11.88 C3.49,13.349 4.852,14.419 6.469,14.449 C5.205,15.429 3.612,16.019 1.882,16.019 C1.583,16.019 1.29,16.009 1,15.969 C2.635,17.019 4.576,17.629 6.662,17.629 C13.454,17.629 17.17,12 17.17,7.129 C17.17,6.969 17.166,6.809 17.157,6.649 C17.879,6.129 18.504,5.478 19,4.74\"/></svg>",
      "uikit": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"14.4,3.1 11.3,5.1 15,7.3 15,12.9 10,15.7 5,12.9 5,8.5 2,6.8 2,14.8 9.9,19.5 18,14.8 18,5.3\"/><polygon points=\"9.8,4.2 6.7,2.4 9.8,0.4 12.9,2.3\"/></svg>",
      "unlock": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect fill=\"none\" stroke=\"#000\" x=\"3.5\" y=\"8.5\" width=\"13\" height=\"10\"/><path fill=\"none\" stroke=\"#000\" d=\"M6.5,8.5 L6.5,4.9 C6.5,3 8.1,1.5 10,1.5 C11.9,1.5 13.5,3 13.5,4.9\"/></svg>",
      "upload": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" points=\"5 8 9.5 3.5 14 8\"/><rect x=\"3\" y=\"17\" width=\"13\" height=\"1\"/><line fill=\"none\" stroke=\"#000\" x1=\"9.5\" y1=\"15\" x2=\"9.5\" y2=\"4\"/></svg>",
      "user": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9.9\" cy=\"6.4\" r=\"4.4\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2\"/></svg>",
      "users": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"7.7\" cy=\"8.6\" r=\"3.5\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M1,18.1 C1.7,14.6 4.4,12.1 7.6,12.1 C10.9,12.1 13.7,14.8 14.3,18.3\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M11.4,4 C12.8,2.4 15.4,2.8 16.3,4.7 C17.2,6.6 15.7,8.9 13.6,8.9 C16.5,8.9 18.8,11.3 19.2,14.1\"/></svg>",
      "video-camera": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><polygon fill=\"none\" stroke=\"#000\" points=\"17.5 6.9 17.5 13.1 13.5 10.4 13.5 14.5 2.5 14.5 2.5 5.5 13.5 5.5 13.5 9.6 17.5 6.9\"/></svg>",
      "vimeo": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.065,7.59C1.84,7.367,1.654,7.082,1.468,6.838c-0.332-0.42-0.137-0.411,0.274-0.772c1.026-0.91,2.004-1.896,3.127-2.688 c1.017-0.713,2.365-1.173,3.286-0.039c0.849,1.045,0.869,2.629,1.084,3.891c0.215,1.309,0.421,2.648,0.88,3.901 c0.127,0.352,0.37,1.018,0.81,1.074c0.567,0.078,1.145-0.917,1.408-1.289c0.684-0.987,1.611-2.317,1.494-3.587 c-0.115-1.349-1.572-1.095-2.482-0.773c0.146-1.514,1.555-3.216,2.912-3.792c1.439-0.597,3.579-0.587,4.302,1.036 c0.772,1.759,0.078,3.802-0.763,5.396c-0.918,1.731-2.1,3.333-3.363,4.829c-1.114,1.329-2.432,2.787-4.093,3.422 c-1.897,0.723-3.021-0.686-3.667-2.318c-0.705-1.777-1.056-3.771-1.565-5.621C4.898,8.726,4.644,7.836,4.136,7.191 C3.473,6.358,2.72,7.141,2.065,7.59C1.977,7.502,2.115,7.551,2.065,7.59L2.065,7.59z\"/></svg>",
      "warning": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"10\" cy=\"14\" r=\"1\"/><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10\" cy=\"10\" r=\"9\"/><path d=\"M10.97,7.72 C10.85,9.54 10.56,11.29 10.56,11.29 C10.51,11.87 10.27,12 9.99,12 C9.69,12 9.49,11.87 9.43,11.29 C9.43,11.29 9.16,9.54 9.03,7.72 C8.96,6.54 9.03,6 9.03,6 C9.03,5.45 9.46,5.02 9.99,5 C10.53,5.01 10.97,5.44 10.97,6 C10.97,6 11.04,6.54 10.97,7.72 L10.97,7.72 Z\"/></svg>",
      "whatsapp": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.7,3.3c-1.8-1.8-4.1-2.8-6.7-2.8c-5.2,0-9.4,4.2-9.4,9.4c0,1.7,0.4,3.3,1.3,4.7l-1.3,4.9l5-1.3c1.4,0.8,2.9,1.2,4.5,1.2 l0,0l0,0c5.2,0,9.4-4.2,9.4-9.4C19.5,7.4,18.5,5,16.7,3.3 M10.1,17.7L10.1,17.7c-1.4,0-2.8-0.4-4-1.1l-0.3-0.2l-3,0.8l0.8-2.9 l-0.2-0.3c-0.8-1.2-1.2-2.7-1.2-4.2c0-4.3,3.5-7.8,7.8-7.8c2.1,0,4.1,0.8,5.5,2.3c1.5,1.5,2.3,3.4,2.3,5.5 C17.9,14.2,14.4,17.7,10.1,17.7 M14.4,11.9c-0.2-0.1-1.4-0.7-1.6-0.8c-0.2-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.6,0.8-0.8,0.9 c-0.1,0.2-0.3,0.2-0.5,0.1c-0.2-0.1-1-0.4-1.9-1.2c-0.7-0.6-1.2-1.4-1.3-1.6c-0.1-0.2,0-0.4,0.1-0.5C8,8.8,8.1,8.7,8.2,8.5 c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0-0.3,0-0.4C8.4,7.6,7.9,6.5,7.7,6C7.5,5.5,7.3,5.6,7.2,5.6c-0.1,0-0.3,0-0.4,0 c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.8,0.8-0.8,2c0,1.2,0.8,2.3,1,2.4c0.1,0.2,1.7,2.5,4,3.5c0.6,0.2,1,0.4,1.3,0.5 c0.6,0.2,1.1,0.2,1.5,0.1c0.5-0.1,1.4-0.6,1.6-1.1c0.2-0.5,0.2-1,0.1-1.1C14.8,12.1,14.6,12,14.4,11.9\"/></svg>",
      "wordpress": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10,0.5c-5.2,0-9.5,4.3-9.5,9.5s4.3,9.5,9.5,9.5c5.2,0,9.5-4.3,9.5-9.5S15.2,0.5,10,0.5L10,0.5L10,0.5z M15.6,3.9h-0.1 c-0.8,0-1.4,0.7-1.4,1.5c0,0.7,0.4,1.3,0.8,1.9c0.3,0.6,0.7,1.3,0.7,2.3c0,0.7-0.3,1.5-0.6,2.7L14.1,15l-3-8.9 c0.5,0,0.9-0.1,0.9-0.1C12.5,6,12.5,5.3,12,5.4c0,0-1.3,0.1-2.2,0.1C9,5.5,7.7,5.4,7.7,5.4C7.2,5.3,7.2,6,7.6,6c0,0,0.4,0.1,0.9,0.1 l1.3,3.5L8,15L5,6.1C5.5,6.1,5.9,6,5.9,6C6.4,6,6.3,5.3,5.9,5.4c0,0-1.3,0.1-2.2,0.1c-0.2,0-0.3,0-0.5,0c1.5-2.2,4-3.7,6.9-3.7 C12.2,1.7,14.1,2.6,15.6,3.9L15.6,3.9L15.6,3.9z M2.5,6.6l3.9,10.8c-2.7-1.3-4.6-4.2-4.6-7.4C1.8,8.8,2,7.6,2.5,6.6L2.5,6.6L2.5,6.6 z M10.2,10.7l2.5,6.9c0,0,0,0.1,0.1,0.1C11.9,18,11,18.2,10,18.2c-0.8,0-1.6-0.1-2.3-0.3L10.2,10.7L10.2,10.7L10.2,10.7z M14.2,17.1 l2.5-7.3c0.5-1.2,0.6-2.1,0.6-2.9c0-0.3,0-0.6-0.1-0.8c0.6,1.2,1,2.5,1,4C18.3,13,16.6,15.7,14.2,17.1L14.2,17.1L14.2,17.1z\"/></svg>",
      "world": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" d=\"M1,10.5 L19,10.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M2.35,15.5 L17.65,15.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M2.35,5.5 L17.523,5.5\"/><path fill=\"none\" stroke=\"#000\" d=\"M10,19.46 L9.98,19.46 C7.31,17.33 5.61,14.141 5.61,10.58 C5.61,7.02 7.33,3.83 10,1.7 C10.01,1.7 9.99,1.7 10,1.7 L10,1.7 C12.67,3.83 14.4,7.02 14.4,10.58 C14.4,14.141 12.67,17.33 10,19.46 L10,19.46 L10,19.46 L10,19.46 Z\"/><circle fill=\"none\" stroke=\"#000\" cx=\"10\" cy=\"10.5\" r=\"9\"/></svg>",
      "xing": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.4,4.56 C4.24,4.56 4.11,4.61 4.05,4.72 C3.98,4.83 3.99,4.97 4.07,5.12 L5.82,8.16 L5.82,8.17 L3.06,13.04 C2.99,13.18 2.99,13.33 3.06,13.44 C3.12,13.55 3.24,13.62 3.4,13.62 L6,13.62 C6.39,13.62 6.57,13.36 6.71,13.12 C6.71,13.12 9.41,8.35 9.51,8.16 C9.49,8.14 7.72,5.04 7.72,5.04 C7.58,4.81 7.39,4.56 6.99,4.56 L4.4,4.56 L4.4,4.56 Z\"/><path d=\"M15.3,1 C14.91,1 14.74,1.25 14.6,1.5 C14.6,1.5 9.01,11.42 8.82,11.74 C8.83,11.76 12.51,18.51 12.51,18.51 C12.64,18.74 12.84,19 13.23,19 L15.82,19 C15.98,19 16.1,18.94 16.16,18.83 C16.23,18.72 16.23,18.57 16.16,18.43 L12.5,11.74 L12.5,11.72 L18.25,1.56 C18.32,1.42 18.32,1.27 18.25,1.16 C18.21,1.06 18.08,1 17.93,1 L15.3,1 L15.3,1 Z\"/></svg>",
      "yelp": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.175,14.971c-0.112,0.77-1.686,2.767-2.406,3.054c-0.246,0.1-0.487,0.076-0.675-0.069\tc-0.122-0.096-2.446-3.859-2.446-3.859c-0.194-0.293-0.157-0.682,0.083-0.978c0.234-0.284,0.581-0.393,0.881-0.276\tc0.016,0.01,4.21,1.394,4.332,1.482c0.178,0.148,0.263,0.379,0.225,0.646L17.175,14.971L17.175,14.971z M11.464,10.789\tc-0.203-0.307-0.199-0.666,0.009-0.916c0,0,2.625-3.574,2.745-3.657c0.203-0.135,0.452-0.141,0.69-0.025\tc0.691,0.335,2.085,2.405,2.167,3.199v0.027c0.024,0.271-0.082,0.491-0.273,0.623c-0.132,0.083-4.43,1.155-4.43,1.155\tc-0.322,0.096-0.68-0.06-0.882-0.381L11.464,10.789z M9.475,9.563C9.32,9.609,8.848,9.757,8.269,8.817c0,0-3.916-6.16-4.007-6.351\tc-0.057-0.212,0.011-0.455,0.202-0.65C5.047,1.211,8.21,0.327,9.037,0.529c0.27,0.069,0.457,0.238,0.522,0.479\tc0.047,0.266,0.433,5.982,0.488,7.264C10.098,9.368,9.629,9.517,9.475,9.563z M9.927,19.066c-0.083,0.225-0.273,0.373-0.54,0.421\tc-0.762,0.13-3.15-0.751-3.647-1.342c-0.096-0.131-0.155-0.262-0.167-0.394c-0.011-0.095,0-0.189,0.036-0.272\tc0.061-0.155,2.917-3.538,2.917-3.538c0.214-0.272,0.595-0.355,0.952-0.213c0.345,0.13,0.56,0.428,0.536,0.749\tC10.014,14.479,9.977,18.923,9.927,19.066z M3.495,13.912c-0.235-0.009-0.444-0.148-0.568-0.382c-0.089-0.17-0.151-0.453-0.19-0.794\tC2.63,11.701,2.761,10.144,3.07,9.648c0.145-0.226,0.357-0.345,0.592-0.336c0.154,0,4.255,1.667,4.255,1.667\tc0.321,0.118,0.521,0.453,0.5,0.833c-0.023,0.37-0.236,0.655-0.551,0.738L3.495,13.912z\"/></svg>",
      "youtube": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15,4.1c1,0.1,2.3,0,3,0.8c0.8,0.8,0.9,2.1,0.9,3.1C19,9.2,19,10.9,19,12c-0.1,1.1,0,2.4-0.5,3.4c-0.5,1.1-1.4,1.5-2.5,1.6 c-1.2,0.1-8.6,0.1-11,0c-1.1-0.1-2.4-0.1-3.2-1c-0.7-0.8-0.7-2-0.8-3C1,11.8,1,10.1,1,8.9c0-1.1,0-2.4,0.5-3.4C2,4.5,3,4.3,4.1,4.2 C5.3,4.1,12.6,4,15,4.1z M8,7.5v6l5.5-3L8,7.5z\"/></svg>",
      "antwort-ja": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xml:space=\"preserve\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\"><path d=\"M14,-1.414L15.414,0L4,11.414L-1.414,6L-0,4.586L4,8.585L14,-1.414Z\" fill-rule=\"nonzero\" transform=\"translate(3 5)\"/></svg>",
      "antwort-nein": "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"#000\" stroke-miterlimit=\"2\"><g fill-rule=\"nonzero\"><path d=\"M16 2.586L17.414 4 4 17.414 2.586 16 16 2.586z\"/><path d=\"M2.586 4L4 2.586 17.414 16 16 17.414 2.586 4z\"/></g></svg>",
      "info-i": "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xml:space=\"preserve\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\"><g fill=\"#298bd4\" transform=\"translate(1 1)\"><path d=\"M9,-0.71C3.637,-0.71 -0.71,3.637 -0.71,9C-0.71,14.363 3.637,18.71 9,18.71C14.363,18.71 18.71,14.363 18.71,9C18.71,3.637 14.363,-0.71 9,-0.71ZM9,1.29C13.258,1.29 16.71,4.742 16.71,9C16.71,13.258 13.258,16.71 9,16.71C4.742,16.71 1.29,13.258 1.29,9C1.29,4.742 4.742,1.29 9,1.29Z\" fill-rule=\"nonzero\"/><path d=\"M10,6.258L10,14.645L8,14.645L8,6.258L10,6.258Z\" fill-rule=\"nonzero\"/><circle cx=\"9\" cy=\"4.065\" r=\"1\"/></g></svg>"
    });
  }
  if (typeof window !== 'undefined' && window.UIkit) {
    window.UIkit.use(plugin);
  }
  return plugin;
});

},{"@babel/runtime/helpers/interopRequireDefault":8,"@babel/runtime/helpers/typeof":18}]},{},[25]);
